import { IPaymentMode, IGetPermissionMandatoryField, ICountry, IFacilityInfoACH, IRCMStatus, IFacilityInfo } from './../interface';
import { Component, OnInit, OnDestroy, TemplateRef, Output, EventEmitter, Input, ViewChild, ElementRef, SimpleChanges, Renderer2, HostListener } from '@angular/core';
import { PaymentService } from 'src/app/services/payment.service';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { IPaymentModeDetails } from '../models/MerchandiseModel';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { EPaymentOrigin, ELOV_TransactionTypes, EPaymentModes, EPaymentGateway, ECreditCards, EPaymentTransactionType, EOpenEdgeSessionStates, EEdgeExpressResultCode, EACHCheckResultCode, EEdgeExpressECIType, EOpenEdgeResponseCode, ELOV_LimitOptions, EACHAccountType, ECallScriptSections, EUserFunctions, ETransactionTypes, ECountries, EACHPaymentGateway, EMandatoryFieldsFormId, EPaymentTransactionTypes, ECashRoundingOption, EPaymentSources, ERentRoundingOption, ERoundingToNearest, EFeesCharges } from '../enum';
import { ToastrService } from 'ngx-toastr';
import { UserSessionService } from 'src/app/services/usersession.service';
import { DocumentService } from 'src/app/services/operations/document.service';
import { FacilityService } from 'src/app/services/facility.service';
import { IFacilityCreditCard } from 'src/app/Shared/interface';
import { ISurchargeFeeInfo } from 'src/app/Shared/models/CustomerModel';
import { TranslateService } from '@ngx-translate/core';
import { IFacPaymentSettingsDetails } from '../models/ProspectModel';
import { GeneralService } from 'src/app/services/general.service';
import { FormGroup, Validators, AbstractControl, NgForm, FormControl } from '@angular/forms';
import { DataService } from 'src/app/facilityOperations/facOps-dashboard/data.service';
import { AutoPaySharedComponent } from '../autoPay/autoPay.component';
import { ProspectService } from 'src/app/services/operations/prospects.service';
import { CustomerService } from 'src/app/services/operations/customer.service';
import { CalltrackerService } from 'src/app/services/operations/calltracker.service';
import { Observable, Subject, Subscription, timer, of, defer } from 'rxjs';
import { AppService } from 'src/app/services/app.service';
import { IDeviceSetting, IState } from '../interface2';
import { environment } from 'src/environments/environment';
import { TransferData } from 'src/app/facilityOperations/facOps-customer/transfer-data';
import { FacOpsDataService } from 'src/app/services/operations/facOpsDataService.service';
import { CommonMethodService } from '../common-method.service';
import { CustomerDataService } from 'src/app/facilityOperations/facOps-customer/customer-data.service';
import { ITwoDigitDecimalInput } from 'src/app/Shared/interface';
import { StripeTerminalSignalRService } from 'src/app/services/payment/stripe-terminal-signal-r.service';
import { DecimalPipe } from '@angular/common';
import { HttpStatusCode } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { AppInsightsService } from 'src/app/services/app-insights.service';
import { take, switchMap, exhaustMap, filter, map, timeout, defaultIfEmpty } from 'rxjs/operators';
import { AfterViewInit } from '@angular/core';
import{interval} from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FocusTrap, FocusTrapFactory } from '@angular/cdk/a11y';
import { PayFieldsSdkLoaderService } from '../payfields-sdk-loader.service';
declare var customcheckout: any;
declare var GlobalPayments: any;

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss'],
    standalone: false
})
export class PaymentComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() tenantModel = null;
  @Input() leaseModel = null;
  RemotePayTransactionId = 0;
  remotePayIsSMS = false;
  remotePayPhoneNumber = '';
  remotePayIsEmail = false;
  remotePayEmailId = '';
  @ViewChild('remotePay', { static: true }) remotePay: TemplateRef<any>;
  remotePayModalRef: BsModalRef;
  stripeClientSecret = '';
  paymentAccountId = '';
  cctOrderId = 0;
  achOrderId = 0;
  PaymentMethod = '';
  selectedPaymentMode = 0;
  stripePublishableKey = '';
  StripeUnifiedAccountId = '';
  partialPaySuccessUnaltered = false;
  @Input() displayCallScript = false
  section = ECallScriptSections.Payment;
  enableAddressAutofill: boolean;
  linkedAutopayModalRef: BsModalRef;
  isPaymentWithAutoPay: boolean = false;
  autopaySetupAchRows: { [payId: string]: { Id: number, UniqueTransId: string } } = {};
  RoundingOption:any;
  RoundingValue : any;
  stripeLoader = {
    isStripeterminal: false,
    isPyamnet: true
  }
  @Input() contactInfo: any;
  @Input() paymentGateway: number;
  private paymentGatewayResolved = false;
  @Input() processPayment: any;
  @Input() emitAutoEnrollPP:boolean = false;
  @Input() apiResponse: any;
  @Input() facilityId: number;
  @Input() receiptNumber: number;
  @Input() Restrictiononcheckpayment: boolean = false;
  @Input() donnotacceptchecksfromRental: boolean = true;
  @Input() autoPayInfo;
  @Input() autoPayRequired: boolean = false;
  @Input() returnPostPayment: boolean;
  @Output() autopayCompleted = new EventEmitter<any>();
  @Output() isCancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() payCompleted: EventEmitter<any> = new EventEmitter<any>();
  @Output() charityFeesContribution: EventEmitter<any> = new EventEmitter<any>();
  @Output() surchargeContribution: EventEmitter<any> = new EventEmitter<any>();
  @Output() afterShowConfirm: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitLoopPayment: EventEmitter<any> = new EventEmitter<any>();
  @Output() isZeroPayment: EventEmitter<any> = new EventEmitter<any>();
  @Output() isChangeDueDateCancelled: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('ACHIFrame', { static: false }) iframeAch: ElementRef;
  @ViewChild('paymentFinishedSignal', { static: false }) payCNPFinished: HTMLInputElement;
  @ViewChild('CPNIFrame', { static: false }) iframe: ElementRef;
  @ViewChild('CNPAliasIFrame', { static: false }) iframeAlias: ElementRef;
  @ViewChild('paymentSuccess', { static: true }) aftePay: TemplateRef<any>;
  @ViewChild('printReceiptPopup', { static: true }) printReceipt: ModalDirective;
  @ViewChild('manualAuthorization', { static: true }) offlinePay: TemplateRef<any>;
  @ViewChild('manualAuthForm', { static: true }) manualAuthForm: NgForm;
  @ViewChild('TdBankIFrame', { static: false }) TdBankIFrame: ElementRef;
  @ViewChild(AutoPaySharedComponent, { static: false }) AutoPaySharedComponent: AutoPaySharedComponent;
  @ViewChild('showTDHostedForm', { static: true }) templateTDHosted: TemplateRef<any>;
  @ViewChild('txtTransactionId', { static: false }) txtTransactionId: ElementRef;
  @ViewChild('checkout-form', { static: false }) checkout_form: ElementRef;
  @ViewChild('showTDchallengeForm', { static: true }) showTDchallengeForm: TemplateRef<any>;
  @ViewChild('cancelPaymentModal', { static: true }) cancelPaymentModal: TemplateRef<any>;
  @ViewChild('achManualAuthorization', { static: true }) achOfflinePay: TemplateRef<any>;
  @ViewChild('eftManualAuthorization', { static: true }) eftOfflinePay: TemplateRef<any>;
  @ViewChild('achManualAuthForm', { static: true }) achManualAuthForm: NgForm;
  @ViewChild('eftManualAuthForm', { static: true }) eftManualAuthForm: NgForm;
  @ViewChild('payFieldsDialog', { static: false, read: ElementRef }) payFieldsDialog: ElementRef<HTMLElement>;
  @ViewChild('showStripePage', { static: true }) showStripePage: TemplateRef<any>;
  @ViewChild('linkedAutopay', { static: true }) linkedAutopay: TemplateRef<any>;
  @ViewChild('showpopupforpartialPayment', { static: true }) showpopupforpartialPayment: ModalDirective;
  @ViewChild('OnDueDateChangeConfirmPopup', { static: true }) OnDueDateChangeConfirmPopup: TemplateRef<any>;
  @ViewChild('surchargeMixedModeAlert', { static: true }) surchargeMixedModeAlertTemplate: TemplateRef<any>;
  @ViewChild('cardMismatchAlert', { static: true }) cardMismatchAlertTemplate: TemplateRef<any>;
  @Input() IsQuickProspect: any;
  private stripeResponseSubscription: Subscription;
  modalConfig = {
  backdrop: 'static'
};
  stripeResponse: any;
  tdNameOnCard = '';
  savedTDResult;
  stripeModalRef: BsModalRef;
  surchargeMixedModeModalRef: BsModalRef;
  /** Stores the row Id and previous mode for the mixed-mode alert revert (Story 2.3). */
  private _surchargeMixedModeRevertContext: { rowId: any; previousModeId: number } | null = null;
  /** i18n text for the lock-reason aria-describedby spans (Story 2.2, NFR-1). Set once in ngOnInit. */
  surchargeLockReasonText = '';
  /** i18n alert message for the mixed-mode alertdialog (Story 2.3, FR-6). Set once in ngOnInit. */
  surchargeMixedModeAlertText = '';
  /** Modal ref for the card/mode mismatch alertdialog (Story 2.5, FR-8). */
  cardMismatchModalRef: BsModalRef;
  /** Stores the row Id for the card mismatch revert on dismissal (Story 2.5). */
  private _cardMismatchRevertContext: { rowId: any } | null = null;
  /** i18n alert text for card/mode mismatch — set at runtime before opening the modal (Story 2.5, NFR-1). */
  cardMismatchAlertText = '';
  /** i18n modal title for card/mode mismatch alertdialog (Story 2.5, AC-5, NFR-1). Set once in ngOnInit. */
  cardMismatchAlertTitleText = '';
  tdModalRef: BsModalRef;
  tdChallengeModalRef: BsModalRef;
  showTDHostedForm = false;
  amountTD = 0;
  mandateId = '';
  tdResponseObj: any;
  isPrintChecked = false;
  paymentTable = [];
  surchargeFees: ISurchargeFeeInfo[] = [];
  totalTaxDue: number = 0;
  payAmount: number;
  lastAccessedFacility: any;
  paymentCount = 0;
  paymentSection = true;
  customerInfoSection = false;
  totalAmount;
  originalTotalAmount;
  remainingAmount;
  sessionId;
  userGroupLimits;
  paymentSettings;
  auto: boolean = false;
  tempremAmt;
  amountToPay;
  tenderAmount :number= 0;
  changeAmount;
  currentPayId;
  creditCardList;
  payModes = [];
  show_OnDueDateChangeConfirmPopup: BsModalRef;
  modalRef: BsModalRef;
  modalRefSelectDevice: BsModalRef;
  checkModalRef: BsModalRef;
  payModalRef: BsModalRef;
  autoModalRef: BsModalRef;
  manualModalRef: BsModalRef;
  achManualModalRef: BsModalRef;
  eftManualModalRef: BsModalRef;
  enableAutopayOrCardOnFile: BsModalRef;
  currentPayModeId = 0;
  merchSaleSection: boolean;
  loaderIcon: Promise<boolean>;
  private readonly loaderOff: Promise<boolean> = Promise.resolve(false);
  private readonly loaderOn: Promise<boolean> = Promise.resolve(true);
  loaderIcon2: Promise<boolean>;
  payStatus: string;
  paymentSuccessFul: boolean;
  paymentFailReason: string;
  showPrintEmailRcpt: boolean;
  finalPayModel: IPaymentModeDetails;
  shareModel = [];
  returnUrl;
  tillNowPaid: number = 0;
  paymentProcessing = false;
  emailCheckBox;
  emailBox;
  enableEmail: boolean;
  emailValid: boolean;
  smsCheckBox;
  smsBox;
  enableSMS: boolean;
  showIFrame = false;
  showAchIFrame = false;
  showIFrameTdBank = false;
  showPage = true;
  urlSafe: SafeResourceUrl;
  achUrlSafe: SafeResourceUrl;
  urlSafeAlias: SafeResourceUrl;
  requestParam: String;
  hstPayBtnMsg: string;
  receiptObj;
  sectionList;
  isResponse = false;
  psForm: FormGroup;
  isSaveInCCTResponse = false;
  isSaveInACHResponse = false;
  autopaydata
  @ViewChild('paymentSuccess', { static: true }) popUpPayment: TemplateRef<any>;
  @ViewChild('autoPay', { static: false }) autoPayPop: TemplateRef<any>
  @ViewChild('checkPayment', { static: true }) checkPayPop: TemplateRef<any>
  defaultmode: number;
  prePayStatus: string;
  TransactionTypeId;
  createAlias: boolean = false;
  rcmAliasKey: string = '';
  cnpAliasKey: string = '';
  hstPayAliasBtnMsg: string;
  showAliasIFrame: boolean = false;
  disablePause = false;
  disableResume = true;
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  aliasOrderId: number;
  public PhoneNumberMask: String = '(000)000-0000';
  public ExpNumberMask: String = '00/0000';
  aliasResp: any;
  credentials: any;
  autoCC: number = 0;
  checkNo = null;
  checkBank: string = '';
  checkDate: Date = new Date();
  today = new Date();
  ManualCardNumber = '';
  ManualCardExp = null;
  ManualCardName = '';
  ManualCardAuthorization = '';
  ManualCardType = '';
  ManualSelectCard;
  ValidManualCardExp: boolean = false;
  ValidManualCardMonth: boolean = false;
  mandateFields: IGetPermissionMandatoryField;
  mandateFieldsforCheckpayment: IGetPermissionMandatoryField;
  mandatoryfields:IGetPermissionMandatoryField;
  amountField: boolean;
  tenderAmtField: boolean;
  changeAmtField: boolean;
  amountFieldforcheck: boolean;
  checknumber: boolean;
  checkdatefield: boolean;
  checkbankname: boolean;
  isManualSelectCard: boolean = false;
  componentName: string = 'payment.component.html';
  TDformName: string = 'tdHostedPageForm'
  unSingedDocuments = [];
  tdResponseObj1;
  ManualCardExpIsDirty: boolean = false;
  maxLengthNameOnCard = 30;
  maxLengthCCBlillingAd = 50;
  maxLengthCCBlillingZip = 15;
  tdAddress = '';
  tdZip = '';
  tdFName = '';
  tdLName = '';
  tdEmail = '';
  tdCity = '';
  tdState = null;
  tdCountry = 1;
  tdCellphone = '';
  cardDetails;
  UniqueKey: string;
  Isopen: boolean = true;
  autopayProfile: any;
  terminalDevicesList = [];
  autopayLinledUnitList = [];
  enableLinkedUnitLeaseNo = [];
  private defaultCountryId = environment.defaultCountryId;
  private paymentGetCCTStatusInterval = environment.paymentGetCCTStatusInterval;
  private paymentMaxWaitTime = environment.paymentMaxWaitTime;
  private tdLocalHostArchitectureFacilities = environment.tdLocalHostArchitectureFacilities;
  private cardNotPresentAPICallInterval = environment.cardNotPresentInterval;
  private enableNewPaymentArchitecture = environment.enableNewPaymentArchitecture;
  @ViewChild('selectDevicePopup', { static: true }) public selectDevicePopup: TemplateRef<any>;
  @ViewChild('selectStripeDevicePopup', { static: true }) public selectStripeDevicePopup: TemplateRef<any>;
  @ViewChild('SelectAutopayorCardOnFile', { static: true }) public SelectAutopayorCardOnFile: TemplateRef<any>;
  selectedDeviceId = 0;
  selectStripeReaderId: string = "";
  public paymentSetting: IFacPaymentSettingsDetails;
  subTD: any;
  subTdhost: any;
  subOpenEdgeHostedpage: any;
  subOpenEdgeEMV: any;
  subVoidTd: any;
  isDisplayCharitable = false;
  isFixedCharityAmount = false;
  charityAmount = 0;
  isOverrideCharityAmount = false;
  isRoundUpCharityAmount = false;
  roundUpValue;
  charityContributionFee;
  tempTotalAmount: number;
  roundUpValueDisplay = 0;
  /** Charity amount (fixed + round-up) last computed by calculateContribution; added to row 0's payAmount and to totalAmount. */
  charityContributionAmount = 0;
  charityContribution;
  mandatoryFieldsTD = [];
  isTDEmailValid = true;
  cellphoneNotValid = false;
  stateList = [];
  countryList = [];
  emailIdsPattern = '^([\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)([\,\;]{1}[\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)*$';
  browserLangauge: string;
  userAgent: string;
  headers: string;
  screenHeight: number;
  screenWidth: number;
  colorDepth: number;
  time_zone: number;
  FacilityDate;
  fieldsRequired = false;
  UniqueIdentifier;
  gatewayResult: any;
  private baseUrl = this.appService.config.apiBaseUrl;
  sessiondata: any;
  cresResponse: number;
  achOrderNumber: any;
  tdPaymentMethod: string;
  TdAmount: number;
  paymentStarted = false;
  subjectPayAmount: Subject<any> = new Subject();
  currentModeId = 0;
  editRightOfflinePayment = false;
  viewRightOfflinePayment = false;
  costValueDirectiveSetting: ITwoDigitDecimalInput = {
    Length: 5,
    IsCurrency: true,
    DefaultMinimum: false,
    MinimumValue: '0.00',
    MaximumValue: '99999.99',
    WholeValue: false,
  };
  openEdgeBillingFields = '';
  isStripeTerminalPay = false;
  emptyStateList = false;
  transactionInitiated = false;
  paymentInProgress = false;
  initiatedVoidCC = false;
  showLoaderMesage = false;
  isAutoPopulateBillingInfo = false;
  tempCNPPayId = null;
  tempCNPAmount = null;
  cctStatusOrderId = 0;
  openEdgeSub: any;
  customerInfo = {
    FirstName: '',
    MiddleName: '',
    LastName: '',
    CompanyName: '',
    AddressOne: '',
    City: '',
    CountryCode: '',
    StateCode: '',
    StateId: 0,
    PostalCode: '',
    CountryId: 0,
    CellPhoneNumber: '',
    Email: '',
    FullName: ''
  }
  customerInfoPresent = false;
  voidOnCancelInitiated = false;
  /** True when callOpenEdgeVoid is running as part of a card/mode mismatch reversal. Prevents isCancel emit. */
  private _isMismatchVoid = false;
  private tdMismatchVoidState: 'pending' | 'confirmed' | 'unconfirmed' = null;
  private static tdMismatchModalSequence = 0;
  /** How long a gateway-side decline waits for the RCM's own response, which carries the device's reason and card details. */
  private static readonly openEdgeRcmResponseGraceMs = 5000;
  /** Existing "check the gateway portal" instruction, used when an OpenEdge sale's outcome can't be determined. */
  private static readonly openEdgeReconciliationMessage = 'Please Contact Administrator to check in Gateway Portal if Payment is Approved. If Yes, key in the Payment as Manual Authorization';
  /** Set when an OpenEdge sale may have been charged but couldn't be confirmed: blocks card retries (see isOpenEdgeReconciliationBlocked). */
  openEdgeReconciliationRequired = false;
  /** New-architecture RCM sale request, kept open for the whole transaction (like callRCM) so its result isn't lost. */
  private openEdgeRcmRequest: Subscription = null;
  private tdMismatchVisibilityWait: Subscription;
  private paymentComponentDestroyed = false;
  cancelPaymentModalRef: BsModalRef;
  partialPaySuccess = false;
  dayendSettingDetails: any;
  multiPaymentVoidEmv: any;
  facilityCreditCards: string = '';
  retryTransactionStatusLoader = false;
  tempRcmRes = {
    rcmSessionId: '',
    rcmResponse: ''
  }
  tempCNPRes: any;
  achSettingPaymentGateway: any;
  achManualRoutingNumber = '';
  achManualCheckNumber = '';
  achManualAccountnumber = '';
  achManualAuthorization = '';
  accounttype: any;
  achManualCardAuthorization = '';
  eftManualCardAuthorization = '';
  nameonAccount = '';

  // PayFields callback lifecycle state (Story 2.2)
  private isPayFieldsTokenPending = false;
  private payFieldsRequestId: string | null = null;
  private payFieldsWatchdogTimer: any = null;
  private readonly PAYFIELDS_TOKEN_TIMEOUT_MS = 30000;
  showPayFieldsEmbeddedForm = false;
  payFieldsStateRequired = false;
  payFieldsMandatoryFieldsLoaded = false;
  isPayFieldsEmbeddedFormReady = false;
  private payFieldsSecureForm: any = null;
  private payFieldsFormListeners: { form: any; tokenSuccess: any; tokenError: any; error: any } | null = null;
  private payFieldsCardValidity = { number: false, expiration: false, cvv: false };
  private payFieldsFocusTrap: FocusTrap | null = null;
  private payFieldsFocusOrigin: HTMLElement | null = null;
  private payFieldsIframeObserver: MutationObserver | null = null;
  private payFieldsFocusTrapRetryTimer: any = null;
  payFieldsPendingAmount = 0;
  private payFieldsTokenizationResult: any = null;
  private payFieldsAutoPayVaultGapWarned = false;
  payFieldsBillingDetails = {
    firstName: '',
    middleName: '',
    lastName: '',
    companyName: '',
    addressOne: '',
    addressTwo: '',
    city: '',
    countryId: environment.defaultCountryId,
    stateId: 0,
    postalCode: ''
  };

  bankName = '';
  accountType = 279;
  checkNumber = ''
  accountNumber = '';
  routingNumber = '';
  isTDEmv = {
    isTransactionWaitTime: false,
    isPortClosingWaitTime: false
  }
  RCMStatusResponse: IRCMStatus = {
    SessionId: '',
    SessionState: 0
  };
  isOpenEdgeEMVCompleted = false;
  requestgatewaydetails;
  paymentIntentId: string;
  autopayMessage: string;
  autopayHeader: string;
  autopayFooter: string;
  remotePayIsSmsAlert = false;
  achgateway: number;
  countryId: number;
  Tenantinfo: any;
  quickProspectTenantInfo: any;
  isLoaderActive: boolean = false;
  stripeTerminalDeviceId : any;
  displayPaymentPopup:boolean=true;
  show_popupforPArtialPayment: BsModalRef;
  amount: any;
  payId: any;
  template: TemplateRef<any>;
  templateCheck: TemplateRef<any>;
  routingNumberfield: boolean;
  accountNumberfield: boolean;
  accountTypefield: boolean;
  authorizationfield: boolean;
  nameonAccountfield:boolean;
  checkNumberfield: boolean;
  RoundDownvalueforCash: any;
  roundUpValueforCash: number;
  EnableCashRounding: boolean = false;
  roundValueforCash: number = 0;
  roundingvalue: any = 0;
  requireFullPaymentForTransaction: boolean = false;
  hasAutopay: boolean = false;
  stripeSetupIntent: any;
  LinkedleaseNo: any;

  constructor(private paymentService: PaymentService,
    private modalService: BsModalService,
    public sanitizer: DomSanitizer,
    private toastr: ToastrService,
    private customerService: CustomerService,
    private userSessionService: UserSessionService,
    public facilityservice: FacilityService,
    private documentService: DocumentService,
    public generalService: GeneralService,
    private data: DataService,
    private prospectSerice: ProspectService,
    private callTrackerService: CalltrackerService,
    private appService: AppService,
    private transferdataservice: TransferData,
    private facOpsDataService: FacOpsDataService,
    private renderer: Renderer2,
    private commonMethod: CommonMethodService,
    public customerDataService: CustomerDataService,
    private signalRService: StripeTerminalSignalRService,
    public decimalPipe: DecimalPipe,
    private appInsightsService: AppInsightsService,
    private translate: TranslateService,
    private focusTrapFactory: FocusTrapFactory,
    private payFieldsSdkLoader: PayFieldsSdkLoaderService
  ) {
  }

  ngOnInit() {
    if (this.processPayment.TenantId) {
      this.getTenantDetailsById(this.processPayment.TenantId);
    } else {
      if (this.tenantModel) {
        const { BusinessAccount, CompanyName, FirstName, MiddleName, LastName, Email, CellPhoneNumber } = this.tenantModel;
        this.quickProspectTenantInfo = {
          IsQuickProspect: this.IsQuickProspect,
          Name: BusinessAccount ? CompanyName : `${FirstName}${MiddleName ? ' ' + MiddleName : ''} ${LastName}`.trim(),
          Email: Email,
          Phone: CellPhoneNumber,
        };
      }
      if (this.IsQuickProspect && this.tenantModel) {
        this.customerInfoPresent = true;
        this.customerInfo = {
          FirstName: this.tenantModel.FirstName,
          MiddleName: this.tenantModel.MiddleName,
          LastName: this.tenantModel.LastName,
          CompanyName: this.tenantModel.CompanyName,
          AddressOne: this.tenantModel.Address,
          City: this.tenantModel.City,
          CountryCode: '',
          StateCode: '',
          StateId: this.tenantModel.State && this.tenantModel.State.Id ? this.tenantModel.State.Id : '',
          PostalCode: this.tenantModel.Zip,
          CountryId: this.tenantModel.CountryId,
          CellPhoneNumber: this.tenantModel.BusinessAccount && this.tenantModel.CompanyPhone ? this.tenantModel.CompanyPhone : this.tenantModel.CellPhoneNumber,
          Email: this.tenantModel.BusinessAccount && this.tenantModel.CompanyEmail ? this.tenantModel.CompanyEmail : this.tenantModel.Email,
          FullName: this.tenantModel.BusinessAccount && this.tenantModel.CompanyName ? this.tenantModel.CompanyName : `${this.tenantModel.FirstName}${this.tenantModel.MiddleName ? ' ' + this.tenantModel.MiddleName : ''} ${this.tenantModel.LastName}`.trim()
        }
      }
    }
    this.setUserPermissions();
    if (this.transferdataservice.pastdueautopay) {
      this.transferdataservice.pastdueautopay = null;
    }
    if (this.facOpsDataService.saveautopay) {
      this.facOpsDataService.saveautopay = null;
    }
    this.manualAuthForm.form.addControl('mManualCardNumber', new FormControl());
    this.manualAuthForm.form.addControl('mManualCardExp', new FormControl());
    this.manualAuthForm.form.addControl('mManualCardName', new FormControl());
    this.manualAuthForm.form.addControl('mCardType', new FormControl());
    this.manualAuthForm.form.addControl('mManualCardAuthorization', new FormControl());
    this.facilityId = this.processPayment.facId;
    this.getDayEndCompletedDate(this.facilityId);
    this.getDayendSettings(this.facilityId);
    this.getCredentials();
    this.getStoresbyId();

    if (this.displayCallScript) {
      this.facOpsDataService.setCurrentType(this.section, true);
      this.facOpsDataService.isScriptDataPresent(this.section, false, false, false);
    }
    //Get Facility Pay settings
    if (this.prospectSerice.paymentSettings && this.prospectSerice.payFacId == this.facilityId)
      this.paymentSetting = this.prospectSerice.paymentSettings;
    if (this.paymentSetting) {
      this.isDisplayCharitable = this.paymentSetting.DisplayCharityContribution;
      this.charityAmount = this.paymentSetting.CharityAmount;
      this.isOverrideCharityAmount = this.paymentSetting.OverrideCharityAmount;
      this.roundUpValue = this.paymentSetting.RoundUpValue;
      this.charityContributionFee = this.paymentSetting.CharityContributionFee;
      this.EnableCashRounding = this.paymentSetting.EnableCashRounding;
      this.RoundingValue = this.paymentSetting.RoundingValue;
      this.RoundingOption = this.paymentSetting.RoundingOption;
    } else
      this.getFacilityPaymentSettings(this.facilityId);
    if (this.processPayment.Type == EPaymentOrigin.MakePayment) {
      this.setMandatoryField(172);
    }
    this.setMandatoryFieldforCheckpayment(173);
    this.getCountries();
    if(this.EnableCashRounding && this.processPayment.Type == EPaymentOrigin.Refund){
      this.RoundingOption = ECashRoundingOption.RoundDown;
    }
    this.hydrateSurchargeContext();
    this.surchargeLockReasonText = this.translate.instant('PaymentSurcharge.SurchargeLockReason');
    this.surchargeMixedModeAlertText = this.translate.instant('PaymentSurcharge.MixedModeWithSurchargeBlocked');
    this.cardMismatchAlertTitleText = this.translate.instant('PaymentSurcharge.CardModeMismatchTitle');
    this.paymentCount = 0;
    this.paymentTable = [];
    this.paymentCount++;
    let amountToPay = 0;
    this.remainingAmount = 0;
    if (!this.paymentSetting || !this.paymentSetting.DoNotDefaultToDueAmount) {
      amountToPay = this.processPayment.AmountTobePaid.toFixed(2);
    } else {
      this.remainingAmount = this.processPayment.AmountTobePaid
    }
    const obj = {
      payId: this.paymentCount,
      payName: 'Payment ' + this.paymentCount,
      payAmount: amountToPay,
      payComplete: false,
      payNowDisable: true,
      payModeId: 0,
      orderId: null,
      changeAmount: 0,
      checkNum: 0,
      checkDate: '',
      bankName: '',
      ManualCardNumber: '',
      ManualCardExp: '',
      ManualCardName: '',
      CreditCardType: 0,
      ManualCardAuthorization: '',
      defaultmode: 0,
      uniqueTransId: null,
      payFailed: false,
      routingNumber: 0,
      accountNumber: 0,
      roundingvalue: 0,
      achManualCardAuthorization: '',
      accountType: 279,
      nameonAccount: '',
      isOpenEdgePaymentCompleted: false,
      remotePayIsSMS: false,
      remotePayPhoneNumber: '',
      remotePayIsEmail: false,
      remotePayEmailId: '',
      stripePaymentIntentId: 0,
      EnableAutopayOrCardOnFile: 'cancel',
      TerminalDeviceId: '',
      surchargeFeeAmount: 0,
      surchargeFeePercentage: 0,
      surchargeLocked: false
    };

    this.paymentTable.push(obj);
    this.lastAccessedFacility = this.userSessionService.userSessionData.LastAccessedStoreId;
    this.totalAmount = +this.processPayment.AmountTobePaid.toFixed(2);
    this.originalTotalAmount = this.totalAmount;
    this.tempTotalAmount = +this.processPayment.AmountTobePaid.toFixed(2);
    this.tempremAmt = this.processPayment.AmountTobePaid.toFixed(2);
    // Always fetch surcharge rules fresh inside the payment component so MinFee/MaxFee/FeePercentage
    // are available for client-side fee calculation from row.payAmount.
    const surchargeFacilityId = this.facilityId || this.processPayment.facId;
    if (this.surchargeFees.length || this.processPayment?.SurchargeFees?.length) {
      this.hydrateSurchargeContext();
      this.initPaymentModes();
    } else if (surchargeFacilityId && !this.isWalkInMerchandiseSale()) {
      this.customerService.getActiveSurchargeRules(surchargeFacilityId)
        .pipe(take(1))
        .subscribe((rules: any[]) => {
          const totalTax = Number(this.processPayment?.TotalTax ?? 0);
          const surchargeBase = Math.max(0, Number(this.processPayment.AmountTobePaid ?? 0) - totalTax);
          this.totalTaxDue = totalTax;
          this.surchargeFees = (rules ?? []).map(rule => ({
            PaymentModeId: rule.PaymentModeId,
            PaymentSourceIds: rule.PaymentSourceIds,
            FeeAmount: this.calculateSurchargeFeeAmount(surchargeBase, rule.FeePercentage, rule.MinFee, rule.MaxFee, rule.RoundingOption, rule.RoundingValue),
            FeePercentage: rule.FeePercentage,
            MinFee: rule.MinFee,
            MaxFee: rule.MaxFee,
            RoundingOption: rule.RoundingOption,
            RoundingValue: rule.RoundingValue,
            FeeId: rule.FeeId
          }));
          this.initPaymentModes();
        }, () => this.initPaymentModes());
    } else {
      this.initPaymentModes();
    }
    if (this.processPayment.sectionList) {
      if (this.processPayment.Type == EPaymentOrigin.Merchandise && this.processPayment.sectionList.length !== 0) {
        this.merchSaleSection = true
        this.sectionList = this.processPayment.sectionList;
        this.TransactionTypeId = ETransactionTypes.Merchandise;
      } else if (this.processPayment.Type == EPaymentOrigin.Rental) {
        this.TransactionTypeId = ETransactionTypes.Move_In;
      }
    }
    this.getCreditCard();
    this.getFacilityInfoACH();
    this.callLinkedUnlitList();
    this.createAlias = false;
    this.autopayProfile = this.autoPayInfo;
    this.subjectPayAmount.pipe(debounceTime(0),distinctUntilChanged()).subscribe(event => {
      let value = event.target.value.replace(/[$,]/g, '') ? event.target.value.replace(/[$,]/g, '') : event.target.value;
      this.onChangepayAmount(value, this.currentModeId);
    });

    this.eftManualAuthForm.form.addControl("eftRoutingNumber", new FormControl());
    this.eftManualAuthForm.form.addControl("eftAccountNumber", new FormControl());
    this.eftManualAuthForm.form.addControl("eftBankName", new FormControl());
    this.achManualAuthForm.form.addControl("eftAuthorization", new FormControl());
    this.eftManualAuthForm.form.addControl("eftAccountType", new FormControl());
    this.eftManualAuthForm.form.get("eftRoutingNumber").setValidators([Validators.required]);
    this.eftManualAuthForm.form.get("eftAccountNumber").setValidators([Validators.required]);
    this.eftManualAuthForm.form.get("eftBankName").setValidators([Validators.required]);
    this.achManualAuthForm.form.get("eftAuthorization").setValidators([Validators.required]);

    this.AutoPaySharedComponent?.setInitialAutopayData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['facilityId']) {
      let payProcess = changes['facilityId'].currentValue;
      if (payProcess) {
        if (this.processPayment.Type === EPaymentOrigin.MakePayment) {
          this.paymentProcessing = false;
          this.paymentTable = [];
          this.paymentCount = 0;
          this.paymentCount = 1;
          const obj = {
            payId: this.paymentCount,
            payName: 'Payment ' + this.paymentCount,
            payAmount: this.processPayment.AmountTobePaid.toFixed(2),
            payComplete: false,
            payNowDisable: true,
            payModeId: 0,
            orderId: null,
            changeAmount: 0,
            checkNum: 0,
            checkDate: '',
            bankName: '',
            ManualCardNumber: '',
            ManualCardExp: '',
            ManualCardName: '',
            CreditCardType: 0,
            ManualCardAuthorization: '',
            defaultmode: 0,
            uniqueTransId: null,
            payFailed: false,
            stripePaymentIntentId: 0,
            roundingvalue: 0,
            isOpenEdgePaymentCompleted: false,
            EnableAutopayOrCardOnFile: 'cancel',
            TerminalDeviceId: ''
          };
          this.paymentTable.push(obj);
          this.totalAmount = +this.processPayment.AmountTobePaid.toFixed(2);
          this.tempTotalAmount = +this.processPayment.AmountTobePaid.toFixed(2);
          this.charityContributionAmount = 0;
          this.remainingAmount = 0;
          this.tempremAmt = this.processPayment.AmountTobePaid.toFixed(2);
        }
      }
    }

    if (changes['apiResponse']) {
      if (this.apiResponse.ReceiptId !== undefined || this.apiResponse.Id !== undefined) {
        this.prePayStatus = 'Transaction';
        if (this.apiResponse.Success) {
          if (this.paymentGateway == EPaymentGateway.Stripe && !this.credentials.CompletePaymentDuringDayEnd && this.selectedPaymentMode != EPaymentModes.DirectDebitEFT && this.selectedPaymentMode != EPaymentModes.ACH) {
            this.paymentTable
              .filter(ele => ele.stripePaymentIntentId && ele.processedStripeCC?.Reason === "requires_capture")
              .forEach((ele) => {
                this.capturePaymentIntent(this.facilityId, ele.stripePaymentIntentId, ele.orderId)
              })
          }
          this.isResponse = true;
          this.apiResponse['date'] = new Date();
          this.payStatus = 'Success';
          if (this.transactionInitiated) {
            this.transactionInitiated = false;
          }
          if (this.partialPaySuccess || this.partialPaySuccessUnaltered) {
            this.paymentSuccessFul = true;
          }
          this.showLoaderMesage = false;
          this.loaderIcon = Promise.resolve(false);
          this.payModalRef = this.modalService.show(this.aftePay, { class: 'modal-dialog-centered ', backdrop: 'static', keyboard: false });
        } else {
          this.isResponse = false;
          this.payStatus = 'Failed';
          this.paymentSuccessFul = false;
          if (this.transactionInitiated) {
            this.transactionInitiated = false;
          }
          this.showLoaderMesage = false;
          this.loaderIcon = Promise.resolve(false);
          if (this.apiResponse.InquiryInsteadofReservation) {
            this.afterpaymentSuccess();
          } else if (this.apiResponse.isErrorSection) {
            this.payModalRef = this.modalService.show(this.aftePay, { class: 'modal-dialog-centered ', backdrop: 'static', keyboard: false });
          } else {
            this.payModalRef = this.modalService.show(this.aftePay, { class: 'modal-dialog-centered ', backdrop: 'static', keyboard: false });
          }
        }
      }
    }
  }

  getCreditCard() {
    this.facilityservice.getCreditCardsForOp(this.processPayment.facId)
      .subscribe((response: IFacilityCreditCard) => {
        this.creditCardList = response.CreditCards;
        this.creditCardList.map(ele => {
          if (ele.Name == "American Express" && ele.Id == 1) {
            this.facilityCreditCards = this.facilityCreditCards.concat('AMEX,');
          } else if (ele.Name == "Visa" && ele.Id == 2) {
            this.facilityCreditCards = this.facilityCreditCards.concat('VISA,');
          } else if (ele.Name == "Master Card" && ele.Id == 3) {
            this.facilityCreditCards = this.facilityCreditCards.concat('MC,');
          } else if (ele.Name == "Discover" && ele.Id == 4) {
            this.facilityCreditCards = this.facilityCreditCards.concat('DISCOVER,');
          } else if (ele.Name == "Diners" && ele.Id == 5) {
            this.facilityCreditCards = this.facilityCreditCards.concat('DINERS,');
          } else if (ele.Name == "JCB" && ele.Id == 6) {
            this.facilityCreditCards = this.facilityCreditCards.concat('JCB,');
          }
        })
        this.facilityCreditCards = this.facilityCreditCards ? this.facilityCreditCards.substring(0, this.facilityCreditCards.length - 1) : null;
      })
  }

  getCredentials() {
    this.paymentService.getCCCredentials(this.processPayment.facId).subscribe((res) => {
      if (res !== null) {
        this.credentials = res.GatewayDetails ? JSON.parse(res.GatewayDetails) : null;
        this.paymentGateway = res.PaymentGateWay;
        if (this.paymentGateway == EPaymentGateway.Stripe) {
          this.stripePublishableKey = this.credentials.PublishableKey;
          this.StripeUnifiedAccountId = this.credentials.AccountId;
          this.enableAddressAutofill = this.credentials.EnableAddressAutofill;
        }
        this.setMandatoryFieldHostedPage();
        // Re-apply the Debit Card terminal-only filter (FR-7) now that paymentGateway and
        // credentials are known. getpaymentmodes() fires in parallel with
        // getCredentials() in ngOnInit, so the initial filter may have used paymentGateway=0.
        this.paymentGatewayResolved = true;
        this.applyDebitCardTerminalFilter();
      }
      else {
        this.paymentGatewayResolved = true;
        this.applyDebitCardTerminalFilter();
      }
    }, () => {
      this.paymentGatewayResolved = true;
      this.applyDebitCardTerminalFilter();
    })
  }

  /** Debit Card is available only when the active payment channel can submit through a terminal. */
  private applyDebitCardTerminalFilter(): void {
    if (!this.paymentGatewayResolved) {
      return;
    }

    // OpenEdge card-present payments run through the RCM (with or without facility terminal devices),
    // so Debit Card is available whenever RCM is configured and Debit Sale is not disabled.
    const hasTerminalDevice = this.paymentGateway == EPaymentGateway.TdBank
      || (this.paymentGateway == EPaymentGateway.OpenEdgeExpress
        && !!this.credentials?.RCMURL
        && !this.credentials.DISABLEDEBITSALE)
      || (this.paymentGateway == EPaymentGateway.Stripe
        && this.credentials
        && Array.isArray(this.credentials.DeviceSettings)
        && this.credentials.DeviceSettings.length > 0);

    if (!hasTerminalDevice && this.payModes) {
      this.payModes = this.payModes.filter((mode) => mode.PaymentModeId != EPaymentModes.DebitCard);
      this.resetRowsWithUnavailableDebitCard();
    }
  }

  /**
   * Payment modes load before credentials, so a row may have picked Debit Card before the filter above removed it.
   * Send such rows back to "Select" so they can't submit under a tender the facility doesn't support.
   */
  private resetRowsWithUnavailableDebitCard(): void {
    const debitRows = (this.paymentTable || []).filter(row => row.payModeId == EPaymentModes.DebitCard && !row.payComplete);
    if (!debitRows.length) {
      return;
    }
    // Remove only these rows' surcharge from the total so other contributions (e.g. another row's cash rounding) stay intact.
    const removedSurcharge = debitRows.reduce((sum, row) => sum + (row.surchargeFeeAmount || 0), 0);
    debitRows.forEach(row => {
      row.defaultmode = 0;
      row.payModeId = 0;
      row.surchargeFeeAmount = 0;
      row.surchargeFeePercentage = 0;
      row.surchargeLocked = false;
      row.payNowDisable = true;
    });
    this.totalAmount = this.totalAmount - removedSurcharge;
    this.recalculateRemainingAmount();
  }

  onAutoPay() {
    this.autoModalRef = this.modalService.show(this.autoPayPop, { class: 'modal-dialog-centered modal-xl', backdrop: 'static', keyboard: false });
  }

  isPaymentModeRefundAllowedDiffFacility(facilityId, paymentMode) {
    if ((this.userSessionService.isCallcenterAgent && !(paymentMode == EPaymentModes.HostedPage || paymentMode == EPaymentModes.ACH || paymentMode == EPaymentModes.CardOnfile || paymentMode == EPaymentModes.ACHOnFile)) || ((!this.userSessionService.isCallcenterAgent && (this.userSessionService.userSessionData.LastAccessedStoreId != facilityId))
      && !(paymentMode == EPaymentModes.CreditCard || paymentMode == EPaymentModes.HostedPage || paymentMode == EPaymentModes.ACH || paymentMode == EPaymentModes.CardOnfile || paymentMode == EPaymentModes.ACHOnFile))) {
      return false;
    }
    return true;
  }

  private initPaymentModes() {
    if (this.processPayment.Type == EPaymentOrigin.Reservation) {
      this.getpaymentmodes(this.facilityId, ELOV_TransactionTypes.Reservation);
    } else if (this.processPayment.Type == EPaymentOrigin.Merchandise) {
      this.getpaymentmodes(this.facilityId, ELOV_TransactionTypes.Merchandise);
    } else {
      this.getpaymentmodes(this.facilityId, ELOV_TransactionTypes.Rental);
    }
  }

  getpaymentmodes(facilityId, transactionType) {
    this.paymentService.GetFacilityPaymentModes(facilityId, transactionType).subscribe((res: IPaymentMode[]) => {
      if (!this.viewRightOfflinePayment) {
        let index = res.findIndex(ele => ele.PaymentModeId == EPaymentModes.ManualAuthorization);
        if (index !== -1) {
          res.splice(index, 1);
        }
      }
      this.payModes = res;
      this.payModes = this.payModes.filter((ele) => ![EPaymentModes.CashApp, EPaymentModes.ApplePay, EPaymentModes.GooglePay].includes(ele.PaymentModeId))
      // Debit Card is terminal-only (FR-7, UX-DR8). Best-effort filter here using whatever
      // paymentGateway is available at this point; getCredentials() re-runs the definitive filter
      // (via applyDebitCardTerminalFilter) after gateway and device settings are fully resolved.
      this.applyDebitCardTerminalFilter();
      if (this.paymentGateway == EPaymentGateway.Stripe) {
        if (this.countryId == ECountries.UnitedStatesOfAmerica) {
          this.payModes = this.payModes.filter((ele) => ![EPaymentModes.DirectDebitEFT, EPaymentModes.DirectDebitEFTOnFile, EPaymentModes.EFTManualAuthorization].includes(ele.PaymentModeId))
        } else if (this.countryId == ECountries.Canada) {
          this.payModes = this.payModes.filter((ele) => ![EPaymentModes.ACH, EPaymentModes.ACHOnFile, EPaymentModes.ACHManualAuthorization].includes(ele.PaymentModeId))
        }
      }
      this.defaultmode = 0;
      const temp = {
        PaymentModeId: 0,
        PaymentModeName: 'Select',
        DeleteFlag: false
      };
      this.payModes.unshift(temp);

      const cashPaymentModeExist = this.payModes.findIndex(mode => mode.PaymentModeId == EPaymentModes.Cash) == -1 ? false : true;
      if (this.processPayment.AmountTobePaid == 0 && cashPaymentModeExist) {
        this.defaultmode = 1;
        this.currentPayModeId = 1;
        this.paymentTable.find(o => o.payId === 1).defaultmode = 1;
        this.paymentTable.find(o => o.payId === 1).payModeId = 1;
        this.paymentTable.find(o => o.payId === 1).payNowDisable = false;
        this.applySurchargeFeeForRow(1, 1);
      }
      if (this.paymentSetting && this.paymentSetting.DefaultToCash && cashPaymentModeExist &&
        !(([EPaymentOrigin.MakePayment, EPaymentOrigin.MoveOut, EPaymentOrigin.Transfer, EPaymentOrigin.ReInstate].includes(this.processPayment.Type)) && this.processPayment.facId != this.lastAccessedFacility)) {
        this.defaultmode = 1;
        this.currentPayModeId = 1;
        this.paymentTable.find(o => o.payId === 1).defaultmode = 1;
        this.paymentTable.find(o => o.payId === 1).payModeId = 1;
        this.paymentTable.find(o => o.payId === 1).payNowDisable = false;
        this.applySurchargeFeeForRow(1, 1);
        // A surcharge row is already cash-rounded last (on base + surcharge + charity) by applySurchargeFeeForRow.
        if(this.EnableCashRounding && !this.paymentTable.find(o => o.payId === 1).surchargeLocked){
        this.paymentTable.find(o => o.payId === 1).payAmount = this.CalculateRoundedCashAmount(this.paymentTable.find(o => o.payId === 1).payAmount,1,true);
        if(this.RoundingOption == ECashRoundingOption.RoundUp || (this.RoundingOption == ECashRoundingOption.Round && this.paymentTable.find(o => o.payId === 1).roundingvalue > 0)){
          this.totalAmount = this.paymentTable.find(o => o.payId === 1).payAmount;
        }
        else if (this.RoundingOption == ECashRoundingOption.RoundDown || (this.RoundingOption == ECashRoundingOption.Round && this.paymentTable.find(o => o.payId === 1).roundingvalue < 0)){
          this.totalAmount = this.originalTotalAmount;
          this.remainingAmount = this.totalAmount -this.paymentTable.reduce((sum, x) => sum + x.payAmount, 0)
        }
      }
      }
      const hostedPagePaymentModeExist = this.payModes.findIndex(mode => mode.PaymentModeId == EPaymentModes.HostedPage) == -1 ? false : true;
      if (this.userSessionService.isCallcenterAgent && hostedPagePaymentModeExist) {
        this.defaultmode = 5;
        this.currentPayModeId = 5;
        this.paymentTable.find(o => o.payId === 1).defaultmode = 5;
        this.paymentTable.find(o => o.payId === 1).payModeId = 5;
        this.paymentTable.find(o => o.payId === 1).payNowDisable = false;
        this.applySurchargeFeeForRow(1, 5);
      }
      if (!this.isPaymentModeRefundAllowedDiffFacility(facilityId, this.defaultmode)) {
        this.defaultmode = 0;
        this.paymentTable.find(o => o.payId === 1).defaultmode = 0;
      }
    });
  }

  callTdVoid(paymentTrnsId) {
    let initiatingVoid = this.multiPaymentVoidEmv.find(t => t.isEmvVoidInitiated == false);
    let isNewTdArchiFac = this.paymentGateway == EPaymentGateway.TdBank && (this.tdLocalHostArchitectureFacilities.find(fac => fac == this.processPayment.facId) || this.enableNewPaymentArchitecture) ? true : false;
    if (initiatingVoid) {
      if (!this._isMismatchVoid) { this.showLoaderMesage = true; }
      let voidAmount = initiatingVoid['processedCC'].Amount;
      let CCTModel = this.generateIntialCCT(voidAmount, EPaymentTransactionType.Reversal_Refund, paymentTrnsId, initiatingVoid.payModeId, 'VOID', initiatingVoid['processedCC'].CreditCardNumber, initiatingVoid['processedCC'].AuthorizationCode, initiatingVoid['processedCC'].OrderId, isNewTdArchiFac, initiatingVoid.payId);
      this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
        if (res.Success) {
          let cctId = res.Id;
          if (isNewTdArchiFac) {
            this.loaderIcon = Promise.resolve(true);
            let isTdVoidTransactionCompleted = false;
            const obj = {
              OrderId: cctId,
              Amount: voidAmount,
              AuthorizationCode: initiatingVoid['processedCC'].AuthorizationCode,
              CreditCardNumber: initiatingVoid['processedCC'].CreditCardNumber.substr(-4),
              TransactionType: "VOID",
              InvoiceNumberForTDVoid: initiatingVoid['processedCC'].OrderId,
              UserId: this.userSessionService.userSessionData.UserId
            }
            this.showLoaderMesage = false;
            this.isTDEmv.isTransactionWaitTime = true;
            let initiateVoid = this.paymentService.InitiateTDPayment(obj, this.credentials.URLforLocalHost).subscribe((res) => {
              if (res) {
                this.isTDEmv.isTransactionWaitTime = false;
                isTdVoidTransactionCompleted = true;
                this.multiPaymentVoidEmv.find(t => t.orderId == initiatingVoid['processedCC'].OrderId).isEmvVoidInitiated = true;
                if (res.ResponseCode == "000") {
                  const CCModel = {
                    Amount: voidAmount,
                    Autopay: false,
                    PaymentModeId: EPaymentModes.CreditCard,
                    AutoCcProcessingDay: 0,
                    CreditCardNumber: !res && res.CreditCardNumber == undefined ? 0 : res.CreditCardNumber,
                    CreditCardType: res && res.CreditCardType ? res.CreditCardType : ECreditCards.Visa,
                    NameonCard: res.NameonCard ? res.NameonCard : " ",
                    CreditCardExpiryMonth: res && res.CreditCardExpiryMonth == 264 && res.CreditCardExpiryYear != 0 ? this.getExpiryMonthValue(parseInt(res.CreditCardExpiryMonth, 10)) : 275,
                    CreditCardExpiryYear: (res == null || !parseInt(res.CreditCardExpiryYear, 10)) ? 2099 : parseInt(res.CreditCardExpiryYear, 10),
                    CreditCardBillingAddress: '',
                    CreditCardBillingZip: '',
                    SwipeTransaction: false,
                    SecurityCodeSent: false,
                    AuthorizationCode: res && res.AuthorizationCode ? res.AuthorizationCode : " ",
                    ResponseCode: res && res.ResponseCode ? res.ResponseCode : "",
                    Reason: res && res.Reason ? res.Reason : "Approved!",
                    PaymentAccountid: '',
                    CcInfoPurged: false,
                    DebitCardPayment: res && res.DebitCardPayment ? true : false,
                    OfflinePayment: 0,
                    PaymentTransactionTypeId: paymentTrnsId,
                    TransactionDateTime: new Date(),
                    TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
                    OrderId: cctId,
                    CCBatchNumber: res && res.CCBatchNumber ? res.CCBatchNumber : null,
                    EmvReceiptText: res && res.EmvReceiptText ? res.EmvReceiptText : null,
                    FacilityId: this.processPayment.facId,
                    TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
                    TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                    LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null
                  };
                  this.paymentService.saveCCTransaction(Object.assign(CCModel)).subscribe((res: any) => { });
                  this.toastr.success(`Refund Processed Successfully - $${initiatingVoid['processedCC'].Amount}`, 'Success', this.toasterConfig);
                } else {
                  this.tdEmvFailedResponse(voidAmount, res, this.currentPayId, cctId, paymentTrnsId, "VOID");
                  this.toastr.error(`Failed to Reverse the Payment - $${initiatingVoid['processedCC'].Amount}`, 'Failure', this.toasterConfig);
                }
              } else {
                this.isTDEmv.isTransactionWaitTime = false;
                isTdVoidTransactionCompleted = true;
                res['ResponseCode'] = '050';
                res['Amount'] = initiatingVoid['processedCC'].Amount;
                const exceptionMessage = {
                  Reason: 'Declined!',
                  ResponseCode: 50
                }
                this.tdEmvFailedResponse(voidAmount, exceptionMessage, this.currentPayId, cctId, paymentTrnsId, "VOID");
                this.toastr.error(`Failed to Reverse the Payment - $${initiatingVoid['processedCC'].Amount}`, 'Failure', this.toasterConfig);
                this.loaderIcon = Promise.resolve(false);
              }
              if (this.multiPaymentVoidEmv.some(function (ele) { return (ele.isEmvVoidInitiated == false); })) {
                this.callTdVoid(paymentTrnsId);
              } else {
                this.loaderIcon = Promise.resolve(false);
                this.paymentStarted = false;
                this.isTDEmv.isTransactionWaitTime = false;
                if (!this.voidOnCancelInitiated && !this._isMismatchVoid) {
                  this.isCancel.emit(true);
                }
              }
            }, err => {
              this.isTDEmv.isTransactionWaitTime = false;
              this.loaderIcon = Promise.resolve(false);
              isTdVoidTransactionCompleted = true;
              if (err.error && err.error.text && (err.error.text.includes('Could not find file') || err.error.text.includes('does not exist'))) { //COM port doesn't exist
                this.toastr.warning(`${err.error.text}`, 'Alert', this.toasterConfig);
              } else if (!err.error.text) {
                this.toastr.warning('Please ask Administrator to configure TD Service', 'Alert', this.toasterConfig);
              }
              this.toastr.error(`Failed to Reverse the Payment - $${initiatingVoid['processedCC'].Amount}`, 'Failure', this.toasterConfig);
              const exceptionMessage = {
                Reason: err.error && err.error.text ? err.error.text : 'Declined!',
                ResponseCode: 50
              }
              if (err.error && err.error.text == 'Another Payment is in progress.') {
                this.toastr.warning('Another Payment is in progress, Please try after sometime.', 'Alert', this.toasterConfig);
                this.isTDEmv.isPortClosingWaitTime = true;
                this.loaderIcon = Promise.resolve(true);
                setTimeout(() => {
                  const obj = {
                    OrderId: cctId,
                    Amount: voidAmount,
                    AuthorizationCode: "0",
                    CreditCardNumber: "0",
                    TransactionType: "RCLT",
                    UserId: this.userSessionService.userSessionData.UserId
                  }
                  this.tdEmvFailedResponse(voidAmount, exceptionMessage, this.currentPayId, cctId, paymentTrnsId, "VOID");
                  this.paymentService.InitiateTDPayment(obj, this.credentials.URLforLocalHost).subscribe((recallRes) => { });
                  this.isTDEmv.isPortClosingWaitTime = false;
                  this.loaderIcon = Promise.resolve(false);
                }, 10000 * 6 * this.paymentMaxWaitTime);
              } else {
                this.tdEmvFailedResponse(voidAmount, exceptionMessage, this.currentPayId, cctId, paymentTrnsId, "VOID");
                this.loaderIcon = Promise.resolve(false);
              }
            });
            //if Port Disconnected or Device Turn off case
            setTimeout(() => {
              if (!isTdVoidTransactionCompleted) {
                initiateVoid.unsubscribe();
                this.toastr.error(`Failed to Reverse the Payment - $${initiatingVoid['processedCC'].Amount}`, 'Failure', this.toasterConfig);
                this.toastr.warning('Please Contact Administrator to check in Gateway Portal if Payment is Approved. If Yes, key in the Payment as Manual Authorization', 'Alert', this.toasterConfig);
                res['ResponseCode'] = '050';
                res['Amount'] = initiatingVoid['processedCC'].Amount;
                this.tdEmvFailedResponse(voidAmount, null, this.currentPayId, cctId, paymentTrnsId, "VOID");
                this.isTDEmv.isTransactionWaitTime = false;
                this.loaderIcon = Promise.resolve(false);
              }
            }, 10000 * 6 * this.paymentMaxWaitTime);

          } else {
            this.initiatedVoidCC = true;
            if (!this.subVoidTd) {
              let intervalTime = this.paymentGetCCTStatusInterval * 1000;
              const source = interval(intervalTime);
              this.subVoidTd = source.subscribe(val => this.getCCTVoidStatus(cctId, 0, val, initiatingVoid['processedCC'].Amount, initiatingVoid['processedCC'].OrderId, paymentTrnsId));
            }
          }
        }
      });
    }

  }

  callOpenEdgeVoid(paymentTrnsId) {
    var initiatingVoid = this.multiPaymentVoidEmv.find(t => t.isEmvVoidInitiated == false);
    if (initiatingVoid) {
      let CCTModel = this.generateIntialCCT(initiatingVoid['processedCC'].APPROVEDAMOUNT, EPaymentTransactionType.Reversal_Refund, paymentTrnsId, initiatingVoid.payModeId, null, null, null, null, false, initiatingVoid.payId);
      this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
        if (res.Success) {
          let orderId = res.Id;
          if (!this._isMismatchVoid) { this.showLoaderMesage = true; }
          let isVoidCompleted = false;
          const requestParam = "<REQUEST> " + "<XWEBID>" + this.credentials.XWEBID + "</XWEBID>" +
            "<XWEBTERMINALID>" + this.credentials.XWEBTERMINALID + "</XWEBTERMINALID>" +
            "<XWEBAUTHKEY>" + this.credentials.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
            "<TRANSACTIONTYPE>DEBITRETURN</TRANSACTIONTYPE><AMOUNT>" + initiatingVoid['processedCC'].APPROVEDAMOUNT + "</AMOUNT><ORDERID>" + res.UniqueTransId + "</ORDERID><OTK>" + res.UniqueTransId + "</OTK></REQUEST>";
          this.initiatedVoidCC = true;
          const rcmRequest = this.paymentService.getRCMService(this.credentials.RCMURL, requestParam).subscribe((res: any) => {
            if (res) {
              const resultFromRCM = res;
              let responseData: any;
              try {
                responseData = JSON.parse(resultFromRCM.RcmResponse);
              } catch { }
              if (!responseData?.RESPONSE) {
                // Unreadable: says nothing about whether the void happened. Leave isVoidCompleted false so the timeout
                // below runs the gateway status query, which settles it (incl. a pending mismatch alert).
                return;
              }
              isVoidCompleted = true;
              this.multiPaymentVoidEmv.find(t => t.orderId === initiatingVoid.orderId).isEmvVoidInitiated = true;
              let cTypeId = responseData && responseData.RESPONSE && responseData.RESPONSE.CARDBRAND ? this.paymentService.openEdgeCardType(responseData.RESPONSE.CARDBRAND) : ECreditCards.Visa;
              if (responseData.RESPONSE.RESULT == EOpenEdgeResponseCode.Approval) {
                const CCTModel = {
                  Amount: responseData.RESPONSE.APPROVEDAMOUNT,
                  Autopay: false,
                  paymentModeId: EPaymentModes.CreditCard,
                  AutoCcProcessingDay: 0,
                  CreditCardNumber: responseData.RESPONSE.ACCOUNT == undefined ? 0 : responseData.RESPONSE.ACCOUNT,
                  CreditCardType: cTypeId,
                  NameonCard: responseData.RESPONSE.CARDHOLDERNAME && responseData.RESPONSE.CARDHOLDERNAME.length > this.maxLengthNameOnCard ?
                    responseData.RESPONSE.CARDHOLDERNAME.substr(0, this.maxLengthNameOnCard) : responseData.RESPONSE.CARDHOLDERNAME,
                  CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(responseData.RESPONSE.EXPMONTH, 10)),
                  CreditCardExpiryYear: parseInt(responseData.RESPONSE.EXPYEAR, 10),
                  CreditCardBillingAddress: '',
                  CreditCardBillingZip: '',
                  SwipeTransaction: false,
                  SecurityCodeSent: false,
                  AuthorizationCode: responseData.RESPONSE.TRANSACTIONID,
                  ResponseCode: responseData.RESPONSE.HOSTRESPONSECODE,
                  Reason: responseData.RESPONSE.HOSTRESPONSEDESCRIPTION,
                  Key: '',
                  PaymentAccountid: '',
                  CcInfoPurged: false,
                  DebitCardPayment: responseData.RESPONSE.CARDTYPE == 'Credit' ? false : true,
                  OfflinePayment: 0,
                  PaymentTransactionTypeId: paymentTrnsId,
                  OrderId: orderId,
                  FacilityId: this.processPayment.facId,
                  TransactionDateTime: new Date(),
                  TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
                  TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                  LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
                  TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
                  EmvReceiptText: responseData.RESPONSE.RECEIPTTEXT ? responseData.RESPONSE.RECEIPTTEXT : null,
                  CCBatchNumber: responseData.RESPONSE.BATCHNO ? responseData.RESPONSE.BATCHNO : null
                };
                this.toastr.success(`Refund Processed Successfully - $${responseData.RESPONSE.APPROVEDAMOUNT}`, 'Success', this.toasterConfig);
                this.finishOpenEdgeMismatchVoid(initiatingVoid, true);
                this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
              } else {
                const CCTModel = {
                  Amount: responseData.RESPONSE && responseData.RESPONSE.APPROVEDAMOUNT ? responseData.RESPONSE.APPROVEDAMOUNT : initiatingVoid['processedCC'].APPROVEDAMOUNT,
                  Autopay: false,
                  paymentModeId: EPaymentModes.CreditCard,
                  AutoCcProcessingDay: 0,
                  CreditCardNumber: responseData.RESPONSE.ACCOUNT == undefined ? '0' : responseData.RESPONSE.ACCOUNT,
                  CreditCardType: cTypeId,
                  NameonCard: responseData.RESPONSE && responseData.RESPONSE.CARDHOLDERNAME && responseData.RESPONSE.CARDHOLDERNAME.length > this.maxLengthNameOnCard ?
                    responseData.RESPONSE.CARDHOLDERNAME.substr(0, this.maxLengthNameOnCard) : initiatingVoid['processedCC'].CARDHOLDERNAME,
                  CreditCardExpiryMonth: responseData.RESPONSE.EXPMONTH ? this.getExpiryMonthValue(parseInt(responseData.RESPONSE.EXPMONTH, 10)) : 275,
                  CreditCardExpiryYear: responseData.RESPONSE.EXPYEAR ? parseInt(responseData.RESPONSE.EXPYEAR, 10) : 2099,
                  CreditCardBillingAddress: '',
                  CreditCardBillingZip: '',
                  SwipeTransaction: false,
                  SecurityCodeSent: false,
                  AuthorizationCode: responseData.RESPONSE.TRANSACTIONID ? responseData.RESPONSE.TRANSACTIONID : '0',
                  ResponseCode: responseData.RESPONSE.RESULT,
                  Reason: responseData.RESPONSE.RESULTMSG ? responseData.RESPONSE.RESULTMSG : 'Declined',
                  Key: '',
                  PaymentAccountid: '',
                  CcInfoPurged: false,
                  DebitCardPayment: responseData.RESPONSE.CARDTYPE == 'Credit' ? false : true,
                  OfflinePayment: 0,
                  PaymentTransactionTypeId: paymentTrnsId,
                  OrderId: orderId,
                  FacilityId: this.processPayment.facId,
                  TransactionDateTime: new Date(),
                  TransactionTypeId: EPaymentTransactionType.Declined,
                  TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                  LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
                  TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
                  EmvReceiptText: responseData.RESPONSE.RECEIPTTEXT ? responseData.RESPONSE.RECEIPTTEXT : null,
                  CCBatchNumber: responseData.RESPONSE.BATCHNO ? responseData.RESPONSE.BATCHNO : null
                };
                this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
                this.toastr.error(`Failed to Reverse the Payment - $${initiatingVoid['processedCC'].APPROVEDAMOUNT}`, 'Failure', this.toasterConfig);
                this.finishOpenEdgeMismatchVoid(initiatingVoid, false);
              }
              if (this.multiPaymentVoidEmv.some(function (ele) { return (ele.isEmvVoidInitiated == false); })) {
                this.callOpenEdgeVoid(paymentTrnsId);
              } else {
                this.loaderIcon = Promise.resolve(false);
                this.showLoaderMesage = false;
                if (!this.voidOnCancelInitiated && !this._isMismatchVoid) {
                  this.isCancel.emit(true);
                }
              }
            }
          }, err => {
            if (initiatingVoid.openEdgeMismatchVoid) {
              // Unconfirmed: mark it attempted (no endless retry of the same row) and keep retry blocked in the alert.
              initiatingVoid.isEmvVoidInitiated = true;
              this.finishOpenEdgeMismatchVoid(initiatingVoid, false);
            }
            if (this.multiPaymentVoidEmv.some(function (ele) { return (ele.isEmvVoidInitiated == false); })) {
              this.callOpenEdgeVoid(paymentTrnsId);
            } else {
              if (!this.voidOnCancelInitiated && !this._isMismatchVoid) {
                this.isCancel.emit(true);
                this.toastr.error(`Failed to Reverse the Payment - $${initiatingVoid['processedCC'].APPROVEDAMOUNT}`, 'Failure', this.toasterConfig);
                this.multiPaymentVoidEmv.find(t => t.orderId === initiatingVoid.orderId).isEmvVoidInitiated = true;
                this.showLoaderMesage = false;
                this.loaderIcon = Promise.resolve(false);
                this.initiatedVoidCC = false;
              }
            }
          });
          setTimeout(() => {
            if (!isVoidCompleted) {
              rcmRequest.unsubscribe();
              // The gateway status query decides: a mismatch reversal stays pending until it reports (see the 'Void'
              // branches of initiatingOpenEdgeQueryPaymentRequest and saveCCTransactionFailureCase). It needs the row's
              // payId to find this void entry.
              this.openEdgeTransactionStatus(orderId, initiatingVoid.payId, 'Void', paymentTrnsId);
            }
          }, 10000 * 6 * this.paymentMaxWaitTime);
        } else {
          // No reversal record, so no gateway void was sent.
          this.finishOpenEdgeMismatchVoid(initiatingVoid, false);
        }
      }, () => this.finishOpenEdgeMismatchVoid(initiatingVoid, false));
    }
  }

  afterpaymentSuccess() {
    if (this.prePayStatus == 'Transaction') {
      this.paymentInProgress = false;
    }
    if (this.paymentSuccessFul) {
      this.paymentTable.find(o => o.payId === this.currentPayId).payComplete = true;
      this.paymentTable.find(o=> o.payId === this.currentPayId).payFailed = false;
    } else {
      this.paymentStarted = false;
    }
    this.tenderAmount = this.changeAmount = 0;
    if (!this.transactionInitiated && this.payModalRef) {
      this.payModalRef.hide();
    }
    let isCC = this.paymentTable.some(function (ele) {return (ele.payModeId != EPaymentModes.ManualAuthorization && [EPaymentModes.CreditCard, EPaymentModes.HostedPage, EPaymentModes.CardOnfile, EPaymentModes.DebitCard].includes(ele.payModeId))});
    this.appInsightsService.logPaymentEvent(isCC, `Go to Complete the paymnet. Show Print Receipt : ${this.showPrintEmailRcpt},
      Is Payment Successfull : ${this.paymentSuccessFul}, SSMSaveApiResponse : ${JSON.stringify(this.apiResponse)}`, { Gateway: this.paymentGateway, FacilityId : this.processPayment.facId, OrderId : this.getPaymentOrderId(), UserId : this.userSessionService.userSessionData.UserId});
    
      if (this.showPrintEmailRcpt && (this.paymentSuccessFul || this.partialPaySuccess)) {
      if (this.apiResponse.ReceiptId === undefined && this.apiResponse.Id === undefined) {
        this.goToComplete(2);
      } else if (this.apiResponse.Success) {
        this.afterShowConfirm.emit(true);
        if (this.isPrintChecked) {
          this.generateAsPdf(this.apiResponse.ReceiptId);
        } else {
          if ([EPaymentOrigin.MakePayment, EPaymentOrigin.Merchandise].includes(this.processPayment.Type)) {
            this.emitLoopPayment.emit(true);
          }
        }
      }
    }
    if (this.apiResponse.ReceiptId != undefined && !this.apiResponse.Success) {
      this.appInsightsService.logPaymentEvent(isCC, `Voiding the amount. Total amount paid : ${this.apiResponse.AmountPaid},`, { Gateway: this.paymentGateway, FacilityId : this.processPayment.facId,  OrderId : this.getPaymentOrderId(), UserId : this.userSessionService.userSessionData.UserId});
      this.loaderIcon = Promise.resolve(true);
      let paymentTrnsId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);

      //Checking Duplicate records which holds same gateway details
      this.paymentTable = this.paymentTable.filter((item, i, arr) => arr.findIndex((t) => t.orderId === item.orderId) === i);

      this.multiPaymentVoidEmv = [];
      if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress) {
        this.paymentTable.forEach((ele => {
          if ([EPaymentModes.CreditCard, EPaymentModes.DebitCard].includes(ele.payModeId) && ele['processedCC'] && this.isOpenEdgeDebitSale(ele)) {
            ele['isEmvVoidInitiated'] = false;
            this.multiPaymentVoidEmv.push(ele);
          } else {
            ele['isEmvVoidInitiated'] = true;
          }
        }));
        if (this.multiPaymentVoidEmv.length > 0) {
          this.callOpenEdgeVoid(paymentTrnsId);
        }
      } else if (this.paymentGateway == EPaymentGateway.TdBank) {
        this.paymentTable.forEach((ele => {
          if ([EPaymentModes.CreditCard, EPaymentModes.DebitCard].includes(ele.payModeId) && ele['processedCC']) {
            ele['isEmvVoidInitiated'] = false;
            this.multiPaymentVoidEmv.push(ele);
          } else {
            ele['isEmvVoidInitiated'] = true;
          }
        }));
        if (this.multiPaymentVoidEmv.length > 0) {
          this.callTdVoid(paymentTrnsId);
        }
      }

      if (this.apiResponse.AmountPaid && this.apiResponse.AmountPaid > 0) {
        this.paymentTable.map(ele => {
          if (this.paymentGateway == EPaymentGateway.Stripe) {
            let paymentData = [EPaymentModes.CreditCard, EPaymentModes.HostedPage, EPaymentModes.CardOnfile, EPaymentModes.DebitCard].includes(ele.payModeId) == true ? ele['processedStripeCC'] : ele['processedACH'];
            this.cancelPaymentIntent(paymentData, ele.payAmount, paymentTrnsId, ele.payModeId);
          } else {
            if ([EPaymentModes.CreditCard, EPaymentModes.DebitCard].includes(ele.payModeId) && ele.isEmvVoidInitiated && this.paymentGateway == EPaymentGateway.TdBank) {
              this.showLoaderMesage = true;
              this.loaderIcon = Promise.resolve(true);
              let amount = this.paymentTable.find(o => o.payId == ele.payId)['processedCC'].Amount;
              let cardNumber = this.paymentTable.find(o => o.payId == ele.payId)['processedCC'].CreditCardNumber;
              let auth = this.paymentTable.find(o => o.payId == ele.payId)['processedCC'].AuthorizationCode;
              let voidOrderId = this.paymentTable.find(o => o.payId == ele.payId)['processedCC'].OrderId;
              let CCTModel = this.generateIntialCCT(amount, EPaymentTransactionType.Reversal_Refund, paymentTrnsId, ele.payModeId, 'VOID', cardNumber, auth, voidOrderId, false, ele.payId);
              let obj = this.paymentTable.find(o => o.payId == ele.payId).processedCC;
              if (obj) {
                this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
                  if (res.Success) {
                    let cctId = res.Id;
                    this.initiatedVoidCC = true;
                    if (!this.subVoidTd) {
                      let intervalTime = this.paymentGetCCTStatusInterval * 1000;
                      const source = interval(intervalTime);
                      this.subVoidTd = source.subscribe(val => this.getCCTVoidStatus(cctId, ele.payId, val, amount, voidOrderId, paymentTrnsId));
                    }
                  }
                });
              }
            } else if ([EPaymentModes.HostedPage, EPaymentModes.CardOnfile, EPaymentModes.CreditCard, EPaymentModes.DebitCard].includes(ele.payModeId) && ele.isEmvVoidInitiated && this.paymentGateway == EPaymentGateway.OpenEdgeExpress) {
              let amount = ele.payAmount;
              var voidPaymentUniqueId = this.paymentTable.find(o => o.payId == ele.payId).uniqueTransId;
              let CCTModel = this.generateIntialCCT(amount, EPaymentTransactionType.Reversal_Refund, paymentTrnsId, ele.payModeId, null, null, null, voidPaymentUniqueId, false, ele.payId);
              this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
                this.voidCCCNP(ele.payId, res.Id, ele.payModeId, paymentTrnsId);
              });
            } else if ([EPaymentModes.HostedPage, EPaymentModes.CardOnfile].includes(ele.payModeId) && ele.isEmvVoidInitiated && this.paymentGateway == EPaymentGateway.TdBank) {
              let amount = this.paymentTable.find(o => o.payId == ele.payId)['processedTDCC'].trnAmount;
              let transactionId = ele.payModeId == EPaymentModes.HostedPage ? this.paymentTable.find(o => o.payId == ele.payId)['processedTDCC'].trnId : this.paymentTable.find(o => o.payId == ele.payId)['processedCC'].AuthorizationCode;
              let CCTModel = this.generateIntialCCT(amount, EPaymentTransactionType.Reversal_Refund, paymentTrnsId, ele.payModeId, null, null, null, null, false, ele.payId);
              this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
                this.voidTdPayment(res.Id, ele.payModeId, amount, transactionId, paymentTrnsId);
              });
            } else if (ele.payModeId == EPaymentModes.ManualAuthorization && ele.isEmvVoidInitiated) {
              this.isCancel.emit(true);
              let amount = this.paymentTable.find(o => o.payId == ele.payId).payAmount;
              let ccNo = this.paymentTable.find(o => o.payId == ele.payId).ManualCardNumber;
              let ccExpiry = this.paymentTable.find(o => o.payId == ele.payId).ManualCardExp;
              let ccName = this.paymentTable.find(o => o.payId == ele.payId).ManualCardName;
              let creditCardType = this.paymentTable.find(o => o.payId == ele.payId).CreditCardType;
              let authrizationCode = this.paymentTable.find(o => o.payId == ele.payId).ManualCardAuthorization;
              let CCTModel = this.manulAuthorizationCCT(amount, ccNo, ccName, creditCardType, authrizationCode, ccExpiry, paymentTrnsId, ele.payModeId);
              this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
                this.showLoaderMesage = false;
                this.loaderIcon = Promise.resolve(false);
              });
            } else if ([EPaymentModes.ACH, EPaymentModes.ACHOnFile, EPaymentModes.DirectDebitEFT, EPaymentModes.DirectDebitEFTOnFile].includes(ele.payModeId) && ele.isEmvVoidInitiated) {
              let achModel = this.generateIntialACH(ele.payAmount, EPaymentTransactionType.Reversal_Refund, paymentTrnsId, ele.payModeId);
              this.paymentService.saveACHTransaction(achModel).subscribe((res) => {
                const achIntOrderId = res.Id;
                this.paymentService.GetACHVoid(this.achSettingPaymentGateway, ele['processedACH'].TRANSACTIONID).subscribe((res: any) => {
                  if (res) {
                    const respose = JSON.parse(res);
                    respose.RESULT['AchIntOrderId'] = achIntOrderId;
                    this.loaderIcon = Promise.resolve(false);
                    this.saveAchTransactions(respose.RESULT, paymentTrnsId, EACHCheckResultCode.CheckApproval && respose.RESULT.RESPONSEDESCRIPTION == "Check Approval: Transaction voided" ? EPaymentTransactionType.Reversal_Refund : EPaymentTransactionType.Declined, null, ele.payId);
                    this.isCancel.emit(true);
                  }
                }, err => {
                  this.loaderIcon = Promise.resolve(false);
                  this.saveAchTransactions(null, paymentTrnsId, 'Declined!', null, ele.payId);
                });
              });

            } else {
              if (this.multiPaymentVoidEmv.length == 0) {
                this.loaderIcon = Promise.resolve(false);
                this.isCancel.emit(true); // For other payment modes(Cash)
                this.showLoaderMesage = false;
              }
            }
            this.toastr.success('Refund is Initiated', 'Success', this.toasterConfig);
          }
        });
      } else {
        this.isCancel.emit(true);
        this.showLoaderMesage = false;
        this.loaderIcon = Promise.resolve(false);
      }
    }
  }

  requestGatewaydetails(paymentModeId?: number, payId?: number) {
    if (this.credentials) {
      const effectivePayId = payId ?? this.currentPayId;
      if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress) {
        // Facility eligibility alone isn't enough — only HostedPage rows are actually processed
        // via the embedded PayFields sale; other OpenEdge modes must keep legacy XWEB details so
        // reversal correctly routes them through GetCNPCreditVoid instead of CallPayFieldReversal.
        const effectiveRow = this.paymentTable.find(o => o.payId === effectivePayId);
        const effectivePayModeId = paymentModeId ?? effectiveRow?.payModeId;
        // Prefer this row's own verified payFieldPayment fact (set only once its sale actually
        // completed via PayFields) over the facility's CURRENT setting — this value gets persisted
        // as the CCT's GatewayDetails and is what a later reversal (even in another session) reads
        // back, so it must reflect what really happened for this row, not today's live config.
        const isPayFieldRow = typeof effectiveRow?.['payFieldPayment'] === 'boolean'
          ? effectiveRow['payFieldPayment']
          : this.canUseOpenEdgePayFieldsRuntime();
        if (isPayFieldRow && (effectivePayModeId === EPaymentModes.HostedPage ||
          (effectivePayModeId === EPaymentModes.CardOnfile && effectiveRow?.['payFieldPayment'] === true))) {
          this.requestgatewaydetails = {
            PayFieldReferenceVersion: 2,
            // Same shape AddOn persists (MakePaymentController.SavePayFieldPaymentDetails).
            XWebId: this.credentials.PAYFIELDSXWEBID,
            XWebTerminalId: this.credentials.PAYFIELDSXWEBTERMINALID,
            XWebAuthKey: this.credentials.PAYFIELDSXWEBAUTHKEY,
            PayField: true,
            Environment: this.getPayFieldsEnvironment(),
            Region: this.getPayFieldRegion(),
            ApiSecret: this.getPayFieldsTransactionsApiSecret()
          }
        } else {
          this.requestgatewaydetails = {
            XWEBID: this.credentials.XWEBID,
            XWEBTERMINALID: this.credentials.XWEBTERMINALID,
            XWEBAUTHKEY: this.credentials.XWEBAUTHKEY,
            QueryPaymentStatusURL: this.credentials.QueryPaymentStatusURL
          }
        }
      } else if (this.paymentGateway == EPaymentGateway.TdBank) {
        this.requestgatewaydetails = {
          MerchantId: this.credentials.MerchantId,
          PassCode: this.credentials.PassCode,
          URLforPaymentTD: this.credentials.URLforPaymentTD
        }
      } else {
        this.requestgatewaydetails = {
          CompletePaymentDuringDayEnd: this.credentials.CompletePaymentDuringDayEnd,
          AccountId: this.credentials.AccountId,
          SecretKey: this.credentials.SecretKey,
          ReaderId: this.paymentTable.find(o => o.payId === effectivePayId)?.TerminalDeviceId
        }
      }
      this.requestgatewaydetails = JSON.stringify(this.requestgatewaydetails);
    } else {
      this.requestgatewaydetails = null;
    }
  }

  private toBoolean(value: any): boolean {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') return value.toLowerCase() === 'true';
    return !!value;
  }

  private isOpenEdgePayFieldPaymentEnabled(): boolean {
    if (this.paymentGateway !== EPaymentGateway.OpenEdgeExpress || !this.credentials) {
      return false;
    }
    // EnablePayFieldPayment is the authoritative bit written by Admin Settings (Story 1.1).
    // Falls back to the legacy EnabledPayFieldPayment key (pre-rename) so facilities that haven't
    // re-saved their settings yet aren't silently disabled client-side, mirroring the same fallback
    // already applied server-side in EdgeExpressBusiness.IsPayFieldsEnabled.
    return this.toBoolean(this.credentials.EnablePayFieldPayment ?? this.credentials.EnabledPayFieldPayment);
  }

  private getPayFieldsEnvironment(): string {
    const raw = ([this.credentials?.PayFieldEnvironment, this.credentials?.PayFieldModeAddOn, this.credentials?.Environment]
      .find((value) => this.hasCredentialValue(value)) ?? 'test').toString().trim().toLowerCase();
    if (['local', 'dev', 'pqa', 'qa', 'test', 'prod'].includes(raw)) {
      return raw;
    }
    if (raw === 'production') {
      return 'prod';
    }
    if (raw === 'sandbox') {
      return 'test';
    }
    return 'test';
  }

  private getPayFieldsTokenizationApiKey(): string {
    return [this.credentials?.PayFieldsAPIKey, this.credentials?.PayFieldApiKey]
      .find((value) => this.hasCredentialValue(value)) ?? '';
  }

  // Mirrors ResolvePayFieldGatewayDetails's ApiKey/ApiSecret fallback chain server-side. Uses
  // hasCredentialValue per-candidate (not ||) so a whitespace-only value doesn't shadow a real fallback.
  private getPayFieldsTransactionsApiKey(): string {
    return [this.credentials?.ApiKey, this.credentials?.PayFieldApiKey, this.credentials?.PAYFIELDSTRANSACTIONSAPIKEY]
      .find((v) => this.hasCredentialValue(v)) ?? '';
  }

  private getPayFieldsTransactionsApiSecret(): string {
    return [this.credentials?.ApiSecret, this.credentials?.PayFieldApiSecret, this.credentials?.PAYFIELDSTRANSACTIONSAPISECRET]
      .find((v) => this.hasCredentialValue(v)) ?? '';
  }

  private getPayFieldsIntegrationUrl(): string {
    return [this.credentials?.PAYFIELDSAPIIntegrationURL, this.credentials?.PayFieldIntegrationURL]
      .find((v) => this.hasCredentialValue(v)) ?? '';
  }

  // Uses hasCredentialValue per-candidate (not ||) so a whitespace-only value doesn't shadow a real fallback.
  private getPayFieldRegion(): string {
    return ([this.credentials?.PayFieldMerchantCountry, this.credentials?.Region, this.credentials?.PayFieldRegion]
      .find((v) => this.hasCredentialValue(v)) ?? '').toString();
  }

  // Mirrors EdgeExpressBusiness.ResolvePayFieldCurrencyCode's configured-code-then-region fallback so
  // the embedded modal shows the same currency the backend actually charges in, not a hardcoded "$".
  protected getPayFieldCurrencySymbol(): string {
    const configuredCurrencyCode = ([this.credentials?.PayFieldCurrencyCode, this.credentials?.CurrencyCode, this.credentials?.PayFieldCurrency, this.credentials?.Currency]
      .find((v) => this.hasCredentialValue(v)) ?? '').toString().trim();
    if (configuredCurrencyCode === '124') {
      return 'C$';
    }
    if (configuredCurrencyCode === '840') {
      return '$';
    }

    const configuredCountryCode = ([this.credentials?.PayFieldCountryCode, this.credentials?.CountryCode, this.credentials?.PayFieldTransactionCountryCode]
      .find((v) => this.hasCredentialValue(v)) ?? '').toString().trim().toUpperCase();
    if (configuredCountryCode === '124' || configuredCountryCode === 'CA' || configuredCountryCode === 'CAN' || configuredCountryCode === 'CANADA') {
      return 'C$';
    }
    if (configuredCountryCode === '840' || configuredCountryCode === 'US' || configuredCountryCode === 'USA' || configuredCountryCode === 'UNITED STATES') {
      return '$';
    }

    const region = this.getPayFieldRegion().toString().trim().toUpperCase();
    return (region === '124' || region === 'CA' || region === 'CAN' || region === 'CANADA') ? 'C$' : '$';
  }

  private canUseOpenEdgePayFieldsRuntime(): boolean {
    if (!this.isOpenEdgePayFieldPaymentEnabled()) {
      return false;
    }
    return this.hasCredentialValue(this.credentials?.PAYFIELDSXWEBID)
      && this.hasCredentialValue(this.credentials?.PAYFIELDSXWEBTERMINALID)
      && this.hasCredentialValue(this.credentials?.PAYFIELDSXWEBAUTHKEY)
      && this.hasCredentialValue(this.getPayFieldsIntegrationUrl())
      && this.hasCredentialValue(this.getPayFieldsTransactionsApiKey())
      && this.hasCredentialValue(this.getPayFieldsTransactionsApiSecret())
      && this.hasCredentialValue(this.getPayFieldsTokenizationApiKey());
  }

  // Angular's Validators.required accepts a whitespace-only string; coerce non-string values safely too.
  private hasCredentialValue(value: any): boolean {
    return !!(value ?? '').toString().trim();
  }

  private logPayFieldsDebug(step: string, payload?: any): void {
    try {
      const context = {
        step,
        requestId: this.payFieldsRequestId,
        currentPayId: this.currentPayId,
        orderId: this.getPaymentOrderId(),
        facilityId: this.processPayment?.facId,
        payload
      };
      this.appInsightsService.logPaymentEvent(
        true,
        `PayFields debug - ${step}`,
        { Gateway: this.paymentGateway, FacilityId: this.processPayment?.facId, OrderId: this.getPaymentOrderId(), UserId: this.userSessionService.userSessionData?.UserId, Context: JSON.stringify(context) }
      );
    } catch (error) {
      this.appInsightsService.logException(error instanceof Error ? error : new Error('Failed to log PayFields debug event'));
    }
  }

  private routeOpenEdgeHostedModePayment(amount: any, payId: number, cctStatusOrderId: number): void {
    this.logPayFieldsDebug('routeOpenEdgeHostedModePayment:start', {
      payId,
      amount,
      canUsePayFieldsRuntime: this.canUseOpenEdgePayFieldsRuntime(),
      payFieldsEnabled: this.isOpenEdgePayFieldPaymentEnabled(),
      hasCardNotPresentUrl: !!this.credentials?.CardNotPresentURL,
      hasPayFieldsApiIntegrationUrl: !!this.credentials?.PAYFIELDSAPIIntegrationURL
    });

    this.tempCNPAmount = amount;
    this.tempCNPPayId = payId;
    this.cctStatusOrderId = cctStatusOrderId;

    if (this.canUseOpenEdgePayFieldsRuntime()) {
      this.appInsightsService.logPaymentEvent(
        true,
        `OpenEdge PayField settings detected. Rendering embedded PayFields form. OrderId: ${this.paymentTable.find(o => o.payId == payId)?.orderId}`,
        { Gateway: this.paymentGateway, FacilityId: this.processPayment.facId, OrderId: this.getPaymentOrderId(), UserId: this.userSessionService.userSessionData.UserId }
      );
      this.currentPayId = payId;
      this.paymentTable.find(o => o.payId === payId).EnableAutopayOrCardOnFile = 'cancel';
      this.openPayFieldsEmbeddedForm(amount, payId);
    } else {
      this.appInsightsService.logPaymentEvent(
        true,
        `OpenEdge PayField settings missing/ineligible. Routing HostedPage mode through legacy HostedPage runtime. OrderId: ${this.paymentTable.find(o => o.payId == payId)?.orderId}`,
        { Gateway: this.paymentGateway, FacilityId: this.processPayment.facId, OrderId: this.getPaymentOrderId(), UserId: this.userSessionService.userSessionData.UserId }
      );
      this.callCNP(amount, 'CREDITSALE', payId); // CNP is always CREDITSALE, Debit card is N/A
    }
  }

  private openPayFieldsEmbeddedForm(amount: number, payId: number): void {
    const activeElement = document.activeElement;
    this.payFieldsFocusOrigin = activeElement instanceof HTMLElement ? activeElement : null;
    this.showIFrame = false;
    this.showPage = true;
    this.showPayFieldsEmbeddedForm = true;
    document.body.classList.add('payfields-modal-open');
    this.paymentStarted = false;
    this.loaderIcon = Promise.resolve(false);
    this.isPayFieldsEmbeddedFormReady = false;
    this.payFieldsTokenizationResult = null;
    this.payFieldsPendingAmount = Number(amount);
    this.currentPayId = payId;
    this.isAutoPopulateBillingInfo = false;
    this.resetPayFieldsBillingDetails();
    setTimeout(() => {
      this.initializePayFieldsEmbeddedForm();
      this.initializePayFieldsFocusTrap();
    }, 0);
  }

  private initializePayFieldsFocusTrap(canRetry: boolean = true): void {
    const dialog = this.payFieldsDialog?.nativeElement;
    if (!dialog) {
      if (canRetry && this.showPayFieldsEmbeddedForm) {
        this.payFieldsFocusTrapRetryTimer = setTimeout(() => this.initializePayFieldsFocusTrap(false), 0);
      } else if (this.showPayFieldsEmbeddedForm) {
        this.logPayFieldsDebug('initializePayFieldsFocusTrap:dialog-not-rendered');
      }
      return;
    }
    this.payFieldsFocusTrap?.destroy();
    this.payFieldsFocusTrap = this.focusTrapFactory.create(dialog);
    this.payFieldsFocusTrap.focusInitialElementWhenReady();
  }

  // Focus trap keeps keyboard-only users inside the dialog, so Escape must be handled explicitly to let them cancel out.
  @HostListener('document:keydown.escape', ['$event'])
  onPayFieldsEscapeKeydown(event: KeyboardEvent): void {
    if (!this.showPayFieldsEmbeddedForm || this.paymentStarted) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.onhstPayBtn('Cancel');
  }

  private resetPayFieldsBillingDetails(): void {
    this.payFieldsBillingDetails.firstName = '';
    this.payFieldsBillingDetails.middleName = '';
    this.payFieldsBillingDetails.lastName = '';
    this.payFieldsBillingDetails.companyName = '';
    this.payFieldsBillingDetails.addressOne = '';
    this.payFieldsBillingDetails.addressTwo = '';
    this.payFieldsBillingDetails.city = '';
    this.payFieldsBillingDetails.postalCode = '';
    this.payFieldsBillingDetails.countryId = environment.defaultCountryId;
    this.payFieldsBillingDetails.stateId = 0;
    this.onCountryChange(this.payFieldsBillingDetails.countryId, 2);
  }

  private populatePayFieldsCustomerInfo(): void {
    if (!this.customerInfoPresent || !this.customerInfo) {
      return;
    }

    this.payFieldsBillingDetails.firstName = this.customerInfo.FirstName || '';
    this.payFieldsBillingDetails.middleName = this.customerInfo.MiddleName || '';
    this.payFieldsBillingDetails.lastName = this.customerInfo.LastName || '';
    this.payFieldsBillingDetails.companyName = this.customerInfo.CompanyName || '';
    this.payFieldsBillingDetails.addressOne = this.customerInfo.AddressOne || '';
    this.payFieldsBillingDetails.addressTwo = '';
    this.payFieldsBillingDetails.city = this.customerInfo.City || '';
    this.payFieldsBillingDetails.postalCode = this.customerInfo.PostalCode || '';
    this.payFieldsBillingDetails.countryId = this.customerInfo.CountryId || environment.defaultCountryId;
    this.payFieldsBillingDetails.stateId = this.customerInfo.StateId || 0;
    this.onCountryChange(this.payFieldsBillingDetails.countryId, 2);
  }

  onPayFieldsAutoPopulateChange(): void {
    if (this.isAutoPopulateBillingInfo) {
      this.populatePayFieldsCustomerInfo();
    } else {
      this.resetPayFieldsBillingDetails();
    }
  }

  private isPayFieldsEmbeddedCustomerInfoValid(): boolean {
    // != (not !==) is intentional: the native <select> stores the placeholder as the string '0',
    // and loose equality is what correctly coerces it to number 0 for this comparison.
    return !!(
      this.payFieldsMandatoryFieldsLoaded &&
      this.payFieldsBillingDetails.firstName?.trim() &&
      this.payFieldsBillingDetails.lastName?.trim() &&
      this.payFieldsBillingDetails.addressOne?.trim() &&
      this.payFieldsBillingDetails.city?.trim() &&
      this.payFieldsBillingDetails.countryId &&
      (this.emptyStateList ||
        (!this.payFieldsStateRequired && (!this.payFieldsBillingDetails.stateId || this.payFieldsBillingDetails.stateId == 0)) ||
        this.stateList?.some((item) => item.Id == this.payFieldsBillingDetails.stateId && item.Code?.trim())) &&
      this.payFieldsBillingDetails.postalCode?.trim()
    );
  }

  isPayFieldsEmbeddedPaymentDisabled(): boolean {
    return !this.isPayFieldsEmbeddedFormReady || this.paymentStarted || !this.isPayFieldsEmbeddedCustomerInfoValid()
      || !this.payFieldsCardValidity.number || !this.payFieldsCardValidity.expiration || !this.payFieldsCardValidity.cvv;
  }

  private resolvePayFieldsTokenValue(result: any): string | null {
    const candidates = [
      result?.temporary_token,
      result?.temporaryToken,
      result?.token,
      result?.paymentReference,
      result?.id,
      result?.response?.temporary_token,
      result?.response?.temporaryToken,
      result?.data?.temporary_token,
      result?.data?.temporaryToken,
      result?.data?.token
    ];

    for (const candidate of candidates) {
      if (!candidate) {
        continue;
      }

      if (typeof candidate === 'string') {
        const trimmed = candidate.trim();
        if (trimmed.length > 0) {
          return trimmed;
        }
        continue;
      }

      if (typeof candidate === 'object') {
        const nested = [
          candidate.temporary_token,
          candidate.temporaryToken,
          candidate.token,
          candidate.id,
          candidate.value,
          candidate.paymentReference
        ];

        for (const nestedCandidate of nested) {
          if (typeof nestedCandidate === 'string') {
            const nestedTrimmed = nestedCandidate.trim();
            if (nestedTrimmed.length > 0) {
              return nestedTrimmed;
            }
          }
        }
      }
    }

    return null;
  }

  private initializePayFieldsEmbeddedForm(): void {
    if (!this.showPayFieldsEmbeddedForm || this.payFieldsSecureForm) {
      return;
    }

    this.payFieldsSdkLoader.load()
      .then(() => this.buildPayFieldsEmbeddedForm())
      .catch((error) => {
        this.logPayFieldsDebug('initializePayFieldsEmbeddedForm:sdk-load-error', error);
        this.toastr.error('GlobalPayments SDK is not available.', 'PayFields Error', this.toasterConfig);
      });
  }

  private buildPayFieldsEmbeddedForm(): void {
    if (!this.showPayFieldsEmbeddedForm || this.payFieldsSecureForm) {
      return;
    }

    const tokenizationApiKey = this.getPayFieldsTokenizationApiKey();
    if (!tokenizationApiKey) {
      this.toastr.error('PayFields API key is missing in gateway settings.', 'PayFields Error', this.toasterConfig);
      return;
    }

    try {
      GlobalPayments.configure({
        'X-GP-Api-Key': tokenizationApiKey,
        'X-GP-Environment': this.getPayFieldsEnvironment()
      });

      this.payFieldsSecureForm = GlobalPayments.ui.form({
        fields: {
          'card-number': { target: '#payfields-card-number', placeholder: 'Card Number', required: true },
          'card-expiration': { target: '#payfields-card-expiration', placeholder: 'MM / YYYY', required: true },
          'card-cvv': { target: '#payfields-card-cvv', placeholder: 'CVV', required: true },
          submit: { target: '#payfields-submit-host', text: 'Submit' }
        },
        styles: {
          input: {
            border: '0px',
            outline: 'none',
            'box-shadow': 'none',
            background: 'transparent',
            'font-size': '14px',
            'font-family': 'Lato, sans-serif',
            color: '#2a2a2a',
            'line-height': '20px',
            'user-select': 'text'
          },
          'input:focus': {
            border: '0px',
            outline: 'none',
            'box-shadow': 'none'
          },
          '::placeholder': {
            color: '#6c757d'
          }
        }
      });

      this.payFieldsCardValidity = { number: false, expiration: false, cvv: false };
      this.payFieldsSecureForm.frames['card-number']?.on('card-number-test', (result: any) => {
        this.payFieldsCardValidity.number = result?.valid === true;
      });
      this.payFieldsSecureForm.frames['card-expiration']?.on('card-expiration-test', (result: any) => {
        this.payFieldsCardValidity.expiration = result?.valid === true;
      });
      this.payFieldsSecureForm.frames['card-cvv']?.on('card-cvv-test', (result: any) => {
        this.payFieldsCardValidity.cvv = result?.valid === true;
      });

      this.payFieldsSecureForm.ready(() => {
        this.isPayFieldsEmbeddedFormReady = true;
      });
      this.watchPayFieldsIframes();
    } catch (error) {
      this.logPayFieldsDebug('initializePayFieldsEmbeddedForm:error', error);
      this.toastr.error('Unable to initialize PayFields form.', 'PayFields Error', this.toasterConfig);
    }
  }

  // Rewrites the SDK's root-relative '/SecureSubmit.v1/...' iframe src to the PayFields CDN host,
  // scoped to the PayFields dialog only (not a global prototype patch) so no other iframe in the app is touched.
  private watchPayFieldsIframes(): void {
    const container = this.payFieldsDialog?.nativeElement;
    if (!container) {
      return;
    }
    const fixIframeSrc = (el: HTMLIFrameElement) => {
      if (el.src && el.src.startsWith(location.origin + '/SecureSubmit.v1/')) {
        el.src = el.src.replace(location.origin, 'https://js.paygateway.com');
      }
    };
    const fixIframesInNode = (node: Node) => {
      if (node instanceof HTMLIFrameElement) {
        fixIframeSrc(node);
      }
      if (node instanceof Element) {
        node.querySelectorAll('iframe').forEach((iframe: HTMLIFrameElement) => fixIframeSrc(iframe));
      }
    };
    fixIframesInNode(container);
    this.payFieldsIframeObserver?.disconnect();
    this.payFieldsIframeObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          fixIframesInNode(node);
        });
        if (mutation.type === 'attributes' && mutation.target instanceof HTMLIFrameElement) {
          fixIframeSrc(mutation.target);
        }
      }
    });
    this.payFieldsIframeObserver.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  }

  private disposePayFieldsEmbeddedForm(): void {
    this.payFieldsIframeObserver?.disconnect();
    this.payFieldsIframeObserver = null;
    document.body.classList.remove('payfields-modal-open');
    this.detachPayFieldsFormListeners();
    if (this.payFieldsFocusTrapRetryTimer) {
      clearTimeout(this.payFieldsFocusTrapRetryTimer);
      this.payFieldsFocusTrapRetryTimer = null;
    }
    this.payFieldsFocusTrap?.destroy();
    this.payFieldsFocusTrap = null;
    const focusOrigin = this.payFieldsFocusOrigin;
    this.payFieldsFocusOrigin = null;
    if (focusOrigin?.isConnected) {
      focusOrigin.focus();
    }
    if (this.payFieldsSecureForm && this.payFieldsSecureForm.dispose) {
      this.payFieldsSecureForm.dispose();
    }
    this.payFieldsSecureForm = null;
    this.isPayFieldsEmbeddedFormReady = false;
  }

  ngOnDestroy(): void {
    this.paymentComponentDestroyed = true;
    if (this.tdMismatchVisibilityWait) {
      this.tdMismatchVisibilityWait.unsubscribe();
      this.tdMismatchVisibilityWait = null;
      this.finishTdCardModeMismatch(false);
    }
    this.cardMismatchModalRef?.hide();
    this.disposePayFieldsEmbeddedForm();
    this.clearPayFieldsWatchdog();
    this.openEdgeRcmRequest?.unsubscribe();
  }

  // Removes the previous attempt's token-success/token-error/error listeners before a new attempt
  // registers its own — the SDK form instance can be reused across retries within one modal session
  // (e.g. tokenization succeeds but the sale is declined and the user retries), so without this,
  // listeners from every prior attempt stay registered and keep firing alongside the current one.
  private detachPayFieldsFormListeners(): void {
    const listeners = this.payFieldsFormListeners;
    if (!listeners || !listeners.form?.off) {
      this.payFieldsFormListeners = null;
      return;
    }
    listeners.form.off('token-success', listeners.tokenSuccess);
    listeners.form.off('token-error', listeners.tokenError);
    listeners.form.off('error', listeners.error);
    this.payFieldsFormListeners = null;
  }

  submitPayFieldsEmbeddedPayment(): void {
    if (this.isPayFieldsTokenPending) {
      this.toastr.warning('Tokenization is in progress. Please wait.', 'Please Wait', this.toasterConfig);
      return;
    }
    if (!this.showPayFieldsEmbeddedForm) {
      return;
    }

    if (!this.isPayFieldsEmbeddedCustomerInfoValid()) {
      this.toastr.warning('Please complete required customer information.', 'Validation', this.toasterConfig);
      return;
    }

    if (!this.payFieldsSecureForm || !this.isPayFieldsEmbeddedFormReady) {
      this.toastr.warning('PayFields form is still loading. Please wait and retry.', 'Please Wait', this.toasterConfig);
      return;
    }

    const requestId = this.generatePayFieldsRequestId();
    this.payFieldsRequestId = requestId;
    this.isPayFieldsTokenPending = true;
    this.paymentStarted = true;
    this.loaderIcon = Promise.resolve(true);
    this.startPayFieldsWatchdog(requestId);

    const submittingForm = this.payFieldsSecureForm;
    this.detachPayFieldsFormListeners();
    const tokenSuccessListener = (result: any) => this.handlePayFieldsAttemptCallback(submittingForm, requestId, result);
    const tokenErrorListener = (result: any) => this.handlePayFieldsAttemptCallback(submittingForm, requestId, { error: { message: result?.error?.message || 'Tokenization failed.' } });
    const errorListener = (result: any) => this.handlePayFieldsAttemptCallback(submittingForm, requestId, { error: { message: result?.reasons?.[0]?.message || 'Tokenization failed.' } });
    submittingForm.on('token-success', tokenSuccessListener);
    submittingForm.on('token-error', tokenErrorListener);
    submittingForm.on('error', errorListener);
    this.payFieldsFormListeners = { form: submittingForm, tokenSuccess: tokenSuccessListener, tokenError: tokenErrorListener, error: errorListener };

    this.logPayFieldsDebug('submitPayFieldsEmbeddedPayment:tokenize', {
      requestId,
      amount: this.payFieldsPendingAmount,
      payId: this.currentPayId
    });

    const submitFrame = (this.payFieldsSecureForm as any)?.frames?.submit;
    if (submitFrame && submitFrame.emit) {
      submitFrame.emit('click');
      return;
    }

    this.failPayFieldsTokenization('PayFields submit control was not initialized.');
  }

  private handlePayFieldsAttemptCallback(submittingForm: any, requestId: string, result: any): void {
    if (submittingForm !== this.payFieldsSecureForm || requestId !== this.payFieldsRequestId) {
      this.logPayFieldsDebug('requestPaymentMethod:disposed-form-callback-ignored', { requestId });
      return;
    }
    this.requestPaymentMethod(result, requestId);
  }

  // ── PayFields tokenization reliability helpers (Story 2.2) ──────────────────

  private generatePayFieldsRequestId(): string {
    return `pf-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  }

  private startPayFieldsWatchdog(requestId: string): void {
    this.clearPayFieldsWatchdog();
    this.payFieldsWatchdogTimer = setTimeout(() => {
      if (this.payFieldsRequestId === requestId && this.isPayFieldsTokenPending) {
        this.appInsightsService.logPaymentEvent(
          true,
          `PayFields tokenization watchdog fired after ${this.PAYFIELDS_TOKEN_TIMEOUT_MS}ms — no token received. RequestId: ${requestId}`,
          { Gateway: this.paymentGateway, FacilityId: this.processPayment?.facId, OrderId: this.getPaymentOrderId(), UserId: this.userSessionService.userSessionData.UserId }
        );
        this.failPayFieldsTokenization('Card tokenization timed out. Please retry.');
      }
    }, this.PAYFIELDS_TOKEN_TIMEOUT_MS);
  }

  private clearPayFieldsWatchdog(): void {
    if (this.payFieldsWatchdogTimer) {
      clearTimeout(this.payFieldsWatchdogTimer);
      this.payFieldsWatchdogTimer = null;
    }
  }

  private clearPayFieldsTokenState(): void {
    this.clearPayFieldsWatchdog();
    this.isPayFieldsTokenPending = false;
    this.payFieldsRequestId = null;
    this.showPayFieldsEmbeddedForm = false;
    this.payFieldsTokenizationResult = null;
    this.disposePayFieldsEmbeddedForm();
    this.paymentStarted = false;
    this.loaderIcon = Promise.resolve(false);
  }

  /**
   * Persists a Declined CCT row for the current orderId (mirrors the sale-failure branch in
   * `completePayFieldsSale`) before clearing PayFields state, so a tokenization failure doesn't
   * leave the transaction stuck in "Attempting to Process".
   */
  private failPayFieldsTokenization(reason: string): void {
    const payment = this.paymentTable.find(o => o.payId === this.currentPayId);
    if (payment) {
      payment.payFailed = true;
      const paymentTrnsId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
      this.saveCCTransactionFailureCase({
        PaymentModeId: EPaymentModes.HostedPage,
        RESULT: {
          RESPONSECODE: 0,
          RESPONSEDESCRIPTION: reason
        }
      }, reason, 'Sale', paymentTrnsId, payment.orderId, payment.payId);
    } else {
      // No matching row to persist against — saveCCTransactionFailureCase's own toast won't fire, so surface one here.
      this.logPayFieldsDebug('failPayFieldsTokenization:no-matching-payment-row', { currentPayId: this.currentPayId, reason });
      this.toastr.error(reason, 'Tokenization Error', this.toasterConfig);
    }
    this.clearPayFieldsTokenState();
  }

  private guardPayFieldsCallback(incomingRequestId?: string): boolean {
    if (!this.isPayFieldsTokenPending) {
      return false;
    }
    if (!incomingRequestId) {
      return true;
    }
    return this.payFieldsRequestId === incomingRequestId;
  }

  /**
   * Entry point for the PayFields SDK token callback.
   * Guards against stale/late responses; surfaces errors explicitly to unblock retry.
   * Token sale completion is normalised in Story 2.3.
   */
  requestPaymentMethod(result: any, requestId?: string): void {
    this.logPayFieldsDebug('requestPaymentMethod:callback-received', {
      incomingRequestId: requestId,
      hasResult: !!result,
      hasError: !!result?.error
    });

    const effectiveRequestId = requestId || this.payFieldsRequestId || 'unknown';
    if (!this.guardPayFieldsCallback(requestId)) {
      this.logPayFieldsDebug('requestPaymentMethod:guard-rejected', {
        incomingRequestId: requestId,
        activeRequestId: this.payFieldsRequestId,
        isTokenPending: this.isPayFieldsTokenPending
      });
      this.appInsightsService.logPaymentEvent(
        false,
        `PayFields: stale or cancelled callback ignored. IncomingId: ${requestId || 'missing'}, ActiveId: ${this.payFieldsRequestId}`,
        { Gateway: this.paymentGateway }
      );
      return;
    }

    this.clearPayFieldsWatchdog();

    if (!result || result.error) {
      const errorMsg = result?.error?.message ?? 'Card tokenization failed. Please retry.';
      this.logPayFieldsDebug('requestPaymentMethod:callback-error', {
        effectiveRequestId,
        error: errorMsg
      });
      this.appInsightsService.logPaymentEvent(
        true,
        `PayFields tokenization error. RequestId: ${effectiveRequestId}. Error: ${errorMsg}`,
        { Gateway: this.paymentGateway, FacilityId: this.processPayment?.facId, OrderId: this.getPaymentOrderId(), UserId: this.userSessionService.userSessionData.UserId }
      );
      this.failPayFieldsTokenization(errorMsg);
      return;
    }

    this.isPayFieldsTokenPending = false;
    this.payFieldsTokenizationResult = result;
    const token = this.resolvePayFieldsTokenValue(result);

    if (!token) {
      this.failPayFieldsTokenization('Tokenization completed but temporary token is missing.');
      return;
    }

    this.logPayFieldsDebug('requestPaymentMethod:callback-success', {
      effectiveRequestId
    });
    this.appInsightsService.logPaymentEvent(
      true,
      `PayFields tokenization succeeded. RequestId: ${effectiveRequestId}`,
      { Gateway: this.paymentGateway, FacilityId: this.processPayment?.facId, OrderId: this.getPaymentOrderId(), UserId: this.userSessionService.userSessionData.UserId }
    );

    this.completePayFieldsSale(token);
  }

  private completePayFieldsSale(temporaryToken: string): void {
    // Captured once and reused in the async callbacks below instead of re-querying by
    // this.currentPayId — that avoids a null-deref if the row is gone by the time the gateway
    // responds, and keeps the response tied to the row that actually initiated it even if
    // this.currentPayId has since moved on to a different row.
    const payment = this.paymentTable.find(o => o.payId === this.currentPayId);
    if (!payment) {
      this.clearPayFieldsTokenState();
      return;
    }

    const amount = parseFloat((this.payFieldsPendingAmount || payment.payAmount || 0).toString());
    const paymentTrnsId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
    const country = this.countryList?.find((item) => item.Id == this.payFieldsBillingDetails.countryId);
    const state = this.stateList?.find((item) => item.Id == this.payFieldsBillingDetails.stateId);
    const tokenResult = this.payFieldsTokenizationResult || {};
    const payload = {
      FacilityId: this.processPayment?.facId,
      Amount: amount,
      TemporaryToken: temporaryToken,
      EnrollInAutopay: ['autopay', 'cardOnFile'].includes(payment.EnableAutopayOrCardOnFile),
      OrderId: payment.uniqueTransId,
      InvoiceNumber: payment.orderId ? payment.orderId.toString() : '',
      FirstName: this.payFieldsBillingDetails.firstName,
      MiddleName: this.payFieldsBillingDetails.middleName,
      LastName: this.payFieldsBillingDetails.lastName,
      Address1: this.payFieldsBillingDetails.addressOne,
      Address2: this.payFieldsBillingDetails.addressTwo,
      City: this.payFieldsBillingDetails.city,
      State: state?.Code || '',
      PostalCode: this.payFieldsBillingDetails.postalCode,
      // PayFields billing-address validation expects a two-letter ISO country code, not the
      // raw app country.Code value. Use the same mapped IsoCode that the refund flow already uses.
      Country: country?.IsoCode || country?.Code || this.getPayFieldRegion() || 'US',
      Company: this.payFieldsBillingDetails.companyName
    };

    this.paymentService.CallPayFieldSale(payload).subscribe((response: any) => {
      let gatewayResponse: any = null;
      try {
        gatewayResponse = response?.GatewayResponse ? JSON.parse(response.GatewayResponse) : null;
      } catch {
        gatewayResponse = null;
      }

      const reusableToken = typeof response?.ReusableToken === 'string' ? response.ReusableToken.trim() : '';
      const excludedTokens = [temporaryToken, response?.ReferenceId, payload.OrderId, payload.InvoiceNumber,
        gatewayResponse?.sale_id, gatewayResponse?.id, gatewayResponse?.reference, gatewayResponse?.payment?.reference_id];
      const normalizedResult = this.normalizePayFieldsResponse({
        reusableToken: payload.EnrollInAutopay && response?.Success === true && response?.EnrollmentSuccess === true
          && !excludedTokens.some(value => typeof value === 'string' && value.trim() === reusableToken) ? reusableToken : '',
        approvedAmount: amount.toFixed(2),
        maskedCardNumber: tokenResult?.details?.cardNumber || gatewayResponse?.card?.masked_card_number || gatewayResponse?.payment_method?.card?.masked_number || '',
        cardBrand: tokenResult?.details?.cardType || gatewayResponse?.card?.type || gatewayResponse?.payment_method?.card?.brand || '',
        cardholderName: `${this.payFieldsBillingDetails.firstName} ${this.payFieldsBillingDetails.lastName}`.trim(),
        expirationMonth: tokenResult?.details?.expiryMonth || gatewayResponse?.card?.expiry_month || gatewayResponse?.payment_method?.card?.expiry_month || '',
        expirationYear: tokenResult?.details?.expiryYear || gatewayResponse?.card?.expiry_year || gatewayResponse?.payment_method?.card?.expiry_year || '',
        billingAddress: this.payFieldsBillingDetails.addressOne,
        billingPostalCode: this.payFieldsBillingDetails.postalCode,
        // Reversal calls /reference_id/{TransactionId}/voids, so TRANSACTIONID must be the exact
        // reference_id the backend actually sent (it sanitizes/truncates OrderId/InvoiceNumber before
        // sending — see EdgeExpressBusiness.BuildPayFieldReferenceIdentifier) — prefer the value the
        // backend echoes back over guessing from the unnormalized payload fields.
        referenceId: response?.ReferenceId || payload.OrderId || payload.InvoiceNumber || gatewayResponse?.sale_id || gatewayResponse?.id || gatewayResponse?.reference || temporaryToken,
        saleId: gatewayResponse?.sale_id || gatewayResponse?.id || gatewayResponse?.reference || '',
        responseCode: response?.Success ? '000' : (response?.ResponseCode || ''),
        responseDescription: response?.Success ? 'Approved' : (gatewayResponse?.error?.message || gatewayResponse?.error_description || gatewayResponse?.message || 'Declined'),
        cardType: 'Credit',
        receiptText: gatewayResponse?.receipt?.text?.merchant_receipt || ''
      });

      if (!response?.Success) {
        this.payFieldsRequestId = null;
        this.payFieldsTokenizationResult = null;
        payment.payFailed = true;
        this.paymentSuccessFul = false;
        this.payStatus = 'Failed';
        this.paymentStarted = false;
        this.loaderIcon = Promise.resolve(false);
        this.showPayFieldsEmbeddedForm = false;
        this.disposePayFieldsEmbeddedForm();
        this.saveCCTransactionFailureCase({
          PaymentModeId: EPaymentModes.HostedPage,
          RESULT: {
            RESPONSECODE: response?.ResponseCode || 0,
            RESPONSEDESCRIPTION: normalizedResult?.RESPONSEDESCRIPTION || 'Declined'
          }
        }, normalizedResult?.RESPONSEDESCRIPTION || 'Declined', 'Sale', paymentTrnsId, payment.orderId, payment.payId);
        return;
      }

      this.paymentSuccessFul = true;
      this.payFieldsRequestId = null;
      this.payFieldsTokenizationResult = null;
      this.payStatus = 'Success';
      payment.payFailed = false;
      // Marks this specific row as an actual PayFields sale so later void/cancel routes correctly
      // even if the facility's PayFields setting changes before the void happens.
      payment['payFieldPayment'] = true;
      payment['processedCNPCC'] = normalizedResult;
      this.showPayFieldsEmbeddedForm = false;
      this.disposePayFieldsEmbeddedForm();
      this.loaderIcon = Promise.resolve(false);
      this.currentPayId = payment.payId;
      this.gotoPaymentSuccess(this.popUpPayment, normalizedResult.APPROVEDAMOUNT || amount.toFixed(2));
    }, () => {
      this.payFieldsRequestId = null;
      this.payFieldsTokenizationResult = null;
      payment.payFailed = true;
      this.paymentSuccessFul = false;
      this.payStatus = 'Failed';
      this.paymentStarted = false;
      this.loaderIcon = Promise.resolve(false);
      this.showPayFieldsEmbeddedForm = false;
      this.disposePayFieldsEmbeddedForm();
      this.saveCCTransactionFailureCase({
        PaymentModeId: EPaymentModes.HostedPage,
        RESULT: {
          RESPONSECODE: 0,
          RESPONSEDESCRIPTION: 'PayFields sale request failed.'
        }
      }, 'PayFields sale request failed.', 'Sale', paymentTrnsId, payment.orderId, payment.payId);
    });
  }

  // ────────────────────────────────────────────────────────────────────────────

  /**
   * Normalizes any PayFields or XWEB sale response to the hosted-page-compatible
   * `processedCNPCC` shape expected by all downstream consumers (save/void/cancel/receipt).
   *
   * Detection: if `raw.APPROVEDAMOUNT` is present the payload is already XWEB
   * upper-case format — returned as-is (AC-4 legacy passthrough).
   * Otherwise attempts a camelCase → UPPER-CASE field mapping for future
   * PayFields direct-API responses.
   * If the payload is null / undefined a safe empty object is returned so
   * callers can test for missing data without crashing.
   */
  private normalizePayFieldsResponse(raw: any): any {
    if (!raw) return {};
    // Already XWEB upper-case format — passthrough (legacy hosted-page, AC-4)
    if (raw.APPROVEDAMOUNT != null) return raw;
    // camelCase → UPPER mapping for PayFields Transactions API shape
    return {
      APPROVEDAMOUNT:       raw.approvedAmount       ?? raw.amount         ?? '',
      MASKEDCARDNUMBER:     raw.maskedCardNumber      ?? raw.cardNumber     ?? '',
      CARDBRAND:            raw.cardBrand             ?? '',
      CUSTOMERNAME:         raw.cardholderName        ?? raw.holderName     ?? '',
      EXPMONTH:             raw.expirationMonth       ?? raw.expMonth       ?? '',
      EXPYEAR:              raw.expirationYear        ?? raw.expYear        ?? '',
      ADDRESS1:             raw.billingAddress        ?? raw.address1       ?? '',
      BILLINGPOSTALCODE:    raw.billingPostalCode     ?? raw.postalCode     ?? '',
      TRANSACTIONID:        raw.referenceId           ?? raw.transactionId  ?? '',
      SALEID:               raw.saleId                ?? '',
      PAYFIELDTOKEN:        raw.reusableToken         ?? '',
      RESPONSECODE:         raw.responseCode          ?? '',
      RESPONSEDESCRIPTION:  raw.responseDescription   ?? '',
      CARDTYPE:             raw.cardType              ?? 'Credit',
      BATCHNO:              raw.batchNumber           ?? raw.batchNo        ?? '',
      RECEIPTTEXT:          raw.receiptText           ?? raw.receipt        ?? '',
      STATE:                raw.state                 ?? raw.STATE          ?? '',
    };
  }

  private getOpenEdgeAutoPayVaultToken(item: any): string {
    if (item.payFieldPayment !== true || !['autopay', 'cardOnFile'].includes(item.EnableAutopayOrCardOnFile)) {
      return '';
    }
    const result = item.processedCNPCC;
    const token = typeof result?.PAYFIELDTOKEN === 'string' ? result.PAYFIELDTOKEN.trim() : '';
    if (token && ![result?.TEMPORARYTOKEN, result?.SALEID, result?.TRANSACTIONID, item.uniqueTransId]
      .some(value => typeof value === 'string' && value.trim() === token)) {
      return token;
    }
    if (!this.payFieldsAutoPayVaultGapWarned) {
      this.payFieldsAutoPayVaultGapWarned = true;
      this.toastr.warning('Payment succeeded, but Auto-pay/Card on File enrollment failed. Please set it up again.', 'PayFields Notice', this.toasterConfig);
    }
    return '';
  }

  goToComplete(type) {
    this.payFieldsAutoPayVaultGapWarned = false;
    var tempCashObj;
    var tempCheckObj;
    var tempMultipleCheck;
    var tempCCObj;
    var tempMultipleCC;
    var tempACHObj;
    var tempMultipleACH;
    var tempRemotePayObj;
    let isCash = false;
    let isCC = false;
    let isCheck = false;
    let isAch = false;
    let isRemotePay = false;
    let hasIncompleteOpenEdgeHostedPagePayment = false;
    const achPaymentModes = new Set<EPaymentModes>
      ([EPaymentModes.ACH, EPaymentModes.ACHOnFile, EPaymentModes.ACHManualAuthorization, EPaymentModes.EFTManualAuthorization, EPaymentModes.DirectDebitEFT, EPaymentModes.DirectDebitEFTOnFile]);
    
    let isCCPayment = this.paymentTable.some(function (ele) {return ( ele.payModeId != EPaymentModes.ManualAuthorization  && [EPaymentModes.CreditCard, EPaymentModes.HostedPage, EPaymentModes.CardOnfile, EPaymentModes.DebitCard].includes(ele.payModeId))});

    let totalApprovedAmount = this.paymentTable.reduce((sum, a) => a.payComplete ? sum + (this.isString(a.payAmount) ? parseFloat(a.payAmount) : a.payAmount) : sum + 0, 0);
    let failedAmount = this.paymentTable.reduce((sum, a) => a.payFailed ? sum + (this.isString(a.payAmount) ? parseFloat(a.payAmount) : a.payAmount) : sum + 0, 0);
    this.appInsightsService.logPaymentEvent(isCCPayment, `Total failed Transaction Amount : ${failedAmount},
      Total succeded Transaction Amount : ${totalApprovedAmount}, Numeber of Mode selected : ${this.paymentTable.length}`, { Gateway: this.paymentGateway, FacilityId : this.processPayment.facId, OrderId : this.getPaymentOrderId(), UserId : this.userSessionService.userSessionData.UserId});
    
    if (failedAmount > 0 && totalApprovedAmount > 0 && !this.partialPaySuccess && this.paymentTable.length > 1) {
      this.partialPaySuccess = true;
      this.partialPaySuccessUnaltered = true;
    }
    let paymentTrnsId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
    //Checking Duplicate records which holds same CCTId
    if (this.paymentTable.length > 1 && (this.paymentTable.find((ele) => [EPaymentModes.CreditCard, EPaymentModes.DebitCard].includes(ele.payModeId)) || this.paymentTable.find((ele) => ele.payModeId == EPaymentModes.HostedPage) || this.paymentTable.find((ele) => ele.payModeId == EPaymentModes.CardOnfile))) {
      let nonCCTTable = this.paymentTable.filter((ele => {
        if (ele.orderId == null) {
          return ele;
        }
      }));

      if (nonCCTTable.length < 1) {
        this.paymentTable = this.paymentTable.filter((item, i, arr) => arr.findIndex((t) => t.orderId === item.orderId) === i);
      }
      this.appInsightsService.logPaymentEvent(isCCPayment,`Selected Payment Modes for Submiting the Transaction.`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : this.getPaymentOrderId(), UserId : this.userSessionService.userSessionData.UserId});
    }
    this.paymentTable.forEach(item => {
      if (item.payComplete && !item.payFailed) { // To process only paid records when some payments failed and partial payment allowed
          this.requestGatewaydetails(item.payModeId, item.payId);
          const payableAmount = this.getRowPayableAmount(item);
        if (item.payModeId == EPaymentModes.Cash) {
          if (tempCashObj == undefined || tempCashObj.CashTransaction == undefined) {
            isCash = true;
            tempCashObj = {
              CashTransaction: {
                Amount: payableAmount,
                ChangeAmount: parseFloat(Number(item.changeAmount).toFixed(2)),
                PaymentModeId: parseInt(item.payModeId, 10),
                PmdId: 0,
                ModeOfPayment: ''
              }
            };
          } else {
            tempCashObj.CashTransaction.Amount += payableAmount;
          }
        } else if (item.payModeId == EPaymentModes.Check) {
          if (tempCheckObj == undefined || tempCheckObj.CheckTransaction == undefined) {
            isCheck = true;
            tempCheckObj = {
              CheckTransaction: [
                {
                  Amount: payableAmount,
                  PaymentModeId: EPaymentModes.Check,
                  CheckNumber: item.checkNum,
                  CheckDate: item.checkDate,
                  BankName: item.bankName,
                  AccountHolder: '',
                  BankAccountNumber: '',
                  BankCode: '',
                  DonotAcceptChecks: true
                }
              ]
            };
          } else {
            tempMultipleCheck = {
              Amount: payableAmount,
              PaymentModeId: EPaymentModes.Check,
              CheckNumber: item.checkNum,
              CheckDate: item.checkDate,
              BankName: item.bankName,
              AccountHolder: '',
              BankAccountNumber: '',
              BankCode: '',
              DonotAcceptChecks: true
            };
            tempCheckObj.CheckTransaction.push(tempMultipleCheck);
            tempMultipleCheck = {};
          }
        } else if ([EPaymentModes.CreditCard, EPaymentModes.DebitCard].includes(item.payModeId)) {
          let cTypeId = 2;
          if (this.paymentGateway == EPaymentGateway.TdBank) {
            let CCTypeId = item['processedCC'].CreditCardType;
            if (tempCCObj == undefined || tempCCObj.CCTransaction == undefined) {
              isCC = true;
              tempCCObj = {
                CCTransaction: [{
                  Amount: item['processedCC'].Amount,
                  Autopay: false,
                  PaymentModeId: item['processedCC'].PaymentModeId,
                  AutoCcProcessingDay: 0,
                  CreditCardNumber: item['processedCC'].CreditCardNumber,
                  CreditCardType: CCTypeId == "00" ? 2 : CCTypeId,
                  NameonCard: item['processedCC'].NameonCard ? item['processedCC'].NameonCard : null,
                  CreditCardExpiryMonth: item['processedCC'].CreditCardExpiryMonth && item['processedCC'].CreditCardExpiryYear != '0' ? item['processedCC'].CreditCardExpiryMonth : 275,
                  CreditCardExpiryYear: item['processedCC'].CreditCardExpiryYear && item['processedCC'].CreditCardExpiryYear != '0' ? item['processedCC'].CreditCardExpiryYear : 2099,
                  CreditCardBillingAddress: item['processedCC'].CreditCardBillingAddress ? item['processedCC'].CreditCardBillingAddress : null,
                  CreditCardBillingZip: item['processedCC'].CreditCardBillingZip ? item['processedCC'].CreditCardBillingZip : null,
                  SwipeTransaction: item['processedCC'].SwipeTransaction,
                  SecurityCodeSent: false,
                  AuthorizationCode: item['processedCC'].AuthorizationCode,
                  ResponseCode: item['processedCC'].ResponseCode,
                  Reason: item['processedCC'].Reason,
                  FacilityId: this.processPayment.facId,
                  Key: item['processedCC'].Key,
                  PaymentAccountid: item['processedCC'].PaymentAccountId,
                  CcInfoPurged: false,
                  DebitCardPayment: item['processedCC'].DebitCardPayment,
                  OfflinePayment: false,
                  UniqueTransId: item['processedCC'].UniqueTransId ? item['processedCC'].UniqueTransId : null,
                  PaymentTransactionTypeId: item['processedCC'].PaymentTransactionTypeId,
                  //TransactionDateTime: new Date(),
                  TransactionTypeId: item['processedCC'].TransactionTypeId,
                  OrderId: item['processedCC'].OrderId,
                  CCBatchNumber: item['processedCC'].CCBatchNumber,
                  TerminalDeviceId: item['processedCC'].TerminalDeviceId ? item['processedCC'].TerminalDeviceId : null,
                  EmvReceiptText: item['processedCC'].EmvReceiptText,
                  TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                  GatewayDetails: this.requestgatewaydetails,
                  GatewayId : this.paymentGateway
                }]
              };
            } else {
              tempMultipleCC = {
                Amount: item['processedCC'].Amount,
                Autopay: false,
                PaymentModeId: item['processedCC'].PaymentModeId,
                AutoCcProcessingDay: 0,
                CreditCardNumber: item['processedCC'].CreditCardNumber,
                CreditCardType: CCTypeId == "00" ? 2 : CCTypeId,
                NameonCard: item['processedCC'].NameonCard ? item['processedCC'].NameonCard : null,
                CreditCardExpiryMonth: item['processedCC'].CreditCardExpiryMonth && item['processedCC'].CreditCardExpiryYear != '0' ? item['processedCC'].CreditCardExpiryMonth : 275,
                CreditCardExpiryYear: item['processedCC'].CreditCardExpiryYear && item['processedCC'].CreditCardExpiryYear != '0' ? item['processedCC'].CreditCardExpiryYear : 2099,
                CreditCardBillingAddress: item['processedCC'].CreditCardBillingAddress ? item['processedCC'].CreditCardBillingAddress : null,
                CreditCardBillingZip: item['processedCC'].CreditCardBillingZip ? item['processedCC'].CreditCardBillingZip : null,
                SwipeTransaction: false,
                SecurityCodeSent: false,
                AuthorizationCode: item['processedCC'].AuthorizationCode,
                ResponseCode: item['processedCC'].ResponseCode,
                Reason: item['processedCC'].Reason,
                FacilityId: this.processPayment.facId,
                Key: item['processedCC'].Key,
                PaymentAccountid: item['processedCC'].PaymentAccountId,
                CcInfoPurged: false,
                DebitCardPayment: item['processedCC'].DebitCardPayment,
                OfflinePayment: false,
                UniqueTransId: item['processedCC'].UniqueTransId ? item['processedCC'].UniqueTransId : null,
                PaymentTransactionTypeId: item['processedCC'].PaymentTransactionTypeId,
                //TransactionDateTime: new Date(),
                TransactionTypeId: item['processedCC'].TransactionTypeId, //Processed
                OrderId: item['processedCC'].OrderId,
                CCBatchNumber: item['processedCC'].CCBatchNumber,
                TerminalDeviceId: item['processedCC'].TerminalDeviceId ? item['processedCC'].TerminalDeviceId : null,
                EmvReceiptText: item['processedCC'].EmvReceiptText,
                TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                GatewayDetails: this.requestgatewaydetails,
                GatewayId : this.paymentGateway
              };
              tempCCObj.CCTransaction.push(tempMultipleCC);
              tempMultipleCC = {};
            }
          } else if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress) {
            var cType = item['processedCC'].CARDBRAND;
            cType = cType.replace(/\s/g, '');
            cTypeId = cType ? this.paymentService.openEdgeCardType(cType) : ECreditCards.Visa;
            isCC = true;
            if (tempCCObj == undefined || tempCCObj.CCTransaction == undefined) {
              isCC = true;
              tempCCObj = {
                CCTransaction: [{
                  Amount: parseFloat(item['processedCC'].APPROVEDAMOUNT),
                  Autopay: false,
                  paymentModeId: parseInt(item.payModeId, 10),
                  AutoCcProcessingDay: 0,
                  CreditCardNumber: item['processedCC'].ACCOUNT,
                  CreditCardType: cTypeId,
                  NameonCard: item['processedCC'] && item['processedCC'].CARDHOLDERNAME && item['processedCC'].CARDHOLDERNAME.length > this.maxLengthNameOnCard ?
                    item['processedCC'].CARDHOLDERNAME.substr(0, this.maxLengthNameOnCard) : item['processedCC'] && item['processedCC'].CARDHOLDERNAME ? item['processedCC'].CARDHOLDERNAME : null,
                  CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(item['processedCC'].EXPMONTH, 10)),
                  CreditCardExpiryYear: parseInt(item['processedCC'].EXPYEAR, 10),
                  CreditCardBillingAddress: '',
                  CreditCardBillingZip: '',
                  SwipeTransaction: false,
                  SecurityCodeSent: false,
                  AuthorizationCode: item['processedCC'].TRANSACTIONID,
                  ResponseCode: item['processedCC'].HOSTRESPONSECODE,
                  Reason: item['processedCC'].HOSTRESPONSEDESCRIPTION,
                  Key: '',
                  PaymentAccountid: '',
                  CcInfoPurged: false,
                  DebitCardPayment: this.isOpenEdgeDebitSale(item),
                  OfflinePayment: 0,
                  PaymentTransactionTypeId: paymentTrnsId,
                  //TransactionDateTime: new Date(),
                  TransactionTypeId: EPaymentTransactionType.Processed,
                  OrderId: item['processedCC'].OrderId,
                  CCBatchNumber: item['processedCC'].BATCHNO,
                  EmvReceiptText: item['processedCC'].RECEIPTTEXT,
                  TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
                  TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                  FacilityId: this.processPayment.facId,
                  GatewayDetails: this.requestgatewaydetails,
                  GatewayId : this.paymentGateway,
                  UniqueTransId : item.uniqueTransId
                }]
              }
            } else {
              tempMultipleCC = {
                Amount: parseFloat(item['processedCC'].APPROVEDAMOUNT),
                Autopay: false,
                PaymentModeId: parseInt(item.payModeId, 10),
                AutoCcProcessingDay: 0,
                CreditCardNumber: item['processedCC'].ACCOUNT == undefined ? 0 : item['processedCC'].ACCOUNT,
                CreditCardType: cTypeId,
                NameonCard: item['processedCC'].CARDHOLDERNAME && item['processedCC'].CARDHOLDERNAME.length > this.maxLengthNameOnCard ?
                  item['processedCC'].CARDHOLDERNAME.substr(0, this.maxLengthNameOnCard) : item['processedCC'].CARDHOLDERNAME,
                CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(item['processedCC'].EXPMONTH, 10)),
                CreditCardExpiryYear: parseInt(item['processedCC'].EXPYEAR, 10),
                CreditCardBillingAddress: '',
                CreditCardBillingZip: '',
                SwipeTransaction: false,
                SecurityCodeSent: false,
                AuthorizationCode: item['processedCC'].TRANSACTIONID,
                ResponseCode: item['processedCC'].HOSTRESPONSECODE,
                Reason: item['processedCC'].HOSTRESPONSEDESCRIPTION,
                Key: '',
                PaymentAccountid: '',
                CcInfoPurged: false,
                DebitCardPayment: this.isOpenEdgeDebitSale(item),
                OfflinePayment: 0,
                PaymentTransactionTypeId: paymentTrnsId,
                //TransactionDateTime: new Date(),
                TransactionTypeId: EPaymentTransactionType.Processed,
                OrderId: item['processedCC'].OrderId,
                CCBatchNumber: item['processedCC'].BATCHNO,
                EmvReceiptText: item['processedCC'].RECEIPTTEXT,
                TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
                TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                FacilityId: this.processPayment.facId,
                GatewayDetails: this.requestgatewaydetails,
                GatewayId : this.paymentGateway,
                UniqueTransId : item.uniqueTransId
              };
              tempCCObj.CCTransaction.push(tempMultipleCC);
              tempMultipleCC = {};
            }
          } else {// stripe
            isCC = true;
            if (tempCCObj == undefined || tempCCObj.CCTransaction == undefined) {
              tempCCObj = {
                CCTransaction: [{
                  Amount: parseFloat(item['processedStripeCC'].Amount),
                  Autopay: false,
                  paymentModeId: parseInt(item.payModeId, 10),
                  AutoCcProcessingDay: 0,
                  CreditCardNumber: item['processedStripeCC'].CreditCardNumber,
                  CreditCardType: item['processedStripeCC'].CreditCardType,
                  NameonCard: item['processedStripeCC'].NameonCard,
                  CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(item['processedStripeCC'].CreditCardExpiryMonth, 10)),
                  CreditCardExpiryYear: parseInt(item['processedStripeCC'].CreditCardExpiryYear, 10),
                  CreditCardBillingAddress: '',
                  CreditCardBillingZip: '',
                  SwipeTransaction: false,
                  SecurityCodeSent: false,
                  AuthorizationCode: item['processedStripeCC'].AuthorizationCode,
                  ResponseCode: item['processedStripeCC'].ResponseCode,
                  Reason: item['processedStripeCC'].Reason,
                  Key: item['processedStripeCC'].Key,
                  PaymentAccountid: item['processedStripeCC'].PaymentAccountid ? item['processedStripeCC'].PaymentAccountid : "",
                  CcInfoPurged: false,
                  DebitCardPayment: item['processedStripeCC'].DebitCardPayment ? true : false,
                  OfflinePayment: 0,
                  PaymentTransactionTypeId: paymentTrnsId,
                  //TransactionDateTime: new Date(),
                  TransactionTypeId: EPaymentTransactionType.Processed,
                  OrderId: item['processedStripeCC'].OrderId,
                  EmvReceiptText: item['processedStripeCC'].EmvReceiptText,
                  TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
                  TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                  FacilityId: this.processPayment.facId,
                  GatewayDetails: this.requestgatewaydetails,
                  CustomerId: item['processedStripeCC'].CustomerId,
                  GatewayId : this.paymentGateway
                }]
              }
            } else {
              tempMultipleCC = {
                Amount: parseFloat(item['processedStripeCC'].Amount),
                Autopay: false,
                PaymentModeId: parseInt(item.payModeId, 10),
                AutoCcProcessingDay: 0,
                CreditCardNumber: item['processedStripeCC'].CreditCardNumber,
                CreditCardType: cTypeId,
                NameonCard: item['processedStripeCC'].NameonCard,
                CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(item['processedStripeCC'].CreditCardExpiryMonth, 10)),
                CreditCardExpiryYear: parseInt(item['processedStripeCC'].CreditCardExpiryYear, 10),
                CreditCardBillingAddress: '',
                CreditCardBillingZip: '',
                SwipeTransaction: false,
                SecurityCodeSent: false,
                AuthorizationCode: item['processedStripeCC'].AuthorizationCode,
                ResponseCode: item['processedStripeCC'].ResponseCode,
                Reason: item['processedStripeCC'].Reason,
                Key: item['processedStripeCC'].Key,
                PaymentAccountid: item['processedStripeCC'].PaymentAccountid ? item['processedStripeCC'].PaymentAccountid : "",
                CcInfoPurged: false,
                DebitCardPayment: item['processedStripeCC'].DebitCardPayment,
                OfflinePayment: 0,
                PaymentTransactionTypeId: paymentTrnsId,
                //TransactionDateTime: new Date(),
                TransactionTypeId: EPaymentTransactionType.Processed,
                OrderId: item['processedStripeCC'].OrderId,
                CCBatchNumber: null,
                EmvReceiptText: item['processedStripeCC'].EmvReceiptText,
                TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
                TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                FacilityId: this.processPayment.facId,
                GatewayDetails: this.requestgatewaydetails,
                CustomerId: item['processedStripeCC'].CustomerId,
                GatewayId : this.paymentGateway
              };
              tempCCObj.CCTransaction.push(tempMultipleCC);
              tempMultipleCC = {};
            }
          }
        } else if (item.payModeId == EPaymentModes.HostedPage) {
          let cardType = '';
          if (this.paymentGateway == EPaymentGateway.TdBank) {
            if (this.tdResponseObj) {
              cardType = this.tdResponseObj.cardType;
              if (tempCCObj == undefined || tempCCObj.CCTransaction == undefined) {
                isCC = true;
                tempCCObj = {
                  CCTransaction: [{
                    Amount: parseFloat(item['processedTDCC'].trnAmount),
                    Autopay: false,
                    PaymentModeId: parseInt(item.payModeId, 10),
                    AutoCcProcessingDay: 0,
                    CreditCardNumber: item['processedTDCC'].cardNumber,
                    CreditCardType: item['processedTDCC'].CreditCardType,
                    NameonCard: item['processedTDCC'].nameOnCard,
                    CreditCardExpiryMonth: item['processedTDCC'].CreditCardExpiryMonth,
                    CreditCardExpiryYear: item['processedTDCC'].CreditCardExpiryYear,
                    CreditCardBillingAddress: item['processedTDCC'].CreditCardBillingAddress,
                    CreditCardBillingZip: item['processedTDCC'].CreditCardBillingZip,
                    SwipeTransaction: false,
                    SecurityCodeSent: false,
                    AuthorizationCode: item['processedTDCC'].trnId,
                    ResponseCode: item['processedTDCC'].trnApproved,
                    Reason: item['processedTDCC'].messageText,
                    FacilityId: this.processPayment.facId,
                    Key: '',
                    PaymentAccountid: '',
                    CcInfoPurged: false,
                    DebitCardPayment: (item['processedTDCC'].cardType == 'PV' || item['processedTDCC'].cardType == 'MD') ? true : false,
                    OfflinePayment: 0,
                    UniqueTransId: null,
                    PaymentTransactionTypeId: paymentTrnsId,
                    //TransactionDateTime: new Date(),
                    TransactionTypeId: EPaymentTransactionType.Processed,
                    OrderId: item.orderId,
                    CCBatchNumber: '',
                    TerminalDeviceId: null,
                    TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                    GatewayDetails: this.requestgatewaydetails,
                    GatewayId : this.paymentGateway
                  }]
                };
              } else {
                tempMultipleCC = {
                  Amount: parseFloat(item['processedTDCC'].trnAmount),
                  Autopay: false,
                  PaymentModeId: parseInt(item.payModeId, 10),
                  AutoCcProcessingDay: 0,
                  CreditCardNumber: item['processedTDCC'].cardNumber,
                  CreditCardType: item['processedTDCC'].CreditCardType,
                  NameonCard: item['processedTDCC'].nameOnCard,
                  CreditCardExpiryMonth: item['processedTDCC'].CreditCardExpiryMonth,
                  CreditCardExpiryYear: item['processedTDCC'].CreditCardExpiryYear,
                  CreditCardBillingAddress: item['processedTDCC'].CreditCardBillingAddress,
                  CreditCardBillingZip: item['processedTDCC'].CreditCardBillingZip,
                  SwipeTransaction: false,
                  SecurityCodeSent: false,
                  AuthorizationCode: item['processedTDCC'].trnId,
                  ResponseCode: item['processedTDCC'].trnApproved,
                  Reason: item['processedTDCC'].messageText,
                  FacilityId: this.processPayment.facId,
                  Key: '',
                  PaymentAccountid: '',
                  CcInfoPurged: false,
                  DebitCardPayment: (item['processedTDCC'].cardType == 'PV' || item['processedTDCC'].cardType == 'MD') ? true : false,
                  OfflinePayment: 0,
                  UniqueTransId: null,
                  PaymentTransactionTypeId: paymentTrnsId,
                  //TransactionDateTime: new Date(),
                  TransactionTypeId: EPaymentTransactionType.Processed,
                  OrderId: item.orderId,
                  CCBatchNumber: '',
                  TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                  TerminalDeviceId: null,
                  GatewayDetails: this.requestgatewaydetails,
                  GatewayId : this.paymentGateway
                };
                tempCCObj.CCTransaction.push(tempMultipleCC);
                tempMultipleCC = {};
              }
            }
          } else if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress) {
            if (!item['processedCNPCC'] || item['processedCNPCC'].APPROVEDAMOUNT == null) {
              this.appInsightsService.logPaymentEvent(true,
                `goToComplete: skipping OpenEdge HostedPage row payId=${item.payId} — processedCNPCC missing or incomplete`,
                { Gateway: this.paymentGateway, FacilityId: this.processPayment.facId }
              );
              item.payFailed = true;
              hasIncompleteOpenEdgeHostedPagePayment = true;
              return;
            }
            const reusableToken = this.getOpenEdgeAutoPayVaultToken(item);
            isCC = true;
            if (tempCCObj == undefined || tempCCObj.CCTransaction == undefined) {
              isCC = true;
              tempCCObj = {
                CCTransaction: [{
                  Amount: parseFloat(item['processedCNPCC'].APPROVEDAMOUNT),
                  Autopay: item.EnableAutopayOrCardOnFile === 'autopay' && !!reusableToken,
                  PaymentModeId: parseInt(item.payModeId, 10),
                  AutoCcProcessingDay: 0,
                  CreditCardNumber: item['processedCNPCC'].MASKEDCARDNUMBER,
                  CreditCardType: item['processedCNPCC'].CARDBRAND ? this.paymentService.openEdgeCardType(item['processedCNPCC'].CARDBRAND) : ECreditCards.Visa,
                  NameonCard: item['processedCNPCC'].CUSTOMERNAME && item['processedCNPCC'].CUSTOMERNAME.length > this.maxLengthNameOnCard ?
                    item['processedCNPCC'].CUSTOMERNAME.substr(0, this.maxLengthNameOnCard) : item['processedCNPCC'].CUSTOMERNAME,
                  CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(item['processedCNPCC'].EXPMONTH, 10)),
                  CreditCardExpiryYear: parseInt(item['processedCNPCC'].EXPYEAR, 10) || 2099,
                  CreditCardBillingAddress: item['processedCNPCC'].ADDRESS1 && item['processedCNPCC'].ADDRESS1.length > this.maxLengthCCBlillingAd ?
                    item['processedCNPCC'].ADDRESS1.substr(0, this.maxLengthCCBlillingAd) : item['processedCNPCC'].ADDRESS1,
                  CreditCardBillingZip: item['processedCNPCC'].BILLINGPOSTALCODE && item['processedCNPCC'].BILLINGPOSTALCODE.length > this.maxLengthCCBlillingZip ?
                    item['processedCNPCC'].BILLINGPOSTALCODE.substr(0, this.maxLengthCCBlillingZip) : item['processedCNPCC'].BILLINGPOSTALCODE,
                  SwipeTransaction: false,
                  SecurityCodeSent: false,
                  AuthorizationCode: item['processedCNPCC'].TRANSACTIONID,
                  ResponseCode: item['processedCNPCC'].RESPONSECODE,
                  Reason: item['processedCNPCC'].RESPONSEDESCRIPTION,
                  Key: '',
                  PaymentAccountid: reusableToken,
                  CcInfoPurged: false,
                  DebitCardPayment: item['processedCNPCC'].CARDTYPE == 'Credit' ? false : true,
                  OfflinePayment: 0,
                  PaymentTransactionTypeId: paymentTrnsId,
                  FacilityId: this.processPayment.facId,
                  //TransactionDateTime: new Date(),
                  TransactionTypeId: EPaymentTransactionType.Processed,
                  OrderId: item.orderId,
                  CCBatchNumber: item['processedCNPCC'].BATCHNO,
                  TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                  TerminalDeviceId: null,
                  EmvReceiptText: item['processedCNPCC'] && item['processedCNPCC'].RECEIPTTEXT ? item['processedCNPCC'].RECEIPTTEXT : null,
                  GatewayDetails: this.requestgatewaydetails,
                  GatewayId : this.paymentGateway,
                  UniqueTransId : item.uniqueTransId
                }]
              };
            } else {
              tempMultipleCC = {
                Amount: parseFloat(item['processedCNPCC'].APPROVEDAMOUNT),
                Autopay: item.EnableAutopayOrCardOnFile === 'autopay' && !!reusableToken,
                PaymentModeId: parseInt(item.payModeId, 10),
                AutoCcProcessingDay: 0,
                CreditCardNumber: item['processedCNPCC'].MASKEDCARDNUMBER,
                CreditCardType: item['processedCNPCC'].CARDBRAND ? this.paymentService.openEdgeCardType(item['processedCNPCC'].CARDBRAND) : ECreditCards.Visa,
                NameonCard: item['processedCNPCC'].CUSTOMERNAME && item['processedCNPCC'].CUSTOMERNAME.length > this.maxLengthNameOnCard ?
                  item['processedCNPCC'].CUSTOMERNAME.substr(0, this.maxLengthNameOnCard) : item['processedCNPCC'].CUSTOMERNAME,
                CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(item['processedCNPCC'].EXPMONTH, 10)),
                CreditCardExpiryYear: parseInt(item['processedCNPCC'].EXPYEAR, 10) || 2099,
                CreditCardBillingAddress: item['processedCNPCC'].ADDRESS1 && item['processedCNPCC'].ADDRESS1.length > this.maxLengthCCBlillingAd ?
                  item['processedCNPCC'].ADDRESS1.substr(0, this.maxLengthCCBlillingAd) : item['processedCNPCC'].ADDRESS1,
                CreditCardBillingZip: item['processedCNPCC'].BILLINGPOSTALCODE && item['processedCNPCC'].BILLINGPOSTALCODE.length > this.maxLengthCCBlillingZip ?
                  item['processedCNPCC'].BILLINGPOSTALCODE.substr(0, this.maxLengthCCBlillingZip) : item['processedCNPCC'].BILLINGPOSTALCODE,
                SwipeTransaction: false,
                SecurityCodeSent: true,
                AuthorizationCode: item['processedCNPCC'].TRANSACTIONID,
                ResponseCode: item['processedCNPCC'].RESPONSECODE,
                Reason: item['processedCNPCC'].RESPONSEDESCRIPTION,
                Key: '',
                PaymentAccountid: reusableToken,
                CcInfoPurged: false,
                DebitCardPayment: item['processedCNPCC'].CARDTYPE == 'Credit' ? false : true,
                OfflinePayment: 0,
                PaymentTransactionTypeId: paymentTrnsId,
                //TransactionDateTime: new Date(),
                TransactionTypeId: EPaymentTransactionType.Processed,
                OrderId: item.orderId,
                CCBatchNumber: item['processedCNPCC'].BATCHNO,
                TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                TerminalDeviceId: null,
                FacilityId: this.processPayment.facId,
                EmvReceiptText: item['processedCNPCC'] && item['processedCNPCC'].RECEIPTTEXT ? item['processedCNPCC'].RECEIPTTEXT : null,
                GatewayDetails: this.requestgatewaydetails,
                GatewayId : this.paymentGateway,
                UniqueTransId : item.uniqueTransId
              };
              tempCCObj.CCTransaction.push(tempMultipleCC);
              tempMultipleCC = {};
            }
            if (reusableToken) {
              const savedCard = tempCCObj.CCTransaction[tempCCObj.CCTransaction.length - 1];
              this.setUpStripeAutopayModel({ ...savedCard, PaymentMethodId: reusableToken }, EPaymentModes.HostedPage, item.payId);
            }
          } else {
            if (tempCCObj == undefined || tempCCObj.CCTransaction == undefined) {
              isCC = true;
              tempCCObj = {
                CCTransaction: [{
                  Amount: parseFloat(item['processedStripeCC'].Amount),
                  Autopay: false,
                  PaymentModeId: parseInt(item.payModeId, 10),
                  AutoCcProcessingDay: 0,
                  CreditCardNumber: item['processedStripeCC'].CreditCardNumber,
                  CreditCardType: item['processedStripeCC'].CreditCardType,
                  NameonCard: item['processedStripeCC'].NameonCard,
                  CreditCardExpiryMonth: item['processedStripeCC'].CreditCardExpiryMonth,
                  CreditCardExpiryYear: item['processedStripeCC'].CreditCardExpiryYear,
                  CreditCardBillingAddress: item['processedStripeCC'].CreditCardBillingAddress,
                  CreditCardBillingZip: item['processedStripeCC'].CreditCardBillingZip,
                  SwipeTransaction: false,
                  SecurityCodeSent: false,
                  AuthorizationCode: item['processedStripeCC'].AuthorizationCode,
                  ResponseCode: item['processedStripeCC'].ResponseCode,
                  Reason: item['processedStripeCC'].Reason,
                  FacilityId: this.processPayment.facId,
                  Key: item['processedStripeCC'].Key,
                  PaymentAccountid: '',
                  CcInfoPurged: false,
                  DebitCardPayment: item['processedStripeCC'].cardType == 'debit' ? true : false,
                  OfflinePayment: 0,
                  UniqueTransId: item.orderId,
                  PaymentTransactionTypeId: paymentTrnsId,
                  //TransactionDateTime: new Date(),
                  TransactionTypeId: EPaymentTransactionType.Processed,
                  OrderId: item.orderId,
                  CCBatchNumber: '',
                  TerminalDeviceId: null,
                  TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                  GatewayDetails: this.requestgatewaydetails,
                  CustomerId: item['processedStripeCC'].CustomerId,
                  EmvReceiptText: item['processedStripeCC'].EmvReceiptText,
                  GatewayId : this.paymentGateway
                }]
              };
            } else {
              tempMultipleCC = {
                Amount: parseFloat(item['processedStripeCC'].Amount),
                Autopay: false,
                PaymentModeId: parseInt(item.payModeId, 10),
                AutoCcProcessingDay: 0,
                CreditCardNumber: item['processedStripeCC'].CreditCardNumber,
                CreditCardType: item['processedStripeCC'].CreditCardType,
                NameonCard: item['processedStripeCC'].NameonCard,
                CreditCardExpiryMonth: item['processedStripeCC'].CreditCardExpiryMonth,
                CreditCardExpiryYear: item['processedStripeCC'].CreditCardExpiryYear,
                CreditCardBillingAddress: item['processedStripeCC'].CreditCardBillingAddress,
                CreditCardBillingZip: item['processedStripeCC'].CreditCardBillingZip,
                SwipeTransaction: false,
                SecurityCodeSent: false,
                AuthorizationCode: item['processedStripeCC'].AuthorizationCode,
                ResponseCode: item['processedStripeCC'].ResponseCode,
                Reason: item['processedStripeCC'].Reason,
                FacilityId: this.processPayment.facId,
                Key: item['processedStripeCC'].Key,
                PaymentAccountid: '',
                CcInfoPurged: false,
                DebitCardPayment: item['processedStripeCC'].cardType == 'debit' ? true : false,
                OfflinePayment: 0,
                UniqueTransId: item.orderId,
                PaymentTransactionTypeId: paymentTrnsId,
                //TransactionDateTime: new Date(),
                TransactionTypeId: EPaymentTransactionType.Processed,
                OrderId: item.orderId,
                CCBatchNumber: '',
                TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                TerminalDeviceId: null,
                GatewayDetails: this.requestgatewaydetails,
                CustomerId: item['processedStripeCC'].CustomerId,
                EmvReceiptText: item['processedStripeCC'].EmvReceiptText,
                GatewayId : this.paymentGateway
              };
              tempCCObj.CCTransaction.push(tempMultipleCC);
              tempMultipleCC = {};
            }
          }
        } else if (item.payModeId == EPaymentModes.ManualAuthorization) {
          if (tempCCObj == undefined || tempCCObj.CCTransaction == undefined) {
            isCC = true;
            tempCCObj = {
              CCTransaction: [{
              Amount: payableAmount,
                Autopay: false,
                PaymentModeId: parseInt(item.payModeId, 10),
                AutoCcProcessingDay: 0,
                CreditCardNumber: item.ManualCardNumber,
                CreditCardType: item.CreditCardType,
                NameonCard: item.ManualCardName && item.ManualCardName.length > this.maxLengthNameOnCard ?
                  item.ManualCardName.substr(0, this.maxLengthNameOnCard) : item.ManualCardName,
                CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(item.ManualCardExp.slice(0, 2))),
                CreditCardExpiryYear: parseInt(item.ManualCardExp.slice(item.ManualCardExp.length - 2)),
                CreditCardBillingAddress: "",
                CreditCardBillingZip: "",
                SwipeTransaction: false,
                SecurityCodeSent: false,
                AuthorizationCode: item.ManualCardAuthorization,
                ResponseCode: '',
                Reason: "Approval",
                Key: "",
                PaymentAccountid: "",
                CcInfoPurged: false,
                DebitCardPayment: false,
                OfflinePayment: true,
                PaymentTransactionTypeId: paymentTrnsId,
                //TransactionDateTime: new Date(),
                TransactionTypeId: EPaymentTransactionType.Processed,
                OrderId: item.orderId,
                CCBatchNumber: '',
                TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                TerminalDeviceId: null,
                FacilityId: this.processPayment.facId,
                GatewayDetails: this.requestgatewaydetails,
                GatewayId : this.paymentGateway
              }]
            };
          } else {
            tempMultipleCC = {
              Amount: payableAmount,
              Autopay: false,
              PaymentModeId: parseInt(item.payModeId, 10),
              AutoCcProcessingDay: 0,
              CreditCardNumber: item.ManualCardNumber,
              CreditCardType: item.CreditCardType,
              NameonCard: item.ManualCardName && item.ManualCardName.length > this.maxLengthNameOnCard ?
                item.ManualCardName.substr(0, this.maxLengthNameOnCard) : item.ManualCardName,
              CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(item.ManualCardExp.slice(0, 2))),
              CreditCardExpiryYear: parseInt(item.ManualCardExp.slice(item.ManualCardExp.length - 2)),
              CreditCardBillingAddress: "",
              CreditCardBillingZip: "",
              SwipeTransaction: false,
              SecurityCodeSent: false,
              AuthorizationCode: item.ManualCardAuthorization,
              ResponseCode: '',
              Reason: "",
              Key: "",
              PaymentAccountid: "",
              CcInfoPurged: false,
              DebitCardPayment: false,
              OfflinePayment: true,
              PaymentTransactionTypeId: paymentTrnsId,
              //TransactionDateTime: new Date(),
              TransactionTypeId: EPaymentTransactionType.Processed,
              OrderId: item.orderId,
              CCBatchNumber: '',
              TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
              TerminalDeviceId: null,
              FacilityId: this.processPayment.facId,
              GatewayDetails: this.requestgatewaydetails,
              GatewayId : this.paymentGateway
            };
            tempCCObj.CCTransaction.push(tempMultipleCC);
            tempMultipleCC = {};
          }
        } else if (achPaymentModes.has(item.payModeId)) {
          if (tempACHObj == undefined || tempACHObj.ACHTransaction == undefined) {
            isAch = true;
            tempACHObj = {
              ACHTransaction: [
                {
                  Amount: parseFloat(Number(item['processedACH'].APPROVEDAMOUNT).toFixed(2)),
                  PaymentModeId: item.payModeId == EPaymentModes.DirectDebitEFT ? EPaymentModes.ACH : item.payModeId == EPaymentModes.EFTManualAuthorization ? EPaymentModes.ACHManualAuthorization : item.payModeId == EPaymentModes.DirectDebitEFTOnFile ? EPaymentModes.ACHOnFile : item.payModeId,
                  CheckNumber: item['processedACH'].CHECKNUMBER,
                  AchAuthorizationCode: item['processedACH'].TRANSACTIONID,
                  ResponseCode: item['processedACH'].RESPONSECODE,
                  Reason: item['processedACH'].RESPONSEDESCRIPTION,
                  AchAccountNumber: item['processedACH'].ACCOUNT,
                  Ach: true,
                  OfflinePayment: item.payModeId == EPaymentModes.ACHManualAuthorization ? true : false,
                  AutoAchProcessingDay: 0,
                  AutoAchPayment: false,
                  //TransactionDateTime: new Date(),
                  TransactionTypeId: EPaymentTransactionType.Processed,
                  OrderId: item.orderId,
                  PaymentTransactionTypeId: paymentTrnsId,
                  FacilityId: this.processPayment.facId,
                  TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                  AchRoutingNumber: item['processedACH'].ROUTINGNUMBER,
                  UniqueTransId: null,
                  ReceiptText: item['processedACH'].RECEIPTTEXT,
                  AchAccountType: item['processedACH'].ACCOUNTYPE,
                  PaymentAccountId: item['processedACH'].PaymentAccountId,
                  GatewayDetails: this.requestgatewaydetails,
                  PaymentIntentId: item['processedACH'].PaymentIntentId,
                  IsStripeEFT: item['processedACH'].IsStripeEFT ? item['processedACH'].IsStripeEFT : item.payModeId == EPaymentModes.EFTManualAuthorization ? true : false,
                  CustomerId: item['processedACH'].CustomerId
                }
              ]
            };
          } else {
            tempMultipleACH = {
              Amount: parseFloat(Number(item['processedACH'].APPROVEDAMOUNT).toFixed(2)),
              PaymentModeId: item.payModeId == EPaymentModes.DirectDebitEFT ? EPaymentModes.ACH : item.payModeId == EPaymentModes.EFTManualAuthorization ? EPaymentModes.ACHManualAuthorization : item.payModeId == EPaymentModes.DirectDebitEFTOnFile ? EPaymentModes.ACHOnFile : item.payModeId,
              CheckNumber: item['processedACH'].CHECKNUMBER,
              AchAuthorizationCode: item['processedACH'].TRANSACTIONID,
              ResponseCode: item['processedACH'].RESPONSECODE,
              Reason: item['processedACH'].RESPONSEDESCRIPTION,
              AchAccountNumber: item['processedACH'].ACCOUNT,
              Ach: true,
              OfflinePayment:  item.payModeId == EPaymentModes.ACHManualAuthorization ? true : false,
              AutoAchProcessingDay: 0,
              AutoAchPayment: false,
              TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
              //TransactionDateTime: new Date(),
              TransactionTypeId: EPaymentTransactionType.Processed,
              OrderId: item.orderId,
              PaymentTransactionTypeId: paymentTrnsId,
              FacilityId: this.processPayment.facId,
              AchRoutingNumber: item['processedACH'].ROUTINGNUMBER,
              UniqueTransId: null,
              ReceiptText: item['processedACH'].RECEIPTTEXT,
              AchAccountType: item['processedACH'].ACCOUNTYPE,
              PaymentAccountId: item['processedACH'].PaymentAccountId,
              GatewayDetails: this.requestgatewaydetails,
              IsStripeEFT: item['processedACH'].IsStripeEFT,
              CustomerId: item['processedACH'].CustomerId
            };
            tempACHObj.ACHTransaction.push(tempMultipleACH);
            tempMultipleACH = {};
          }
        } else if (item.payModeId == EPaymentModes.CardOnfile) {
          isCC = true;
          let arr = [this.paymentGateway === EPaymentGateway.Stripe ? item['processedStripeCC'] : item['processedCC']];

          if (!tempCCObj || !tempCCObj.CCTransaction) {
            tempCCObj = { CCTransaction: arr };
          } else {
            tempCCObj.CCTransaction.push(arr[0]);
          }
        } else if (item.payModeId == EPaymentModes.RemotePay) {
          if (tempRemotePayObj == undefined || tempRemotePayObj.IsRemotePayTransaction == undefined) {
            isRemotePay = true;
            tempRemotePayObj = {
              IsRemotePayTransaction: {
                Amount: payableAmount,
                PaymentModeId: EPaymentModes.RemotePay,
              }
            };
          } else {
            tempRemotePayObj.IsRemotePayTransaction.Amount += payableAmount;
          }
        }
      }
    });

    // The forEach `return` above only skips one row — abort completion here so the overall
    // transaction can't finish without a HostedPage payment that never actually processed.
    if (hasIncompleteOpenEdgeHostedPagePayment) {
      this.loaderIcon = Promise.resolve(false);
      this.toastr.error('A card payment did not complete successfully. Please retry before continuing.', 'Payment Incomplete', this.toasterConfig);
      return;
    }

    if (tempCashObj && tempCashObj.CashTransaction) {
      if (tempCashObj.CashTransaction.Amount == 0) {
        tempCashObj = undefined;
        isCash = false;
      }
    }
    if (tempCheckObj && tempCheckObj.CheckTransaction) {
      let totalAmt = 0;
      tempCheckObj.CheckTransaction.map((item) => {
        totalAmt += item.Amount;
      });
      if (totalAmt == 0) {
        tempCheckObj = undefined;
        isCheck = false;
      }
    }

    if (tempACHObj && tempACHObj.ACHTransaction) {
      let totalAmt = 0;
      tempACHObj.ACHTransaction.map((item) => {
        totalAmt += item.Amount;
      });
      if (totalAmt == 0) {
        tempACHObj = undefined;
        isAch = false;
      }
    }

    if (tempCCObj && tempCCObj.CCTransaction.length) {
      let totalAmt = 0;
      tempCCObj.CCTransaction.map((item) => {
        totalAmt += item.Amount;
      });
      if (totalAmt == 0) {
        tempCCObj = undefined;
        isCC = false;
      }
    }
    if (tempRemotePayObj && tempRemotePayObj.IsRemotePayTransaction) {
      if (tempRemotePayObj.IsRemotePayTransaction.Amount == 0) {
        tempRemotePayObj = undefined;
        isRemotePay = false;
      }
    }
    if (isCash && isCC && isCheck && isAch) {
      this.finalPayModel = Object.assign(tempCashObj, tempCCObj, tempCheckObj, tempACHObj);
    } else if (isCash && isCC && isCheck) {
      this.finalPayModel = Object.assign(tempCashObj, tempCCObj, tempCheckObj);
    } else if (isCash && isCC && isAch) {
      this.finalPayModel = Object.assign(tempCashObj, tempCCObj, tempACHObj);
    } else if (isCheck && isCC && isAch) {
      this.finalPayModel = Object.assign(tempCheckObj, tempCCObj, tempACHObj);
    } else if (isCheck && isCash && isAch) {
      this.finalPayModel = Object.assign(tempCheckObj, tempCashObj, tempACHObj);
    } else if (isCash && isCC) {
      this.finalPayModel = Object.assign(tempCashObj, tempCCObj);
    } else if (isCash && isCheck) {
      this.finalPayModel = Object.assign(tempCashObj, tempCheckObj);
    } else if (isCC && isCheck) {
      this.finalPayModel = Object.assign(tempCCObj, tempCheckObj);
    } else if (isCash && isAch) {
      this.finalPayModel = Object.assign(tempCashObj, tempACHObj);
    } else if (isCC && isAch) {
      this.finalPayModel = Object.assign(tempCCObj, tempACHObj);
    } else if (isCheck && isAch) {
      this.finalPayModel = Object.assign(tempCheckObj, tempACHObj);
    } else if (isCash) {
      this.finalPayModel = Object.assign(tempCashObj);
    } else if (isCC) {
      this.finalPayModel = Object.assign(tempCCObj);
    } else if (isCheck) {
      this.finalPayModel = Object.assign(tempCheckObj);
    } else if (isAch) {
      this.finalPayModel = Object.assign(tempACHObj);
    }

    if (isRemotePay) {
      let remotePayObj = {
        IsRemotePayTransaction: true,
        RemotePayTransactionId: this.RemotePayTransactionId,
        RemotePayAmount: parseFloat(Number(tempRemotePayObj.IsRemotePayTransaction.Amount).toFixed(2))
      };
      if (this.finalPayModel) {
        this.finalPayModel = Object.assign(this.finalPayModel, remotePayObj);
      } else {
        this.finalPayModel = Object.assign(remotePayObj);
      }
    }
    this.shareModel.push(this.finalPayModel);
    let ccObj;

    ccObj = null;
    this.shareModel.push(ccObj);
    this.shareModel.push({
    LinkedleaseNo: this.LinkedleaseNo});
    this.charityFeesContribution.emit(this.charityContribution);
    this.surchargeContribution.emit(this.buildSurchargeContribution());
    this.appInsightsService.logPaymentEvent(isCCPayment, `Emmiting Transaction Response to Rental Component.`, { Gateway: this.paymentGateway ,FacilityId : this.processPayment.facId, OrderId : this.getPaymentOrderId(), UserId : this.userSessionService.userSessionData.UserId});
    this.payCompleted.emit(this.shareModel);
    if (this.paymentTable && this.paymentTable.length) {
      let sum = this.paymentTable.reduce((sum, a) => sum + a.payAmount, 0);
      if (sum == 0) {
        this.isZeroPayment.emit(true);
      }
    }

    if (type == 1 && this.partialPaySuccess) {
      this.showPrintEmailRcpt = true;
    }
  }

  addRow() {
    if (this.isTdMismatchRetryBlocked || this.isAnyRowSurchargeLocked()) {
      return;
    }
    var obj;
    this.defaultmode = 0;
    this.paymentCount++;
    if (this.paymentTable.length == 0) {
      obj = {
        payId: this.paymentCount,
        payName: 'Payment ' + this.paymentCount,
        payAmount: this.totalAmount,
        payComplete: false,
        payNowDisable: true,
        payModeId: 0,
        orderId: null,
        changeAmount: 0,
        checkNum: 0,
        checkDate: '',
        bankName: '',
        ManualCardNumber: '',
        ManualCardExp: '',
        ManualCardName: '',
        CreditCardType: 0,
        ManualCardAuthorization: '',
        defaultmode: 0,
        roundingvalue: 0,
        uniqueTransId: null,
        payFailed: false,
        routingNumber: '',
        accountNumber: 0,
        achManualCardAuthorization: '',
        accountType: 279,
        nameonAccount: '',
        isOpenEdgePaymentCompleted: false,
        remotePayIsSMS: false,
        remotePayPhoneNumber: '',
        remotePayIsEmail: false,
        remotePayEmailId: '',
        stripePaymentIntentId: 0,
        EnableAutopayOrCardOnFile: 'cancel',
        TerminalDeviceId: '',
        surchargeLocked: false
      };
    } else {
      obj = {
        payId: this.paymentCount,
        payName: 'Payment ' + this.paymentCount,
        payAmount: 0,
        payComplete: false,
        payNowDisable: true,
        payModeId: 0,
        orderId: null,
        changeAmount: 0,
        checkNum: 0,
        checkDate: '',
        bankName: '',
        ManualCardNumber: '',
        ManualCardExp: '',
        ManualCardName: '',
        CreditCardType: 0,
        ManualCardAuthorization: '',
        defaultmode: 0,
        uniqueTransId: null,
        payFailed: false,
        routingNumber: '',
        accountNumber: 0,
        achManualCardAuthorization: '',
        accountType: 279,
        nameonAccount: '',
        isOpenEdgePaymentCompleted: false,
        remotePayIsSMS: false,
        remotePayPhoneNumber: '',
        remotePayIsEmail: false,
        remotePayEmailId: '',
        stripePaymentIntentId: 0,
        roundingvalue: 0,
        EnableAutopayOrCardOnFile: 'cancel',
        TerminalDeviceId: '',
        surchargeLocked: false
      };
    }
    this.paymentTable.push(obj);
  }

  removeRow() {
    if (this.isTdMismatchRetryBlocked) { return; }
    if (this.paymentCount != 1 && (!this.paymentTable[this.paymentTable.length - 1].payComplete)) {
      this.paymentCount--;
      if (this.paymentTable.length == 0) {
        this.remainingAmount = parseFloat(this.totalAmount);
      } else {
        let tempRemaing = 0;
        let Id = this.paymentTable[this.paymentTable.length - 1].payId;
        this.paymentTable.map(item => {
          if (Id !== item.payId) {
            tempRemaing += item.payAmount;
          }
        });
        if (this.EnableCashRounding && this.paymentTable.find((ele) => ele.payId == Id && ele.payModeId == EPaymentModes.Cash && (this.RoundingOption == ECashRoundingOption.RoundUp || (this.RoundingOption == ECashRoundingOption.Round && this.paymentTable.find((ele) => ele.payId == Id).roundingvalue > 0)))) {
          this.totalAmount = this.totalAmount - this.paymentTable.find((ele) => ele.payId == Id).roundingvalue;
        }
        this.remainingAmount = (this.totalAmount - tempRemaing) >= 0 ? (this.totalAmount - tempRemaing) : 0;
      }
      this.paymentTable.splice(this.paymentTable.length - 1, 1);
    }
  }

  onChangeAmt(Id, val) {
    if (this.paymentTable.find((ele) => ele.payId == Id)?.surchargeLocked) {
      return;
    }
    this.currentModeId = Id;
    this.loaderIcon2 = Promise.resolve(true);
    this.paymentTable.find((ele) => ele.payId == Id)['enterValDisable'] = true;
    if (this.EnableCashRounding && this.paymentTable.find((ele) => ele.payId == Id && ele.payModeId == EPaymentModes.Cash)) {
      this.paymentTable.find((ele) => ele.payId == Id)['payAmount'] = this.CalculateRoundedCashAmount(val, Id, true)
    }
    const enteredValue = parseFloat(val.replace(/[^0-9.-]+/g, ''));
    const amountToBePaid = this.processPayment.AmountTobePaid;
    if (this.EnableCashRounding) {
      const totalSurchargeFee = this.paymentTable.reduce((sum, x) => sum + (x.surchargeFeeAmount || 0), 0);
      if (this.paymentTable.filter(x => x.payModeId == 1) != null && this.paymentTable.reduce((sum, x) => sum + x.payAmount, 0) > this.originalTotalAmount) {
        this.totalAmount = this.originalTotalAmount + this.paymentTable.reduce((sum, x) => sum + x.roundingvalue, 0) + totalSurchargeFee + (this.charityContributionAmount || 0);
        this.remainingAmount = this.totalAmount - this.paymentTable.reduce((sum, x) => sum + Number(x.payAmount), 0)
      }
      else {
        this.totalAmount = this.originalTotalAmount + totalSurchargeFee + (this.charityContributionAmount || 0);
        this.remainingAmount = this.totalAmount - this.paymentTable.reduce((sum, x) => sum + Number(x.payAmount), 0)
      }
    }

  }
  onChangepayAmount(val, Id) {
    val = !val ? 0 : val;
    let payAmount = 0;
    let sumOfAmountExceptEdited = 0;
    let disablePayNow = false;
    this.paymentTable.map((item) => {
      if (item.payId !== Id && !item.payNowDisable) {
        let amount = this.isString(item.payAmount) ? parseFloat(item.payAmount) : item.payAmount;
        payAmount = payAmount + amount;
      }
    });
    sumOfAmountExceptEdited = payAmount;
    payAmount = payAmount + parseFloat(val);
    if (((this.processPayment.Type == EPaymentOrigin.Transfer) && (!this.processPayment.requireFullPayment ||
      (this.processPayment.requireFullPayment && (this.processPayment.PrePayPeriod > 0 || this.processPayment.IsDueWoPrePayZero)))) ||
      (([EPaymentOrigin.Rental, EPaymentOrigin.Reservation, EPaymentOrigin.MakePayment].includes(this.processPayment.Type)) &&
        (!this.processPayment.requireFullPayment))
      || ([EPaymentOrigin.MoveOut, EPaymentOrigin.ReInstate].includes(this.processPayment.Type))
      || this.processPayment.isAllowanceApplied) { // for Transfer,Movein and Moveout Zero payment
      if (parseFloat(val) === 0 && this.paymentTable.find(o => o.payId === Id).payModeId != 0) {
        this.paymentTable.find(o => o.payId === Id).payNowDisable = disablePayNow;
      } else {
        if (parseFloat(val) > 0 && this.paymentTable.find(o => o.payId === Id).payModeId > 0) {
          this.paymentTable.find(o => o.payId === Id).payNowDisable = disablePayNow;
        } else {
          this.paymentTable.find(o => o.payId === Id).payNowDisable = true;
        }
      }
      if (parseFloat(this.remainingAmount) >= 0) {
        let tempRemaing = 0;
        this.paymentTable.map(item => {
          if (Id == item.payId) {
            tempRemaing += parseFloat(val);
          }
          else {
            tempRemaing += parseFloat(item.payAmount);
          }
        });
        let tempBox = parseFloat(tempRemaing.toFixed(2))
        this.remainingAmount = (parseFloat(this.totalAmount) - tempBox) >= 0 ? (parseFloat(this.totalAmount) - tempBox) : 0; 
      }
      this.paymentTable.find(o => o.payId === Id).payAmount = parseFloat(val);

    } else {
      if (parseFloat(this.remainingAmount) >= 0) {
        let tempRemaing = 0;
        this.paymentTable.map(item => {
          if (Id == item.payId) {
            tempRemaing += parseFloat(val);
          } else {
            tempRemaing += parseFloat(item.payAmount);
          }
        });
        let tempBox = parseFloat(tempRemaing.toFixed(2))
        this.remainingAmount = (parseFloat(this.totalAmount) - tempBox) >= 0 ? (parseFloat(this.totalAmount) - tempBox) : 0;
      }
      if (this.remainingAmount > 0 && this.processPayment.Type == EPaymentOrigin.Transfer) {
        this.paymentTable.map(ele => ele.payNowDisable = true);
        disablePayNow = true;
      } else {
        this.paymentTable.map((item) => {
          if (item.payModeId != 0 && item.payAmount != 0) {
            item.payNowDisable = false
          }
        });
        disablePayNow = false;
      }
      if (parseFloat(val) > 0 && this.paymentTable.find(o => o.payId === Id).payModeId > 0) {
        this.paymentTable.find(o => o.payId === Id).payNowDisable = disablePayNow;
      } else {
        this.paymentTable.find(o => o.payId === Id).payNowDisable = true;
      }
      this.paymentTable.find(o => o.payId === Id).payAmount = parseFloat(val);
    }
    this.paymentTable.find((ele) => ele.payId == Id)['enterValDisable'] = false;
    this.loaderIcon2 = Promise.resolve(false);
    this.reapplySurchargeIfLocked(Id);
    this.restrictOverpay(payAmount, sumOfAmountExceptEdited, Id)
    if (this.processPayment.FromAmenities && this.processPayment.minAmountFromAmenities && this.processPayment.minAmountFromAmenities > 0) {
      this.processPayment.minAmountFromAmenities = Math.min(this.processPayment.minAmountFromAmenities, this.processPayment.AmountTobePaid);

      let isMultimodePayment = this.paymentTable.length > 1;

      if (isMultimodePayment) {
        // Only enforce after all rows have a value
        let allRowsFilled = this.paymentTable.every(item => {
          let amount = this.isString(item.payAmount) ? parseFloat(item.payAmount) : item.payAmount;
          return amount > 0;
        });
        if (allRowsFilled) {
          this.enforceMinAmount(payAmount, sumOfAmountExceptEdited, Id);
        }
      } else {
        this.enforceMinAmount(payAmount, sumOfAmountExceptEdited, Id);
      }
    }
  }

  restrictOverpay(payAmount, sumOfAmountExceptEdited, Id) {
    payAmount = this.isString(payAmount) ? parseFloat(payAmount) : payAmount;
    if ((payAmount).toFixed(2) > this.totalAmount) {
      let isMultimodePayment = this.paymentTable.length > 1 ? true : false;
      let alertMessage = (isMultimodePayment && (this.paymentTable.filter(x=>x.payModeId == 1)== null && this.RoundingOption === ECashRoundingOption.RoundUp))   ? 'Sum of Tender Amount cannot be greater than Total Amount.' :
        'Tender Amount cannot be greater than Total Amount.';
      this.toastr.warning(alertMessage, 'Alert', this.toasterConfig);
      let valToUpdate = 0;
      if (isMultimodePayment) {
        valToUpdate = this.totalAmount - sumOfAmountExceptEdited;
      } else {
        valToUpdate = this.totalAmount;
      }
      this.updateAgain(valToUpdate, Id);
    }
  }

  enforceMinAmount(payAmount, sumOfAmountExceptEdited, Id) {
    payAmount = this.isString(payAmount) ? parseFloat(payAmount) : payAmount;
    if ((payAmount).toFixed(2) < this.processPayment.minAmountFromAmenities) {
      let isMultimodePayment = this.paymentTable.length > 1 ? true : false;
      let alertMessage = isMultimodePayment ? 'Sum of Tender Amount is less than the minimum Amount.' :
        'Tender Amount is less than minimum Amount.';
      this.toastr.warning(alertMessage, 'Alert', this.toasterConfig);
      let valToUpdate = 0;
      if (isMultimodePayment) {
        valToUpdate = Math.max(0, this.processPayment.minAmountFromAmenities - sumOfAmountExceptEdited);
      } else {
        valToUpdate = this.processPayment.minAmountFromAmenities;
      }
      this.updateAgain(valToUpdate, Id);
    }
  }

  updateAgain(val, Id) {
    setTimeout(() => {
      this.paymentTable.find(o => o.payId === Id).payAmount = val.toFixed(2);
      if (this.processPayment.FromAmenities && this.processPayment.minAmountFromAmenities && this.processPayment.minAmountFromAmenities > 0) {
        let correctedSum = this.paymentTable.reduce((sum, item) => {
          return sum + (this.isString(item.payAmount) ? parseFloat(item.payAmount) : item.payAmount);
        }, 0);
        this.remainingAmount = Math.max(0, parseFloat(this.totalAmount) - parseFloat(correctedSum.toFixed(2)));
        }
      if (this.EnableCashRounding && this.paymentTable.find((ele) => ele.payId == Id && ele.payModeId == EPaymentModes.Cash)) {
        this.paymentTable.find((ele) => ele.payId == Id)['payAmount'] = this.CalculateRoundedCashAmount(val, Id);
        this.remainingAmount = this.totalAmount - this.paymentTable.reduce((sum, x) => sum + x.payAmount, 0);
      }
      this.reapplySurchargeIfLocked(Id);
    }, 10);
  }

  maxValueValidate(val) {
    if (val > this.tempremAmt) {
      return this.tempremAmt;
    } else {
      return val;
    }
  }

  onChangeManualCard(evt) {
    this.ManualSelectCard = evt.target.value;
    this.isManualSelectCard = this.ManualSelectCard == '0' ? true : false;
    this.manualAuthForm.form.patchValue({
      mCardType: this.ManualSelectCard == '0' ? 0 : this.ManualSelectCard
    })
  }

  onPayClick(amount, payId, template: TemplateRef<any>, templateCheck: TemplateRef<any>) {
    if (this.isTdMismatchRetryBlocked || this.isOpenEdgeReconciliationBlocked(this.paymentTable.find(o => o.payId == payId))) {
      return;
    }
    this.displayPaymentPopup=true;
    this.amount=amount;
    this.payId=payId;
    this.template=template;
    this.templateCheck=templateCheck;
    if (this.generalService.emitoAutEnrollPP && ! this.generalService.revokeAutoEnrollPP && this.remainingAmount>0) 
          {
            this.showpopupforpartialPayment.show();
            this.displayPaymentPopup=false;
          }
    if(this.generalService.emitAutoEnrolwithNoDue && ! this.generalService.revokeAutoEnrollPP && this.amount==0){
      {
            this.showpopupforpartialPayment.show();
            this.displayPaymentPopup=false;
          }
    }
    if(this.facOpsDataService?.RequireFullPrepaymentOnDueDateChange?.IsNextBillingDateChanged && this.remainingAmount>0){
      this.show_OnDueDateChangeConfirmPopup = this.modalService.show(this.OnDueDateChangeConfirmPopup, { class: 'modal-dialog modal-dialog-centered modal-md', backdrop: 'static', keyboard: false });
      return;
    }      
    let paymentModeId = this.paymentTable.find(o => o.payId === payId).payModeId;
    var allowPartialPayment = this.userSessionService.userSessionData?.UserGroup.IndividualPermission?.UserGroupOverrideSettings?.AllowPartialPayment;
    if ((this.processPayment.Type == EPaymentOrigin.Transfer && this.processPayment.requireFullPayment &&
      !(this.processPayment.PrePayPeriod > 0 || this.processPayment.IsDueWoPrePayZero)) && !this.isCurrentPeriodAmountAdded() && !allowPartialPayment) { // for Transfer Require full payment
      this.toastr.warning('Please Pay Full Amount!', 'Alert', this.toasterConfig);
    } else if (this.processPayment.Type == EPaymentOrigin.Merchandise && (this.remainingAmount > 0)) { // For Merchandise always Full Amount need to Pay
      this.toastr.warning('Please Pay Full Amount!', 'Alert', this.toasterConfig);
    } else if ((this.processPayment.Type == EPaymentOrigin.Rental && this.processPayment.requireFullPayment) && !this.isCurrentPeriodAmountAdded() && !allowPartialPayment) { // for rental Require full payment
      this.toastr.warning('Please Pay Full Amount!', 'Alert', this.toasterConfig);
    } else if ((this.processPayment.Type == EPaymentOrigin.Reservation && this.processPayment.requireFullPayment) && (this.remainingAmount > 0)) { // for Reservation need to do full payment
      this.toastr.warning('Please Pay required Amount!', 'Alert', this.toasterConfig);
    } else if ((this.processPayment.Type == EPaymentOrigin.AuctionManager && this.processPayment.requireFullPayment) && (this.remainingAmount > 0)) { // make payment for Auction
      this.toastr.warning('Please Pay Full Amount!', 'Alert', this.toasterConfig);
    } else if ((this.processPayment.Type == EPaymentOrigin.MakePayment && this.processPayment.requireFullPayment && (!this.isCurrentPeriodAmountAdded() || (this.processPayment.AmountTobePaid < this.processPayment.AmountTobePaidWithoutPD ))) && !allowPartialPayment) { // for make payment delinquent
      this.toastr.warning('Please Pay Full Amount!', 'Alert', this.toasterConfig);
    } else if (this.paymentGateway == EPaymentGateway.Stripe && [EPaymentModes.CreditCard, EPaymentModes.DirectDebitEFTOnFile, EPaymentModes.HostedPage, EPaymentModes.ACH, EPaymentModes.DirectDebitEFT,
    EPaymentModes.CardOnfile, EPaymentModes.ACHOnFile, EPaymentModes.ApplePay, EPaymentModes.GooglePay, EPaymentModes.CashApp,
    EPaymentModes.RemotePay].includes(paymentModeId) && amount < 0.50) { // Stripe doesn't allow < 0.50 payment
      this.toastr.warning('Amount must be at least $0.50 for Stripe payment!', 'Alert', this.toasterConfig);
    } else if (amount == 0 && this.paymentTable.length == 1 && ! this.generalService.emitoAutEnrollPP && !this.generalService.emitAutoEnrolwithNoDue) { // for Transfer and Movein Zero payment
      if ([EPaymentOrigin.Transfer, EPaymentOrigin.Rental].includes(this.processPayment.Type) && this.processPayment.requireFullPayment) {
        this.payBasedOnMode(amount, payId, template, templateCheck);
      } else {
        this.loaderIcon = Promise.resolve(true); // gets stopped after the Transaction is Success/Failed
        this.paymentStarted = true;
        this.showPrintEmailRcpt = true;
        let obj = null;
        this.payStatus = 'Success';
        this.paymentSuccessFul = true;
        this.currentPayId = payId;
        this.shareModel.push(obj);
        let ccObj;
        ccObj = null;
        this.shareModel.push(ccObj);
        this.charityFeesContribution.emit(this.charityContribution);
        this.payCompleted.emit(this.shareModel);
      }
    } else if(this.paymentTable.length>1 && this.paymentTable.some(function (ele) { return ele.payComplete == false && (ele.payAmount == 0 || ele.payModeId == 0); }))
    { 
      if (this.paymentTable.some(function (ele) { return ele.payComplete == false && ele.payModeId == 0; })){
        this.toastr.warning('Please select Payment Mode', 'Alert', this.toasterConfig);
      }
      else{
           this.toastr.warning('Please Enter Tender Amount', 'Alert', this.toasterConfig);
      }

    }

    else {
      if(this.displayPaymentPopup){
          this.payBasedOnMode(amount, payId, template, templateCheck);
      }
    }
  }

  onPayCancel() {
    this.paymentStarted = false;
    this.tenderAmount = 0;
    this.changeAmount = 0;
    this.modalRef.hide();
    this.checkPaymentProcess();
  }

  /**
   * Calculates the surcharge fee for a given base and rule config — mirrors the backend
   * FeeChargeCalculator.CalculateSurchargeFeeAmount logic (FR-4 / SPEC §4.3).
   * base * pct/100, rounded per the rule's rounding config, then clamped to [minFee, maxFee]
   * (falls back to 2-decimal rounding when no rounding option/value is configured).
   * A zero/negative base always returns 0, bypassing rounding/minFee/maxFee — a $0 (or negative)
   * pre-tax balance must never be charged a surcharge, even under an active minimum-fee rule.
   */
  calculateSurchargeFeeAmount(base: number, feePercentage: number, minFee?: number, maxFee?: number, roundingOption?: number, roundingValue?: number): number {
    if (base <= 0) {
      return 0;
    }
    let result = base * (feePercentage / 100);
    result = this.applySurchargeRounding(result, roundingOption, roundingValue);
    if (minFee != null) result = Math.max(result, minFee);
    if (maxFee != null) result = Math.min(result, maxFee);
    result = Math.max(0, result);
    return parseFloat(result.toFixed(2));
  }

  /** RoundingValue is the LOVType 10 ("Rounding To Nearest") id, not a numeric step — resolve it
   *  the same way RoundOffCalculator.ResolveRoundingToNearestValue does server-side before use. */
  private resolveRoundingToNearestValue(roundingValueLovId?: number): number {
    switch (roundingValueLovId) {
      case ERoundingToNearest.Cents5: return 0.05;
      case ERoundingToNearest.Cents10: return 0.1;
      case ERoundingToNearest.Cents50: return 0.5;
      case ERoundingToNearest.Dollar1: return 1;
      default: return 0;
    }
  }

  /** Mirrors backend RoundOffCalculator.CalculateRounding so client-side recalculation stays
   *  consistent with the amount the server already computed the same rule with. */
  private applySurchargeRounding(amount: number, roundingOption?: number, roundingValue?: number): number {
    const step = this.resolveRoundingToNearestValue(roundingValue);
    if (!step) {
      return parseFloat(amount.toFixed(2));
    }
    if (roundingOption === ERentRoundingOption.Round) {
      return Math.round(amount / step) * step;
    }
    if (roundingOption === ERentRoundingOption.RoundUp) {
      return Math.ceil(amount / step) * step;
    }
    if (roundingOption === ERentRoundingOption.RoundDown) {
      return Math.floor(amount / step) * step;
    }
    return parseFloat(amount.toFixed(2));
  }

  /**
   * Builds the surcharge ModifiedFeesList entry to be emitted to the parent,
   * mirroring the charity fee pattern. Returns null if no surcharge applies.
   */
  buildSurchargeContribution(): any {
    const lockedRow = this.paymentTable && this.paymentTable.find(r => r.surchargeLocked && r.surchargeFeeAmount > 0);
    if (!lockedRow) { return null; }
    const rule = this.findSurchargeRuleForSource(lockedRow.payModeId);
    if (!rule || !rule.FeeId) { return null; }
    return {
      FeesAndChargesId: rule.FeeId,
      Amount: lockedRow.surchargeFeeAmount,
      // Fixed fee: the applied value is the amount; saved as ufc_int_ValueApplied.
      Value: lockedRow.surchargeFeeAmount,
      OneTimeFees: true,
      IsSurchargeFee: true,
      Type: EFeesCharges.Fixed,
      EffectiveDate: new Date(),
      Modified: false,
      Tax: []
    };
  }

  hydrateSurchargeContext(): void {
    const surchargeFees = this.processPayment?.SurchargeFees ?? this.surchargeFees ?? [];
    this.surchargeFees = Array.isArray(surchargeFees) ? surchargeFees : [];
    const taxDue = this.processPayment?.TotalTax ?? this.totalTaxDue ?? 0;
    this.totalTaxDue = Number.isFinite(taxDue) ? Number(taxDue) : 0;
    if (this.processPayment?.SurchargeBase != null && !this.surchargeFees.length) {
      this.surchargeFees = [];
    }
  }

  // Walk-in merchandise sales (no tenant/lease) never carry a surcharge fee.
  private isWalkInMerchandiseSale(): boolean {
    return this.processPayment?.Type == EPaymentOrigin.Merchandise && this.processPayment?.isMerchSale === true;
  }

  private getCurrentPaymentSourceId(): number {
    return this.userSessionService?.isCallcenterAgent ? EPaymentSources.CallCenter : EPaymentSources.InStore;
  }

  private findSurchargeRuleForSource(paymentModeId: number): ISurchargeFeeInfo | undefined {
    if (this.isWalkInMerchandiseSale()) {
      return undefined;
    }
    const currentSourceId = this.getCurrentPaymentSourceId();
    return (this.surchargeFees || []).find(rule => {
      if (rule.PaymentModeId !== paymentModeId) {
        return false;
      }

      return !!rule.PaymentSourceIds?.includes(currentSourceId);
    });
  }

  /**
   * Applies (or clears) the surcharge fee for a row based on the selected payment mode.
   * Fee is calculated from the row's current payAmount so prepay / distribution-override
   * changes are automatically reflected — no static backend base is used.
   */
  applySurchargeFeeForRow(payId: number, payModeId: number) {
    const row = this.paymentTable.find(o => o.payId === payId);
    if (!row) {
      return;
    }
    // Cash rounding on a surcharge row is applied last, so take it out before re-computing the surcharge base.
    if (row.surchargeLocked && row.roundingvalue) {
      row.payAmount = parseFloat(((this.isString(row.payAmount) ? parseFloat(row.payAmount) : (row.payAmount || 0)) - row.roundingvalue).toFixed(2));
      row.roundingvalue = 0;
    }
    const matchedSurchargeFee = this.findSurchargeRuleForSource(payModeId);
    if (matchedSurchargeFee) {
      const rowBase = this.isString(row.payAmount) ? parseFloat(row.payAmount) : (row.payAmount || 0);
      // Charity (first row only) is applied after the surcharge, so it is excluded from the surcharge base.
      const rowCharity = row === this.paymentTable[0] ? (this.charityContributionAmount || 0) : 0;
      // Surcharge is calculated on the pre-tax amount: subtract the total tax due from the row amount.
      const preTaxBase = Math.max(0, rowBase - rowCharity - (this.totalTaxDue || 0));
      row.surchargeFeeAmount = this.calculateSurchargeFeeAmount(
        preTaxBase,
        matchedSurchargeFee.FeePercentage,
        matchedSurchargeFee.MinFee,
        matchedSurchargeFee.MaxFee,
        matchedSurchargeFee.RoundingOption,
        matchedSurchargeFee.RoundingValue
      );
      row.surchargeFeePercentage = matchedSurchargeFee.FeePercentage;
      row.surchargeLocked = true;
    } else {
      row.surchargeFeeAmount = 0;
      row.surchargeFeePercentage = 0;
      row.surchargeLocked = false;
    }
    this.totalAmount = parseFloat((this.originalTotalAmount + this.getTotalSurchargeFee() + (this.charityContributionAmount || 0)).toFixed(2));
    this.applySurchargeCashRounding(row, payModeId);
  }

  /**
   * Cash rounding for a surcharge-locked Cash row is the last step: it rounds base + surcharge + charity
   * (the payable) with the facility's cash-rounding setting. The delta is stored in roundingvalue and added to
   * the row's payAmount (not to the surcharge fee) and to totalAmount. Expects payAmount and totalAmount to
   * exclude any earlier rounding. No-op for rows without a surcharge (their cash rounding is unchanged).
   */
  private applySurchargeCashRounding(row: any, payModeId: number): void {
    if (!row || !row.surchargeLocked) {
      return;
    }
    row.roundingvalue = 0;
    if (!this.EnableCashRounding || Number(payModeId) !== EPaymentModes.Cash) {
      return;
    }
    const unroundedAmount = this.isString(row.payAmount) ? parseFloat(row.payAmount) : (row.payAmount || 0);
    const payable = parseFloat((unroundedAmount + (row.surchargeFeeAmount || 0)).toFixed(2));
    this.CalculateRoundedCashAmount(payable, row.payId, true);
    row.payAmount = parseFloat((unroundedAmount + row.roundingvalue).toFixed(2));
    this.totalAmount = parseFloat((parseFloat(this.totalAmount) + row.roundingvalue).toFixed(2));
  }

  /** Cash rounding applied to surcharge-locked rows (see applySurchargeCashRounding). */
  private getSurchargeCashRounding(): number {
    return this.paymentTable.reduce((sum, x) => x.surchargeLocked ? sum + (x.roundingvalue || 0) : sum, 0);
  }

  /** Sum of all rows' surcharge fees (Processing Fee in the surcharge summary). */
  getTotalSurchargeFee(): number {
    return parseFloat(this.paymentTable.reduce((sum, x) => sum + (x.surchargeFeeAmount || 0), 0).toFixed(2));
  }

  /** Cash rounding included in totalAmount (Cash Rounding line in the surcharge summary). */
  getCashRoundingAmount(): number {
    if (!this.EnableCashRounding) {
      return 0;
    }
    const rounding = Math.round((parseFloat(this.totalAmount) - this.originalTotalAmount - this.getTotalSurchargeFee() - (this.charityContributionAmount || 0)) * 100) / 100;
    return rounding === 0 ? 0 : rounding;
  }

  /** Re-calculates surcharge fee for a row when its payAmount changes (prepay / override). */
  private reapplySurchargeIfLocked(payId: number): void {
    const row = this.paymentTable.find(o => o.payId === payId);
    if (row && row.surchargeLocked && row.payModeId) {
      this.applySurchargeFeeForRow(payId, row.payModeId);
      this.recalculateRemainingAmount();
    }
  }

  // totalAmount includes each row's surcharge, so the surcharge counts as tendered.
  private recalculateRemainingAmount(): void {
    const tendered = this.paymentTable.reduce((sum, row) => row.payModeId ? sum + this.getRowPayableAmount(row) : sum, 0);
    this.remainingAmount = Math.max(0, parseFloat((parseFloat(this.totalAmount) - tendered).toFixed(2)));
  }

  isAnyRowSurchargeLocked(): boolean {
    return this.paymentTable.some(row => row.surchargeLocked);
  }

  /** Row's payable amount including surcharge fee (Sub Total column / Pay Now amount).
   *  payAmount can be a string (e.g. "28960.65") so we must parseFloat before adding. */
  getRowPayableAmount(drow: any): number {
    const base = this.isString(drow.payAmount) ? parseFloat(drow.payAmount) : (drow.payAmount || 0);
    return parseFloat((base + (drow.surchargeFeeAmount || 0)).toFixed(2));
  }

  /** i18n text for the lock-reason aria-describedby spans (Story 2.2, NFR-1). */
  getSurchargeLockReasonText(): string {
    return this.surchargeLockReasonText;
  }

  /** i18n alert message for the mixed-mode alertdialog (Story 2.3, FR-6). */
  getSurchargeMixedModeAlertText(): string {
    return this.surchargeMixedModeAlertText;
  }

  /**
   * Dismiss the mixed-mode surcharge alertdialog (Story 2.3, UX-DR10).
   * Reverts the row's mode selector to its previous mode (Select for a newly-added row) and
   * returns focus to it. The row itself is always kept so the user can pick another mode.
   */
  dismissSurchargeMixedModeAlert(): void {
    const revertContext = this._surchargeMixedModeRevertContext;
    this._surchargeMixedModeRevertContext = null;

    if (this.surchargeMixedModeModalRef) {
      // Return focus to the mode selector after the modal finishes hiding (UX-DR10).
      // Uses the modal's onHidden observable instead of setTimeout to avoid timing anti-patterns.
      if (revertContext) {
        this.surchargeMixedModeModalRef.onHidden.pipe(take(1)).subscribe(() => {
          try {
            const el = this.renderer.selectRootElement(`[data-surcharge-row-id="${revertContext.rowId}"]`, true);
            el.focus();
          } catch {
            // selectRootElement throws if the element is not found; focus is best-effort.
          }
        });
      }
      this.surchargeMixedModeModalRef.hide();
      this.surchargeMixedModeModalRef = null;
    }

    if (revertContext) {
      const row = this.paymentTable.find(o => o.payId === revertContext.rowId);
      if (!row) { return; }

      row.defaultmode = revertContext.previousModeId;
      row.payModeId = revertContext.previousModeId;
      row.surchargeFeeAmount = 0;
      row.surchargeFeePercentage = 0;
      row.surchargeLocked = false;
      if (revertContext.previousModeId === 0) {
        row.payNowDisable = true;
      }
      this.recalculateRemainingAmount();
    }
  }

  /**
   * Checks whether the card type returned by the gateway mismatches the user-selected payment mode (FR-8).
   * Reads only the existing DebitCardPayment-derived flag — no new card-data capture (AD-12, NFR-2).
   * If a mismatch is detected: sets alert text, stores revert context, opens the alertdialog, returns true.
   * Returns false when there is no mismatch (caller proceeds normally).
   */
  private checkCardModeMismatch(payId: any, isDebitCardFromGateway: boolean, showAlert = true): boolean {
    const row = this.paymentTable.find(o => o.payId === payId);
    if (!row) { return false; }

    const selectedMode = row.payModeId;
    let mismatch = false;
    let alertKey = '';

    if (isDebitCardFromGateway && selectedMode === EPaymentModes.CreditCard) {
      // Debit card swiped under Credit Card mode (AC-1)
      mismatch = true;
      alertKey = 'PaymentSurcharge.CardModeMismatchDebitUnderCredit';
    } else if (!isDebitCardFromGateway && selectedMode === EPaymentModes.DebitCard) {
      // Credit card swiped under Debit Card mode (AC-2)
      mismatch = true;
      alertKey = 'PaymentSurcharge.CardModeMismatchCreditUnderDebit';
    }

    if (!mismatch) { return false; }

    this.cardMismatchAlertText = this.translate.instant(alertKey);
    this._cardMismatchRevertContext = { rowId: payId };
    if (showAlert) {
      this.showCardMismatchAlert();
    }
    return true;
  }

  private saveCardModeMismatchDecline(orderId: any, amount: any, paymentModeId: number, paymentTrnsId: number, card: any, reason: string): Observable<any> {
    const CCTModel = {
      Amount: amount,
      Autopay: false,
      paymentModeId: paymentModeId,
      AutoCcProcessingDay: 0,
      CreditCardNumber: card?.CreditCardNumber ?? '0',
      CreditCardType: card?.CreditCardType ?? ECreditCards.Visa,
      NameonCard: card?.NameonCard ?? card?.NameOnCard ?? '',
      CreditCardExpiryMonth: card?.CreditCardExpiryMonth ?? 275,
      CreditCardExpiryYear: card?.CreditCardExpiryYear ?? 2099,
      CreditCardBillingAddress: '',
      CreditCardBillingZip: '',
      SwipeTransaction: false,
      SecurityCodeSent: false,
      AuthorizationCode: card?.AuthorizationCode ?? '0',
      ResponseCode: card?.ResponseCode ?? '',
      Reason: reason,
      Key: card?.Key ?? '',
      PaymentAccountid: '',
      CcInfoPurged: false,
      DebitCardPayment: card?.DebitCardPayment === true,
      OfflinePayment: 0,
      PaymentTransactionTypeId: paymentTrnsId,
      OrderId: orderId,
      FacilityId: this.processPayment.facId,
      TransactionDateTime: new Date(),
      TransactionTypeId: EPaymentTransactionType.Declined,
      TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
      TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
      LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
      EmvReceiptText: card?.EmvReceiptText ?? null,
      CCBatchNumber: card?.CCBatchNumber ?? null,
      GatewayDetails: this.requestgatewaydetails
    };
    return this.paymentService.saveCCTransaction(CCTModel);
  }

  get isTdMismatchDismissBlocked(): boolean {
    return this.tdMismatchVoidState === 'pending';
  }

  get isTdMismatchRetryBlocked(): boolean {
    return this.tdMismatchVoidState === 'pending' || this.tdMismatchVoidState === 'unconfirmed';
  }

  private showCardMismatchAlert(id?: string): void {
    if (this.paymentComponentDestroyed) { return; }
    // Keep the default animation: the app's dimmed overlay is styled on `.modal.fade.show` (main.scss), so a
    // non-animated modal has no backdrop and blends into the page. onShown still fires once it is fully visible.
    this.cardMismatchModalRef = this.modalService.show(this.cardMismatchAlertTemplate, {
      class: 'modal-medium modal-dialog-centered',
      backdrop: 'static',
      keyboard: false,
      ...(id ? {
        id,
        closeInterceptor: () => this.paymentComponentDestroyed || !this.isTdMismatchDismissBlocked
          ? Promise.resolve() : Promise.reject()
      } : {})
    });
  }

  /**
   * The card type actually presented, as far as an OpenEdge response reveals it (null when it can't be told):
   * - a credit card under DEBITSALE fails with "Card Not Supported for Debit Transactions";
   * - a debit card under CREDITSALE (approved or declined) reports CARDTYPE "Credit", but its receipt carries the
   *   chip's AID NAME (e.g. "Mastercard Debit").
   */
  private getOpenEdgePresentedCardIsDebit(response: any): boolean | null {
    if (/not supported for debit/i.test(response?.RESULTMSG ?? response?.RESPONSEDESCRIPTION ?? '')) {
      return false;
    }
    if (/AID NAME[^\r\n]*debit/i.test(response?.RECEIPTTEXT ?? '')) {
      return true;
    }
    return null;
  }

  /**
   * OpenEdge sends an explicit CREDITSALE / DEBITSALE, so a card that doesn't match the selected tender is declined
   * rather than approved — show the card/mode mismatch alert instead of the generic decline popup.
   * Only when the response proves the presented card type; any other decline keeps the generic popup.
   */
  private showOpenEdgeDeclineMismatch(payId: any, response: any): boolean {
    const row = this.paymentTable.find(o => o.payId == payId);
    if (this.paymentGateway != EPaymentGateway.OpenEdgeExpress || !row) {
      return false;
    }
    const presentedCardIsDebit = this.getOpenEdgePresentedCardIsDebit(response);
    return presentedCardIsDebit !== null && this.checkCardModeMismatch(row.payId, presentedCardIsDebit);
  }

  /**
   * Whether an OpenEdge terminal row's sale was a DEBITSALE (reversed card-present via DEBITRETURN, saved as debit).
   * The type SSM sent is authoritative: a QUERYPAYMENT/RCM response may omit TRANSACTIONTYPE.
   */
  private isOpenEdgeDebitSale(row: any): boolean {
    return (row?.openEdgeSaleType ?? row?.processedCC?.TRANSACTIONTYPE) === 'DEBITSALE';
  }

  /**
   * After an OpenEdge approval: a debit card tapped under Credit Card is approved as a CREDITSALE, so check the card
   * actually presented and, on a mismatch, show the card/mode mismatch alert and reverse the sale (as TD/Stripe do).
   * Returns true when the approval was rejected; the caller must then not continue to payment success.
   */
  private rejectOpenEdgeMismatchedApproval(payId: any, approved: any, paymentTrnsId: any, rcmApprovedResponse?: any): boolean {
    const row = this.paymentTable.find(o => o.payId == payId);
    if (this.paymentGateway != EPaymentGateway.OpenEdgeExpress || !row || !approved) {
      return false;
    }
    // What SSM sent is authoritative; a gateway response may omit or reformat TRANSACTIONTYPE.
    const saleType = row.openEdgeSaleType ?? approved.TRANSACTIONTYPE;
    // A DEBITSALE can only be approved for a debit card; a CREDITSALE needs card evidence to be called debit.
    const cardEvidence = this.getOpenEdgePresentedCardIsDebit(approved)
      ?? this.getOpenEdgePresentedCardIsDebit(rcmApprovedResponse);
    if (cardEvidence === null && saleType === 'CREDITSALE' && row.payModeId == EPaymentModes.CreditCard) {
      // Reached only when the RCM answer never arrived (max-wait reconciliation) or carried no receipt: the approved
      // charge is kept rather than voided without evidence, but flagged for review.
      this.appInsightsService.logPaymentEvent(true, 'OpenEdge CREDITSALE approved without chip-receipt evidence; card type (credit/debit) not verified', { Gateway: this.paymentGateway, FacilityId: this.processPayment.facId, OrderId: row.uniqueTransId, UserId: this.userSessionService.userSessionData.UserId });
    }
    const presentedCardIsDebit = cardEvidence ?? saleType === 'DEBITSALE';
    if (!this.checkCardModeMismatch(row.payId, presentedCardIsDebit, false)) {
      return false;
    }
    row.payComplete = false;
    row.payFailed = true;
    row.payNowDisable = true;
    this.paymentSuccessFul = false;
    this.loaderIcon = Promise.resolve(false);
    this._isMismatchVoid = true;
    // As the TD flow: the alert can't be dismissed and no retry is allowed until the reversal completes
    // (finishOpenEdgeMismatchVoid), which then shows the confirmed/unconfirmed outcome.
    row.openEdgeMismatchVoid = true;
    this.tdMismatchVoidState = 'pending';
    this.cardMismatchAlertText = this.translate.instant('PaymentSurcharge.OpenEdgeMismatchVoidPrompt');
    this.showCardMismatchAlert(`openedge-card-mismatch-${++PaymentComponent.tdMismatchModalSequence}`);
    if (saleType === 'DEBITSALE') {
      // Card-present reversal (DEBITRETURN). NOTE: push only — don't reset multiPaymentVoidEmv mid-flight.
      row['isEmvVoidInitiated'] = false;
      this.multiPaymentVoidEmv.push(row);
      this.callOpenEdgeVoid(paymentTrnsId);
    } else {
      this.voidOpenEdgeMismatchedCreditSale(row, approved, paymentTrnsId);
    }
    return true;
  }

  /**
   * Card-not-present CREDITVOID of a CREDITSALE approved under the wrong tender — the customer doesn't have to present
   * the card again. Unlike voidCCCNP (the cancel flow), this never closes the payment screen: the mismatch alert stays
   * up and the user picks the matching tender. Values are captured up front because dismissing the alert clears the row.
   */
  private voidOpenEdgeMismatchedCreditSale(row: any, approved: any, paymentTrnsId: any): void {
    const amount = approved.APPROVEDAMOUNT;
    const transactionId = approved.TRANSACTIONID;
    const payModeId = row.payModeId;
    const reversal = this.generateIntialCCT(amount, EPaymentTransactionType.Reversal_Refund, paymentTrnsId, payModeId,
      null, null, null, row.uniqueTransId, false, row.payId);
    this.paymentService.saveCCTransaction(reversal).pipe(
      switchMap((saved: any) => {
        // As callOpenEdgeVoid: no gateway void without a reversal record to tie it to.
        if (!saved?.Success) {
          throw new Error('OpenEdge mismatch void could not be recorded');
        }
        return this.paymentService.GetCNPCreditVoid(this.credentials, transactionId, amount)
          .pipe(map((res: any) => ({ saved, res })));
      })
    ).subscribe(({ saved, res }) => {
      let result: any = null;
      try {
        result = (typeof res === 'string' ? JSON.parse(res) : res)?.RESULT;
      } catch { }
      const voided = result?.RESPONSECODE == EOpenEdgeResponseCode.Approval;
      this.paymentService.saveCCTransaction({
        ...reversal,
        Amount: result?.APPROVEDAMOUNT ?? amount,
        CreditCardNumber: result?.MASKEDCARDNUMBER ?? approved.ACCOUNT ?? 0,
        CreditCardType: approved.CARDBRAND ? this.paymentService.openEdgeCardType(approved.CARDBRAND) : ECreditCards.Visa,
        AuthorizationCode: result?.TRANSACTIONID ?? transactionId,
        ResponseCode: result?.RESPONSECODE ?? '',
        Reason: result?.RESPONSEDESCRIPTION ?? 'No Response',
        DebitCardPayment: true,
        OrderId: saved?.Id,
        TransactionTypeId: voided ? EPaymentTransactionType.Reversal_Refund : EPaymentTransactionType.Declined,
        CCBatchNumber: result?.BATCHNO ?? null,
        EmvReceiptText: result?.RECEIPTTEXT ?? null
      }).subscribe(() => { });
      // The mismatch alert shows the confirmed/unconfirmed outcome (and keeps retry blocked if unconfirmed).
      this.finishOpenEdgeMismatchVoid(row, voided);
    }, (err) => {
      // Reversal not recorded or gateway unreachable: the approved sale stays live and needs manual reconciliation.
      this.appInsightsService.logPaymentEvent(true, `OpenEdge mismatch void failed: ${err?.message ?? 'No Response'}, TransactionId : ${transactionId}`, { Gateway: this.paymentGateway, FacilityId: this.processPayment.facId, OrderId: row.uniqueTransId, UserId: this.userSessionService.userSessionData.UserId });
      this.finishOpenEdgeMismatchVoid(row, false);
    });
  }

  private handleTdCardModeMismatch(payId: any, approvedPayment: any, paymentTrnsId: number): boolean {
    if (this.paymentComponentDestroyed || this.tdMismatchVoidState) {
      return true;
    }
    if (!this.checkCardModeMismatch(payId, approvedPayment.DebitCardPayment === true, false)) {
      return false;
    }

    const row = this.paymentTable.find(payment => payment.payId === payId);
    row.processedCC = approvedPayment;
    row.payComplete = false;
    row.payFailed = true;
    row.payNowDisable = true;
    this.paymentSuccessFul = false;
    this.paymentStarted = true;
    this.tdMismatchVoidState = 'pending';
    this.cardMismatchAlertText = this.translate.instant('PaymentSurcharge.TdMismatchVoidPrompt');
    this.loaderIcon = Promise.resolve(false);
    this.showLoaderMesage = false;
    this.initiatedVoidCC = true;
    this.disableNextButton();

    const modalId = `td-card-mismatch-${++PaymentComponent.tdMismatchModalSequence}`;
    const waitMilliseconds = Math.max(1, this.paymentMaxWaitTime || 1) * 60000;
    this.tdMismatchVisibilityWait = this.modalService.onShown.pipe(
      filter(event => event?.id === modalId),
      take(1),
      switchMap(() => new Observable<void>(observer => {
        let frame = requestAnimationFrame(() => {
          frame = requestAnimationFrame(() => {
            observer.next();
            observer.complete();
          });
        });
        return () => cancelAnimationFrame(frame);
      })),
      timeout(waitMilliseconds)
    ).subscribe({
      next: () => {
        this.tdMismatchVisibilityWait = null;
        if (!this.paymentComponentDestroyed && this.tdMismatchVoidState === 'pending') {
          this.startTdCardModeMismatchVoid(payId, approvedPayment, paymentTrnsId);
        }
      },
      error: () => {
        this.tdMismatchVisibilityWait = null;
        this.finishTdCardModeMismatch(false);
      }
    });
    try {
      this.showCardMismatchAlert(modalId);
    } catch {
      this.tdMismatchVisibilityWait?.unsubscribe();
      this.tdMismatchVisibilityWait = null;
      this.finishTdCardModeMismatch(false);
    }
    return true;
  }

  private startTdCardModeMismatchVoid(payId: any, approvedPayment: any, paymentTrnsId: number): void {
    const row = this.paymentTable.find(payment => payment.payId === payId);
    const localWorker = !!(this.tdLocalHostArchitectureFacilities?.includes(this.processPayment.facId)
      || this.enableNewPaymentArchitecture);
    const waitMilliseconds = Math.max(1, this.paymentMaxWaitTime || 1) * 60000;
    let voidRequest: any;
    defer(() => {
      voidRequest = this.generateIntialCCT(approvedPayment.Amount, EPaymentTransactionType.Reversal_Refund,
        paymentTrnsId, row.payModeId, 'VOID', approvedPayment.CreditCardNumber,
        approvedPayment.AuthorizationCode, approvedPayment.OrderId, localWorker, payId);
      return this.paymentService.saveCCTransaction(voidRequest);
    }).pipe(
      take(1),
      timeout(waitMilliseconds),
      switchMap(saved => {
        if (!saved?.Success) {
          throw new Error('TD mismatch void could not be queued');
        }
        if (localWorker) {
          return this.paymentService.InitiateTDPayment({
            OrderId: saved.Id,
            Amount: approvedPayment.Amount,
            AuthorizationCode: approvedPayment.AuthorizationCode,
            CreditCardNumber: String(approvedPayment.CreditCardNumber).slice(-4),
            TransactionType: 'VOID',
            InvoiceNumberForTDVoid: approvedPayment.OrderId,
            UserId: this.userSessionService.userSessionData.UserId
          }, this.credentials.URLforLocalHost).pipe(
            take(1),
            timeout(waitMilliseconds),
            switchMap(response => {
              if (!response) { return of(null); }
              return this.paymentService.saveCCTransaction({
                ...voidRequest,
                ...response,
                OrderId: saved.Id,
                paymentModeId: row.payModeId,
                TransactionTypeId: response.ResponseCode === '000'
                  ? EPaymentTransactionType.Reversal_Refund : EPaymentTransactionType.Declined,
                Reason: response.Reason || 'TD mismatch void response'
              }).pipe(take(1), timeout(waitMilliseconds), map(recorded => recorded?.Success ? response : null));
            })
          );
        }
        return timer(0, Math.max(1, this.paymentGetCCTStatusInterval || 1) * 1000).pipe(
          exhaustMap(() => this.paymentService.getCCTStatus(saved.Id)),
          filter(response => !!response),
          map(response => typeof response === 'string' ? JSON.parse(response) : response),
          filter(response => !!response),
          take(1),
          timeout(waitMilliseconds)
        );
      }),
      defaultIfEmpty(null)
    ).subscribe({
      next: response => this.finishTdCardModeMismatch(response?.ResponseCode === '000'),
      error: () => this.finishTdCardModeMismatch(false)
    });
  }

  /** Ends a pending mismatch void (TD, or OpenEdge with messagePrefix 'OpenEdgeMismatch'): unblocks or keeps blocking retry and shows the outcome. */
  private finishTdCardModeMismatch(voidConfirmed: boolean, messagePrefix = 'TdMismatch'): void {
    this.tdMismatchVoidState = voidConfirmed ? 'confirmed' : 'unconfirmed';
    this.loaderIcon = Promise.resolve(false);
    this.showLoaderMesage = false;
    this.initiatedVoidCC = false;
    this.isTDEmv.isTransactionWaitTime = false;
    this.isTDEmv.isPortClosingWaitTime = false;
    this.paymentProcessing = false;
    this.paymentInProgress = false;
    this.paymentStarted = !voidConfirmed;
    this.transactionInitiated = !voidConfirmed;
    if (voidConfirmed) {
      this.cardMismatchAlertText = this.translate.instant(`PaymentSurcharge.${messagePrefix}VoidConfirmed`);
    } else {
      this.cardMismatchAlertText = this.translate.instant(`PaymentSurcharge.${messagePrefix}VoidUnconfirmed`);
    }
  }

  /** Completes the pending OpenEdge mismatch reversal for this row, if it is the one being reversed. */
  private finishOpenEdgeMismatchVoid(row: any, voidConfirmed: boolean): void {
    if (!row?.openEdgeMismatchVoid || this.tdMismatchVoidState !== 'pending') {
      return;
    }
    row.openEdgeMismatchVoid = false;
    this.finishTdCardModeMismatch(voidConfirmed, 'OpenEdgeMismatch');
  }

  /**
   * Dismiss the card/mode mismatch alertdialog (Story 2.5, FR-8, UX-DR10).
   * Reverts the affected row's mode to unselected and returns focus to that row's mode selector.
   */
  dismissCardMismatchAlert(): void {
    if (this.isTdMismatchDismissBlocked) { return; }
    if (this.tdMismatchVoidState === 'unconfirmed') {
      this.cardMismatchModalRef?.hide();
      this.cardMismatchModalRef = null;
      return;
    }
    this.tdMismatchVoidState = null;
    this._isMismatchVoid = false;
    const revertContext = this._cardMismatchRevertContext;
    this._cardMismatchRevertContext = null;

    if (this.cardMismatchModalRef) {
      if (revertContext) {
        this.cardMismatchModalRef.onHidden.pipe(take(1)).subscribe(() => {
          try {
            const el = this.renderer.selectRootElement(`[data-surcharge-row-id="${revertContext.rowId}"]`, true);
            el.focus();
          } catch {
            // selectRootElement throws if the element is not found; focus is best-effort.
          }
        });
      }
      this.cardMismatchModalRef.hide();
      this.cardMismatchModalRef = null;
    }

    if (revertContext) {
      const row = this.paymentTable.find(o => o.payId === revertContext.rowId);
      if (row) {
        // H3: subtract the surcharge from totalAmount before zeroing the row field (Story 2.5 code review).
        // applySurchargeFeeForRow adds surchargeFeeAmount to totalAmount; we must undo that here.
        this.totalAmount = this.originalTotalAmount +
          this.paymentTable
            .filter(r => r.payId !== revertContext.rowId)
            .reduce((sum, r) => sum + (r.surchargeFeeAmount || 0), 0);
        row.defaultmode = 0;
        row.payModeId = 0;
        row.surchargeFeeAmount = 0;
        row.surchargeFeePercentage = 0;
        row.surchargeLocked = false;
        // H4: clear stale gateway data so a retry starts clean (Story 2.5 code review).
        row['processedCC'] = null;
        this.transactionInitiated = false;
      }
    }
  }

  onLockedFieldKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Tab' && !event.ctrlKey && !event.metaKey) {
      event.preventDefault();
    }
  }

  onLockedFieldPaste(event: ClipboardEvent): void {
    event.preventDefault();
  }

  onAmountBlur(drow: any, event: Event): void {
    if (drow.surchargeLocked) {
      return;
    }
    this.subjectPayAmount.next(event);
    this.onChangeAmt(drow.payId, (event.target as HTMLInputElement).value);
  }

  onChangePayMode(eve, Id) {
    const isOtherRowSurchargeLocked = this.paymentTable.some(row => row.payId !== Id && row.surchargeLocked);
    if (isOtherRowSurchargeLocked) {
      // Another row already has a surcharge-locked mode — silently revert this row's select (Story 2.2 server-side
      // protection already covers the actual save; the alertdialog in Story 2.3 only fires when THIS row is the
      // one introducing the surcharge mode into a multi-row payment for the first time).
      eve.target.value = this.paymentTable.find(o => o.payId === Id).defaultmode;
      return;
    }
    const previousModeId: number = this.paymentTable.find(o => o.payId === Id).defaultmode ?? 0;
    let modeId = eve.target.value;
    this.currentPayModeId = parseInt(modeId);
    this.paymentTable.find(o => o.payId === Id).defaultmode = this.currentPayModeId;
    this.currentPayId = Id;
    if ([EPaymentModes.CreditCard, EPaymentModes.HostedPage, EPaymentModes.CardOnfile, EPaymentModes.DebitCard].includes(this.currentPayModeId)) {
      if (this.credentials == null) {
        this.toastr.warning('We could not process your payment for this facility, Please contact the Administrator!', 'Please try a different Payment method', this.toasterConfig);
        this.paymentTable.find(o => o.payId === Id).payNowDisable = true;
        return;
      } else if (this.credentials && (modeId == EPaymentModes.CreditCard || modeId == EPaymentModes.DebitCard)) {
        this.showLoaderMesage = false;
        this.loaderIcon = Promise.resolve(true);
        if (this.paymentGateway != EPaymentGateway.Stripe) {
          this.facilityservice.getTerminalDevicesForOp(this.facilityId).subscribe((response: IDeviceSetting[]) => {
            if (response) {
              this.terminalDevicesList = response;
            } else {
              this.terminalDevicesList = [];
            }
            this.loaderIcon = Promise.resolve(false);
            if ((this.terminalDevicesList.length && this.terminalDevicesList.length > 1) && ((this.paymentGateway == EPaymentGateway.OpenEdgeExpress && this.defaultCountryId == ECountries.Canada) ||
              (this.paymentGateway == EPaymentGateway.TdBank))) {
              this.modalRefSelectDevice = this.modalService.show(this.selectDevicePopup, { class: 'modal-medium modal-dialog-centered', backdrop: 'static', keyboard: false });
            } else if (this.terminalDevicesList.length && this.terminalDevicesList.length == 1 && this.paymentGateway == EPaymentGateway.TdBank) {
              this.selectedDeviceId = this.terminalDevicesList[0].Id
            }
            // resetting payFailed flag, on changing Mode for the failed pay record
            this.paymentTable.find(o => o.payId === Id).payFailed = false;
          },
            () => {
              this.paymentTable.find(o => o.payId === Id).payFailed = false;
              this.terminalDevicesList = [];
              this.loaderIcon = Promise.resolve(false);
            });
        } else {
          this.terminalDevicesList = this.credentials.DeviceSettings ? this.credentials.DeviceSettings : [];
          if (this.terminalDevicesList.length > 0) {
            if (this.terminalDevicesList.length > 1) {
              this.modalRefSelectDevice = this.modalService.show(this.selectStripeDevicePopup, { class: 'modal-medium modal-dialog-centered', backdrop: 'static', keyboard: false });
              this.loaderIcon = Promise.resolve(false);
            } else {
              this.selectStripeReaderId = this.terminalDevicesList[0] && this.terminalDevicesList[0].TerminalReaderId ? this.terminalDevicesList[0].TerminalReaderId : '';
              this.paymentTable.find(o => o.payId === Id).TerminalDeviceId = this.selectStripeReaderId;
              this.loaderIcon = Promise.resolve(false);
            }
          } else {
            this.loaderIcon = Promise.resolve(false);
            this.toastr.warning('Please ask Administrator to configure Stripe Terminal', 'Device required', this.toasterConfig);
          }
        }
      } else {
        this.paymentTable.find(o => o.payId === Id).payFailed = false;
      }
    } else {
      this.paymentTable.find(o => o.payId === Id).payFailed = false;
    }
    if (this.EnableCashRounding) {
      const payment = this.paymentTable.find(ele => ele.payId == Id && this.currentPayModeId == EPaymentModes.Cash);
      if (payment) {
        payment.payAmount = this.CalculateRoundedCashAmount(payment.payAmount,Id);
        this.remainingAmount =this.totalAmount -this.paymentTable.reduce((sum, x) => sum + x.payAmount, 0);
      }
    }
    const surchargeRow = this.paymentTable.find(o => o.payId === Id);
    const wasSurchargeLocked = !!surchargeRow.surchargeLocked;
    surchargeRow.payModeId = parseInt(modeId);
    const matchedSurchargeFee = this.findSurchargeRuleForSource(this.currentPayModeId);

    // Story 2.3 (FR-6, UX-DR10): if the selected mode carries a surcharge fee and there are other payment rows,
    // block this selection with an alertdialog; revert the row to unselected on dismissal.
    if (matchedSurchargeFee && this.paymentTable.length > 1) {
      this._surchargeMixedModeRevertContext = { rowId: Id, previousModeId };
      this.surchargeMixedModeModalRef = this.modalService.show(this.surchargeMixedModeAlertTemplate, {
        class: 'modal-sm modal-dialog-centered',
        backdrop: 'static',
        keyboard: false
      });
      // Revert the row state immediately; the select keeps the user's choice displayed until reset here.
      eve.target.value = previousModeId;
      surchargeRow.defaultmode = previousModeId;
      surchargeRow.payModeId = previousModeId;
      surchargeRow.surchargeFeeAmount = 0;
      surchargeRow.surchargeFeePercentage = 0;
      surchargeRow.surchargeLocked = false;
      if (previousModeId === 0) {
        surchargeRow.payNowDisable = true;
      }
      return;
    }

    // Recalculate live from the row's current payAmount instead of the stale FeeAmount captured
    // when rules were first loaded, so any eligible single-mode switch applies the correct fee.
    if (matchedSurchargeFee) {
      // A surcharge-carrying mode requires full payment (mirrors the server's ValidateSurchargeRestriction).
      // Reset any partial amount left over from editing while a non-surcharge mode was selected, so the
      // lock below can never preserve a partial payAmount on a surcharge-locked row.
      // Row 0 keeps its charity contribution (charity is excluded from the surcharge base).
      surchargeRow.payAmount = this.originalTotalAmount + (surchargeRow === this.paymentTable[0] ? (this.charityContributionAmount || 0) : 0);
      // payAmount is unrounded again; cash rounding (if any) is re-applied last by applySurchargeFeeForRow.
      surchargeRow.roundingvalue = 0;
    }
    this.applySurchargeFeeForRow(Id, this.currentPayModeId);
    // Charity is applied after the surcharge, so recompute it when the surcharge on the charity row changed.
    if ((this.isFixedCharityAmount || this.isRoundUpCharityAmount) && this.paymentTable.length === 1
      && (wasSurchargeLocked || surchargeRow.surchargeLocked)) {
      this.calculateContribution();
    }
    if (this.currentPayModeId == 0) {
      this.paymentTable.find(o => o.payId === Id).payNowDisable = true;
    } else if (this.processPayment.AmountTobePaid == 0) {
      this.paymentTable.find(o => o.payId === Id).payNowDisable = false;
    } else if (this.processPayment.Type == 1 || this.processPayment.Type == 2 || this.processPayment.Type == 5 || this.processPayment.Type == 6) {
      if (((this.processPayment.Type == 1 || this.processPayment.Type == 2) && this.processPayment.requireFullPayment)
        || (this.processPayment.Type == 5 && (this.processPayment.isMerchandiseSalesOnly || this.processPayment.requireFullPayment))
        || (this.processPayment.Type == 6 && !(this.processPayment.PrePayPeriod > 0 || this.processPayment.IsDueWoPrePayZero))) {
        if (this.remainingAmount > 0) {
          this.paymentTable.find(o => o.payId === Id).payNowDisable = true;
        } else {
          this.paymentTable.find(o => o.payId === Id).payNowDisable = false;
        }
      } else {
        this.paymentTable.find(o => o.payId === Id).payNowDisable = false;
      }
    } else if (this.processPayment.Type !== 4) {
      if (this.paymentTable.find(o => o.payId === Id).payAmount == 0) {
        this.paymentTable.find(o => o.payId === Id).payNowDisable = true;
      } else {
        this.paymentTable.find(o => o.payId === Id).payNowDisable = false;
      }
    } else {
      this.paymentTable.find(o => o.payId === Id).payNowDisable = false;
    }

    let payAmount = 0;
    let currentVal = this.paymentTable.find(o => o.payId === Id).payAmount;
    let sumOfAmountExceptEdited = 0;
    this.paymentTable.map((item) => {
      if (item.payId !== Id && !item.payNowDisable) {
        let amount = this.isString(item.payAmount) ? parseFloat(item.payAmount) : item.payAmount;
        payAmount = payAmount + amount;
      }
    });
    sumOfAmountExceptEdited = payAmount;
    payAmount = payAmount + currentVal;
    const totalSurchargeFee = this.paymentTable.reduce((sum, x) => sum + (x.surchargeFeeAmount || 0), 0);
    if (this.isAnyRowSurchargeLocked()) {
      // Surcharge rows: cash rounding (if any) was applied last on base + surcharge + charity.
      this.totalAmount = parseFloat((this.originalTotalAmount + totalSurchargeFee + (this.charityContributionAmount || 0) + this.getSurchargeCashRounding()).toFixed(2));
    }
    else if(this.paymentTable.filter(x=>x.payModeId == 1)!= null && this.paymentTable.reduce((sum, x) => sum + x.payAmount, 0) >this.originalTotalAmount){
      this.totalAmount = this.originalTotalAmount + this.paymentTable.reduce((sum, x) => sum + x.roundingvalue, 0) + totalSurchargeFee + (this.charityContributionAmount || 0);
    }
    else{
      this.totalAmount = this.originalTotalAmount + totalSurchargeFee + (this.charityContributionAmount || 0);
    }
    this.recalculateRemainingAmount();
    this.restrictOverpay(payAmount, sumOfAmountExceptEdited, Id)
  }

  /**
   * The tender (Credit Card / Debit Card) is chosen before the RCM is invoked, so send the explicit
   * CREDITSALE / DEBITSALE type — a generic SALE makes the RCM prompt "Credit or Debit?" again.
   */
  private getOpenEdgeEmvTransactionType(payId): string {
    // Facility-level "Disable Debit Sale" always wins, even if Debit Card was selected before credentials loaded.
    if (this.credentials.DISABLEDEBITSALE) {
      this.toastr.warning('Please Insert Credit Card For Payment', 'Alert', this.toasterConfig);
      return 'CREDITSALE';
    }
    return this.paymentTable.find(o => o.payId == payId)?.payModeId == EPaymentModes.DebitCard ? 'DEBITSALE' : 'CREDITSALE';
  }

  callRCM(amount, payId, orderId, paymentTrnsId) {
    let tempAmount;
    if (!this.credentials.RCMURL) {
      this.toastr.warning('Please ask Administrator to configure RCM URL', 'URL required', this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
    } else {
      this.paymentMaxWaitTime = this.paymentMaxWaitTime != undefined && this.paymentGetCCTStatusInterval != 0 ? this.paymentMaxWaitTime : 2;
      this.paymentGetCCTStatusInterval = this.paymentGetCCTStatusInterval != undefined && this.paymentGetCCTStatusInterval != 0 ? this.paymentGetCCTStatusInterval : 10;
      let isPaymentCompleted = false; //for retry logic
      this.paymentInProgress = true;
      const emvTransactionType = this.getOpenEdgeEmvTransactionType(payId);
      this.paymentTable.find(o => o.payId == payId).openEdgeSaleType = emvTransactionType;
      this.showLoaderMesage = false;
      this.isTDEmv.isTransactionWaitTime = true;
      this.loaderIcon = Promise.resolve(true);
      const requestParam = "<REQUEST>" +
        "<XWEBID>" + this.credentials.XWEBID + "</XWEBID>" +
        "<XWEBTERMINALID>" + this.credentials.XWEBTERMINALID + "</XWEBTERMINALID>" +
        "<XWEBAUTHKEY>" + this.credentials.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
        "<TRANSACTIONTYPE>" + emvTransactionType + "</TRANSACTIONTYPE>  <AMOUNT>" + amount + "</AMOUNT> <ORDERID>" + orderId + "</ORDERID> <OTK>" + orderId + "</OTK><ALLOWDUPLICATES /> <CLERK></CLERK>  <RECEIPTCOPYLABEL>MERCHANT_COPY</RECEIPTCOPYLABEL><TITLE>SSM 6.0</TITLE><CREATEALIAS>FALSE</CREATEALIAS></REQUEST>" //JSON.stringify(tempObj);
      const rcmRequest = this.paymentService.getRCMService(this.credentials.RCMURL, requestParam).subscribe((res: any) => {
        if (res) {
          const resultFromRCM = res;
          const responseData = JSON.parse(resultFromRCM.RcmResponse);
          // With an explicit CREDITSALE/DEBITSALE the RCM no longer echoes TRANSACTIONTYPE (it did for a generic SALE).
          // The approval check below, the saved debit flag and the cancel-time void type all rely on it.
          if (responseData?.RESPONSE && !responseData.RESPONSE.TRANSACTIONTYPE) {
            responseData.RESPONSE.TRANSACTIONTYPE = emvTransactionType;
          }
          this.prePayStatus = 'Payment';
          this.paymentTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted = true;
          if ((responseData && responseData.RESPONSE && responseData.RESPONSE.APPROVEDAMOUNT != 0 && responseData.RESPONSE.HOSTRESPONSECODE && responseData.RESPONSE.RESULT && responseData.RESPONSE.CARDBRAND && responseData.RESPONSE.ACCOUNT
            && responseData.RESPONSE.EXPMONTH && responseData.RESPONSE.EXPYEAR && responseData.RESPONSE.TRANSACTIONID && responseData.RESPONSE.HOSTRESPONSEDESCRIPTION && responseData.RESPONSE.TRANSACTIONTYPE) || (responseData.RESPONSE.RESULT == EEdgeExpressResultCode.Canceled || responseData.RESPONSE.RESULT == EEdgeExpressResultCode.Declined || responseData.RESPONSE.RESULT == EEdgeExpressResultCode.Fail)) {
            let cTypeId = responseData.RESPONSE && responseData.RESPONSE.CARDBRAND ? this.paymentService.openEdgeCardType(responseData.RESPONSE.CARDBRAND) : ECreditCards.Visa;
            if (responseData && responseData.RESPONSE && responseData.RESPONSE.RESULT == EEdgeExpressResultCode.Success) {//Success
              this.payStatus = 'Success';
              this.isTDEmv.isTransactionWaitTime = false;
              this.paymentTable.find(o => o.payId == payId).payFailed = false;
              this.disableNextButton();
              this.paymentSuccessFul = true;
              responseData.RESPONSE['OrderId'] = responseData.RESPONSE && responseData.RESPONSE.ORDERID ? responseData.RESPONSE.ORDERID : orderId;
              this.paymentTable.find(o => o.payId == payId)['processedCC'] = responseData.RESPONSE;
              // Story 2.5 (FR-8): reject payment if the card presented mismatches the selected mode.
              if (this.rejectOpenEdgeMismatchedApproval(payId, responseData.RESPONSE, paymentTrnsId)) {
                return;
              }
              this.loaderIcon = Promise.resolve(false);
              this.gotoPaymentSuccess(this.popUpPayment, amount);
            } else if (responseData && responseData.RESPONSE && responseData.RESPONSE.RESULT == EEdgeExpressResultCode.Canceled || responseData.RESPONSE.RESULT == EEdgeExpressResultCode.Fail) { //Cancel
              this.payStatus = 'Cancelled';
              this.isTDEmv.isTransactionWaitTime = false;
              this.paymentTable.find(o => o.payId == payId).payFailed = true;
              this.isAnyPaymentProcessed();
              this.paymentSuccessFul = false;
              this.paymentProcessing = false;
              this.paymentFailReason = responseData.RESPONSE.RESULTMSG;
              const CCTModel = {
                Amount: parseFloat(amount),
                Autopay: false,
                PaymentModeId: this.paymentTable.find(o => o.payId == payId)?.payModeId || EPaymentModes.CreditCard,
                AutoCcProcessingDay: 0,
                CreditCardNumber: responseData.RESPONSE && responseData.RESPONSE.ACCOUNT ? responseData.RESPONSE.ACCOUNT : 0,
                CreditCardType: cTypeId,
                NameonCard: responseData.RESPONSE && responseData.RESPONSE.CARDHOLDERNAME && responseData.RESPONSE.CARDHOLDERNAME.length > this.maxLengthNameOnCard ?
                  responseData.RESPONSE.CARDHOLDERNAME.substr(0, this.maxLengthNameOnCard) : responseData.RESPONSE && responseData.RESPONSE.CARDHOLDERNAME ? responseData.RESPONSE.CARDHOLDERNAME : null,
                CreditCardExpiryMonth: responseData.RESPONSE && responseData.RESPONSE.EXPMONTH ? this.getExpiryMonthValue(parseInt(responseData.RESPONSE.EXPMONTH, 10)) : 275,
                CreditCardExpiryYear: !parseInt(responseData.RESPONSE.EXPYEAR, 10) ? 2099 : parseInt(responseData.RESPONSE.EXPYEAR, 10),
                CreditCardBillingAddress: '',
                CreditCardBillingZip: '',
                SwipeTransaction: false,
                SecurityCodeSent: false,
                AuthorizationCode: responseData.RESPONSE && responseData.RESPONSE.TRANSACTIONID ? responseData.RESPONSE.TRANSACTIONID : 0,
                ResponseCode: responseData.RESPONSE && responseData.RESPONSE.HOSTRESPONSECODE ? responseData.RESPONSE.HOSTRESPONSECODE : responseData.RESPONSE.RESULT,
                Reason: responseData.RESPONSE && responseData.RESPONSE.HOSTRESPONSEDESCRIPTION ? responseData.RESPONSE.HOSTRESPONSEDESCRIPTION : responseData.RESPONSE.RESULTMSG,
                Key: '',
                PaymentAccountid: '',
                CcInfoPurged: false,
                DebitCardPayment: this.getOpenEdgePresentedCardIsDebit(responseData.RESPONSE) ?? responseData.RESPONSE?.TRANSACTIONTYPE == 'DEBITSALE',
                OfflinePayment: 0,
                PaymentTransactionTypeId: paymentTrnsId,
                TransactionDateTime: new Date(),
                TransactionTypeId: EPaymentTransactionType.Declined, //declined
                OrderId: this.paymentTable.find(o => o.payId == this.currentPayId).orderId,
                CCBatchNumber: responseData.RESPONSE && responseData.RESPONSE.BATCHNO ? responseData.RESPONSE.BATCHNO : null,
                EmvReceiptText: responseData.RESPONSE && responseData.RESPONSE.RECEIPTTEXT ? responseData.RESPONSE.RECEIPTTEXT : null,
                FacilityId: this.processPayment.facId,
                TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
                TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null
              };
              this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => {
              });
              this.loaderIcon = Promise.resolve(false);
              if (!this.showOpenEdgeDeclineMismatch(payId, responseData.RESPONSE)) {
                this.gotoPaymentSuccess(this.popUpPayment, 0);
              }
            } else {
              this.isAnyPaymentProcessed();
              this.payStatus = 'Failed';
              this.isTDEmv.isTransactionWaitTime = false;
              this.paymentTable.find(o => o.payId == payId).payFailed = true;
              this.paymentSuccessFul = false;
              this.paymentFailReason = responseData.RESPONSE && responseData.RESPONSE.RESULTMSG ? responseData.RESPONSE.RESULTMSG : 'Declined!';
              this.paymentProcessing = false;
              const CCTModel = {
                Amount: parseFloat(amount),
                Autopay: false,
                PaymentModeId: this.paymentTable.find(o => o.payId == payId)?.payModeId || EPaymentModes.CreditCard,
                AutoCcProcessingDay: 0,
                CreditCardNumber: responseData.RESPONSE && responseData.RESPONSE.ACCOUNT ? responseData.RESPONSE.ACCOUNT : 0,
                CreditCardType: cTypeId,
                NameonCard: responseData.RESPONSE && responseData.RESPONSE.CARDHOLDERNAME && responseData.RESPONSE.CARDHOLDERNAME.length > this.maxLengthNameOnCard ?
                  responseData.RESPONSE.CARDHOLDERNAME.substr(0, this.maxLengthNameOnCard) : responseData.RESPONSE && responseData.RESPONSE.CARDHOLDERNAME ? responseData.RESPONSE.CARDHOLDERNAME : null,
                CreditCardExpiryMonth: responseData.RESPONSE && responseData.RESPONSE.EXPMONTH ? this.getExpiryMonthValue(parseInt(responseData.RESPONSE.EXPMONTH, 10)) : 275,
                CreditCardExpiryYear: !parseInt(responseData.RESPONSE.EXPYEAR, 10) ? 2099 : parseInt(responseData.RESPONSE.EXPYEAR, 10),
                CreditCardBillingAddress: '',
                CreditCardBillingZip: '',
                SwipeTransaction: false,
                SecurityCodeSent: false,
                AuthorizationCode: responseData.RESPONSE && responseData.RESPONSE.TRANSACTIONID ? responseData.RESPONSE.TRANSACTIONID : 0,
                ResponseCode: responseData.RESPONSE && responseData.RESPONSE.HOSTRESPONSECODE ? responseData.RESPONSE.HOSTRESPONSECODE : responseData.RESPONSE.RESULT ? responseData.RESPONSE.RESULT : responseData.RESPONSE.RESPONSECODE,
                Reason: responseData.RESPONSE && responseData.RESPONSE.HOSTRESPONSEDESCRIPTION ? responseData.RESPONSE.HOSTRESPONSEDESCRIPTION : responseData.RESPONSE.RESULTMSG,
                Key: '',
                PaymentAccountid: '',
                CcInfoPurged: false,
                DebitCardPayment: this.getOpenEdgePresentedCardIsDebit(responseData.RESPONSE) ?? responseData.RESPONSE?.TRANSACTIONTYPE == 'DEBITSALE',
                OfflinePayment: 0,
                PaymentTransactionTypeId: paymentTrnsId,
                TransactionDateTime: new Date(),
                TransactionTypeId: EPaymentTransactionType.Declined, //declined
                OrderId: this.paymentTable.find(o => o.payId == this.currentPayId).orderId,
                CCBatchNumber: responseData.RESPONSE && responseData.RESPONSE.BATCHNO ? responseData.RESPONSE.BATCHNO : null,
                EmvReceiptText: responseData.RESPONSE && responseData.RESPONSE.RECEIPTTEXT ? responseData.RESPONSE.RECEIPTTEXT : null,
                FacilityId: this.processPayment.facId,
                TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
                TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null
              };
              this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
              this.loaderIcon = Promise.resolve(false);
              if (!this.showOpenEdgeDeclineMismatch(payId, responseData.RESPONSE)) {
                this.gotoPaymentSuccess(this.popUpPayment, 0);
              }
            }
          } else {
            this.isTDEmv.isTransactionWaitTime = false;
            rcmRequest.unsubscribe();
            this.cctStatusOrderId = 0;
            this.openEdgeTransactionStatus(orderId, payId, 'Sale', paymentTrnsId);
          }
        }
      }, err => {
        this.isTDEmv.isTransactionWaitTime = false;
        this.paymentTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted = true;
        this.paymentTable.find(o => o.payId == payId).payFailed = true;
        this.loaderIcon = Promise.resolve(false);
        this.toastr.warning('Please connect the device ', 'Device Required', this.toasterConfig);
        this.payStatus = 'Failed';
        this.paymentFailReason = 'Device Not Connected!'
        this.isAnyPaymentProcessed();
        this.paymentSuccessFul = false;
        this.paymentProcessing = false;
        const CCTModel = {
          Amount: parseFloat(amount),
          Autopay: false,
          PaymentModeId: this.paymentTable.find(o => o.payId == payId)?.payModeId || EPaymentModes.CreditCard,
          AutoCcProcessingDay: 0,
          CreditCardNumber: 0,
          CreditCardType: ECreditCards.Visa,
          NameonCard: null,
          CreditCardExpiryMonth: 275,
          CreditCardExpiryYear: 2099,
          CreditCardBillingAddress: '',
          CreditCardBillingZip: '',
          SwipeTransaction: false,
          SecurityCodeSent: false,
          AuthorizationCode: '0',
          ResponseCode: '0',
          Reason: "Device not Connected!",
          Key: '',
          PaymentAccountid: '',
          CcInfoPurged: false,
          DebitCardPayment: this.paymentTable.find(o => o.payId == payId)?.payModeId == EPaymentModes.DebitCard,
          OfflinePayment: 0,
          PaymentTransactionTypeId: paymentTrnsId,
          TransactionDateTime: new Date(),
          TransactionTypeId: EPaymentTransactionType.Declined,
          OrderId: this.paymentTable.find(o => o.payId == this.currentPayId).orderId,
          CCBatchNumber: null,
          EmvReceiptText: null,
          FacilityId: this.processPayment.facId,
          TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
          TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
          LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null
        };
        this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => {
        });
        this.gotoPaymentSuccess(this.popUpPayment, tempAmount);
      });
      setTimeout(() => {
        if (!this.paymentTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted && this.paymentTable.find(o => o.payId == payId).orderId == orderId) {
          this.isTDEmv.isTransactionWaitTime = false;
          this.cctStatusOrderId = 0;
          rcmRequest.unsubscribe();
          this.openEdgeTransactionStatus(orderId, payId, 'Sale', paymentTrnsId);
        }
      }, 10000 * 6 * this.paymentMaxWaitTime);
    }
  }

  addJsToElement(src: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    this.renderer.appendChild(document.body, script);
    return script;
  }

  callTdHostedPage(amount) {
    this.loaderIcon = Promise.resolve(false);
    this.amountTD = amount;
    this.showTDHostedForm = true;
    this.appInsightsService.logPaymentEvent(true,`Initiating TD Hosted Page Payment. OrderId : ${this.paymentTable.find(o => o.payId == this.currentPayId).orderId} `, { Gateway: this.paymentGateway , FacilityId :  this.processPayment.facId, OrderId : this.getPaymentOrderId(), UserId : this.userSessionService.userSessionData.UserId});
    this.tdModalRef = this.modalService.show(this.templateTDHosted, { class: 'modal-medium modal-dialog-centered', backdrop: 'static', keyboard: false });
    this.addJsToElement('https://libs.na.bambora.com/customcheckout/1/customcheckout.js').onload = () => {
      this.bamboraScriptForCustomChekout();
    }
  }

  onTDHostedPagePay() {
    if (this.showTDHostedForm) {
      this.showLoaderMesage = true;
      this.loaderIcon = Promise.resolve(true);
      document.getElementById("pay-button").click();
    }
  }

  callSaveTDPayment() {
    this.paymentInProgress = true;
    this.cardDetails = JSON.parse((<HTMLInputElement>document.getElementById('customCardDetails')).value);
    let billingName = (this.tdFName + ' ' + this.tdLName).length > 64 ? (this.tdFName + ' ' + this.tdLName).substring(0, 64) : (this.tdFName + ' ' + this.tdLName);
    let billingAddress = this.tdAddress.length > 64 ? this.tdAddress.substring(0, 64) : this.tdAddress;
    let billingInfoObj = {
      name: billingName,
      address_line1: billingAddress,
      city: this.tdCity,
      province: !this.emptyStateList && this.tdState ? this.stateList.find((item) => item.Id == this.tdState).Code : '--',
      country: this.countryList.find((item) => item.Id == this.tdCountry).IsoCode,
      postal_code: this.tdZip,
      phone_number: this.tdCellphone,
      email_address: this.getFirstEmailId(this.tdEmail)
    }

    this.browserLangauge = navigator.language;
    this.userAgent = window.navigator.userAgent;
    var req = new XMLHttpRequest();
    req.open('GET', window.location.href, false);
    req.send(null);
    this.headers = req.getResponseHeader('content-type');
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    this.colorDepth = window.screen.colorDepth;
    this.time_zone = (new Date()).getTimezoneOffset();

    const threeDSecurePayment = {
      amount: this.amountTD,
      OrderId: this.paymentTable.find(o => o.payId == this.currentPayId).orderId.toString(),
      payment_method: "token",
      term_url: `${this.baseUrl}/Payments/GetCresReturnToApplication`,
      customer_ip: "::1",
      billing: billingInfoObj,
      token: {
        complete: true,
        code: (<HTMLInputElement>document.getElementById('txtTransactionId')).value,
        name: this.tdNameOnCard,
        "3d_secure": {
          browser: {
            accept_header: this.headers,
            java_enabled: false,
            language: this.browserLangauge,
            color_depth: this.colorDepth,
            screen_height: this.screenHeight,
            screen_width: this.screenWidth,
            time_zone: this.time_zone,
            user_agent: this.userAgent,
            javascript_enabled: true
          },
          enabled: true,
          version: 2,
          auth_required: true
        }
      }
    }
    let paymentTrnsId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
    this.TdAmount = this.amountTD;
    this.tdPaymentMethod = "token";
    this.generalService.threeDSecurePayment(threeDSecurePayment, this.credentials).subscribe(response => {
      this.prePayStatus = 'Payment';
      let amount = 0;
      this.tdModalRef.hide();
      if (response) {
        let gatewayRes = response;
        this.appInsightsService.logPaymentEvent(true,`TD Hosted page Payments api Response. Response Message : ${response.message} `, { Gateway: this.paymentGateway, FacilityId : this.processPayment.facId, OrderId : this.getPaymentOrderId() ,UserId : this.userSessionService.userSessionData.UserId});
        let cardDetails = this.cardDetails;
        if (response.message == "Approved") {
          this.loaderIcon = Promise.resolve(false);
          let process = gatewayRes.id;
          let approved = gatewayRes.approved;
          let trnId = gatewayRes.id;
          let messageId = gatewayRes.message_id;
          let messageText = gatewayRes.message;
          let authCode = gatewayRes.auth_code;
          let trnAmount = gatewayRes.amount;
          let trnDate = gatewayRes.created;
          let trnOrderNumber = gatewayRes.order_number;
          let cardType = gatewayRes.card.card_type;
          let cardNumber = gatewayRes.card.last_four;
          let trnType = gatewayRes.type;
          let paymentMethod = gatewayRes.payment_method;
          this.tdResponseObj = {
            Process: process,
            trnApproved: approved,
            trnId: trnId,
            messageId: messageId,
            messageText: messageText,
            authCode: authCode,
            trnAmount: trnAmount,
            trnDate: trnDate,
            trnOrderNumber: trnOrderNumber,
            cardType: cardType,
            trnType: trnType,
            cardNumber: cardNumber,
            paymentMethod: paymentMethod,
            nameOnCard: this.tdNameOnCard,
            CreditCardExpiryMonth: cardDetails ? this.getExpiryMonthValue(parseInt(cardDetails.expiryMonth, 10)) : 275,
            CreditCardExpiryYear: cardDetails ? parseInt(cardDetails.expiryYear, 10) : 2099,
            CreditCardBillingAddress: this.tdAddress && this.tdAddress.length > 50 ? this.tdAddress.substring(0, 50) : this.tdAddress,
            CreditCardBillingZip: this.tdZip,
            CreditCardType: ECreditCards.Visa
          }
          this.tdResponseObj.CreditCardType = gatewayRes && gatewayRes.card && gatewayRes.card.card_type ? this.paymentService.getTdPaymentCardType(gatewayRes.card.card_type) : ECreditCards.Visa;
          this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = false;
          this.paymentTable.find(o => o.payId == this.currentPayId)['processedTDCC'] = this.tdResponseObj;
          amount = trnAmount;
          this.paymentSuccessFul = true;
          this.payStatus = 'Success';
          this.appInsightsService.logPaymentEvent(true,`Go to Payment Success.`, { Gateway: this.paymentGateway , FacilityId :  this.processPayment.facId,  OrderId : this.getPaymentOrderId(), UserId : this.userSessionService.userSessionData.UserId});
          this.gotoPaymentSuccess(this.popUpPayment, amount);
        } else {
          this.loaderIcon = Promise.resolve(false);
          this.appInsightsService.logPaymentEvent(true,`Gateway Failure. Response Message : ${response.Message}`, { Gateway: this.paymentGateway , FacilityId :  this.processPayment.facId,  OrderId : this.getPaymentOrderId(), UserId : this.userSessionService.userSessionData.UserId});
          this.toastr.warning(response.Message, 'Payment Failed', this.toasterConfig);
          this.paymentSuccessFul = false;
          this.paymentProcessing = false;
          this.payStatus = 'Failed';
          this.isAnyPaymentProcessed();
          const CCTModel = {
            Amount: this.amountToPay,
            Autopay: false,
            paymentModeId: EPaymentModes.HostedPage,
            AutoCcProcessingDay: 0,
            CreditCardNumber: 'XXXX',
            CreditCardType: gatewayRes && gatewayRes.card && gatewayRes.card.card_type ? this.paymentService.getTdPaymentCardType(gatewayRes.card.card_type) : ECreditCards.Visa,
            NameonCard: '',
            CreditCardExpiryMonth: 275,
            CreditCardExpiryYear: 2099,
            CreditCardBillingAddress: '',
            CreditCardBillingZip: '',
            SwipeTransaction: false,
            SecurityCodeSent: false,
            AuthorizationCode: '',
            ResponseCode: '',
            Reason: 'Declined',
            Key: '',
            PaymentAccountid: '',
            CcInfoPurged: false,
            DebitCardPayment: false,
            OfflinePayment: 0,
            PaymentTransactionTypeId: paymentTrnsId,
            OrderId: this.paymentTable.find(o => o.payId == this.currentPayId).orderId,
            FacilityId: this.processPayment.facId,
            TransactionDateTime: new Date(),
            TransactionTypeId: EPaymentTransactionType.Declined,
            TerminalDeviceId: null,
            TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
            LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null
          };
          this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
          this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
          this.gotoPaymentSuccess(this.popUpPayment, 0);
        }
      }
    }, err => {
      if (err.status === 302 && err.error.links[0].rel === 'continue') {
        this.prePayStatus = 'Payment';
        this.tdModalRef.hide();
        var formContents = err.error.contents;
        this.appInsightsService.logPaymentEvent(true,`TD Hosted Page Challenge Flow`, { Gateway: this.paymentGateway , FacilityId :  this.processPayment.facId,  OrderId : this.getPaymentOrderId(), UserId : this.userSessionService.userSessionData.UserId});
        this.callAuthenticationForm(formContents, threeDSecurePayment.OrderId, this.currentPayId, paymentTrnsId);
      } else if (err.error.message && err.error.code) {
        this.appInsightsService.logPaymentEvent(true,`Gateway Failure. Response Message : ${err.error.message}`, { Gateway: this.paymentGateway , FacilityId :  this.processPayment.facId,  OrderId : this.getPaymentOrderId(), UserId : this.userSessionService.userSessionData.UserId});
        this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
        this.tdModalRef.hide();
        this.toastr.warning(err.error.message, 'Payment Failed', this.toasterConfig);
        this.paymentSuccessFul = false;
        this.paymentProcessing = false;
        this.prePayStatus = 'Payment';
        this.payStatus = 'Failed';
        this.isAnyPaymentProcessed();
        const cCTModel = {
          Amount: this.amountToPay,
          Autopay: false,
          paymentModeId: EPaymentModes.HostedPage,
          AutoCcProcessingDay: 0,
          CreditCardNumber: 'XXXX',
          CreditCardType: ECreditCards.Visa,
          NameonCard: '',
          CreditCardExpiryMonth: 275,
          CreditCardExpiryYear: 2099,
          CreditCardBillingAddress: '',
          CreditCardBillingZip: '',
          SwipeTransaction: false,
          SecurityCodeSent: false,
          AuthorizationCode: '',
          ResponseCode: err.error.code,
          Reason: err.error.message,
          Key: '',
          PaymentAccountid: '',
          CcInfoPurged: false,
          DebitCardPayment: false,
          OfflinePayment: 0,
          PaymentTransactionTypeId: paymentTrnsId,
          OrderId: this.paymentTable.find(o => o.payId == this.currentPayId).orderId,
          FacilityId: this.processPayment.facId,
          TransactionDateTime: new Date(),
          TransactionTypeId: EPaymentTransactionType.Declined,
          TerminalDeviceId: null,
          TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
          LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null
        };
        this.paymentService.saveCCTransaction(Object.assign(cCTModel)).subscribe((res: any) => { });
        this.loaderIcon = Promise.resolve(false);
        this.gotoPaymentSuccess(this.popUpPayment, 0);
      } else {
        this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
        this.paymentStarted = false;
        this.toastr.warning('Please verify the settings!', 'Verify Settings', this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
        const cCTModel = {
          Amount: this.amountToPay,
          Autopay: false,
          paymentModeId: EPaymentModes.HostedPage,
          AutoCcProcessingDay: 0,
          CreditCardNumber: 'XXXX',
          CreditCardType: ECreditCards.Visa,
          NameonCard: '',
          CreditCardExpiryMonth: 275,
          CreditCardExpiryYear: 2099,
          CreditCardBillingAddress: '',
          CreditCardBillingZip: '',
          SwipeTransaction: false,
          SecurityCodeSent: false,
          AuthorizationCode: '',
          ResponseCode: '0',
          Reason: 'Please verify the settings!',
          Key: '',
          PaymentAccountid: '',
          CcInfoPurged: false,
          DebitCardPayment: false,
          OfflinePayment: 0,
          PaymentTransactionTypeId: paymentTrnsId,
          OrderId: this.paymentTable.find(o => o.payId == this.currentPayId).orderId,
          FacilityId: this.processPayment.facId,
          TransactionDateTime: new Date(),
          TransactionTypeId: EPaymentTransactionType.Declined,
          TerminalDeviceId: null,
          TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
          LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null
        };
        this.paymentService.saveCCTransaction(Object.assign(cCTModel)).subscribe((res: any) => { });
        this.gotoPaymentSuccess(this.popUpPayment, 0);
      }
    });
  }

  callCNP(amount: any, transType: string, payId: number): void {
    const cnpServiceUrl = this.credentials?.CardNotPresentURL;
    this.logPayFieldsDebug('callCNP:init', {
      payId,
      amount,
      transType,
      selectedUrl: cnpServiceUrl
    });
    this.appInsightsService.logPaymentEvent(
      true,
      `Hosted CNP init. URL: ${cnpServiceUrl || 'missing'}. RequestId: ${this.payFieldsRequestId || 'n/a'}`,
      { Gateway: this.paymentGateway, FacilityId: this.processPayment?.facId, OrderId: this.getPaymentOrderId(), UserId: this.userSessionService.userSessionData.UserId }
    );
    if (!cnpServiceUrl) {
      this.logPayFieldsDebug('callCNP:missing-url', {
        cardNotPresentUrl: this.credentials?.CardNotPresentURL
      });
      this.paymentStarted = false;
      this.toastr.warning('Please ask Administrator to configure CNP URL', 'URL required', this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
    } else {
      //let rqsturl = 'https://ee.test.paygateway.com/HostPayService/v1/hostpay/transactions/';
      const tempOrderId = this.paymentTable.find(o => o.payId == payId).uniqueTransId;
      if (this.isAutoPopulateBillingInfo && this.customerInfo) {
        this.setCNPCustomerInfo(amount, transType, payId);
      } else {
        this.requestParam =
          "<REQUEST>" +
          "<XWEBID>" + this.credentials.XWEBID + "</XWEBID>" +
          "<XWEBTERMINALID>" + this.credentials.XWEBTERMINALID + "</XWEBTERMINALID>" +
          "<XWEBAUTHKEY>" + this.credentials.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
          "<TRANSACTIONTYPE>" + transType + "</TRANSACTIONTYPE>" +
          "<AMOUNT>" + amount + "</AMOUNT>" +
          "<CLERK></CLERK>" +
          "<ORDERID>" + tempOrderId + "</ORDERID>" +
          "<ECI>" + EEdgeExpressECIType.Moto + "</ECI>" +
          "<HOSTPAYSETTING>" +
          "<CARDBRAND>" + this.facilityCreditCards + "</CARDBRAND>" +
          "<DISABLEFRAMING>FALSE</DISABLEFRAMING>" +
          "<RECEIPTFORMAT>TEXT</RECEIPTFORMAT>" +
          "<CUSTOMIZATION>" +
          "<PAGE> " +
          this.openEdgeBillingFields +
          "</PAGE>" +
          "<BRANDING>" +
          "<BODY>" +
          "<FONT-FAMILY> LATO,SANS-SERIF;</FONT-FAMILY>" +
          "<FONT-SIZE>14px</FONT-SIZE>" +
          "</BODY>" +
          "<BTN>" +
          "<BACKGROUND-COLOR>#3757C5;</BACKGROUND-COLOR>" +
          "<FONT-SIZE>14PX;</FONT-SIZE>" +
          "</BTN>" +
          "<SPECIALCSS>" +
          "<SECTION-HEADER-FONT-SIZE>18px</SECTION-HEADER-FONT-SIZE>" +
          "<COLOR>#3757C5;</COLOR>" +
          "</SPECIALCSS>" +
          "</BRANDING>" +
          "</CUSTOMIZATION>" +
          "<POSDEVICE>" +
          "<TYPE>KEYED</TYPE>" +
          "</POSDEVICE>" +
          "</HOSTPAYSETTING>" +
          "</REQUEST>";
      }
      this.appInsightsService.logPaymentEvent(true, `Initializing the Card Not Present Request.  OrderId : ${tempOrderId},`, { Gateway: this.paymentGateway, FacilityId: this.processPayment.facId, OrderId: tempOrderId, UserId: this.userSessionService.userSessionData.UserId });
      this.paymentService.getCNPService(cnpServiceUrl, this.requestParam).subscribe((res: any) => {
        this.loaderIcon = Promise.resolve(false);
        const resultResponse = JSON.parse(res);
        this.logPayFieldsDebug('callCNP:paypage-received', {
          hasPayPageUrl: !!resultResponse?.RESULT?.PAYPAGEURL,
          responseCode: resultResponse?.RESULT?.RESPONSECODE,
          responseDescription: resultResponse?.RESULT?.RESPONSEDESCRIPTION
        });
        this.appInsightsService.logPaymentEvent(
          true,
          `Hosted CNP page URL received. RequestId: ${this.payFieldsRequestId || 'n/a'}`,
          { Gateway: this.paymentGateway, FacilityId: this.processPayment?.facId, OrderId: tempOrderId, UserId: this.userSessionService.userSessionData.UserId }
        );
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(resultResponse.RESULT.PAYPAGEURL);
        this.showIFrame = true;
        this.showPage = !this.showIFrame;
      }, err => {
        this.appInsightsService.logPaymentEvent(
          true,
          `Hosted CNP init failed. RequestId: ${this.payFieldsRequestId || 'n/a'}. Error: ${err?.status || 'unknown'} ${err?.statusText || ''}`,
          { Gateway: this.paymentGateway, FacilityId: this.processPayment?.facId, OrderId: tempOrderId, UserId: this.userSessionService.userSessionData.UserId }
        );
        this.logPayFieldsDebug('callCNP:init-failed', {
          status: err?.status,
          statusText: err?.statusText,
          error: err
        });
        this.paymentStarted = false;
        this.toastr.warning('Please ask Administrator to configure CNP URL', 'URL required', this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
      });
    }
  }

  onChangeMerchSection() {
    this.merchSaleSection = false;
  }

  onPaymentCancel() {
    this.clearPayFieldsTokenState();
    if (this.facOpsDataService.saveautopay != null) {
      if (this.getUniqueIdentifier) {
        this.UniqueIdentifier = this.getUniqueIdentifier;
        this.UniqueIdentifier = this.UniqueIdentifier.replaceAll("-", "");
      } else {
        this.UniqueIdentifier = '';
      }
      var deleteSavedautopayProfile = this.facOpsDataService.saveautopay;
      if (deleteSavedautopayProfile && deleteSavedautopayProfile.Autopay == true && deleteSavedautopayProfile.PaymentAccountId != null && (!this.autoPayInfo || (this.autoPayInfo && this.autoPayInfo.PaymentAccountId != this.UniqueIdentifier)) && this.paymentGateway == EPaymentGateway.TdBank) {
        this.paymentService.deleteTDBankProfile(this.facilityId, deleteSavedautopayProfile.PaymentAccountId).subscribe((res) => {
        })
      }
    }
    this.facOpsDataService.clearRequireFullPrepaymentOnDueDateChange();
    this.isCancel.emit(true);
  }

  gotoPaymentSuccess(template: TemplateRef<any>, amount) {
    this.paymentStarted = true;
    this.tillNowPaid += parseFloat(amount);
    if (this.paymentSuccessFul && !this.partialPaySuccess) {
      this.paymentTable.find(o => o.payId === this.currentPayId).payComplete = true;
    }
    let isCC = this.paymentTable.some(function (ele) {return (ele.payModeId != EPaymentModes.ManualAuthorization && [EPaymentModes.CreditCard, EPaymentModes.HostedPage, EPaymentModes.CardOnfile, EPaymentModes.DebitCard].includes(ele.payModeId))});
    this.appInsightsService.logPaymentEvent(isCC,`Transaction Status. Till Now Paid : ${this.tillNowPaid},
      ProcessPaymnet Type : ${this.processPayment.Type}, IsRequired_Full_Payment : ${this.processPayment.requireFullPayment},Is Payment Completed : ${this.paymentTable.find(o => o.payId === this.currentPayId).payComplete},`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : this.getPaymentOrderId(), UserId : this.userSessionService.userSessionData.UserId});
    if ((this.processPayment.Type == EPaymentOrigin.Transfer && (!this.processPayment.requireFullPayment ||
      (this.processPayment.requireFullPayment && (this.processPayment.PrePayPeriod > 0 || this.processPayment.IsDueWoPrePayZero)))) ||
      (this.processPayment.Type == EPaymentOrigin.Rental && (!this.processPayment.requireFullPayment))) { // for Transfer and Movein Partial payment
      
      let status = this.paymentTable.some(function (ele) { return ele.payComplete == false && (ele.payAmount !== 0 && ele.payModeId !== 0); });
      if (status) {
        this.showPrintEmailRcpt = false;
      } else {
        this.showPrintEmailRcpt = true;
      }
    } else if ((this.processPayment.Type === EPaymentOrigin.MoveOut) && (!this.processPayment.requireFullPayment)) {  //Moveout Partial payment
      let status = this.paymentTable.some(function (ele) { return ele.payComplete == false && (ele.payAmount !== 0 && ele.payModeId !== 0); });
      if (status) {
        this.showPrintEmailRcpt = false;
      } else {
        this.showPrintEmailRcpt = true;
      }

    } else if (this.processPayment.Type === EPaymentOrigin.MakePayment) {
      let status = this.paymentTable.some(function (ele) { return ele.payComplete == false && (ele.payAmount !== 0 && ele.payModeId !== 0); });
      if (status) {
        this.showPrintEmailRcpt = false;
      } else {
        this.showPrintEmailRcpt = true;
      }
    } else if (this.processPayment.Type === EPaymentOrigin.ReInstate) {
      let status = this.paymentTable.some(function (ele) { return ele.payComplete == false && (ele.payAmount !== 0 && ele.payModeId !== 0); });
      if (status) {
        this.showPrintEmailRcpt = false;
      } else {
        this.showPrintEmailRcpt = true;
      }
    } else if (this.processPayment.Type === EPaymentOrigin.AuctionManager) {
      let status = this.paymentTable.some(function (ele) { return ele.payComplete == false && (ele.payAmount !== 0 && ele.payModeId !== 0); });
      if (status) {
        this.showPrintEmailRcpt = false;
      } else {
        this.showPrintEmailRcpt = true;
      }
    } else if (this.processPayment.Type === 9) {
      this.showPrintEmailRcpt = true;
    } else {
      let status = this.paymentTable.some(function (ele) { return ele.payComplete == false && (ele.payAmount !== 0 && ele.payModeId !== 0); });
      if (status) {
        this.showPrintEmailRcpt = false;
      } else {
        if (this.paymentTable.length == 1) {
          this.showPrintEmailRcpt = true;
        } else {
          if (this.processPayment.Type == EPaymentOrigin.Transfer && this.processPayment.requireFullPayment) {
            this.showPrintEmailRcpt = this.checkIfFullAmountPaid() ? true : false;
          } else if(this.processPayment.Type == EPaymentOrigin.Rental && this.processPayment.requireFullPayment && !this.isCurrentPeriodAmountAdded() && !this.userSessionService.userSessionData?.UserGroup.IndividualPermission?.UserGroupOverrideSettings?.AllowPartialPayment){
            this.showPrintEmailRcpt = this.checkIfFullAmountPaid() ? true : false;
          }else{
            this.showPrintEmailRcpt = true;
          }
        }
      }

    }

    if (this.paymentTable.find(o => o.payId == this.currentPayId).payModeId == EPaymentModes.Cash) {
      this.modalRef.hide();
      this.paymentInProgress = true;
      this.paymentTable.find(o => o.payId == this.currentPayId).changeAmount = this.changeAmount;
    } else if (this.paymentTable.find(o => o.payId == this.currentPayId).payModeId == EPaymentModes.Check) {
      this.checkModalRef.hide();
      this.paymentInProgress = true;
      this.paymentTable.find(o => o.payId == this.currentPayId).checkNum = this.checkNo;
      this.paymentTable.find(o => o.payId == this.currentPayId).checkDate = this.checkDate;
      this.paymentTable.find(o => o.payId == this.currentPayId).bankName = this.checkBank;
    } else if (this.paymentTable.find(o => o.payId == this.currentPayId).payModeId == EPaymentModes.ManualAuthorization) {
      this.manualModalRef.hide();
      this.paymentInProgress = true;
      this.paymentTable.find(o => o.payId == this.currentPayId).ManualCardNumber = this.ManualCardNumber;
      this.paymentTable.find(o => o.payId == this.currentPayId).ManualCardExp = this.ManualCardExp;
      this.paymentTable.find(o => o.payId == this.currentPayId).ManualCardName = this.ManualCardName;
      if (this.ManualSelectCard) {
        this.paymentTable.find(o => o.payId == this.currentPayId).CreditCardType = this.creditCardList.find(o => o.Id == parseInt(this.ManualSelectCard)).Id;
      } else {
        this.paymentTable.find(o => o.payId == this.currentPayId).CreditCardType = null
      }
      this.paymentTable.find(o => o.payId == this.currentPayId).ManualCardAuthorization = this.ManualCardAuthorization;
      setTimeout(() => {
        this.ManualCardNumber = '';
        this.ManualCardExp = '';
        this.ManualCardName = '';
        this.ManualCardAuthorization = '';
      }, 500);
    } else if (this.paymentTable.find(o => o.payId == this.currentPayId).payModeId == EPaymentModes.ACHManualAuthorization) {
      this.achManualModalRef.hide();
      this.paymentInProgress = true;
      this.paymentTable.find(o => o.payId == this.currentPayId).routingNumber = this.routingNumber;
      this.paymentTable.find(o => o.payId == this.currentPayId).accountNumber = this.accountNumber;
      this.paymentTable.find(o => o.payId == this.currentPayId).accountType = this.accountType;
      this.paymentTable.find(o => o.payId == this.currentPayId).nameonAccount = this.nameonAccount;
      this.paymentTable.find(o => o.payId == this.currentPayId).achManualCardAuthorization = this.achManualCardAuthorization;
      const obj = {
        APPROVEDAMOUNT: amount,
        CHECKNUMBER: this.checkNumber,
        TRANSACTIONID: this.achManualCardAuthorization,
        RESPONSECODE: '000',
        RESPONSEDESCRIPTION: 'Approved',
        ORDERID: null,
        ACCOUNT: this.accountNumber,
        ROUTINGNUMBER: this.routingNumber,
        RECEIPTTEXT: null,
        ACCOUNTYPE: this.accountType
      };
      this.paymentTable.find(o => o.payId == this.currentPayId)['processedACH'] = obj;
      setTimeout(() => {
        this.routingNumber = '';
        this.achManualCardAuthorization = '';
        this.accountNumber = '';
        this.accountType = 279;
        this.nameonAccount = '';
        this.checkNumber = '';
      }, 500);
    } else if (this.paymentTable.find(o => o.payId == this.currentPayId).payModeId == EPaymentModes.EFTManualAuthorization) {
      this.eftManualModalRef.hide();
      this.paymentInProgress = true;
      this.paymentTable.find(o => o.payId == this.currentPayId).routingNumber = this.routingNumber;
      this.paymentTable.find(o => o.payId == this.currentPayId).accountNumber = this.accountNumber;
      this.paymentTable.find(o => o.payId == this.currentPayId).accountType = this.accountType;
      this.paymentTable.find(o => o.payId == this.currentPayId).bankName = this.nameonAccount;
      this.paymentTable.find(o => o.payId == this.currentPayId).eftManualCardAuthorization = this.eftManualCardAuthorization;
      const obj = {
        APPROVEDAMOUNT: amount,
        TRANSACTIONID: this.eftManualCardAuthorization,
        RESPONSECODE: '000',
        RESPONSEDESCRIPTION: 'Approved',
        ORDERID: null,
        ACCOUNT: this.accountNumber,
        ROUTINGNUMBER: this.routingNumber,
        RECEIPTTEXT: null,
        ACCOUNTYPE: this.accountType
      };
      this.paymentTable.find(o => o.payId == this.currentPayId)['processedACH'] = obj;
      setTimeout(() => {
        this.routingNumber = '';
        this.eftManualCardAuthorization = '';
        this.accountNumber = '';
        this.accountType = 279;
        this.bankName = '';
        this.checkNumber = '';
      }, 500);
    } else if (this.paymentTable.find(o => o.payId == this.currentPayId).payModeId == EPaymentModes.RemotePay) {
      this.paymentInProgress = true;
      this.paymentTable.find(o => o.payId == this.currentPayId).remotePayIsSMS = this.remotePayIsSMS;
      this.paymentTable.find(o => o.payId == this.currentPayId).remotePayPhoneNumber = this.remotePayPhoneNumber;
      this.paymentTable.find(o => o.payId == this.currentPayId).remotePayIsEmail = this.remotePayIsEmail;
      this.paymentTable.find(o => o.payId == this.currentPayId).remotePayEmailId = this.remotePayEmailId;
      setTimeout(() => {
        this.remotePayIsSMS = false;
        this.remotePayPhoneNumber = '';
        this.remotePayIsEmail = false;
        this.remotePayEmailId = '';
      }, 500);
    }

    ///////////////////////////////////////////////////////////
    this.appInsightsService.logPaymentEvent(isCC, `Show Email Receipt : ${this.showPrintEmailRcpt}, IsPaymentSuccessfull : ${this.paymentSuccessFul}`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : this.getPaymentOrderId(),UserId : this.userSessionService.userSessionData.UserId});
    if (this.showPrintEmailRcpt || !this.paymentSuccessFul) {
      if (!this.paymentSuccessFul) {
        this.payModalRef = this.modalService.show(template, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
      }
      if (this.showPrintEmailRcpt) {
        this.callTransactionComplete();
      }
    }
  }

  callTransactionComplete() {
    this.showLoaderMesage = true;
    this.loaderIcon = Promise.resolve(true);
    this.transactionInitiated = true;
    this.afterpaymentSuccess();
  }

  OnmanualCancel() {
    this.paymentStarted = false;
    this.ManualCardExpIsDirty = false;
    this.ManualCardNumber = '';
    this.ManualCardExp = '';
    this.ManualCardName = '';
    this.ManualCardAuthorization = '';
    this.manualModalRef.hide();
    this.checkPaymentProcess();
  }

  OnCardcancel() {
    this.paymentStarted = false;
    this.selectedDeviceId = 0;
    this.selectStripeReaderId = "";
    this.modalRefSelectDevice.hide();
    this.checkPaymentProcess();
  }

  onEmailCheck(event) {
    if (event.target.checked) {
      this.enableEmail = true;
    } else {
      this.enableEmail = false;
    }
  }

  onSMSCheck(event) {
    if (event.target.checked) {
      this.enableSMS = true;
    } else {
      this.enableSMS = false;
    }
  }

  onKeyEmail(event) {
    if (this.emailBox != '' || this.emailBox != null) {
      this.emailValid = true;
    } else {
      this.emailValid = false;
    }
  }

getHiddenInput(): void {
  this.hstPayBtnMsg = 'Cancel';
  const iframeSrc = this.iframe.nativeElement.src.split('/');
  const tempId = iframeSrc.pop();
  if (!this.credentials?.QueryPaymentStatusURL) {
    this.toastr.warning('Please ask Administrator to configure CNP URL','URL required',this.toasterConfig);
    return;
  }
  if (this.sessionId !== tempId) {
    this.sessionId = tempId;
    return;
  }
  this.sessionId = tempId;
  this.paymentInProgress = true;
  this.showLoaderMesage = true;
  this.loaderIcon = Promise.resolve(true);
  this.hstPayBtnMsg = 'OK';
  const payment = this.paymentTable.find(o => o.payId === this.currentPayId);
  if (!payment) return;

  const paymentTrnsId =
    this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);

  const startTime = Date.now();
  const maxWaitMs = 10000 * 6 * this.paymentMaxWaitTime; // same as old logic
  let pollTimer: any;

  const stopPolling = () => {
    if (pollTimer) {
      clearTimeout(pollTimer);
      pollTimer = null;
    }
  };

  const poll = () => {
    const elapsed = Date.now() - startTime;

    if (elapsed >= maxWaitMs) {
      stopPolling();
      this.clearPayFieldsWatchdog();
      this.loaderIcon = Promise.resolve(false);
      this.showIFrame = false;
      this.showPage = true;
      this.payStatus = 'Failed';
      payment.payFailed = true;
      this.toastr.error('Payment timed out', 'Timeout');

      this.saveCCTransactionFailureCase(
        {
          PaymentModeId: EPaymentModes.HostedPage,
          RESULT: {
            RESPONSECODE: 408,
            RESPONSEDESCRIPTION: 'Payment timeout'
          }
        },
        'Payment timeout',
        'Sale',
        paymentTrnsId,
        payment.orderId,
        payment.payId
      );
      return;
    }

    this.paymentService
      .getCNPResponse(this.credentials, payment.uniqueTransId)
      .subscribe(
        (res: any) => {
          const jsonResp = JSON.parse(res);
          const result = jsonResp?.RESULT;

          // ✅ SUCCESS
          if (
            result?.RESPONSECODE === EOpenEdgeResponseCode.Approval &&
            result?.STATE !== 'IN_PROGRESS'
          ) {
            stopPolling();
            this.clearPayFieldsTokenState();

            this.loaderIcon = Promise.resolve(false);
            this.showIFrame = false;
            this.showPage = true;
            this.paymentSuccessFul = true;
            this.payStatus = 'Success';
            payment.payFailed = false;
            payment.processedCNPCC = this.normalizePayFieldsResponse(result);

            const amount = parseFloat(payment.processedCNPCC.APPROVEDAMOUNT ?? 0).toFixed(2);
            this.disableNextButton();
            this.gotoPaymentSuccess(this.popUpPayment, amount);
            return;
          }

          if (
            result?.STATE === 'IN_PROGRESS' ||
            result?.RESPONSECODE ===
              EOpenEdgeResponseCode.TransactionDoesNotExist
          ) {
            pollTimer = setTimeout(poll, 1000);
            return;
          }

          stopPolling();
          this.clearPayFieldsWatchdog();

          this.loaderIcon = Promise.resolve(false);
          this.showIFrame = false;
          this.showPage = true;
          this.payStatus = 'Failed';
          payment.payFailed = true;

          jsonResp.PaymentModeId = EPaymentModes.HostedPage;

          this.saveCCTransactionFailureCase(jsonResp,result?.RESPONSEDESCRIPTION ?? 'Declined','Sale',paymentTrnsId,payment.orderId,payment.payId);
        },
        err => {
          if (err.status === HttpStatusCode.BadGateway) {
            pollTimer = setTimeout(poll, 1000);
            return;
          }

          stopPolling();
          this.clearPayFieldsWatchdog();

          this.loaderIcon = Promise.resolve(false);
          this.showIFrame = false;
          this.showPage = true;
          this.payStatus = 'Failed';
          payment.payFailed = true;

          this.toastr.error('Payment Failed', 'Failure');

          this.saveCCTransactionFailureCase(
            {
              PaymentModeId: EPaymentModes.HostedPage,
              RESULT: {
                RESPONSECODE: err?.status ?? 0,
                RESPONSEDESCRIPTION: err?.statusText ?? ''
              }
            },
            'Gateway Rejected - No response received!','Sale',paymentTrnsId,payment.orderId,payment.payId);
        }
      );
  };

  poll();
}
  HostedCNPResponse(orderId, payId, paymentTrnsId) {
    if (!this.paymentTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted) {
      const startTime = Date.now();
      this.paymentService.getCNPResponse(this.credentials, orderId).subscribe((res: any) => {
        const jsonResp = JSON.parse(res);
        const elapsedTime = Date.now() - startTime;
        const waitTime = Math.max(1000 - elapsedTime, 0);
        if (jsonResp.RESULT && jsonResp.RESULT.STATE && jsonResp.RESULT.STATE != 'IN_PROGRESS' && jsonResp.RESULT.RESPONSECODE == EOpenEdgeResponseCode.Approval) {
          this.showIFrame = false;
          this.showPage = !this.showIFrame;
          this.paymentSuccessFul = true;
          this.payStatus = 'Success';
          this.disableNextButton();
          this.paymentTable.find(o => o.payId == payId).payFailed = false;
          const processedCNPCC = this.normalizePayFieldsResponse(jsonResp.RESULT);
          this.paymentTable.find(o => o.payId == payId)['processedCNPCC'] = processedCNPCC;
          this.paymentTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted = true;
          this.appInsightsService.logPaymentEvent(true,`Goto Payment Success : ${parseFloat(processedCNPCC.APPROVEDAMOUNT ?? 0).toFixed(2)}`, { Gateway: this.paymentGateway , FacilityId :  this.processPayment.facId,OrderId : orderId, UserId : this.userSessionService.userSessionData.UserId});
          this.currentPayId = payId;
          this.gotoPaymentSuccess(this.popUpPayment, parseFloat(processedCNPCC.APPROVEDAMOUNT ?? 0).toFixed(2));
        } else if (jsonResp.RESULT.STATE == 'IN_PROGRESS' || (jsonResp.RESULT && jsonResp.RESULT.RESPONSECODE == EOpenEdgeResponseCode.TransactionDoesNotExist && jsonResp.RESULT.RESPONSEDESCRIPTION == 'Invalid Reference Error: Transaction does not exist')) {
          setTimeout(() => {
            this.HostedCNPResponse(orderId, payId, paymentTrnsId);
          }, waitTime);
        } else {
          this.appInsightsService.logPaymentEvent(true,`Gateway Failure : ${jsonResp?.RESULT?.RESPONSEDESCRIPTION ?? "Gateway failure"}`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : orderId, UserId : this.userSessionService.userSessionData.UserId});
          this.paymentTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted = true;
          this.paymentSuccessFul = false;
          this.paymentProcessing = false;
          this.payStatus = 'Failed';
          this.paymentTable.find(o => o.payId == payId).payFailed = true;
          jsonResp['PaymentModeId'] = EPaymentModes.HostedPage;
          this.saveCCTransactionFailureCase(jsonResp, jsonResp.RESULT && jsonResp.RESULT.RESPONSEDESCRIPTION ? jsonResp.RESULT.RESPONSEDESCRIPTION : 'Declined!', 'Sale', paymentTrnsId, this.paymentTable.find(o => o.payId == payId).orderId, payId);
        }
      }, err => {
        if (err.status == HttpStatusCode.BadGateway) { // Gateway Timeout
          const elapsedTime = Date.now() - startTime;
          const waitTime = Math.max(1000 - elapsedTime, 0);
          setTimeout(() => {
            this.HostedCNPResponse(orderId, payId, paymentTrnsId);
          }, waitTime);
        } else {
          this.paymentTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted = true;
          this.loaderIcon = Promise.resolve(false);
          this.tempCNPRes = {
            PaymentModeId: EPaymentModes.HostedPage,
            RESULT: {
              RESPONSECODE: err?.status ?? 0,
              RESPONSEDESCRIPTION: err?.statusText ?? ''
            }
          }
          this.paymentFailReason = 'Declined!';
          this.showIFrame = false;
          this.showPage = !this.showIFrame;
          this.payStatus = 'Failed';
          this.paymentStarted = false;
          this.paymentTable.find(o => o.payId == payId).payFailed = true;
          this.toastr.error('Payment Failed', 'Failure');
          this.saveCCTransactionFailureCase(this.tempCNPRes, this.paymentFailReason, 'Sale', paymentTrnsId, this.paymentTable.find(o => o.payId == payId).orderId, payId);
        }
      });
    }
  }

  onhstPayBtn(val) {
    if (val == 'OK') {
      this.paymentTable.find(o => o.payId === this.currentPayId).payComplete = true;
    } else if (val == 'Cancel') {
      this.clearPayFieldsTokenState();
      this.paymentStarted = false;
      let paymentransactionTypeId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
      if (this.paymentTable.find(o => o.payId === this.currentPayId).payModeId == EPaymentModes.HostedPage) {
        const cCModel = {
          Amount: this.paymentTable.find(o => o.payId === this.currentPayId).payAmount,
          Autopay: false,
          PaymentModeId: EPaymentModes.HostedPage,
          AutoCcProcessingDay: 0,
          CreditCardNumber: 0,
          CreditCardType: ECreditCards.Visa,
          NameonCard: " ",
          CreditCardExpiryMonth: 275,
          CreditCardExpiryYear: 2099,
          CreditCardBillingAddress: '',
          CreditCardBillingZip: '',
          SwipeTransaction: false,
          SecurityCodeSent: false,
          AuthorizationCode: '0',
          ResponseCode: '0',
          Reason: 'Transaction Cancelled By User',
          PaymentAccountid: '',
          CcInfoPurged: false,
          DebitCardPayment: false,
          OfflinePayment: 0,
          PaymentTransactionTypeId: paymentransactionTypeId,
          TransactionDateTime: new Date(),
          TransactionTypeId: EPaymentTransactionType.Declined,
          OrderId: this.paymentTable.find(o => o.payId === this.currentPayId).orderId,
          CCBatchNumber: null,
          EmvReceiptText: null,
          FacilityId: this.processPayment.facId,
          TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
          TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
          LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null
        };
        this.paymentService.saveCCTransaction(Object.assign(cCModel)).subscribe((res: any) => { });
        this.showIFrame = false;
        this.showPage = !this.showIFrame;
      } else {
        this.showAchIFrame = false;
        this.showPage = !this.showIFrame;
        this.saveAchTransactions(null, paymentransactionTypeId, EPaymentTransactionType.Declined, "Transaction Cancelled By User", this.currentPayId);
      }
    }
  }

  saveInCCT(amount, payId, transTypeId) {
    this.paymentFailReason = '';
    this.isTDEmv.isTransactionWaitTime = false;
    this.stripeLoader.isStripeterminal = false;
    let paymentTrnsId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
    let payModeId = this.paymentTable.find(o => o.payId === payId).payModeId;
    let isNewPaymentArchiFac = (this.tdLocalHostArchitectureFacilities.find(fac => fac == this.processPayment.facId) || this.enableNewPaymentArchitecture) ? true : false;
    let CCTModel = this.generateIntialCCT(amount, transTypeId, paymentTrnsId, payModeId, null, null, null, null, isNewPaymentArchiFac, payId);
    this.paymentService.saveCCTransaction(CCTModel).subscribe((cctRes) => {
      if (cctRes.Success) {
        let cctId = cctRes.Id;
        this.isSaveInCCTResponse = true;
        this.paymentTable.find(o => o.payId == payId).orderId = cctRes.Id;
        this.paymentTable.find(o => o.payId == payId).uniqueTransId = cctRes.UniqueTransId;
        if ([EPaymentModes.CreditCard, EPaymentModes.DebitCard].includes(this.paymentTable.find(o => o.payId === payId).payModeId)) {
          this.appInsightsService.logPaymentEvent(true, `Initializing the Credit Card Payment. Order Id: ${this.paymentGateway == EPaymentGateway.TdBank ? cctId : cctRes.UniqueTransId}`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : this.paymentGateway == EPaymentGateway.TdBank ? cctId : cctRes.UniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
          if (this.paymentGateway == EPaymentGateway.TdBank) {
            if (isNewPaymentArchiFac) {
              const obj = {
                OrderId: cctRes.Id,
                Amount: amount,
                AuthorizationCode: "0",
                CreditCardNumber: "0",
                TransactionType: "SALE",
                InvoiceNumberForTDVoid: 0,
                UserId: this.userSessionService.userSessionData.UserId
              }
              this.loaderIcon = Promise.resolve(true);
              this.showLoaderMesage = false;
              this.isTDEmv.isTransactionWaitTime = true;
              let isTdTransactionCompleted = false;
              let initiateTDPayment = this.paymentService.InitiateTDPayment(obj, this.credentials.URLforLocalHost).subscribe((res) => {
                if (res) {
                  this.isTDEmv.isTransactionWaitTime = false;
                  isTdTransactionCompleted = true;
                  this.paymentInProgress = true;
                  if (res.ResponseCode == '000') {
                    res.OrderId = res.OrderId || cctId;
                    if (this.handleTdCardModeMismatch(payId, res, paymentTrnsId)) { return; }
                    this.prePayStatus = 'Payment';
                    this.payStatus = 'Success';
                    this.paymentSuccessFul = true;
                    this.paymentTable.find(o => o.payId == payId).payFailed = false;
                    this.disableNextButton();
                    res['TransactionTypeId'] = EPaymentTransactionType.Processed;
                    res['PaymentTransactionTypeId'] = paymentTrnsId;
                    this.paymentTable.find(o => o.payId == payId)['processedCC'] = res;
                    this.gotoPaymentSuccess(this.popUpPayment, res.Amount);
                    this.loaderIcon = Promise.resolve(false);
                  } else {
                    this.tdEmvFailedResponse(amount, res, payId, cctId, paymentTrnsId, "SALE");
                  }
                } else {
                  this.isTDEmv.isTransactionWaitTime = false;
                  isTdTransactionCompleted = true;
                  this.tdEmvFailedResponse(amount, res, payId, cctId, paymentTrnsId, "SALE");
                  this.loaderIcon = Promise.resolve(false);
                }
              }, err => {
                this.isTDEmv.isTransactionWaitTime = false;
                isTdTransactionCompleted = true;
                if (err.error && err.error.text && (err.error.text.includes('Could not find file') || err.error.text.includes('does not exist'))) { //COM port doesn't exist
                  this.paymentFailReason = 'EMV Device Not Connected!';
                  this.toastr.warning(`${err.error.text}`, 'Alert', this.toasterConfig);
                } else if (!err.error.text) {
                  this.toastr.warning('Please ask Administrator to configure TD Service', 'Alert', this.toasterConfig);
                }
                const exceptionMessage = {
                  Reason: err.error && err.error.text ? err.error.text : 'Declined'
                }
                if (exceptionMessage.Reason == 'Another Payment is in progress.') {
                  this.toastr.warning('Another Payment is in progress, Please try after sometime.', 'Alert', this.toasterConfig);
                  this.isTDEmv.isPortClosingWaitTime = true;
                  this.loaderIcon = Promise.resolve(true);
                  this.paymentFailReason = exceptionMessage.Reason;
                  setTimeout(() => {
                    const obj = {
                      OrderId: cctRes.Id,
                      Amount: amount,
                      AuthorizationCode: "0",
                      CreditCardNumber: "0",
                      TransactionType: "RCLT",
                      UserId: this.userSessionService.userSessionData.UserId
                    }
                    this.tdEmvFailedResponse(amount, exceptionMessage, payId, cctId, paymentTrnsId, "SALE");
                    this.paymentService.InitiateTDPayment(obj, this.credentials.URLforLocalHost).subscribe((recallRes) => { });
                    this.isTDEmv.isPortClosingWaitTime = false;
                    this.loaderIcon = Promise.resolve(false);
                  }, 10000 * 6 * this.paymentMaxWaitTime);
                } else {
                  this.tdEmvFailedResponse(amount, exceptionMessage, payId, cctId, paymentTrnsId, "SALE");
                }
              });
              //if Port Disconnected or Device Turn off case
              setTimeout(() => {
                if (!isTdTransactionCompleted) {
                  this.isTDEmv.isTransactionWaitTime = false;
                  initiateTDPayment.unsubscribe();
                  const exceptionMessage = {
                    Reason: 'No Response',
                    ResponseCode: 50
                  }
                  this.tdEmvFailedResponse(amount, exceptionMessage, payId, cctId, paymentTrnsId, "SALE");
                  this.loaderIcon = Promise.resolve(false);
                }
              }, 10000 * 6 * this.paymentMaxWaitTime);
            } else {
              this.paymentInProgress = true;
              if (!this.subTD) {
                let intervalTime = this.paymentGetCCTStatusInterval * 1000;
                const source = interval(intervalTime);
                this.subTD = source.subscribe(val => this.getCCTStatus(cctId, payId, val, paymentTrnsId));
              }
            }
          } else if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress) {
            if (isNewPaymentArchiFac) {
              this.callOpenEdgeTerminal(amount, payId, cctRes.Id, paymentTrnsId, cctRes.UniqueTransId);
            } else {
              this.callRCM(amount, payId, cctRes.Id, paymentTrnsId);
            }
          } else {
            this.stripeResponse = this.stripeTerminalDeviceId = '';
            // Autopay/Card on File is offered for Credit Card only, never Debit Card (PR 33768).
            if (this.defaultCountryId == ECountries.UnitedStatesOfAmerica && payModeId !== EPaymentModes.DebitCard && [EPaymentOrigin.MakePayment, EPaymentOrigin.ReInstate, EPaymentOrigin.Rental, EPaymentOrigin.Transfer].includes(this.processPayment.Type) && this.isAutopayEnabled()) {
              this.loaderIcon = Promise.resolve(false);
              this.autopayHeader = "Enable Autopay or Card on File?";
              this.autopayMessage = "Do you want to enable Autopay or Card on File for the Card used to Pay Now?";
              this.autopayFooter = "Enable Card on File";
              this.enableAutopayOrCardOnFile = this.modalService.show(this.SelectAutopayorCardOnFile, { class: 'modal-medium modal-dialog-centered', backdrop: 'static', keyboard: false });
            } else {
              this.stripeTerminalPayment();
            }
          }
        } else if (this.paymentTable.find(o => o.payId === payId).payModeId == EPaymentModes.HostedPage) {
          if (this.paymentGateway == EPaymentGateway.TdBank) {
            this.callTdHostedPage(amount);
          } else if (this.paymentGateway == EPaymentGateway.Stripe) {
            this.stripeResponse = '';
            this.selectedPaymentMode = payModeId;
            this.cctOrderId = cctId;
            if ([EPaymentOrigin.MakePayment, EPaymentOrigin.ReInstate, EPaymentOrigin.Rental, EPaymentOrigin.Transfer].includes(this.processPayment.Type) && this.isAutopayEnabled()) {
              this.loaderIcon = Promise.resolve(false);
              this.autopayHeader = "Enable Autopay or Card on File?";
              this.autopayMessage = "Do you want to enable Autopay or Card on File for the Card used to Pay Now?";
              this.autopayFooter = "Enable Card on File";
              this.enableAutopayOrCardOnFile = this.modalService.show(this.SelectAutopayorCardOnFile, { class: 'modal-medium modal-dialog-centered', backdrop: 'static', keyboard: false });
            } else {
              this.createPaymentIntent(amount, EPaymentModes.HostedPage, payId);
            }
          } else {
            this.routeOpenEdgeHostedModePayment(amount, payId, cctRes.Id);
          }
        } else if (this.paymentTable.find(o => o.payId === payId).payModeId == EPaymentModes.ManualAuthorization) {
          this.loaderIcon = Promise.resolve(false);
          if (this.showPrintEmailRcpt) {
            this.setMandatoryFieldsManualAuthForm();
            this.manualModalRef = this.modalService.show(this.offlinePay, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
          } else {
            this.setMandatoryFieldsManualAuthForm();
            this.manualModalRef = this.modalService.show(this.offlinePay, { class: 'modal-dialog-centered modal-md', backdrop: 'static', keyboard: false });
          }
        } else if (this.paymentTable.find(o => o.payId === payId).payModeId == EPaymentModes.CardOnfile) {
          this.loaderIcon = Promise.resolve(false);
          if (this.paymentGateway == EPaymentGateway.TdBank) {
            this.cardOnFileTD(amount, cctRes.Id, payId, paymentTrnsId);
          } else if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress) {
            if (this.processPayment.LeaseNo) {
              this.customerService.GetAutoPayDetails(this.processPayment.LeaseNo, this.facilityId).subscribe((response: any) => {
                if (response) {
                  this.autoPayInfo = JSON.parse(JSON.stringify(response));
                  this.autoPayInfo.LeaseNo= JSON.parse(JSON.stringify(this.processPayment.LeaseNo));
                  this.cardOnFileEdge(amount, cctRes, payId, paymentTrnsId);
                }
              });
            }
            else {
              this.cardOnFileEdge(amount, cctRes, payId, paymentTrnsId);
            }
          } else { //stripe
            this.cardOnFileStripe(amount, cctRes, payId, paymentTrnsId);
          }
        }
      } else {
        this.loaderIcon = Promise.resolve(false);
        this.paymentStarted = false;
        this.toastr.error("We couldn't create CCT, Please try again!", 'Failure', this.toasterConfig);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
      this.paymentStarted = false;
      this.toastr.error(' Something went wrong!', 'Failure', this.toasterConfig);
    });
  }

  voidCCRCM(id, orderId, paymentTrnsId) {
    let TID = this.paymentTable.find(o => o.payId == id)['processedCC'].TRANSACTIONID;
    let amount = this.paymentTable.find(o => o.payId == id)['processedCC'].APPROVEDAMOUNT;
    if (!this.credentials.RCMURL) {
      this.toastr.warning('Please ask Administrator to configure RCM URL', 'URL required', this.toasterConfig);
      this.showLoaderMesage = false;
      this.loaderIcon = Promise.resolve(false);
    } else {
      let TransactionType = this.paymentTable.find(o => o.payId == id)['processedCC'].TRANSACTIONTYPE;
      if (TransactionType == 'CREDITSALE') {
        this.paymentService.GetCNPCreditVoid(this.credentials, TID, amount).subscribe((res: any) => {
          if (res) {
            const jsonResp = JSON.parse(res);
            if (jsonResp.RESULT.RESPONSECODE == EOpenEdgeResponseCode.Approval) {
              const CCTModel = {
                Amount: jsonResp.RESULT.APPROVEDAMOUNT,
                Autopay: false,
                paymentModeId: EPaymentModes.CreditCard,
                AutoCcProcessingDay: 0,
                CreditCardNumber: jsonResp.RESULT.MASKEDCARDNUMBER,
                CreditCardType: jsonResp.RESPONSE && jsonResp.RESPONSE.CARDBRAND ? this.paymentService.openEdgeCardType(jsonResp.RESPONSE.CARDBRAND) : ECreditCards.Visa,
                NameonCard: jsonResp.RESULT.CARDBRANDSHORT,
                CreditCardExpiryMonth: jsonResp.RESULT.EXPMONTH ? this.getExpiryMonthValue(parseInt(jsonResp.RESULT.EXPMONTH, 10)) : 275,
                CreditCardExpiryYear: jsonResp.RESULT.EXPYEAR ? parseInt(jsonResp.RESULT.EXPYEAR, 10) : 2099,
                CreditCardBillingAddress: '',
                CreditCardBillingZip: '',
                SwipeTransaction: false,
                SecurityCodeSent: false,
                AuthorizationCode: jsonResp.RESULT.TRANSACTIONID,
                ResponseCode: jsonResp.RESULT.RESPONSECODE,
                Reason: jsonResp.RESULT.RESPONSEDESCRIPTION,
                Key: '',
                PaymentAccountid: '',
                CcInfoPurged: false,
                DebitCardPayment: jsonResp.RESULT.CARDTYPE == 'Credit' ? false : true,
                OfflinePayment: 0,
                PaymentTransactionTypeId: paymentTrnsId,
                OrderId: orderId,
                FacilityId: this.processPayment.facId,
                TransactionDateTime: new Date(),
                TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
                TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
                TerminalDeviceId: null,
                EmvReceiptText: jsonResp.RESULT.RECEIPTTEXT ? jsonResp.RESULT.RECEIPTTEXT : null
              };
              this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
              if (!this.multiPaymentVoidEmv.some(function (ele) { return (ele.isEmvVoidInitiated == false); })) {
                this.showLoaderMesage = false;
                if (!this.voidOnCancelInitiated) {
                  this.isCancel.emit(true);
                }
                this.initiatedVoidCC = false;
                this.loaderIcon = Promise.resolve(false);
              }
            } else {
              this.saveCCTransactionFailureCase(jsonResp, jsonResp.RESULT.RESPONSEDESCRIPTION ? jsonResp.RESULT.RESPONSEDESCRIPTION : 'Declined', 'Void', paymentTrnsId, orderId, id);
              this.showLoaderMesage = false;
              this.initiatedVoidCC = false;
            }
          }
        });
      } else {// Debit return
        this.showLoaderMesage = true;
        let requestParam = "<REQUEST> " + "<XWEBID>" + this.credentials.XWEBID + "</XWEBID>" +
          "<XWEBTERMINALID>" + this.credentials.XWEBTERMINALID + "</XWEBTERMINALID>" +
          "<XWEBAUTHKEY>" + this.credentials.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
          "<TRANSACTIONTYPE>DEBITRETURN</TRANSACTIONTYPE><AMOUNT>" + amount + "</AMOUNT><ORDERID>" + orderId + "</ORDERID><OTK>" + orderId + "</OTK></REQUEST>";
        this.initiatedVoidCC = true;
        this.paymentService.getRCMService(this.credentials.RCMURL, requestParam).subscribe((res: any) => {
          const responseData = JSON.parse(res.RcmResponse);
          if (responseData.RESPONSE.RESULT == EOpenEdgeResponseCode.Approval) {
            if (!this.voidOnCancelInitiated) {
              this.isCancel.emit(true);
            }
            this.showLoaderMesage = false;
            this.loaderIcon = Promise.resolve(false);
            const CCTModel = {
              Amount: responseData.RESPONSE.APPROVEDAMOUNT,
              Autopay: false,
              paymentModeId: EPaymentModes.CreditCard,
              AutoCcProcessingDay: 0,
              CreditCardNumber: responseData.RESPONSE.ACCOUNT == undefined ? 0 : responseData.RESPONSE.ACCOUNT,
              CreditCardType: responseData.RESPONSE && responseData.RESPONSE.CARDBRAND ? this.paymentService.openEdgeCardType(responseData.RESPONSE.CARDBRAND) : ECreditCards.Visa,
              NameonCard: responseData.RESPONSE.CARDHOLDERNAME && responseData.RESPONSE.CARDHOLDERNAME.length > this.maxLengthNameOnCard ?
                responseData.RESPONSE.CARDHOLDERNAME.substr(0, this.maxLengthNameOnCard) : responseData.RESPONSE.CARDHOLDERNAME,
              CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(responseData.RESPONSE.EXPMONTH, 10)),
              CreditCardExpiryYear: parseInt(responseData.RESPONSE.EXPYEAR, 10),
              CreditCardBillingAddress: '',
              CreditCardBillingZip: '',
              SwipeTransaction: false,
              SecurityCodeSent: false,
              AuthorizationCode: responseData.RESPONSE.TRANSACTIONID,
              ResponseCode: responseData.RESPONSE.HOSTRESPONSECODE,
              Reason: responseData.RESPONSE.HOSTRESPONSEDESCRIPTION,
              Key: '',
              PaymentAccountid: '',
              CcInfoPurged: false,
              DebitCardPayment: responseData.RESPONSE.CARDTYPE == 'Credit' ? false : true,
              OfflinePayment: false,
              PaymentTransactionTypeId: paymentTrnsId,
              OrderId: orderId,
              FacilityId: this.processPayment.facId,
              TransactionDateTime: new Date(),
              TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
              TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
              LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
              TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
              EmvReceiptText: responseData.RESPONSE.RECEIPTTEXT ? responseData.RESPONSE.RECEIPTTEXT : null,
              CCBatchNumber: responseData.RESPONSE.BATCHNO ? responseData.RESPONSE.BATCHNO : null
            };
            this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
            this.initiatedVoidCC = false;
          } else {
            const CCTModel = {
              Amount: responseData.RESPONSE.APPROVEDAMOUNT ? responseData.RESPONSE.APPROVEDAMOUNT : amount,
              Autopay: false,
              paymentModeId: EPaymentModes.CreditCard,
              AutoCcProcessingDay: 0,
              CreditCardNumber: responseData.RESPONSE.ACCOUNT == undefined ? '0' : responseData.RESPONSE.ACCOUNT,
              CreditCardType: responseData.RESPONSE && responseData.RESPONSE.CARDBRAND ? this.paymentService.openEdgeCardType(responseData.RESPONSE.CARDBRAND) : ECreditCards.Visa,
              NameonCard: responseData.RESPONSE.CARDHOLDERNAME && responseData.RESPONSE.CARDHOLDERNAME.length > this.maxLengthNameOnCard ?
                responseData.RESPONSE.CARDHOLDERNAME.substr(0, this.maxLengthNameOnCard) : responseData.RESPONSE.CARDHOLDERNAME,
              CreditCardExpiryMonth: responseData.RESPONSE.EXPMONTH ? this.getExpiryMonthValue(parseInt(responseData.RESPONSE.EXPMONTH, 10)) : 275,
              CreditCardExpiryYear: responseData.RESPONSE.EXPYEAR ? parseInt(responseData.RESPONSE.EXPYEAR, 10) : 2099,
              CreditCardBillingAddress: '',
              CreditCardBillingZip: '',
              SwipeTransaction: false,
              SecurityCodeSent: false,
              AuthorizationCode: responseData.RESPONSE.TRANSACTIONID ? responseData.RESPONSE.TRANSACTIONID : '0',
              ResponseCode: responseData.RESPONSE.RESULT,
              Reason: responseData.RESPONSE.RESULTMSG ? responseData.RESPONSE.RESULTMSG : 'Declined',
              Key: '',
              PaymentAccountid: '',
              CcInfoPurged: false,
              DebitCardPayment: responseData.RESPONSE.CARDTYPE == 'Credit' ? false : true,
              OfflinePayment: false,
              PaymentTransactionTypeId: paymentTrnsId,
              OrderId: orderId,
              FacilityId: this.processPayment.facId,
              TransactionDateTime: new Date(),
              TransactionTypeId: EPaymentTransactionType.Declined,
              TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
              LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
              TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
              EmvReceiptText: responseData.RESPONSE.RECEIPTTEXT ? responseData.RESPONSE.RECEIPTTEXT : null,
              CCBatchNumber: responseData.RESPONSE.BATCHNO ? responseData.RESPONSE.BATCHNO : null
            };
            this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
            if (!this.voidOnCancelInitiated) {
              this.isCancel.emit(true);
            }
            this.toastr.error('Failed to Reverse the Payment!', 'Failure', this.toasterConfig);
            this.showLoaderMesage = false;
            this.loaderIcon = Promise.resolve(false);
            this.initiatedVoidCC = false;
          }
          this.showLoaderMesage = false;
        }, err => {
          if (!this.multiPaymentVoidEmv.some(function (ele) { return (ele.isEmvVoidInitiated == false); })) {
            this.showLoaderMesage = false;
            if (!this.voidOnCancelInitiated) {
              this.isCancel.emit(true);
            }
            this.initiatedVoidCC = false;
            this.loaderIcon = Promise.resolve(false);
          }
        });
      }
    }
  }

  voidCCCNP(id, orderId, payModeId, paymentTrnsId) {
    let rqsturl = 'https://ee.test.paygateway.com/HostPayService/v1/directpay/express';
    let paymentDetails = this.paymentTable.find(o => o.payId == id);

    // Guard: HostedPage rows require processedCNPCC; if absent (e.g. interrupted payment) bail out safely.
    if (payModeId == EPaymentModes.HostedPage && !paymentDetails?.['processedCNPCC']?.TRANSACTIONID) {
      this.appInsightsService.logPaymentEvent(true,
        `voidCCCNP: cannot void HostedPage row payId=${id} — processedCNPCC missing`,
        { Gateway: this.paymentGateway, FacilityId: this.processPayment?.facId }
      );
      this.showLoaderMesage = false;
      this.saveCCTransactionFailureCase({
        PaymentModeId: EPaymentModes.HostedPage,
        RESULT: {
          RESPONSECODE: 0,
          RESPONSEDESCRIPTION: 'Payment response data is missing. Check gateway portal.'
        }
      }, 'Payment response data is missing. Check gateway portal.', 'Void', paymentTrnsId, orderId, id);
      return;
    }

    let TID = payModeId == EPaymentModes.CardOnfile ? paymentDetails['processedCC'].AuthorizationCode
      : payModeId == EPaymentModes.CreditCard ? paymentDetails['processedCC'].TRANSACTIONID
        : paymentDetails['processedCNPCC'].TRANSACTIONID;

    let amount = payModeId == EPaymentModes.CardOnfile ? paymentDetails['processedCC'].Amount
      : payModeId == EPaymentModes.CreditCard ? paymentDetails['processedCC'].APPROVEDAMOUNT
        : paymentDetails['processedCNPCC'].APPROVEDAMOUNT;

    // PayFields HostedPage detection: route by whether THIS row was actually sold via PayFields
    // (the payFieldPayment marker set at sale completion), not by recomputing eligibility from the
    // facility's current settings — those can change (e.g. PayFields enabled later) after an older
    // legacy XWEB sale, which would otherwise send that sale's XWEB TRANSACTIONID to the PayFields
    // reference_id/{id}/voids endpoint.
    if ([EPaymentModes.HostedPage, EPaymentModes.CardOnfile].includes(payModeId) && this.paymentGateway == EPaymentGateway.OpenEdgeExpress && paymentDetails['payFieldPayment']) {
      this.requestGatewaydetails(payModeId, id);
      this.voidPayFieldsHostedPage(TID, amount, orderId, paymentTrnsId, payModeId, id);
      return;
    }

    this.paymentService.GetCNPCreditVoid(this.credentials, TID, amount).subscribe((res: any) => {
      if (res) {
        const jsonResp = JSON.parse(res);
        this.showLoaderMesage = false;
        if (jsonResp.RESULT.RESPONSECODE == EOpenEdgeResponseCode.Approval) {
          this.toastr.success(`Refund Processed Successfully - $${amount}`, 'Success', this.toasterConfig);
          const CCTModel = {
            Amount: jsonResp.RESULT.APPROVEDAMOUNT,
            Autopay: false,
            paymentModeId: payModeId,
            AutoCcProcessingDay: 0,
            CreditCardNumber: jsonResp.RESULT.MASKEDCARDNUMBER == undefined ? 0 : jsonResp.RESULT.MASKEDCARDNUMBER,
            CreditCardType: jsonResp.RESULT && jsonResp.RESULT.CARDBRAND ? this.paymentService.openEdgeCardType(jsonResp.RESULT.CARDBRAND) : ECreditCards.Visa,
            NameonCard: this.autoPayInfo && this.autoPayInfo.NameonCard ? this.autoPayInfo.NameonCard : '',
            CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(jsonResp.RESULT.EXPMONTH, 10)),
            CreditCardExpiryYear: parseInt(jsonResp.RESULT.EXPYEAR, 10),
            CreditCardBillingAddress: this.autoPayInfo && this.autoPayInfo.CreditCardBillingAddress ? this.autoPayInfo.CreditCardBillingAddress : '',
            CreditCardBillingZip: this.autoPayInfo && this.autoPayInfo.CreditCardBillingZip ? this.autoPayInfo.CreditCardBillingZip : '',
            SwipeTransaction: false,
            SecurityCodeSent: false,
            AuthorizationCode: jsonResp.RESULT.TRANSACTIONID,
            ResponseCode: jsonResp.RESULT.RESPONSECODE,
            Reason: jsonResp.RESULT.RESPONSEDESCRIPTION,
            Key: '',
            PaymentAccountid: '',
            CcInfoPurged: false,
            DebitCardPayment: jsonResp.RESULT.CARDTYPE == 'Credit' ? false : true,
            OfflinePayment: 0,
            PaymentTransactionTypeId: paymentTrnsId,
            OrderId: orderId,
            FacilityId: this.processPayment.facId,
            TransactionDateTime: new Date(),
            TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
            TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
            LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
            TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
            CCBatchNumber: jsonResp.RESULT.BATCHNO ? jsonResp.RESULT.BATCHNO : null,
            EmvReceiptText: jsonResp.RESULT.RECEIPTTEXT ? jsonResp.RESULT.RECEIPTTEXT : null
          };
          this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
          if (!this.multiPaymentVoidEmv.some(function (ele) { return (ele.isEmvVoidInitiated == false); })) {
            this.showLoaderMesage = false;
            if (!this.voidOnCancelInitiated) {
              this.isCancel.emit(true);
            }
            this.loaderIcon = Promise.resolve(false);
          }
        } else {
          this.paymentFailReason = jsonResp.RESULT && jsonResp.RESULT.RESPONSEDESCRIPTION ? jsonResp.RESULT.RESPONSEDESCRIPTION : 'Declined';
          this.saveCCTransactionFailureCase(jsonResp, this.paymentFailReason, 'Void', paymentTrnsId, orderId, id);
        }
      }
    }, err => {
      this.showLoaderMesage = false;
      this.loaderIcon = Promise.resolve(false);
      if (!this.voidOnCancelInitiated) {
        this.isCancel.emit(true);
      }
      this.toastr.error(`Failed to Reverse the Payment - $${amount}`, 'Failure', this.toasterConfig);
    });
  }

  /**
   * PayFields-specific HostedPage void/reversal handler.
   * Called when user cancels after a PayFields embedded form approval.
   * Routes to CallPayFieldReversal (Transactions API) instead of legacy GetCNPCreditVoid (XWEB).
   */
  private voidPayFieldsHostedPage(transactionId: string, amount: any, orderId: any, paymentTrnsId: any, payModeId: any, payId?: number): void {
    const gatewayDetailsObj = this.requestgatewaydetails ? JSON.parse(this.requestgatewaydetails) : { PayFieldPayment: true };
    const reversalPayload = {
      FacilityId: this.processPayment?.facId,
      GatewayDetails: gatewayDetailsObj,
      Amount: amount,
      InvoiceNumber: orderId,
      TransactionId: transactionId,
      TransactionType: 'voids'
    };

    this.paymentService.CallPayFieldReversal(reversalPayload).subscribe(
      (response: any) => {
        this.showLoaderMesage = false;
        try {
          const gatewayResponse = response?.GatewayResponse ? JSON.parse(response.GatewayResponse) : null;
          const reversalStatus = String(gatewayResponse?.status ?? '').trim().toLowerCase();
          if (gatewayResponse && (reversalStatus.startsWith('approved') || reversalStatus.startsWith('voided')) && [200, 201].includes(response.ResponseCode)) {
            this.toastr.success(`Payment Reversal Processed Successfully - ${this.getPayFieldCurrencySymbol()}${amount}`, 'Success', this.toasterConfig);
            const CCTModel = {
              Amount: amount,
              Autopay: false,
              paymentModeId: payModeId,
              AutoCcProcessingDay: 0,
              CreditCardNumber: gatewayResponse.card?.masked_card_number || gatewayResponse.card?.last_four || '',
              CreditCardType: gatewayResponse.card?.type ? this.paymentService.openEdgeCardType(gatewayResponse.card.type) : ECreditCards.Visa,
              NameonCard: gatewayResponse.card?.cardholder_name || '',
              CreditCardExpiryMonth: gatewayResponse.card?.expiry_month ? this.getExpiryMonthValue(parseInt(gatewayResponse.card.expiry_month, 10)) : 275,
              CreditCardExpiryYear: gatewayResponse.card?.expiry_year ? parseInt(gatewayResponse.card.expiry_year, 10) : 2099,
              CreditCardBillingAddress: '',
              CreditCardBillingZip: '',
              SwipeTransaction: false,
              SecurityCodeSent: false,
              AuthorizationCode: gatewayResponse.sale_id || transactionId,
              ResponseCode: response?.ResponseCode || 200,
              Reason: gatewayResponse.status || 'Voided',
              Key: '',
              PaymentAccountid: '',
              CcInfoPurged: false,
              DebitCardPayment: false,
              OfflinePayment: 0,
              PaymentTransactionTypeId: paymentTrnsId,
              OrderId: orderId,
              FacilityId: this.processPayment?.facId,
              TransactionDateTime: new Date(),
              TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
              TenantId: this.processPayment?.TenantId || null,
              LeaseNo: this.processPayment?.LeaseNo || null,
              TerminalDeviceId: this.selectedDeviceId || null,
              CCBatchNumber: null,
              EmvReceiptText: gatewayResponse.receipt?.text?.merchant_receipt || null,
              GatewayDetails: this.requestgatewaydetails
            };
            this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
            // HostedPage rows are never pushed into multiPaymentVoidEmv (only CreditCard/DEBITSALE rows are),
            // so this array's pending check reflects only those parallel voids, not this HostedPage reversal.
            if (!this.multiPaymentVoidEmv.some(function (ele) { return (ele.isEmvVoidInitiated == false); })) {
              this.showLoaderMesage = false;
              if (!this.voidOnCancelInitiated) {
                this.isCancel.emit(true);
              }
              this.loaderIcon = Promise.resolve(false);
            }
          } else {
            const errorMsg = gatewayResponse?.error?.message || gatewayResponse?.message || 'Reversal failed';
            this.paymentFailReason = errorMsg;
            this.saveCCTransactionFailureCase({
              PaymentModeId: payModeId,
              RESULT: {
                RESPONSECODE: response?.ResponseCode || 0,
                RESPONSEDESCRIPTION: errorMsg
              }
            }, errorMsg, 'Void', paymentTrnsId, orderId, payId);
          }
        } catch (e) {
          const errorMsg = e?.message ? `Failed to parse PayFields reversal response: ${e.message}` : 'Failed to parse PayFields reversal response';
          this.paymentFailReason = errorMsg;
          this.saveCCTransactionFailureCase({
            PaymentModeId: payModeId,
            RESULT: {
              RESPONSECODE: response?.ResponseCode || 0,
              RESPONSEDESCRIPTION: errorMsg
            }
          }, errorMsg, 'Void', paymentTrnsId, orderId, payId);
        }
      },
      (err: any) => {
        this.showLoaderMesage = false;
        const errorMsg = err?.error?.message || err?.message || err?.statusText || 'PayFields Gateway Error';
        this.paymentFailReason = errorMsg;
        this.saveCCTransactionFailureCase({
          PaymentModeId: payModeId,
          RESULT: {
            RESPONSECODE: err?.status || 0,
            RESPONSEDESCRIPTION: errorMsg
          }
        }, errorMsg, 'Void', paymentTrnsId, orderId, payId);
      }
    );
  }

  generateIntialCCT(amt, transTypeId, ptId, paymentModeId, payvoid, cardNumber, authCode, voidOrderId, newTdArchiFac, payId?) {
    this.requestGatewaydetails(paymentModeId, payId);
    const isTerminalCard = [EPaymentModes.CreditCard, EPaymentModes.DebitCard].includes(paymentModeId);
    const CCTModel = {
      Amount: amt,
      Autopay: false,
      paymentModeId: paymentModeId ? paymentModeId : null,
      AutoCcProcessingDay: 0,
      CreditCardNumber: this.paymentGateway == EPaymentGateway.TdBank && cardNumber ? cardNumber.substr(cardNumber.length - 4) : 0,
      CreditCardType: ECreditCards.Visa,
      NameonCard: '',
      CreditCardExpiryMonth: 264,
      CreditCardExpiryYear: 2099,
      CreditCardBillingAddress: '',
      CreditCardBillingZip: '',
      SwipeTransaction: false,
      SecurityCodeSent: false,
      AuthorizationCode: this.paymentGateway == EPaymentGateway.TdBank && authCode ? authCode : 0,
      ResponseCode: '',
      Reason: 'Attempting to Process',
      Key: this.paymentGateway == EPaymentGateway.TdBank && payvoid != null ? payvoid : '',
      PaymentAccountid: '',
      CcInfoPurged: false,
      DebitCardPayment: false,
      OfflinePayment: 0,
      UniqueTransId: this.paymentGateway == EPaymentGateway.OpenEdgeExpress && voidOrderId ? voidOrderId : null,
      PaymentTransactionTypeId: ptId,
      OrderId: null,
      FacilityId: this.processPayment.facId,
      TransactionDateTime: new Date(),
      TransactionTypeId: transTypeId,
      TerminalDeviceId: isTerminalCard && this.selectedDeviceId ? this.selectedDeviceId : null,
      LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
      TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
      InvoiceNumberForTDVoid: this.paymentGateway == EPaymentGateway.TdBank && isTerminalCard && payvoid == 'VOID' && voidOrderId != null ? voidOrderId : null,
      NewTDArchitectureFacility: newTdArchiFac,
      GatewayDetails: this.requestgatewaydetails
    };
    return Object.assign(CCTModel);
  }

  generateAsPdf(receiptsIds) {

    var obj = {
      PaymentReceiptIds: receiptsIds,
    };

    this.paymentService.generatePDF(obj).subscribe(response => {
      const byteCharacters = atob(response.FileContent);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const fileUrl = URL.createObjectURL(blob);

      this.printReceipt.show();
      const iFrame = document.createElement("iframe");
      iFrame.src = fileUrl;
      iFrame.style.height = '500px';
      iFrame.style.width = '100%';
      let container = document.getElementById('recieptContainerPayment');
      container.append(iFrame);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
      this.toastr.error('Failed to fetch the document!', 'Failed', this.toasterConfig);
    });
  }

  redirectToMaster() {
    if ([EPaymentOrigin.MakePayment, EPaymentOrigin.Merchandise].includes(this.processPayment.Type)) {
      this.apiResponse = {};
      this.emitLoopPayment.emit(true);
    } else {
      this.afterShowConfirm.emit(true);
    }
    this.printReceipt.hide();
  }

  isPaymentModesDisabled(paymentModeId, payId) {
    if (this.userSessionService.isCallcenterAgent) {
      if (!(paymentModeId == EPaymentModes.HostedPage || paymentModeId == EPaymentModes.ACH || paymentModeId == EPaymentModes.CardOnfile ||
        paymentModeId == EPaymentModes.ACHOnFile || paymentModeId == EPaymentModes.DirectDebitEFT || paymentModeId == EPaymentModes.DirectDebitEFTOnFile || paymentModeId == EPaymentModes.ACHManualAuthorization || paymentModeId == EPaymentModes.EFTManualAuthorization || paymentModeId == EPaymentModes.ManualAuthorization || (paymentModeId == EPaymentModes.RemotePay && this.paymentGateway == EPaymentGateway.Stripe))) {
        return true;
      }
    }
    else {
      if (this.userSessionService.userSessionData.LastAccessedStoreId != this.facilityId &&
        !(paymentModeId == EPaymentModes.CreditCard || paymentModeId == EPaymentModes.HostedPage || paymentModeId == EPaymentModes.ACH ||
          paymentModeId == EPaymentModes.CardOnfile || paymentModeId == EPaymentModes.ACHOnFile ||
          (paymentModeId == EPaymentModes.RemotePay && this.paymentGateway == EPaymentGateway.Stripe))) {
        return true;
      }
    }
    if (paymentModeId == EPaymentModes.RemotePay && (![EPaymentOrigin.Rental, EPaymentOrigin.MakePayment, EPaymentOrigin.ReInstate, EPaymentOrigin.MoveOut, EPaymentOrigin.Transfer].includes(this.processPayment.Type))) {
      return true;
    }
    if (paymentModeId !== EPaymentModes.RemotePay && this.disableModeForRemotePay(paymentModeId, payId)) {
      return true;
    }
    if (paymentModeId == EPaymentModes.Check) {
      if ([EPaymentOrigin.Rental, EPaymentOrigin.Transfer].includes(this.processPayment.Type) && this.donnotacceptchecksfromRental) {
        return true;
      } else if ([EPaymentOrigin.MakePayment, EPaymentOrigin.MoveOut, EPaymentOrigin.Transfer, EPaymentOrigin.ReInstate].includes(this.processPayment.Type) && this.Restrictiononcheckpayment) {
        return true;
      }
    }
    if (paymentModeId == EPaymentModes.ManualAuthorization && !this.editRightOfflinePayment) {
      return true;
    }

    if (this.processPayment.Type == EPaymentOrigin.Reservation && [EPaymentModes.CardOnfile, EPaymentModes.ACHOnFile, EPaymentModes.DirectDebitEFTOnFile].includes(paymentModeId)) {
      return true;
    }

    if (paymentModeId == EPaymentModes.CardOnfile) {
      if (this.facOpsDataService?.saveautopay?.PaymentAccountId && [EPaymentOrigin.Rental, EPaymentOrigin.Transfer, EPaymentOrigin.MakePayment, EPaymentOrigin.ReInstate].includes(this.processPayment.Type)) {
        return false;
      } else if (!this.autoPayInfo?.PaymentAccountId) {
        return true;
      } else {
        return false;
      }
    }

    if (paymentModeId == EPaymentModes.ACHOnFile) {
      if (this.facOpsDataService?.saveautopay?.ACHPaymentAccountId && !this.facOpsDataService?.saveautopay?.DirectDebit && [EPaymentOrigin.Rental, EPaymentOrigin.Transfer, EPaymentOrigin.MakePayment, EPaymentOrigin.ReInstate].includes(this.processPayment.Type)) {
        if (this.paymentGateway == EPaymentGateway.Stripe) {
          return this.facOpsDataService?.saveautopay?.DisableStripeAchOnfile;
        }
        return false;
      } else if (this.autoPayInfo?.ACHPaymentAccountId) {
        if (this.paymentGateway == EPaymentGateway.Stripe) {
          return this.autoPayInfo?.DisableStripeAchOnfile;
        }
        return false;
      } else {
        return true;
      }
    }

    if (paymentModeId == EPaymentModes.DirectDebitEFTOnFile) {
      if (this.paymentGateway != EPaymentGateway.Stripe) {
        return true;
      }
      if (this.facOpsDataService?.saveautopay?.ACHPaymentAccountId && this.facOpsDataService?.saveautopay?.DirectDebit && [EPaymentOrigin.Rental, EPaymentOrigin.Transfer, EPaymentOrigin.MakePayment, EPaymentOrigin.ReInstate].includes(this.processPayment.Type)) {
        return !!this.facOpsDataService?.saveautopay?.DisableStripeAchOnfile;
      } else if (!this.autoPayInfo?.ACHPaymentAccountId) {
        return true;
      } else if (this.autoPayInfo?.DisableStripeAchOnfile) {
        return true;
      }
    }

    if (this.processPayment.Type === EPaymentOrigin.AuctionManager) {
      if ([EPaymentModes.CardOnfile, EPaymentModes.ACHOnFile].includes(paymentModeId)) {
        return true;
      }
    }
    if (paymentModeId == EPaymentModes.DirectDebitEFT && this.paymentGateway !== EPaymentGateway.Stripe) {
      return true;
    }
    if (this.countryId == ECountries.UnitedStatesOfAmerica && (paymentModeId == EPaymentModes.DirectDebitEFT || paymentModeId == EPaymentModes.DirectDebitEFTOnFile) && this.paymentGateway === EPaymentGateway.Stripe) {
      return true;
    }

    if (this.countryId == ECountries.Canada && (paymentModeId == EPaymentModes.ACH || paymentModeId == EPaymentModes.ACHOnFile || paymentModeId == EPaymentModes.ACHManualAuthorization) && this.paymentGateway === EPaymentGateway.Stripe) {
      return true;
    }
    if (paymentModeId == EPaymentModes.RemotePay && (this.paymentGateway !== EPaymentGateway.Stripe || this.disableModeForRemotePay(EPaymentModes.RemotePay, payId))) {
      return true;
    }
    if (paymentModeId == EPaymentModes.ApplePay || paymentModeId == EPaymentModes.CashApp || paymentModeId == EPaymentModes.GooglePay) {
      return true;
    }
    if (this.data.isWalkinCustomer && this.paymentGateway === EPaymentGateway.Stripe && ([EPaymentModes.DirectDebitEFT, EPaymentModes.ACH, EPaymentModes.ACHManualAuthorization, EPaymentModes.DirectDebitEFTOnFile, EPaymentModes.EFTManualAuthorization].includes(paymentModeId))) {
      return true;
    }
    return false;
  }

  disableModeForRemotePay(mode, payId) {
    if (this.paymentGateway == EPaymentGateway.Stripe) {
      let multiUnitPayment = this.processPayment?.UnitDetails && this.processPayment?.UnitDetails.length > 1 ? true : false;
      if (multiUnitPayment && mode != 0) {
        if (this.paymentTable.length > 1 && !this.paymentTable.every((ele) => ele.payModeId == 0) && this.paymentTable.some((ele) => ele.payId != payId && ele.payModeId !== 0)) {
          if (mode == EPaymentModes.RemotePay && this.paymentTable.some((ele) => ele.payModeId != 0 && ele.payModeId !== EPaymentModes.RemotePay)) {
            return true;
          }
          if (mode !== EPaymentModes.RemotePay && this.paymentTable.some((ele) => ele.payModeId == EPaymentModes.RemotePay)) {
            return true;
          }
        }
      }
    }
    return false;
  }

  disableRemotePaySms(smsVal) {
    if (this.remotePayPhoneNumber == "" || this.remotePayPhoneNumber == null) {
      return true;
    }
    else if (smsVal.value != null && smsVal.value.length < 10) {
      return true;
    }
    return false;
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 46 || charCode > 57 || charCode == 47)) {
      return false;
    }
    return true;
  }

  onPaste(e: any) {
    var regex = /^\d+$/;
    var pastedData = e.clipboardData.getData('text/plain');
    if (pastedData.match(regex) == null) {
      e.preventDefault();
      return false;
    }
  }

  IsAlphaNumeric(e) {
    var specialKeys = new Array();
    specialKeys.push(8);  //Backspace
    specialKeys.push(9);  //Tab
    specialKeys.push(46); //Delete
    specialKeys.push(36); //Home
    specialKeys.push(35); //End
    specialKeys.push(37); //Left
    specialKeys.push(39); //Right
    var keyCode = e.keyCode == 0 ? e.charCode : e.keyCode;
    var ret = ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 65 && keyCode <= 90) || keyCode == 32 || (keyCode >= 97 && keyCode <= 122) || (specialKeys.indexOf(e.keyCode) != -1 && e.charCode != e.keyCode));
    return ret;
  }

  sendMessageForESignature() {
    var data = {
      FacilityId: this.lastAccessedFacility,
      TenantId: this.apiResponse.TenantId,
      LetterId: this.apiResponse.LetterId,
      TemplateId: 31,
      LeaseNumber: this.apiResponse.LeaseNumber
    };
    this.documentService.sendMessageForESignature(data).subscribe((res: any) => {
    });
  }

  onCheckCancel() {
    this.paymentStarted = false;
    this.checkNo = null;
    this.checkDate = new Date();
    this.checkBank = '';
    this.checkModalRef.hide();
    this.checkPaymentProcess();
  }

  OnChangeManualCardExp(event) {
    this.ManualCardExpIsDirty = true;
    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth() + 1;
    let expMonth = this.ManualCardExp.substring(0, 2)
    let expYear = this.ManualCardExp.substring(2)
    if (event.target.value) {
      if (this.ManualCardExp.length !== 6) {
        this.ValidManualCardExp = false;
      } else if (parseInt(expMonth) == 0 || parseInt(expMonth) > 12) {
        this.ValidManualCardExp = false;
      } else if ((parseInt(expYear) < currentYear) || (parseInt(expMonth) < currentMonth && parseInt(expYear) == currentYear)) {
        this.ValidManualCardExp = false;
      } else {
        this.ValidManualCardExp = true;
      }
    }
  }

  onDisableCheck() {
    if (this.checkNo == '0' || (this.checkBank.trim() == '' && this.checkbankname) ||
      ((this.checkNo == null || this.checkNo == undefined || this.checkNo == '') && this.checknumber)
      || (this.checkDate == null && this.checkdatefield)
      || (this.checkBank == null && this.checkbankname)) {
      return true;
    } else {
      return false;
    }
  }

  clickautopay() {
    this.data.custimerInfoStorage = {
      tenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
      facilityID: this.processPayment.facId ? this.processPayment.facId : null,
      leaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
    };
    this.auto = true;
    setTimeout(() => {
      if (!this.AutoPaySharedComponent) {
        return;
      }
      this.AutoPaySharedComponent.setDataOnAutopayFormOpen();
      this.AutoPaySharedComponent.openModal();
    });
  }

  setMandatoryField(formId: number) {
    this.generalService.GetMandatoryFieldsById(this.userSessionService.userSessionData.LastAccessedStoreId, formId)
      .subscribe((response: IGetPermissionMandatoryField) => {
        this.mandateFields = response;
        this.amountField = this.mandateFields.Form.ListOfProperties.find(o => o.Name == 'amountToPay').Required;
        this.tenderAmtField = this.mandateFields.Form.ListOfProperties.find(o => o.Name == 'tenderAmount').Required;
        this.changeAmtField = this.mandateFields.Form.ListOfProperties.find(o => o.Name == 'changeAmount').Required;
      });
  }

  setMandatoryFieldforCheckpayment(formId: number) {
    this.generalService.GetMandatoryFieldsById(this.userSessionService.userSessionData.LastAccessedStoreId, formId)
      .subscribe((response: IGetPermissionMandatoryField) => {
        this.mandateFieldsforCheckpayment = response;
        this.amountFieldforcheck = this.mandateFieldsforCheckpayment.Form.ListOfProperties.find(o => o.Name == 'Amount').Required;
        this.checknumber = this.mandateFieldsforCheckpayment.Form.ListOfProperties.find(o => o.Name == 'checkNo').Required;
        this.checkdatefield = this.mandateFieldsforCheckpayment.Form.ListOfProperties.find(o => o.Name == 'checkDate').Required;
        this.checkbankname = this.mandateFieldsforCheckpayment.Form.ListOfProperties.find(o => o.Name == 'checkBank').Required;
      });
  }

  setMandatoryFieldsManualAuthForm() {
    this.loaderIcon = Promise.resolve(true);
     this.generalService.GetMandatoryFieldsById(this.userSessionService.userSessionData.LastAccessedStoreId, 174)
      .subscribe((response: IGetPermissionMandatoryField) => {
        var data = response;
        if (data.Name == this.componentName) {
          if (data.Form.ListOfProperties.length != 0) {
            data.Form.ListOfProperties.forEach(field => {
              let name = `m${field.Name}`;
              if (this.manualAuthForm.form.get(name) != null) {
                if (field.Required) {
                  this.manualAuthForm.form.get(name).setValidators([Validators.required]);
                }
                else {
                  this.manualAuthForm.form.get(name).setValidators(null);
                }
                this.manualAuthForm.form.updateValueAndValidity();
                this.manualAuthForm.reset();
                this.isManualSelectCard = false;
                this.manualAuthForm.form.patchValue({
                  mCardType: 0
                })
              }
            });
          }
        }
        this.getCreditCard()
        this.loaderIcon = Promise.resolve(false);
      });
  }

setMandatoryFieldsACHManualAuthForm(formId: number) {
    this.generalService.GetMandatoryFieldsById(this.userSessionService.userSessionData.LastAccessedStoreId, formId)
      .subscribe((response: IGetPermissionMandatoryField) => {
        this.mandatoryfields = response;
        this.routingNumberfield = this.mandatoryfields.Form.ListOfProperties.find(o => o.Name == 'routingNumber').Required;
        this.accountNumberfield = this.mandatoryfields.Form.ListOfProperties.find(o => o.Name == 'accountNumber').Required;
        this.accountTypefield = this.mandatoryfields.Form.ListOfProperties.find(o => o.Name == 'accountType').Required;
        this.authorizationfield = this.mandatoryfields.Form.ListOfProperties.find(o => o.Name == 'authorization').Required;
        this.nameonAccountfield = this.mandatoryfields.Form.ListOfProperties.find(o => o.Name == 'nameonAccount').Required;
        this.checkNumberfield = this.mandatoryfields.Form.ListOfProperties.find(o => o.Name == 'checkNumber').Required;
      });
  }

  isRequired(control) {
    if (control != null) {
      if (this.manualAuthForm.form.get(control) != null) {
        if (this.manualAuthForm.form.get(control).validator !== null) {
          const validator = this.manualAuthForm.form.get(control).validator({} as AbstractControl);
          return validator && validator.required ? true : false;
        } else {
          return false
        }
      }
    }
  }

  cardOnFileEdge(amt, res, payId, paymentTrnsId) {
    this.paymentInProgress = true;
    this.showLoaderMesage = true;
    this.loaderIcon = Promise.resolve(true);

    const orderId = res?.UniqueTransId;
    const cctId = res?.Id;
    const ccAutoPayDetails = this.ccAutoPayDetails();

    const stopLoader = () => {
      this.loaderIcon = Promise.resolve(false);
      this.paymentInProgress = false;
      this.paymentStarted = false;
    };

    const setProcessedCC = (ccModel: any) => {
      const row = this.paymentTable.find(o => o.payId === payId);
      if (row) {
        row.processedCC = ccModel;
      }
    };

    const markFailureAndExit = (logMsg: string) => {
      stopLoader();
      this.appInsightsService.logPaymentEvent(true, logMsg, { Gateway: this.paymentGateway, FacilityId: this.processPayment.facId, OrderId: orderId, UserId: this.userSessionService.userSessionData.UserId });
      const row = this.paymentTable.find(o => o.payId === payId);
      if (row) {
        row.payFailed = true;
      }
      this.paymentSuccessFul = false;
      this.toastr.error('Payment Failed', 'Failure');
      this.gotoPaymentSuccess(this.popUpPayment, 0);
    };
    const requestObj = {
      FacilityId: ccAutoPayDetails.FacilityId,
      Alias: ccAutoPayDetails.PaymentAliasKey,
      Amount: amt,
      OrderId: orderId,
      LeaseNo: ccAutoPayDetails.LeaseNo,
      GatewayAttributesModel: {
        DuplicateMode: false,
        CustomerPresent: false,
        CardPresent: false
      },
      CreditCardTransaction: null,
      ZipCode:
        ccAutoPayDetails.ZillingZip ??
        this.Tenantinfo?.Zip ??
        this.Tenantinfo?.BusinessAccount?.CompanyZip ??
        ''
    };
    this.appInsightsService.logPaymentEvent(true, `Initiating Open Edge Card On File Payment. OrderId : ${orderId}`, { Gateway: this.paymentGateway, FacilityId: this.processPayment.facId, OrderId: orderId, UserId: this.userSessionService.userSessionData.UserId });
    this.paymentService.cardOnFilePaymentEdge(requestObj).pipe(take(1)).subscribe({
      next: (response: any) => {
        if (!response) {
          markFailureAndExit(`EdgeExpressCCPayment response NULL. OrderId : ${orderId}`);
          return;
        }
        let responseData: any;
        try {
          responseData = JSON.parse(response.GatewayResponse);
        } catch {
          markFailureAndExit(`GatewayResponse parse failed. OrderId : ${orderId}`);
          return;
        }
        const gateway = responseData?.GatewayResponse;
        if (!gateway) {
          markFailureAndExit(`GatewayResponse missing. OrderId : ${orderId}`);
          return;
        }

        const cardTypeMap = { ax: 1, vs: 2, mc: 3, ds: 4, di: 5, jb: 6 };
        const cTypeId = gateway.CardBrandShort ? cardTypeMap[gateway.CardBrandShort.toLowerCase()] : ccAutoPayDetails.CardType;
        const expMonth = gateway.ExpDate ? parseInt(gateway.ExpDate.substring(0, 2), 10) : null;
        const expYear = gateway.ExpDate ? parseInt(gateway.ExpDate.substring(2), 10) : null;

        this.appInsightsService.logPaymentEvent(true, `EdgeExpressCCPayment api Response. Is Transaction Success : ${response.Success}`, { Gateway: this.paymentGateway, FacilityId: this.processPayment.facId, OrderId: orderId, UserId: this.userSessionService.userSessionData.UserId });

        if (response.Success === true) {

          stopLoader();
          this.paymentSuccessFul = true;
          this.prePayStatus = 'Payment';
          this.payStatus = 'Success';
          const payment = this.paymentTable.find(row => row.payId === payId);
          if (payment) {
            payment['payFieldPayment'] = response.PayFieldPayment === true;
          }
          this.currentPayId = payId;
          this.requestGatewaydetails(EPaymentModes.CardOnfile, payId);

          setProcessedCC({
            Amount: gateway.Amount,
            Autopay: false,
            paymentModeId: EPaymentModes.CardOnfile,
            AutoCcProcessingDay: 0,
            CreditCardNumber: gateway.MaskedAcctNum ?? ccAutoPayDetails.CcNumber,
            CreditCardType: cTypeId,
            NameonCard: ccAutoPayDetails.NameOnCard ?? '',
            CreditCardExpiryMonth: expMonth
              ? this.getExpiryMonthValue(expMonth)
              : ccAutoPayDetails.ExpiryMonth,
            CreditCardExpiryYear: expYear ?? ccAutoPayDetails.ExpiryYear,
            CreditCardBillingAddress: ccAutoPayDetails.BillingAdd ?? '',
            CreditCardBillingZip: requestObj.ZipCode,
            SwipeTransaction: false,
            SecurityCodeSent: false,
            AuthorizationCode: gateway.TransactionID,
            ResponseCode: gateway.ResponseCode,
            Reason: gateway.ResponseDescription,
            PaymentAccountid: ccAutoPayDetails.PaymentAliasKey ?? '',
            DebitCardPayment: gateway.CardType !== 'Credit',
            PaymentTransactionTypeId: paymentTrnsId,
            OrderId: cctId,
            UniqueTransId: orderId,
            FacilityId: this.processPayment.facId,
            TransactionDateTime: new Date(),
            TransactionTypeId: EPaymentTransactionType.Processed,
            LeaseNo: this.processPayment.LeaseNo ?? null,
            TenantId: this.processPayment.TenantId ?? null,
            CCBatchNumber: gateway.BatchNum ?? null,
            EmvReceiptText: gateway.Receipt ?? null,
            GatewayDetails: this.requestgatewaydetails,
            GatewayId: this.paymentGateway
          });

          this.appInsightsService.logPaymentEvent(true, `Go to Payment Success. OrderId : ${orderId}`, { Gateway: this.paymentGateway, FacilityId: this.processPayment.facId, OrderId: orderId, UserId: this.userSessionService.userSessionData.UserId });

          this.gotoPaymentSuccess(this.popUpPayment, amt);
          return;
        }

        if (gateway.ResponseCode === '007') {
          stopLoader();
          this.toastr.error('Payment Failed', 'Failure');
          setTimeout(() => { this.toastr.success('Refund is Initiated', 'Success', this.toasterConfig); }, 2000);

          setProcessedCC({
            Amount: gateway.Amount,
            paymentModeId: EPaymentModes.CardOnfile,
            TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
            OrderId: cctId,
            UniqueTransId: orderId,
            FacilityId: this.processPayment.facId,
            TransactionDateTime: new Date(),
            GatewayId: this.paymentGateway
          });

          this.voidCCCNP(payId, cctId, EPaymentModes.CardOnfile, paymentTrnsId);
          return;
        }
        else if (response.Success === false){
            this.saveCCTransactionFailureCase(gateway, response.Message, EPaymentModes.CardOnfile, paymentTrnsId, cctId, payId);
           return;
        }
        setProcessedCC({Amount: amt,paymentModeId: EPaymentModes.CardOnfile,TransactionTypeId: EPaymentTransactionType.Declined,OrderId: cctId,UniqueTransId: orderId,FacilityId: this.processPayment.facId,TransactionDateTime: new Date(),GatewayId: this.paymentGateway});

        markFailureAndExit(`Card on file Failure Response. OrderId : ${orderId}`);
      },

      /* ERROR CALLBACK */
      error: () => {
        setProcessedCC({
          Amount: amt,
          paymentModeId: EPaymentModes.CardOnfile,
          TransactionTypeId: EPaymentTransactionType.Declined,
          OrderId: cctId,
          UniqueTransId: orderId,
          FacilityId: this.processPayment.facId,
          TransactionDateTime: new Date(),
          GatewayId: this.paymentGateway
        });

        markFailureAndExit(`EdgeExpressCCPayment api Error. OrderId : ${orderId}`);
      }
    });
  }

  tenderChanged(data) {
    let tenderMoney = Number(String(data).replace(/[$]/g, ''));
    let payAmount = Number(String(this.amountToPay).replace(/[$]/g, ''));
    if (data < 0) {
      this.tenderAmount = 0;
    } else {
      this.changeAmount = tenderMoney - payAmount;
      this.changeAmount = this.changeAmount.toFixed(2);
    }
    if (tenderMoney < payAmount) {
      this.requireFullPaymentForTransaction = true;
    } else {
      this.requireFullPaymentForTransaction = false;
    }
  }

  getFacilityPaymentSettings(facId) {
    this.prospectSerice.getpaymentSettings(facId).subscribe((response: IFacPaymentSettingsDetails) => {
      this.paymentSetting = response;
      if (this.paymentSetting) {
        this.isDisplayCharitable = this.paymentSetting.DisplayCharityContribution;
        this.charityAmount = this.paymentSetting.CharityAmount;
        this.isOverrideCharityAmount = this.paymentSetting.OverrideCharityAmount;
        this.roundUpValue = this.paymentSetting.RoundUpValue;
        this.charityContributionFee = this.paymentSetting.CharityContributionFee;
        this.RoundingValue = this.paymentSetting.RoundingValue;
        this.RoundingOption = this.paymentSetting.RoundingOption;
        this.EnableCashRounding = this.paymentSetting.EnableCashRounding
      }
    });
  }

  //media Sense buttons functionality

  recordAction(ActionNum) {
    var phoneCallSID;
    if (ActionNum == 3) {
      this.disablePause = true;
    } else if (ActionNum == 2) {
      this.disableResume = true;
    }
    phoneCallSID = this.userSessionService.callTrackerUserData.CallSID;
    this.callTrackerService.pauseAndPlaySession(ActionNum, phoneCallSID).subscribe((response: any) => {
      if (response) {
      }
    });
  }

  calculateContribution() {
  if (this.paymentTable && this.paymentTable.length > 0) {
    this.paymentTable = [this.paymentTable[0]];
    this.paymentCount = 1;
  }
    // Charity is applied last: reset the row to the base due (no charity), re-apply the surcharge on that
    // pre-tax base, then compute the charity (fixed and/or round-up) on base + surcharge.
    const firstRow: any = this.paymentTable[0];
    const baseAmount = this.tempTotalAmount;
    this.charityContributionAmount = 0;
    firstRow.payAmount = baseAmount;
    // payAmount is unrounded again; cash rounding is re-applied last, after the charity (below).
    firstRow.roundingvalue = 0;
    this.reapplySurchargeIfLocked(firstRow.payId);
    const firstRowSurcharge = firstRow.surchargeFeeAmount || 0;
    const amountWithSurcharge = parseFloat((baseAmount + firstRowSurcharge).toFixed(2));

    let amount = amountWithSurcharge;
    this.totalAmount = amountWithSurcharge;
    this.roundUpValueDisplay = 0;
    if (this.isFixedCharityAmount) {
      this.totalAmount = this.charityAmount + this.totalAmount;
      this.paymentTable[0].payAmount = this.totalAmount;
      this.isOverrideCharityAmount = this.paymentSetting.OverrideCharityAmount;
    } else if (this.isRoundUpCharityAmount) {
      let roundUpValue = Math.ceil(+amount / this.roundUpValue) * this.roundUpValue;
      this.roundUpValueDisplay = +roundUpValue - +this.totalAmount
      this.totalAmount = roundUpValue;
      this.paymentTable[0].payAmount = roundUpValue;
    } else {
      this.totalAmount = amountWithSurcharge;
      this.paymentTable[0].payAmount = this.totalAmount;
      this.isOverrideCharityAmount = false;
    }

    if (!this.isFixedCharityAmount) {
      this.charityAmount = this.paymentSetting.CharityAmount
    }
    if (this.isFixedCharityAmount && this.isRoundUpCharityAmount) {

      // Fixed
      this.totalAmount = amountWithSurcharge;
      this.totalAmount = this.charityAmount + this.totalAmount;
      this.paymentTable[0].payAmount = this.totalAmount;

      // Round Up
      let roundUpValue = Math.ceil(+amount / this.roundUpValue) * this.roundUpValue;
      let roundUpValueContribution = +roundUpValue - +amountWithSurcharge

      if (roundUpValueContribution >= this.charityAmount) {
        this.totalAmount = amountWithSurcharge + roundUpValueContribution;
        this.paymentTable[0].payAmount = this.totalAmount;
        this.roundUpValueDisplay = roundUpValueContribution - this.charityAmount
      }

      if (roundUpValueContribution < this.charityAmount) {
        let tempBaseAmount = amountWithSurcharge + this.charityAmount;
        // RoundUp tempBaseAmount
        let roundUpBase = Math.ceil(+tempBaseAmount / this.roundUpValue) * this.roundUpValue;
        this.roundUpValueDisplay = +roundUpBase - amountWithSurcharge - this.charityAmount
        this.totalAmount = roundUpBase;
        this.paymentTable[0].payAmount = roundUpBase;
      }
    }
    this.roundUpValueDisplay = parseFloat((+this.roundUpValueDisplay).toFixed(2));

    let totalContribution = 0;
    if (this.isFixedCharityAmount && this.isRoundUpCharityAmount) {
      totalContribution = this.roundUpValueDisplay + this.charityAmount;
    } else if (this.isFixedCharityAmount) {
      totalContribution = this.charityAmount
    } else if (this.isRoundUpCharityAmount) {
      totalContribution = this.roundUpValueDisplay;
    }

    // Row payAmount excludes the surcharge (getRowPayableAmount adds it); totalAmount includes it.
    this.charityContributionAmount = parseFloat((+totalContribution || 0).toFixed(2));
    firstRow.payAmount = parseFloat((baseAmount + this.charityContributionAmount).toFixed(2));
    this.totalAmount = parseFloat((baseAmount + firstRowSurcharge + this.charityContributionAmount).toFixed(2));
    // Cash rounding is applied after the charity, on base + surcharge + charity.
    this.applySurchargeCashRounding(firstRow, firstRow.payModeId);
    // A Cash row without a surcharge keeps the normal cash rounding, re-applied on base + charity.
    if (!firstRow.surchargeLocked && this.EnableCashRounding && Number(firstRow.payModeId) === EPaymentModes.Cash) {
      firstRow.payAmount = this.CalculateRoundedCashAmount(firstRow.payAmount, firstRow.payId, true);
      this.totalAmount = parseFloat((this.totalAmount + (firstRow.roundingvalue || 0)).toFixed(2));
    }

    if ([EPaymentOrigin.Rental, EPaymentOrigin.Transfer].includes(this.processPayment.Type)) {
      let charityContributionObj = {
        FeesandChargesId: this.paymentSetting.CharityContributionFee,
        FeesandChargesName: "",
        Recurring: false,
        Refundable: false,
        Type: 184,
        Value: parseFloat(totalContribution.toFixed(2)),
        Amount: parseFloat(totalContribution.toFixed(2)),
        StandardFee: 10,
        TotalFeeTax: 0,
        Prorate: false,
        ApplyAtMoveIn: true,
        ApplyAtTransfer: false,
        ExemptExistingTenantsMoveIn: false,
        ApplyManually: false,
        AllowToOverride: false,
        AppliedFeesandChargesTaxInfo: [],
        NotesInfo: null,
        FeesAllowance: null,
        Name: null,
        Tax: null,
        Id: 0,
        FromDate: null,
        ToDate: null,
        IsCharitableFee: this.isFixedCharityAmount || this.isRoundUpCharityAmount,
        FixedCharityAmount: this.isFixedCharityAmount,
        OverrideCharityAmount: this.paymentSetting.OverrideCharityAmount,
        CharityAmount: this.charityAmount,
        RoundUpCharityAmount: this.isRoundUpCharityAmount,
        RoundUpAmount: +this.roundUpValueDisplay.toFixed(2),
        Head: 0,
        RentalChargeId: null,
        LedgerId: null,
        AmountPaid: 0,
        AllowancePaid: 0,
        LateLienDate: null,
        PaidThroughDate: null,
        DiscountAmount: 0,
        LateAndLienId: null,
        oldValue: 1
      }
      this.charityContribution = charityContributionObj
    } else if (this.processPayment.Type == EPaymentOrigin.MakePayment) {
      let charityContributionObj = {
        RecurringFeeId: 0,
        FeesAndChargesId: this.paymentSetting.CharityContributionFee,
        Name: '',
        OneTimeFees: true,
        EffectiveDate: this.FacilityDate,
        StopDate: new Date(),
        TypeName: '',
        Type: 184,
        Value: parseFloat(totalContribution.toFixed(2)),
        Amount: parseFloat(totalContribution.toFixed(2)),
        Notes: null,
        Stopped: false,
        edit: true,
        ApplyManually: false,
        selected: true,
        Modified: false,
        IsCharitableFee: this.isFixedCharityAmount || this.isRoundUpCharityAmount,
        FixedCharityAmount: this.isFixedCharityAmount,
        OverrideCharityAmount: this.paymentSetting.OverrideCharityAmount,
        CharityAmount: this.charityAmount,
        RoundUpCharityAmount: this.isRoundUpCharityAmount,
        RoundUpAmount: +this.roundUpValueDisplay.toFixed(2)
      }
      this.charityContribution = charityContributionObj
    } else if (this.processPayment.Type == EPaymentOrigin.ReInstate) {
      let charityContributionObj = {
        FeesId: this.paymentSetting.CharityContributionFee,
        ProrateFeeAtTransfer: true,
        ProrateFeeAtMoveOut: true,
        Recurring: true,
        Refundable: true,
        Amount: parseFloat(totalContribution.toFixed(2)),
        Name: "",
        FixedCharityAmount: this.isFixedCharityAmount,
        OverrideCharityAmount: this.paymentSetting.OverrideCharityAmount,
        CharityAmount: this.charityAmount,
        RoundUpCharityAmount: this.isRoundUpCharityAmount,
        RoundUpAmount: +this.roundUpValueDisplay.toFixed(2),
        Tax: [],
        Id: 0,
        CharitableFee: this.isFixedCharityAmount || this.isRoundUpCharityAmount,
        FromDate: new Date(),
        ToDate: new Date(),
        Head: 0,
        RentalChargeId: 0,
        LedgerId: 0,
        AmountPaid: 0,
        AllowancePaid: 0,
        LateLienDate: new Date(),
        PaidThroughDate: new Date(),
        DiscountAmount: 0,
        LateAndLienId: 0
      }
      this.charityContribution = charityContributionObj
    }
    // Row 0 covers the full total (its Sub Total adds the surcharge back), so remaining is 0 for a single row.
    this.remainingAmount = Math.max(0, parseFloat((this.totalAmount - this.getRowPayableAmount(firstRow)).toFixed(2)));
  }

  onBlurNumericTextBox(eve) {
    if (eve.value == null) {
      this.charityAmount = this.paymentSetting.CharityAmount;
    }
  }

  getExpiryMonthValue(expiryMonth) {
    let tempMonth = 263;
    if (expiryMonth) {
      if (expiryMonth > 0 && expiryMonth < 13) {
        expiryMonth = tempMonth + expiryMonth;
      } else if (expiryMonth > 263 && expiryMonth < 276) {
        expiryMonth = expiryMonth;
      } else {
        expiryMonth = 264;
      }
    } else {
      expiryMonth = 264;
    }
    return expiryMonth;
  }

  onSelectDevice() {
    this.paymentStarted = true;
    if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress) {
      let deviceObj = this.terminalDevicesList.find(o => o.Id == this.selectedDeviceId);
      this.credentials.XWEBTERMINALID = deviceObj.WebId;
      this.credentials.XWEBAUTHKEY = deviceObj.AuthKey;
    } else if (this.paymentGateway == EPaymentGateway.Stripe) {
      this.paymentTable.find(o => o.payId === this.currentPayId).TerminalDeviceId = this.selectStripeReaderId;
    }
    this.modalRefSelectDevice.hide();
  }

  bamboraScriptForCustomChekout(): void {
    customcheckout = new customcheckout();
    var isCardNumberComplete = false;
    var isCVVComplete = false;
    var isExpiryComplete = false;
    var customCheckoutController = {
      init: function () {
        console.log('checkout.init()');
        this.createInputs();
        this.addListeners();
      },
      createInputs: function () {
        console.log('checkout.createInputs()');
        var options = { placeholder: '' };

        // Create and mount the inputs
        options.placeholder = 'Card number';
        customcheckout.create('card-number', options).mount('#card-number');

        options.placeholder = 'CVV';
        customcheckout.create('cvv', options).mount('#card-cvv');

        options.placeholder = 'MM / YY';
        customcheckout.create('expiry', options).mount('#card-expiry');
      },
      addListeners: function () {
        var self = this;

        // listen for submit button
        if (document.getElementById('checkout-form') !== null) {
          document
            .getElementById('checkout-form')
            .addEventListener('submit', self.onSubmit.bind(self));
        }

        customcheckout.on('brand', function (event) {
          console.log('brand: ' + JSON.stringify(event));

          var cardLogo = 'none';
          if (event.brand && event.brand !== 'unknown') {
            var filePath =
              'https://cdn.na.bambora.com/downloads/images/cards/' +
              event.brand +
              '.svg';
            cardLogo = 'url(' + filePath + ')';
          }
          document.getElementById('card-number').style.backgroundImage = cardLogo;
        });

        customcheckout.on('blur', function (event) {
          console.log('blur: ' + JSON.stringify(event));
        });

        customcheckout.on('focus', function (event) {
          console.log('focus: ' + JSON.stringify(event));
        });

        customcheckout.on('empty', function (event) {
          console.log('empty: ' + JSON.stringify(event));

          if (event.empty) {
            if (event.field === 'card-number') {
              isCardNumberComplete = false;
            } else if (event.field === 'cvv') {
              isCVVComplete = false;
            } else if (event.field === 'expiry') {
              isExpiryComplete = false;
            }
            self.setPayButton(false);
          }
        });

        customcheckout.on('complete', function (event) {
          console.log('complete: ' + JSON.stringify(event));
          if (event.field === 'card-number') {
            isCardNumberComplete = true;
            self.hideErrorForId('card-number');
          } else if (event.field === 'cvv') {
            isCVVComplete = true;
            self.hideErrorForId('card-cvv');
          } else if (event.field === 'expiry') {
            isExpiryComplete = true;
            self.hideErrorForId('card-expiry');
          }

          self.setPayButton(
            isCardNumberComplete && isCVVComplete && isExpiryComplete
          );
          this.isCustomChekoutformValid = isCardNumberComplete && isCVVComplete && isExpiryComplete ? true : false;
          this.customCheckoutValid = this.isCustomChekoutformValid;
          document.getElementById("isTDFormValid").setAttribute('value', this.isCustomChekoutformValid);
        });

        customcheckout.on('error', function (event) {
          console.log('error: ' + JSON.stringify(event));

          if (event.field === 'card-number') {
            isCardNumberComplete = false;
            self.showErrorForId('card-number', event.message);
          } else if (event.field === 'cvv') {
            isCVVComplete = false;
            self.showErrorForId('card-cvv', event.message);
          } else if (event.field === 'expiry') {
            isExpiryComplete = false;
            self.showErrorForId('card-expiry', event.message);
          }
          self.setPayButton(false);
        });
      },
      onSubmit: function (event) {
        var self = this;

        console.log('checkout.onSubmit()');

        event.preventDefault();
        self.setPayButton(false);
        self.toggleProcessingScreen();

        var callback = function (result) {
          console.log('token result : ' + JSON.stringify(result));
          document.getElementById("customCardDetails").setAttribute('value', JSON.stringify(result));
          if (result.error) {
            self.processTokenError(result.error);
          } else {
            self.processTokenSuccess(result.token);
          }
        };

        console.log('checkout.createToken()');
        customcheckout.createToken(callback);
      },
      hideErrorForId: function (id) {
        console.log('hideErrorForId: ' + id);

        var element = document.getElementById(id);

        if (element !== null) {
          var errorElement = document.getElementById(id + '-error');
          if (errorElement !== null) {
            errorElement.innerHTML = '';
          }

          var bootStrapParent = document.getElementById(id + '-bootstrap');
          if (bootStrapParent !== null) {
            bootStrapParent.classList.remove('has-error');
            bootStrapParent.classList.add('has-success');
          }
        } else {
          console.log('showErrorForId: Could not find ' + id);
        }
      },
      showErrorForId: function (id, message) {
        console.log('showErrorForId: ' + id + ' ' + message);

        var element = document.getElementById(id);

        if (element !== null) {
          var errorElement = document.getElementById(id + '-error');
          if (errorElement !== null) {
            errorElement.innerHTML = message;
          }

          var bootStrapParent = document.getElementById(id + '-bootstrap');
          if (bootStrapParent !== null) {
            bootStrapParent.classList.add('has-error');
            bootStrapParent.classList.remove('has-success');
          }
        } else {
          console.log('showErrorForId: Could not find ' + id);
        }
      },
      setPayButton: function (enabled) {
        console.log('checkout.setPayButton() disabled: ' + !enabled);

        var payButton = document.getElementById('pay-button');
        if (enabled) {
          payButton['disabled'] = false;
          payButton.className = 'btn btn-primary';
          this.isCustomChekoutformValid = true;
        } else {
          payButton['disabled'] = true;
          payButton.className = 'btn btn-primary disabled';
          this.isCustomChekoutformValid = false;
        }
        document.getElementById("isTDFormValid").setAttribute('value', this.isCustomChekoutformValid);
      },
      toggleProcessingScreen: function () {
        var processingScreen = document.getElementById('processing-screen');
        if (processingScreen) {
          processingScreen.classList.toggle('visible');
        }
      },
      showErrorFeedback: function (message) {
        var xMark = '\u2718';
        this.feedback = document.getElementById('feedback');
        this.feedback.innerHTML = xMark + ' ' + message;
        this.feedback.classList.add('error');
      },
      showSuccessFeedback: function (message) {
        var checkMark = '\u2714';
        this.feedback = document.getElementById('feedback');
        this.feedback.innerHTML = checkMark + ' ' + message;
        this.feedback.classList.add('success');
      },
      processTokenError: function (error) {
        error = JSON.stringify(error, undefined, 2);
        console.log('processTokenError: ' + error);

        this.showErrorFeedback(
          'Error creating token: </br>' + JSON.stringify(error, null, 4)
        );
        this.setPayButton(true);
        this.toggleProcessingScreen();
        document.getElementById("BtnError").click();
        document.getElementById("BtnError")['disabled'] = true;
      },
      processTokenSuccess: function (token) {
        console.log('processTokenSuccess: ' + token);
        this.setPayButton(true);
        this.toggleProcessingScreen();

        // Use token to call payments api
        document.getElementById("txtTransactionId").setAttribute('value', token);
        document.getElementById("BtnPay").click();
        document.getElementById("BtnPay")['disabled'] = true;
      },
    };

    customCheckoutController.init();
  }

  voidTdPayment(orderId, paymentModeId, voidAmount, voidTransactionId, paymentTrnsId) {
    let voidPayment = {
      amount: voidAmount,
      TransactionId: voidTransactionId
    }
    this.paymentService.TdBankVoidPayment(voidPayment, this.credentials).subscribe((response: any) => {
      if (response) {
        let voidResponse = response;
        let cartdTypeId = voidResponse.card && voidResponse.card.card_type ? this.paymentService.getTdPaymentCardType(voidResponse.card.card_type) : ECreditCards.Visa;
        if (response.message == 'Approved') {
          this.toastr.success(`Refund Processed Successfully - $${voidAmount}`, 'Success', this.toasterConfig);
          var CCNumber = (paymentModeId == EPaymentModes.HostedPage && voidResponse.card && voidResponse.card.last_four) ? voidResponse.card.last_four : (paymentModeId == EPaymentModes.CardOnfile && this.autoPayInfo && this.autoPayInfo.CreditCardNumber) ? this.autoPayInfo.CreditCardNumber : this.cardDetails.last4;
          this.autoPayInfo;
          const CCTModel = {
            Amount: voidResponse && voidResponse.amount ? parseFloat(voidResponse.amount) : voidAmount,
            Autopay: false,
            paymentModeId: paymentModeId,
            AutoCcProcessingDay: 0,
            CreditCardNumber: CCNumber ? CCNumber : '0',
            CreditCardType: cartdTypeId,
            NameonCard: this.tdNameOnCard,
            CreditCardExpiryMonth: (paymentModeId == EPaymentModes.HostedPage && this.cardDetails && this.cardDetails.expiryMonth) ? this.getExpiryMonthValue(parseInt(this.cardDetails.expiryMonth, 10)) : (paymentModeId == EPaymentModes.CardOnfile && this.autoPayInfo && this.autoPayInfo.CreditCardExpiryMonth) ? this.autoPayInfo.CreditCardExpiryMonth : 275,
            CreditCardExpiryYear: (paymentModeId == EPaymentModes.HostedPage && this.cardDetails && this.cardDetails.expiryYear) ? parseInt(this.cardDetails.expiryYear, 10) : (paymentModeId == EPaymentModes.CardOnfile && this.autoPayInfo && this.autoPayInfo.CreditCardExpiryYear) ? this.autoPayInfo.CreditCardExpiryYear : 2099,
            CreditCardBillingAddress: paymentModeId == EPaymentModes.CardOnfile && this.autoPayInfo && this.autoPayInfo.CreditCardBillingAddress ? this.autoPayInfo.CreditCardBillingAddress : '',
            CreditCardBillingZip: paymentModeId == EPaymentModes.CardOnfile && this.autoPayInfo && this.autoPayInfo.CreditCardBillingZip ? this.autoPayInfo.CreditCardBillingZip : '',
            SwipeTransaction: false,
            SecurityCodeSent: false,
            AuthorizationCode: voidResponse.id,
            ResponseCode: voidResponse.approved,
            Reason: voidResponse.message,
            Key: '',
            PaymentAccountid: '',
            CcInfoPurged: false,
            DebitCardPayment: (voidResponse.card.card_type == 'MD' || voidResponse.card.card_type == 'PV') ? true : false,
            OfflinePayment: 0,
            PaymentTransactionTypeId: paymentTrnsId,
            OrderId: orderId,
            FacilityId: this.processPayment.facId,
            TransactionDateTime: new Date(),
            TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
            TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
            LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
            TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null
          };
          if (!this.multiPaymentVoidEmv.some(function (ele) { return (ele.isEmvVoidInitiated == false); }) && !this.voidOnCancelInitiated) {
            this.showLoaderMesage = false;
            this.isCancel.emit(true);
            this.loaderIcon = Promise.resolve(false);
          };
          this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
        } else {
          this.toastr.error(`Failed to Reverse the Payment - $${voidAmount}`, 'Failure', this.toasterConfig);
          var CCNumber = (paymentModeId == EPaymentModes.HostedPage && voidResponse.card && voidResponse.card.last_four) ? voidResponse.card.last_four : this.cardDetails.last4;
          this.autoPayInfo;
          const CCTModel = {
            Amount: voidResponse && voidResponse.amount ? parseFloat(voidResponse.amount) : voidAmount,
            Autopay: false,
            paymentModeId: paymentModeId,
            AutoCcProcessingDay: 0,
            CreditCardNumber: CCNumber ? CCNumber : '0',
            CreditCardType: cartdTypeId,
            NameonCard: this.tdNameOnCard,
            CreditCardExpiryMonth: (paymentModeId == EPaymentModes.HostedPage && this.cardDetails && this.cardDetails.expiryMonth) ? this.getExpiryMonthValue(parseInt(this.cardDetails.expiryMonth, 10)) : (paymentModeId == EPaymentModes.CardOnfile && this.autoPayInfo && this.autoPayInfo.CreditCardExpiryMonth) ? this.autoPayInfo.CreditCardExpiryMonth : 275,
            CreditCardExpiryYear: (paymentModeId == EPaymentModes.HostedPage && this.cardDetails && this.cardDetails.expiryYear) ? parseInt(this.cardDetails.expiryYear, 10) : (paymentModeId == EPaymentModes.CardOnfile && this.autoPayInfo && this.autoPayInfo.CreditCardExpiryYear) ? this.autoPayInfo.CreditCardExpiryYear : 2099,
            CreditCardBillingAddress: paymentModeId == EPaymentModes.CardOnfile && this.autoPayInfo && this.autoPayInfo.CreditCardBillingAddress ? this.autoPayInfo.CreditCardBillingAddress : '',
            CreditCardBillingZip: paymentModeId == EPaymentModes.CardOnfile && this.autoPayInfo && this.autoPayInfo.CreditCardBillingZip ? this.autoPayInfo.CreditCardBillingZip : '',
            SwipeTransaction: false,
            SecurityCodeSent: false,
            AuthorizationCode: voidResponse.id ? voidResponse.id : '0',
            ResponseCode: voidResponse.approved ? voidResponse.approved : '0',
            Reason: voidResponse.message ? voidResponse.message : 'Declined',
            Key: '',
            PaymentAccountid: '',
            CcInfoPurged: false,
            DebitCardPayment: (voidResponse.card.card_type == 'MD' || voidResponse.card.card_type == 'PV') ? true : false,
            OfflinePayment: 0,
            PaymentTransactionTypeId: paymentTrnsId,
            OrderId: orderId,
            FacilityId: this.processPayment.facId,
            TransactionDateTime: new Date(),
            TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
            TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
            LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
            TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null
          };
          if (!this.multiPaymentVoidEmv.some(function (ele) { return (ele.isEmvVoidInitiated == false); }) && !this.voidOnCancelInitiated) {
            this.showLoaderMesage = false;
            this.isCancel.emit(true);
            this.loaderIcon = Promise.resolve(false);
          }
          this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
        }
      }
    }, err => {
      this.toastr.error(`Failed to Reverse the Payment - $${voidAmount}`, 'Failure', this.toasterConfig);
      this.showLoaderMesage = false;
      this.loaderIcon = Promise.resolve(false);
      let voidResponse = err.error;
      var CCNumber = (paymentModeId == EPaymentModes.HostedPage && voidResponse.card && voidResponse.card.last_four) ? voidResponse.card.last_four : this.cardDetails.last4;
      this.autoPayInfo;
      if (!this.voidOnCancelInitiated) {
        this.isCancel.emit(true);
      }
      const CCTModel = {
        Amount: this.tdResponseObj.trnAmount ? this.tdResponseObj.trnAmount : voidPayment.amount,
        Autopay: false,
        paymentModeId: paymentModeId,
        AutoCcProcessingDay: 0,
        CreditCardNumber: CCNumber ? CCNumber : '0',
        CreditCardType: ECreditCards.Visa,
        NameonCard: this.tdNameOnCard,
        CreditCardExpiryMonth: (paymentModeId == EPaymentModes.HostedPage && this.cardDetails && this.cardDetails.expiryMonth) ? this.getExpiryMonthValue(parseInt(this.cardDetails.expiryMonth, 10)) : (paymentModeId == EPaymentModes.CardOnfile && this.autoPayInfo && this.autoPayInfo.CreditCardExpiryMonth) ? this.autoPayInfo.CreditCardExpiryMonth : 275,
        CreditCardExpiryYear: (paymentModeId == EPaymentModes.HostedPage && this.cardDetails && this.cardDetails.expiryYear) ? parseInt(this.cardDetails.expiryYear, 10) : (paymentModeId == EPaymentModes.CardOnfile && this.autoPayInfo && this.autoPayInfo.CreditCardExpiryYear) ? this.autoPayInfo.CreditCardExpiryYear : 2099,
        CreditCardBillingAddress: paymentModeId == EPaymentModes.CardOnfile && this.autoPayInfo && this.autoPayInfo.CreditCardBillingAddress ? this.autoPayInfo.CreditCardBillingAddress : '',
        CreditCardBillingZip: paymentModeId == EPaymentModes.CardOnfile && this.autoPayInfo && this.autoPayInfo.CreditCardBillingZip ? this.autoPayInfo.CreditCardBillingZip : '',
        SwipeTransaction: false,
        SecurityCodeSent: false,
        AuthorizationCode: voidResponse.id ? voidResponse.id : '0',
        ResponseCode: voidResponse.code ? voidResponse.code : '0',
        Reason: voidResponse.message ? voidResponse.message : 'Declined',
        Key: '',
        PaymentAccountid: '',
        CcInfoPurged: false,
        DebitCardPayment: false,
        OfflinePayment: 0,
        PaymentTransactionTypeId: paymentTrnsId,
        OrderId: orderId,
        FacilityId: this.processPayment.facId,
        TransactionDateTime: new Date(),
        TransactionTypeId: EPaymentTransactionType.Declined,
        TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
        LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
        TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null
      };
      this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
    });
  }

  cardOnFileTD(amt, orderId, payId, paymentTrnsId) {
    this.paymentInProgress = true;
    this.showLoaderMesage = true;
    this.loaderIcon = Promise.resolve(true);
    this.browserLangauge = navigator.language;
    this.userAgent = window.navigator.userAgent;
    var req = new XMLHttpRequest();
    req.open('GET', window.location.href, false);
    req.send(null);
    this.headers = req.getResponseHeader('content-type');
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    this.colorDepth = window.screen.colorDepth;
    this.time_zone = (new Date()).getTimezoneOffset();
    let tdAutoPayDetails = this.ccAutoPayDetails();

    const threeDSecureProfilePayment = {
      amount: amt,
      OrderId: orderId.toString(),
      payment_method: "payment_profile",
      term_url: `${this.baseUrl}/Payments/GetCresReturnToApplication`,
      customer_ip: "::1",
      payment_profile: {
        complete: true,
        customer_code: tdAutoPayDetails.PaymentAliasKey,
        card_id: 1,  // Starts at 1 for the first card, since multiple cards can be stored for profile. (Its not the type id of the card)
        Name: tdAutoPayDetails.NameOnCard,
        "3d_secure": {
          browser: {
            accept_header: this.headers,
            java_enabled: false,
            language: this.browserLangauge,
            color_depth: this.colorDepth,
            screen_height: this.screenHeight,
            screen_width: this.screenWidth,
            time_zone: this.time_zone,
            user_agent: this.userAgent,
            javascript_enabled: true
          },
          enabled: true,
          version: 2,
          auth_required: true
        }
      },
      card_on_file: {
        type: "subsequent_unscheduled",
        series_id: tdAutoPayDetails.SerialId
      }
    }
    this.TdAmount = amt;
    this.tdPaymentMethod = "payment_profile";
    this.appInsightsService.logPaymentEvent(true,`Initiating TD Card On File Payment. OrderId : ${orderId} `, { Gateway: this.paymentGateway, FacilityId : this.processPayment.facId, OrderId : orderId, UserId : this.userSessionService.userSessionData.UserId});
    this.generalService.threeDSecurePayment(threeDSecureProfilePayment, this.credentials).subscribe(response => {
      if (response) {
        this.prePayStatus = 'Payment';
        if (response && response.message == 'Approved') { //  If Success transaction type id 357 - processed.
          this.appInsightsService.logPaymentEvent(true,`TD Payments api Response. Is Transaction Success : ${response.message} `, { Gateway: this.paymentGateway, FacilityId : this.processPayment.facId, OrderId : orderId});
          this.loaderIcon = Promise.resolve(false);
          this.paymentSuccessFul = true;
          this.payStatus = 'Success';
            let gatewayRes = response;
            let process = gatewayRes.id;
            let approved = gatewayRes.approved;
            let trnId = gatewayRes.id;
            let messageId = gatewayRes.message_id;
            let messageText = gatewayRes.message;
            let authCode = gatewayRes.auth_code;
            let trnAmount = gatewayRes.amount;
            let trnDate = gatewayRes.created;
            let trnOrderNumber = gatewayRes.order_number;
            let cardType = gatewayRes.card.card_type;
            let cardNumber = gatewayRes.card.last_four;
            let trnType = gatewayRes.type;
            let paymentMethod = gatewayRes.payment_method;
            this.tdResponseObj = {
              Process: process,
              trnApproved: approved,
              trnId: trnId,
              messageId: messageId,
              messageText: messageText,
              authCode: authCode,
              trnAmount: trnAmount,
              trnDate: trnDate,
              trnOrderNumber: trnOrderNumber,
              cardType: cardType,
              trnType: trnType,
              cardNumber: cardNumber,
              paymentMethod: paymentMethod,
            }
            const CCModel = {
              Amount: response.amount,
              Autopay: false,
              paymentModeId: EPaymentModes.CardOnfile,
              AutoCcProcessingDay: 0,
              CreditCardNumber: response.card.last_four ? response.card.last_four : tdAutoPayDetails.CcNumber,
              CreditCardType: cardType ? this.paymentService.getTdPaymentCardType(this.tdResponseObj.cardType) : tdAutoPayDetails.CardType,
              NameonCard: tdAutoPayDetails.NameOnCard ? tdAutoPayDetails.NameOnCard : '',
              CreditCardExpiryMonth: tdAutoPayDetails.ExpiryMonth ? tdAutoPayDetails.ExpiryMonth : 275,
              CreditCardExpiryYear: tdAutoPayDetails.ExpiryYear ? tdAutoPayDetails.ExpiryYear : 2099,
              CreditCardBillingAddress: tdAutoPayDetails.BillingAdd ? tdAutoPayDetails.BillingAdd : '',
              CreditCardBillingZip: tdAutoPayDetails.ZillingZip ? tdAutoPayDetails.ZillingZip : '',
              SwipeTransaction: false,
              SecurityCodeSent: false,
              AuthorizationCode: response.id,
              ResponseCode: response.approved,
              Reason: response.message,
              Key: '',
              PaymentAccountid: tdAutoPayDetails.PaymentAliasKey,
              CcInfoPurged: false,
              DebitCardPayment: (response.card.card_type == 'PV' || response.card.card_type == 'MD') ? true : false,
              OfflinePayment: 0,
              PaymentTransactionTypeId: paymentTrnsId,
              OrderId: orderId,
              FacilityId: this.processPayment.facId,
              TransactionDateTime: new Date(),
              TransactionTypeId: EPaymentTransactionType.Processed,
              TerminalDeviceId: null,
              LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
              TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
              GatewayId : this.paymentGateway
            };
            this.paymentTable.find(o => o.payId == payId)['processedCC'] = CCModel;
            this.paymentTable.find(o => o.payId == payId).payFailed = false;
            this.disableCancelButton();
            this.appInsightsService.logPaymentEvent(true,`Go to Payment Success. OrderId : ${orderId} `, { Gateway: this.paymentGateway, FacilityId : this.processPayment.facId, OrderId : orderId});
            this.gotoPaymentSuccess(this.popUpPayment, amt);    
        } else {
          const CCModel = {
            Amount: response.amount,
            Autopay: false,
            paymentModeId: EPaymentModes.CardOnfile,
            AutoCcProcessingDay: 0,
            CreditCardNumber: response.card && response.card.last_four ? response.card.last_four : tdAutoPayDetails.CcNumber,
            CreditCardType: tdAutoPayDetails.CardType,
            NameonCard: tdAutoPayDetails.NameOnCard ? tdAutoPayDetails.NameOnCard : '',
            CreditCardExpiryMonth: tdAutoPayDetails.ExpiryMonth ? tdAutoPayDetails.ExpiryMonth : 275,
            CreditCardExpiryYear: tdAutoPayDetails.ExpiryYear ? tdAutoPayDetails.ExpiryYear : 2099,
            CreditCardBillingAddress: tdAutoPayDetails.BillingAdd ? tdAutoPayDetails.BillingAdd : '',
            CreditCardBillingZip: tdAutoPayDetails.ZillingZip ? tdAutoPayDetails.ZillingZip : '',
            SwipeTransaction: false,
            SecurityCodeSent: false,
            AuthorizationCode: response.id ? response.id : '0',
            ResponseCode: response.approved,
            Reason: response.message,
            Key: '',
            PaymentAccountid: tdAutoPayDetails.PaymentAliasKey ? tdAutoPayDetails.PaymentAliasKey : "",
            CcInfoPurged: false,
            DebitCardPayment: response.card && response.card.card_type && (response.card.card_type == 'PV' || response.card.card_type == 'MD') ? true : false,
            OfflinePayment: 0,
            PaymentTransactionTypeId: paymentTrnsId,
            OrderId: orderId,
            FacilityId: this.processPayment.facId,
            TransactionDateTime: new Date(),
            TransactionTypeId: EPaymentTransactionType.Declined,
            TerminalDeviceId: null,
            LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
            TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
            GatewayId : this.paymentGateway
          };
          this.appInsightsService.logPaymentEvent(true,`Payment Failed. Gateway Message : ${response?.Message ?? 'Payment Failed'} `, { Gateway: this.paymentGateway, FacilityId : this.processPayment.facId, OrderId : orderId, UserId : this.userSessionService.userSessionData.UserId});
          this.paymentTable.find(o => o.payId == payId)['processedCC'] = CCModel;
          this.paymentService.saveCCTransaction(Object.assign(CCModel)).subscribe((res: any) => { });
          this.paymentSuccessFul = false;
          this.payStatus = 'Failed!';
          this.paymentTable.find(o => o.payId == payId).payFailed = true;
          this.isAnyPaymentProcessed();
          this.paymentStarted = false;
          this.loaderIcon = Promise.resolve(false);
          if (response.Message) {
            this.toastr.warning(response.Message, 'Payment Failed', this.toasterConfig);
          } else {
            this.toastr.error('Payment Failed', 'Failure');
          }
        }
      }
    }, err => {
      if (err.status === 302 && err.error.links[0].rel === 'continue') {
        var formContents = err.error.contents;
        this.appInsightsService.logPaymentEvent(true,`Challenge Card Payment - Authentication required`, { Gateway: this.paymentGateway , FacilityId :  this.processPayment.facId, OrderId : orderId, UserId : this.userSessionService.userSessionData.UserId});
        this.callAuthenticationForm(formContents, orderId, payId, paymentTrnsId);
      } else if (err.error.message && err.error.code) {
        this.appInsightsService.logPaymentEvent(true,`Payment Failed. Gateway Message : ${err?.error?.message?? 'Payment Failed'}`, { Gateway: this.paymentGateway , FacilityId :  this.processPayment.facId, OrderId : orderId, UserId : this.userSessionService.userSessionData.UserId});
        this.toastr.warning(err.error.message, 'Payment Failed', this.toasterConfig);
        this.paymentSuccessFul = false;
        this.paymentProcessing = false;
        this.prePayStatus = 'Payment';
        this.payStatus = 'Failed';
        this.paymentTable.find(o => o.payId == payId).payFailed = true;
        this.isAnyPaymentProcessed();
        const tempCCModel = {
          Amount: this.amountToPay,
          Autopay: false,
          paymentModeId: EPaymentModes.CardOnfile,
          AutoCcProcessingDay: 0,
          CreditCardNumber: 'XXXX',
          CreditCardType: ECreditCards.Visa,
          NameonCard: '',
          CreditCardExpiryMonth: 275,
          CreditCardExpiryYear: 2099,
          CreditCardBillingAddress: '',
          CreditCardBillingZip: '',
          SwipeTransaction: false,
          SecurityCodeSent: false,
          AuthorizationCode: '',
          ResponseCode: err.error.code,
          Reason: err.error.message,
          Key: '',
          PaymentAccountid: '',
          CcInfoPurged: false,
          DebitCardPayment: false,
          OfflinePayment: 0,
          PaymentTransactionTypeId: paymentTrnsId,
          OrderId: this.paymentTable.find(o => o.payId == this.currentPayId).orderId,
          FacilityId: this.processPayment.facId,
          TransactionDateTime: new Date(),
          TransactionTypeId: EPaymentTransactionType.Declined,
          TerminalDeviceId: null,
          TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
          LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null
        };
        this.paymentService.saveCCTransaction(Object.assign(tempCCModel)).subscribe((res: any) => { });
        this.loaderIcon = Promise.resolve(false);
        this.gotoPaymentSuccess(this.popUpPayment, 0);
      } else {
        this.loaderIcon = Promise.resolve(false);
        this.paymentSuccessFul = false;
        this.paymentStarted = false;
        this.paymentTable.find(o => o.payId == payId).payFailed = true;
        this.toastr.error('Payment Failed', 'Failure');
      }
    });
  }

  disableTDForm() {
    const obj = {
      MandatoryFields: this.mandatoryFieldsTD,
      FName: this.tdFName,
      LName: this.tdLName,
      City: this.tdCity,
      Address: this.tdAddress,
      Zip: this.tdZip,
      Cellphone: this.tdCellphone,
      Email: this.tdEmail,
      NameOnCard: this.tdNameOnCard,
      StateId: this.tdState,
      CellphoneNotValid: this.cellphoneNotValid
    }
    return this.paymentService.disablePaymentTDForm(obj);
  }

  cancelTDForm() {
    this.paymentStarted = false;
    this.tdModalRef.hide();
    this.tdAddress = '';
    this.tdZip = '';
    this.tdNameOnCard = '';
    this.tdFName = '';
    this.tdLName = '';
    this.tdEmail = '';
    this.tdCity = '';
    this.tdCellphone = '';
    this.isAutoPopulateBillingInfo = false;
    this.tdCountry = environment.defaultCountryId;
    this.onCountryChange(this.tdCountry, 1);
    this.checkPaymentProcess();
  }

  getCCTStatus(cctId, payId, count, paymentTrnsId) {
    let tempAmount;
    let res;
    let maxTime = (this.paymentMaxWaitTime * 60) / this.paymentGetCCTStatusInterval;
    this.appInsightsService.logPaymentEvent(true,`Transaction Status. Retry Count : ${count}`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : cctId, UserId : this.userSessionService.userSessionData.UserId});
    this.paymentService.getCCTStatus(cctId).subscribe((Response: any) => {
      if (Response) {
        res = JSON.parse(Response);
        if (this.subTD) {
          this.subTD.unsubscribe();
          this.subTD = null;
        }
        this.appInsightsService.logPaymentEvent(true,`Transaction Status Response. CCTStatusOrderId : ${this.cctStatusOrderId}, OrderId : ${cctId} , Response Code : ${res.ResponseCode}, Amount : ${res?.Amount ?? 0},`, { Gateway: this.paymentGateway, FacilityId : this.processPayment.facId, OrderId : cctId, UserId : this.userSessionService.userSessionData.UserId});
        if (this.cctStatusOrderId != cctId) {
          this.cctStatusOrderId = res.OrderId;
          if (res.ResponseCode == '000') {
            res.OrderId = res.OrderId || cctId;
            if (this.handleTdCardModeMismatch(payId, res, paymentTrnsId)) { return; }
            this.prePayStatus = 'Payment';
            this.payStatus = 'Success';
            this.paymentSuccessFul = true;
            tempAmount = res.Amount;
            this.paymentTable.find(o => o.payId == payId).payFailed = false;
            this.disableNextButton();
            this.paymentTable.find(o => o.payId == payId)['processedCC'] = res;
            this.appInsightsService.logPaymentEvent(true, `Go to Payment Success.`, { Gateway: this.paymentGateway , FacilityId :  this.processPayment.facId, OrderId : cctId, UserId : this.userSessionService.userSessionData.UserId});
          } else {
            this.appInsightsService.logPaymentEvent(true,`GateWay Failure. ResponseCode : ${res.ResponseCode}`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : cctId, UserId : this.userSessionService.userSessionData.UserId});
            this.paymentTable.find(o => o.payId == payId).payFailed = true;
            this.paymentFailReason = '';
            if (res.ResponseCode == '050' || res.ResponseCode == '086') {
              this.prePayStatus = '';
              this.payStatus = 'Declined!';
              this.paymentSuccessFul = false;
              tempAmount = 0;
              this.paymentProcessing = false;
            } else if (res.ResponseCode == '107') {
              this.prePayStatus = '';
              this.payStatus = '$ LIMIT EXCEEDED';
              this.paymentSuccessFul = false;
              tempAmount = 0;
              this.paymentProcessing = false;
            } else if (res.ResponseCode == '903') {
              this.prePayStatus = '';
              this.payStatus = 'CARD CANCELLED';
              this.paymentSuccessFul = false;
              tempAmount = 0;
              this.paymentProcessing = false;
            } else if (res.ResponseCode == '10') {
              this.prePayStatus = '';
              this.payStatus = 'Declined by host or by card';
              this.paymentSuccessFul = false;
              tempAmount = 0;
              this.paymentProcessing = false;
            } else if (res.ResponseCode == '11') {
              this.prePayStatus = '';
              this.payStatus = 'Communication Error';
              this.paymentSuccessFul = false;
              tempAmount = 0;
              this.paymentProcessing = false;
            } else if (res.ResponseCode == '12') {
              this.prePayStatus = '';
              this.payStatus = 'USER ABORTED';
              this.paymentSuccessFul = false;
              tempAmount = 0;
              this.paymentProcessing = false;
            } else if (res.ResponseCode == '13') {
              this.prePayStatus = '';
              this.payStatus = 'TIME OUT';
              this.paymentSuccessFul = false;
              tempAmount = 0;
              this.paymentProcessing = false;
            } else if (res.ResponseCode == '14') {
              this.prePayStatus = '';
              this.payStatus = 'Transaction/Function Not Completed';
              this.paymentSuccessFul = false;
              tempAmount = 0;
              this.paymentProcessing = false;
            } else if (res.ResponseCode == '16') {
              this.prePayStatus = '';
              this.payStatus = 'Declined by Merchant';
              this.paymentSuccessFul = false;
              tempAmount = 0;
              this.paymentProcessing = false;
            } else if (res.ResponseCode == '405') {
              this.prePayStatus = '';
              this.payStatus = 'Card Verification Decline';
              this.paymentSuccessFul = false;
              tempAmount = 0;
              this.paymentProcessing = false;
            } else if (res.ResponseCode == '18') {
              this.prePayStatus = '';
              this.payStatus = 'Transaction Already Voided';
              this.paymentSuccessFul = false;
              tempAmount = 0;
              this.paymentProcessing = false;
            } else if (res.ResponseCode == '95') {
              this.toastr.warning('Device is not ready to Accept any Payment. Please ensure Device is Idle and ready to Accept New Payment Request.', 'Alert', this.toasterConfig);
              this.prePayStatus = 'Payment';
              this.payStatus = 'Failed';
              this.paymentSuccessFul = false;
              tempAmount = 0;
              this.paymentProcessing = false;
            } else if (res.Reason == "EMV Device Not Connected!") {
              this.prePayStatus = 'Payment';
              this.payStatus = 'Failed';
              this.paymentFailReason = 'EMV Device Not Connected';
              tempAmount = 0;
              this.paymentSuccessFul = false;
              this.paymentProcessing = false;
            } else {
              if (res.Reason == 'Device is Busy, Please try after sometime.') { // Triggering multiple transactions
                this.toastr.warning('Device is not ready to Accept Payment, Please try after sometime.', 'Alert', this.toasterConfig);
              }
              else if (res.Reason == 'Another Payment is in progress.') {
                this.toastr.warning('Another Payment is in progress, Please try after sometime.', 'Alert', this.toasterConfig);
              }
              this.prePayStatus = 'Payment';
              this.payStatus = 'Failed';
              this.paymentSuccessFul = false;
              tempAmount = 0;
              this.paymentProcessing = false;
            }
            this.isAnyPaymentProcessed();
          }
          if (res.ResponseCode != '000') {
            const CCTModel = {
              Amount: parseFloat(res.Amount),
              Autopay: false,
              PaymentModeId: EPaymentModes.CreditCard,
              AutoCcProcessingDay: 0,
              CreditCardNumber: res.CreditCardNumber == undefined ? 0 : res.CreditCardNumber,
              CreditCardType: res.CreditCardType ? res.CreditCardType : 2,
              NameonCard: res.NameonCard ? res.NameonCard : " ",
              CreditCardExpiryMonth: res.CreditCardExpiryMonth == 264 && res.CreditCardExpiryYear != 0 ? this.getExpiryMonthValue(parseInt(res.CreditCardExpiryMonth, 10)) : 275,
              CreditCardExpiryYear: !parseInt(res.CreditCardExpiryYear, 10) ? 2099 : parseInt(res.CreditCardExpiryYear, 10),
              CreditCardBillingAddress: '',
              CreditCardBillingZip: '',
              SwipeTransaction: false,
              SecurityCodeSent: false,
              AuthorizationCode: res.AuthorizationCode ? res.AuthorizationCode : " ",
              ResponseCode: res.ResponseCode,
              Reason: res.Reason,
              Key: '',
              PaymentAccountid: '',
              CcInfoPurged: false,
              DebitCardPayment: res.DebitCardPayment == true ? true : false,
              OfflinePayment: 0,
              PaymentTransactionTypeId: paymentTrnsId,
              TransactionDateTime: new Date(),
              TransactionTypeId: EPaymentTransactionType.Declined,
              OrderId: cctId,
              CCBatchNumber: res.CCBatchNumber ? res.CCBatchNumber : null,
              EmvReceiptText: res.EmvReceiptText ? res.EmvReceiptText : null,
              FacilityId: this.processPayment.facId,
              TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
              TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
              LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null
            };
            this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
          }
          this.loaderIcon = Promise.resolve(false);
          this.gotoPaymentSuccess(this.popUpPayment, tempAmount);
        }
      } else if (Response == null) {
        this.paymentTable.find(o => o.payId == payId).payFailed = true;
        if (count > maxTime) {
          if (this.subTD) {
            this.subTD.unsubscribe();
            this.subTD = null;
          }
          this.loaderIcon = Promise.resolve(false);
          this.paymentStarted = false;
          this.toastr.error('Payment Failed', 'Failure');
          this.appInsightsService.logPaymentEvent(true, `GetCreditCardTransactionStatus API call is reached max wait Time.`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : cctId, UserId : this.userSessionService.userSessionData.UserId});
          this.isAnyPaymentProcessed();
        }
      }
    }, err => {
      this.paymentTable.find(o => o.payId == payId).payFailed = true;
      this.appInsightsService.logPaymentEvent(true,`Exception occured in GetCreditCardTransactionStatus Api.`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : cctId, UserId : this.userSessionService.userSessionData.UserId});
      if (count > maxTime) {
        if (this.subTD) {
          this.subTD.unsubscribe();
          this.subTD = null;
        }
        this.loaderIcon = Promise.resolve(false);
        this.paymentStarted = false;
        this.toastr.error('Payment Failed', 'Failure');
        this.isAnyPaymentProcessed();
      }
    });
  }

  callOnTokenError() {
    this.loaderIcon = Promise.resolve(false);
  }

  getCCTVoidStatus(cctId, payId, count, amount, initiatedOrderId, paymentTrnsId) {
    let res;
    let maxTime = (this.paymentMaxWaitTime * 60) / this.paymentGetCCTStatusInterval;
    this.paymentService.getCCTStatus(cctId).subscribe((Response: any) => {
      if (Response) {
        res = JSON.parse(Response);
        this.multiPaymentVoidEmv.find(t => t.orderId == initiatedOrderId).isEmvVoidInitiated = true;
        this.subTD = null;
        if (this.subVoidTd) {
          this.subVoidTd.unsubscribe();
          this.subVoidTd = null;
        }
        if (res.ResponseCode == '000') {
          this.toastr.success(`Refund Processed Successfully - $${amount}`, 'Success', this.toasterConfig);
        } else {
          this.toastr.error(`Failed to Reverse the Payment - $${amount}`, 'Failure', this.toasterConfig);
        }
        if (this.multiPaymentVoidEmv.some(function (ele) { return (ele.isEmvVoidInitiated == false); })) {
          this.callTdVoid(paymentTrnsId);
        } else {
          this.loaderIcon = Promise.resolve(false);
          this.paymentStarted = false;
          this.showLoaderMesage = false;
          this.initiatedVoidCC = false;
          if (!this.voidOnCancelInitiated) {
            this.isCancel.emit(true);
          }
        }
      } else if (Response == null) {
        this.multiPaymentVoidEmv.find(t => t.orderId == initiatedOrderId).isEmvVoidInitiated = true;
        if (count > maxTime) {
          if (this.subVoidTd) {
            this.subVoidTd.unsubscribe();
            this.subVoidTd = null;
          }
          this.toastr.error(`Failed to Reverse the Payment - $${amount}`, 'Failure', this.toasterConfig);;
          if (this.multiPaymentVoidEmv.some(function (ele) { return (ele.isEmvVoidInitiated == false); })) {
            this.callTdVoid(paymentTrnsId);
          } else {
            if (!this.voidOnCancelInitiated) {
              this.isCancel.emit(true);
            }
            this.showLoaderMesage = false;
            this.loaderIcon = Promise.resolve(false);
            this.paymentStarted = false;
            this.initiatedVoidCC = false;
          }
        }
      }
    }, err => {
      if (count > maxTime) {
        if (this.subVoidTd) {
          this.subVoidTd.unsubscribe();
          this.subVoidTd = null;
        }
        this.multiPaymentVoidEmv.find(t => t.orderId == initiatedOrderId).isEmvVoidInitiated = true;
        if (this.multiPaymentVoidEmv.some(function (ele) { return (ele.isEmvVoidInitiated == false); })) {
          this.callTdVoid(paymentTrnsId);
        } else {
          this.loaderIcon = Promise.resolve(false);
          if (!this.voidOnCancelInitiated) {
            this.isCancel.emit(true);
          }
          this.toastr.error(`Failed to Reverse the Payment - $${amount}`, 'Failure', this.toasterConfig);
          this.showLoaderMesage = false;
          this.loaderIcon = Promise.resolve(false);
          this.paymentStarted = false;
          this.initiatedVoidCC = false;
        }
      }
    });
  }

  manulAuthorizationCCT(amt, ccNumber, ccName, ccType, authrizationCode, ccExpiry, ptId, paymentModeId) {
    let CCTModel;
    let ccExpMonth = ccExpiry.substr(0, 2);
    let ccExpYear = ccExpiry.substr(4);
    const tempCCModel = {
      Amount: amt,
      Autopay: false,
      paymentModeId: paymentModeId,
      AutoCcProcessingDay: 0,
      CreditCardNumber: ccNumber ? ccNumber : 0,
      CreditCardType: ccType, //Visa
      NameonCard: ccName ? ccName : '',
      CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(ccExpMonth, 10)),
      CreditCardExpiryYear: parseInt(ccExpYear, 10),
      CreditCardBillingAddress: '',
      CreditCardBillingZip: '',
      SwipeTransaction: false,
      SecurityCodeSent: false,
      AuthorizationCode: authrizationCode,
      ResponseCode: '',
      Reason: 'Approval',
      Key: '',
      PaymentAccountid: '',
      CcInfoPurged: false,
      DebitCardPayment: false,
      OfflinePayment: 0,
      PaymentTransactionTypeId: ptId,
      OrderId: null,
      FacilityId: this.processPayment.facId,
      TransactionDateTime: new Date(),
      TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
      TerminalDeviceId: paymentModeId == EPaymentModes.CreditCard && this.selectedDeviceId ? this.selectedDeviceId : null,
      LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
      TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null
    };
    CCTModel = Object.assign(tempCCModel);
    return CCTModel;
  }

  payBasedOnMode(amount, payId, template: TemplateRef<any>, templateCheck: TemplateRef<any>) {
    this.amountToPay = parseFloat(parseFloat(amount).toFixed(2));
    this.currentPayId = payId;
    this.paymentProcessing = true;
    this.isStripeTerminalPay = false;
    if (this.paymentTable.find(o => o.payId === payId).payModeId == EPaymentModes.Cash) { // For Cash Payment
      this.requireFullPaymentForTransaction = false;
      this.payStatus = 'Success';
      this.prePayStatus = 'Payment';
      this.paymentSuccessFul = true;
      this.tenderAmount = parseFloat(parseFloat(amount).toFixed(2));
      this.changeAmount = 0;
      if (this.showPrintEmailRcpt) {
        this.modalRef = this.modalService.show(template, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
      } else {
        this.modalRef = this.modalService.show(template, { class: 'modal-dialog-centered modal-md', backdrop: 'static', keyboard: false });
      }
    } else if (this.paymentTable.find(o => o.payId === payId).payModeId == EPaymentModes.Check) {
      this.payStatus = 'Success';
      this.prePayStatus = 'Payment';
      this.checkNo = null;
      this.checkDate = new Date();
      this.checkBank = '';
      this.paymentSuccessFul = true;
      if (this.showPrintEmailRcpt) {
        this.checkModalRef = this.modalService.show(templateCheck, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
      } else {
        this.checkModalRef = this.modalService.show(templateCheck, { class: 'modal-dialog-centered modal-md', backdrop: 'static', keyboard: false });
      }
    } else if ([EPaymentModes.HostedPage, EPaymentModes.CardOnfile, EPaymentModes.CreditCard, EPaymentModes.DebitCard].includes(this.paymentTable.find(o => o.payId === payId).payModeId)) {
      const hasMultipleDevice = this.terminalDevicesList.length && this.terminalDevicesList.length > 1 && [EPaymentModes.CreditCard, EPaymentModes.DebitCard].includes(this.paymentTable.find(o => o.payId === payId).payModeId);
      if (((this.paymentGateway == EPaymentGateway.OpenEdgeExpress && this.defaultCountryId == ECountries.Canada) || this.paymentGateway == EPaymentGateway.TdBank) && hasMultipleDevice && this.selectedDeviceId == 0) {
        this.modalRefSelectDevice = this.modalService.show(this.selectDevicePopup, { class: 'modal-medium modal-dialog-centered', backdrop: 'static', keyboard: false });
      } else if (this.paymentGateway == EPaymentGateway.Stripe && this.paymentTable.find(o => o.payId === payId).payModeId == EPaymentModes.CreditCard && hasMultipleDevice && this.paymentTable.find(o => o.payId === payId).TerminalDeviceId == '') {
        this.modalRefSelectDevice = this.modalService.show(this.selectStripeDevicePopup, { class: 'modal-medium modal-dialog-centered', backdrop: 'static', keyboard: false });
      } else if (this.paymentGateway == EPaymentGateway.Stripe && this.terminalDevicesList.length == 0 && this.paymentTable.find(o => o.payId === payId).payModeId == EPaymentModes.CreditCard) {
        this.toastr.warning('Please ask Administrator to configure Stripe Terminal', 'Device Required', this.toasterConfig);
      } else {
        this.paymentStarted = true;
        this.saveInCCT(amount, payId, EPaymentTransactionType.Processed);
        this.showLoaderMesage = true;
        this.loaderIcon = Promise.resolve(true);
      }
    } else if (this.paymentTable.find(o => o.payId === payId).payModeId == EPaymentModes.ManualAuthorization) {
      this.payStatus = 'Success';
      this.prePayStatus = 'Payment';
      this.paymentSuccessFul = true;

      if (this.showPrintEmailRcpt) {
       this.setMandatoryFieldsManualAuthForm();
        this.manualModalRef = this.modalService.show(this.offlinePay, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
      } else {
        this.setMandatoryFieldsManualAuthForm();
        this.manualModalRef = this.modalService.show(this.offlinePay, { class: 'modal-dialog-centered modal-md', backdrop: 'static', keyboard: false });
      }
    } else if ([EPaymentModes.ACHOnFile, EPaymentModes.ACH, EPaymentModes.DirectDebitEFTOnFile, EPaymentModes.DirectDebitEFT].includes(this.paymentTable.find(o => o.payId === payId).payModeId)) {
      this.paymentStarted = true;
      this.saveInACH(amount, payId, EPaymentTransactionType.Processed);
      this.loaderIcon = Promise.resolve(true);
    } else if (this.paymentTable.find(o => o.payId === payId).payModeId == EPaymentModes.ACHManualAuthorization) {
      this.setMandatoryFieldsACHManualAuthForm(276);
      this.payStatus = 'Success';
      this.prePayStatus = 'Payment';
      this.paymentSuccessFul = true;
      this.achManualModalRef = this.modalService.show(this.achOfflinePay, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
    }
    else if (this.paymentTable.find(o => o.payId === payId).payModeId == EPaymentModes.EFTManualAuthorization) {
      this.payStatus = 'Success';
      this.prePayStatus = 'Payment';
      this.paymentSuccessFul = true;
      this.eftManualModalRef = this.modalService.show(this.eftOfflinePay, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
    } else if (this.paymentTable.find(o => o.payId === payId).payModeId == EPaymentModes.RemotePay) {
      this.payStatus = 'Success';
      this.prePayStatus = 'Payment';
      let email = '';
      let phoneNo = '';
      if (this.tenantModel) {
        email = this.tenantModel.BusinessAccount && this.tenantModel.CompanyEmail ? this.tenantModel.CompanyEmail : this.tenantModel.Email
        phoneNo = this.tenantModel.BusinessAccount && this.tenantModel.CompanyPhone ? this.tenantModel.CompanyPhone : this.tenantModel.CellPhoneNumber
      } else {
        email = this.customerInfo?.Email;
        phoneNo = this.customerInfo?.CellPhoneNumber;
      }
      this.remotePayIsSmsAlert = this.contactInfo ? this.contactInfo.SendSMSAlerts : this.Tenantinfo.SendSMSAlerts;
      this.remotePayEmailId = email ? email : '';
      this.remotePayPhoneNumber = phoneNo ? phoneNo : '';
      this.remotePayModalRef = this.modalService.show(this.remotePay, { class: 'modal-dialog-centered modal-md', backdrop: 'static', keyboard: false });
    }
  }

  setMandatoryFieldHostedPage() {
    this.payFieldsMandatoryFieldsLoaded = false;
    this.payFieldsStateRequired = false;
    this.generalService.GetMandatoryFields(this.userSessionService.userSessionData.LastAccessedStoreId, this.componentName, this.TDformName)
      .subscribe((response: IGetPermissionMandatoryField) => {
        const data = response;
        this.payFieldsMandatoryFieldsLoaded = Array.isArray(data?.Form?.ListOfProperties);
        if (this.payFieldsMandatoryFieldsLoaded && data.Form.ListOfProperties.length) {
          if ([EPaymentGateway.TdBank, EPaymentGateway.Stripe].includes(this.paymentGateway)) {
            this.fieldsRequired = data.Form.ListOfProperties.some(o => o.Required);
            this.mandatoryFieldsTD = data.Form.ListOfProperties;
          } else {
            this.setOpenEdgeMandatory(response);
          }
        }
      }, () => {
        this.toastr.error('Unable to load mandatory field settings. Please refresh and try again.', 'Settings Error', this.toasterConfig);
      });
  }

  isMandatory(fieldName) {
    let record = this.mandatoryFieldsTD.find((item) => fieldName == item.Name);
    return record.Required;
  }

  onEmailEntered(tdEmail) {
    this.isTDEmailValid = tdEmail.valid;
  }

  public cellPhoneValidator(control) {
    if ((control.value !== '') && (control.value !== null)) {
      const isWhitespace = (control.value).trim().length < 10;
      const isValid = !isWhitespace;
      this.cellphoneNotValid = isValid ? false : true;
    }
  }

  // Called only from the PayFields country <select> (change) handler - clears a stale state id
  // from the previous country before switching state lists, so an old US/Canada state id can't
  // pass validation for the newly-selected country.
  onPayFieldsCountryChange(value): void {
    this.payFieldsBillingDetails.stateId = 0;
    if (value == 1 || value == 2) {
      this.emptyStateList = false;
      this.generalService.getStates(value).subscribe({
        next: (response: IState[]) => {
          // Guard against a stale response from a superseded country selection (rapid switching),
          // mirroring refund.component.ts's onPayFieldsCreditCountryChange.
          if (this.payFieldsBillingDetails.countryId != value) {
            return;
          }
          this.stateList = response;
          if (this.IsQuickProspect && this.customerInfo) {
            const countryId = this.customerInfo.CountryId ?? this.tenantModel.CountryId;
            const country = this.countryList?.find(item => item.Id === countryId);
            this.customerInfo.CountryCode = country?.IsoCode ?? '';
            const stateId = this.customerInfo.StateId || this.tenantModel.State.Id;
            const state = this.stateList?.find(item => item.Id == stateId);
            this.customerInfo.StateCode = state ? state.Code : '';
          }
        },
        error: () => {
          this.toastr.error('Unable to load states/provinces. Please retry.', 'PayFields Error', this.toasterConfig);
        }
      });
      return;
    }
    this.onCountryChange(value, 2);
  }

  onCountryChange(id, type) {
    if (id == 1 || id == 2) {
      this.emptyStateList = false;
      this.getStates(id, type);
    } else {
      this.emptyStateList = true;
      this.stateList = [];
      this.tdState = '0';
      if (this.IsQuickProspect && this.customerInfo) {
        this.customerInfo.CountryCode = this.countryList?.find((item) => item.Id == this.customerInfo.CountryId).IsoCode ?? '';
        this.customerInfo.StateCode = this.stateList?.find((item) => item.Id == this.customerInfo.StateId).Code ?? '';
      }
    }
  }

  getStates(id, type) {
    this.generalService.getStates(id).subscribe((response: IState[]) => {
      this.stateList = response;
      if (type == 1) {
        this.tdState = response[0].Id;
      }
      if (this.IsQuickProspect && this.customerInfo) {
        const countryId = this.customerInfo.CountryId ?? this.tenantModel.CountryId;
        const country = this.countryList?.find(item => item.Id === countryId);
        this.customerInfo.CountryCode = country?.IsoCode ?? '';
        const stateId = this.customerInfo.StateId || this.tenantModel.State.Id;
        const state = this.stateList?.find(item => item.Id == stateId);
        this.customerInfo.StateCode = state ? state.Code : '';
      }
    });
  }

  getCountries() {
    this.generalService.getCountries().subscribe((response: ICountry[]) => {
      this.countryList = response;
      this.mapCountryIsoCode()
      this.tdCountry = environment.defaultCountryId;
      this.onCountryChange(this.tdCountry, 1)
    });
  }

  getDayEndCompletedDate(facilityId) {
    this.generalService.getDayEndCompletedDate(facilityId).subscribe((response) => {
      if (response) {
        this.FacilityDate = this.commonMethod.getFormattedDate(response.FacilityDateTime);
      }
    });
  }

  get getUniqueIdentifier() {
    return this.customerDataService.uniqueIdentifier;
  }

  showAutoPay() {
    // Autopay/Card on File must never be offered while Debit Card is the selected payment mode (PR 33768, Sanath).
    if (this.paymentTable.some(row => row.payModeId === EPaymentModes.DebitCard)) {
      return false;
    }
    if (this.processPayment.Type !== EPaymentOrigin.Merchandise && this.processPayment.Type !== EPaymentOrigin.MoveOut &&
      this.processPayment.Type !== EPaymentOrigin.AuctionManager && this.processPayment.Type !== EPaymentOrigin.Reservation) {
      return true;
    } else {
      return false;
    }
  }

  callAuthenticationForm(contents, orderId, payId, paymentTrnsId) {
    this.loaderIcon = Promise.resolve(false);
    this.tdChallengeModalRef = this.modalService.show(this.showTDchallengeForm, { class: 'modal-medium modal-dialog-centered', backdrop: 'static', keyboard: false });
    var tempDivElement = document.createElement("div");
    tempDivElement.innerHTML = decodeURIComponent(contents.replace(/\+/g, ' '));
    const formElements = tempDivElement.getElementsByTagName('form');
    var tdBankForm = document.createElement("form");
    tdBankForm.target = "threedframe";
    tdBankForm.method = "Post";
    tdBankForm.action = formElements['challengeform'].action;
    for (var i = 0; i < formElements[0].length; i++) {
      var mapInput = document.createElement("input");
      mapInput.type = "hidden";
      mapInput.name = formElements[0][i]['name'];
      mapInput.setAttribute("value", formElements[0][i]['value']);
      tdBankForm.appendChild(mapInput);
    }
    document.body.appendChild(tdBankForm);
    this.sessiondata = formElements[0][0]['value'];
    sessionStorage.setItem("tdSessiondata", this.sessiondata);
    tdBankForm.submit();
    if (!this.subTdhost) {
      const source = interval(2000);
      this.subTdhost = source.subscribe(val => this.getCresResponse(this.sessiondata, val, orderId, payId, paymentTrnsId));
    }
  }

  challengeFlowRes(tdCres, orderId, payId, paymentTrnsId) {
    if (!this.credentials) {
      this.getCredentials();
    }
    const inputModel = {
      payment_method: this.tdPaymentMethod,
      card_response: {
        cres: tdCres.cres
      }
    }
    this.generalService.tDBankPaymentContinue(inputModel, this.sessiondata, this.credentials).subscribe((response: any) => {
      var tdCountinueResponse;
      if (response) {
        this.loaderIcon = Promise.resolve(false);
        this.sessiondata = null;
        tdCountinueResponse = response;
      }
      let amount = 0;
      if (tdCountinueResponse.message == "Approved") {
        this.paymentTable.find(o => o.payId == payId).payFailed = false;
        let process = tdCountinueResponse.id;
        let approved = tdCountinueResponse.approved;
        let trnId = tdCountinueResponse.id;
        let messageId = tdCountinueResponse.message_id;
        let messageText = tdCountinueResponse.message;
        let authCode = tdCountinueResponse.auth_code;
        let trnAmount = tdCountinueResponse.amount;
        let trnDate = tdCountinueResponse.created;
        let trnOrderNumber = tdCountinueResponse.order_number;
        let cardType = tdCountinueResponse.card.card_type;
        let cardNumber = tdCountinueResponse.card.last_four;
        let trnType = tdCountinueResponse.type;
        let paymentMethod = tdCountinueResponse.payment_method;
        let cardDetails = this.cardDetails;
        this.tdResponseObj = {
          Process: process,
          trnApproved: approved,
          trnId: trnId,
          messageId: messageId,
          messageText: messageText,
          authCode: authCode,
          trnAmount: trnAmount,
          trnDate: trnDate,
          trnOrderNumber: trnOrderNumber,
          cardType: cardType,
          trnType: trnType,
          cardNumber: cardNumber,
          paymentMethod: paymentMethod,
          nameOnCard: this.tdNameOnCard,
          CreditCardExpiryMonth: cardDetails ? this.getExpiryMonthValue(parseInt(cardDetails.expiryMonth, 10)) : 275,
          CreditCardExpiryYear: cardDetails ? parseInt(cardDetails.expiryYear, 10) : 2099,
          CreditCardBillingAddress: this.tdAddress,
          CreditCardBillingZip: this.tdZip,
          CreditCardType: 2
        }
        this.tdResponseObj.CreditCardType = this.tdResponseObj.cardType ? this.paymentService.getTdPaymentCardType(this.tdResponseObj.cardType) : ECreditCards.Visa;
        if (this.tdPaymentMethod == "payment_profile") {
          const tempCCModel = {
            Amount: tdCountinueResponse.amount,
            Autopay: false,
            paymentModeId: EPaymentModes.CardOnfile,
            AutoCcProcessingDay: 0,
            CreditCardNumber: tdCountinueResponse.card.last_four,
            CreditCardType: this.autoPayInfo.CreditCardType,
            NameonCard: this.autoPayInfo ? this.autoPayInfo.NameonCard : '',
            CreditCardExpiryMonth: this.autoPayInfo ? this.autoPayInfo.CreditCardExpiryMonth : 275,
            CreditCardExpiryYear: this.autoPayInfo ? this.autoPayInfo.CreditCardExpiryYear : 2099,
            CreditCardBillingAddress: this.autoPayInfo ? this.autoPayInfo.CreditCardBillingAddress : '',
            CreditCardBillingZip: this.autoPayInfo ? this.autoPayInfo.CreditCardBillingZip : '',
            SwipeTransaction: false,
            SecurityCodeSent: false,
            AuthorizationCode: tdCountinueResponse.id,
            ResponseCode: tdCountinueResponse.message_id,
            Reason: tdCountinueResponse.message,
            Key: '',
            PaymentAccountid: this.autoPayInfo.PaymentAccountId,
            CcInfoPurged: false,
            DebitCardPayment: (response.card.card_type == 'PV' || response.card.card_type == 'MD') ? true : false,
            OfflinePayment: 0,
            PaymentTransactionTypeId: paymentTrnsId,
            OrderId: orderId,
            FacilityId: this.processPayment.facId,
            TransactionDateTime: new Date(),
            TransactionTypeId: EPaymentTransactionType.Processed,
            TerminalDeviceId: null,
            LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
            TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null
          };
          this.paymentTable.find(o => o.payId == payId)['processedCC'] = tempCCModel; // Profile_Payment
        } else {
          this.paymentTable.find(o => o.payId == payId)['processedTDCC'] = this.tdResponseObj; //3d Secure Payment
        }
        amount = trnAmount;
        this.paymentSuccessFul = true;
        this.prePayStatus = 'Payment';
        this.payStatus = 'Success';
        this.tdPaymentMethod = null;
        this.gotoPaymentSuccess(this.popUpPayment, amount);
      } else {
        this.paymentTable.find(o => o.payId == payId).payFailed = true;
        this.loaderIcon = Promise.resolve(false);
        this.paymentTable.find(o => o.payId == payId).payFailed = true;
        this.toastr.warning(tdCountinueResponse.Message, 'Payment Failed', this.toasterConfig);
        this.paymentSuccessFul = false;
        this.paymentProcessing = false;
        this.prePayStatus = 'Payment';
        this.payStatus = 'Failed';
        this.isAnyPaymentProcessed();
        this.gotoPaymentSuccess(this.popUpPayment, amount);

        const ccModel = {
          Amount: tdCountinueResponse.amount,
          Autopay: false,
          paymentModeId: EPaymentModes.CardOnfile,
          AutoCcProcessingDay: 0,
          CreditCardNumber: tdCountinueResponse.card.last_four ? tdCountinueResponse.card.last_four : 'XXXX',
          CreditCardType: this.autoPayInfo.CreditCardType ? this.autoPayInfo.CreditCardType : ECreditCards.Visa,
          NameonCard: this.autoPayInfo ? this.autoPayInfo.NameonCard : '',
          CreditCardExpiryMonth: this.autoPayInfo ? this.autoPayInfo.CreditCardExpiryMonth : 275,
          CreditCardExpiryYear: this.autoPayInfo ? this.autoPayInfo.CreditCardExpiryYear : 2099,
          CreditCardBillingAddress: this.autoPayInfo ? this.autoPayInfo.CreditCardBillingAddress : '',
          CreditCardBillingZip: this.autoPayInfo ? this.autoPayInfo.CreditCardBillingZip : '',
          SwipeTransaction: false,
          SecurityCodeSent: false,
          AuthorizationCode: tdCountinueResponse.id ? tdCountinueResponse.id : '0',
          ResponseCode: tdCountinueResponse.message_id,
          Reason: tdCountinueResponse.message ? tdCountinueResponse.message : 'Declined!',
          Key: '',
          PaymentAccountid: this.autoPayInfo.PaymentAccountId,
          CcInfoPurged: false,
          DebitCardPayment: response.card && (response.card.card_type == 'PV' || response.card.card_type == 'MD') ? true : false,
          OfflinePayment: 0,
          PaymentTransactionTypeId: paymentTrnsId,
          OrderId: orderId,
          FacilityId: this.processPayment.facId,
          TransactionDateTime: new Date(),
          TransactionTypeId: EPaymentTransactionType.Processed,
          TerminalDeviceId: null,
          LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
          TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null
        };
        this.paymentService.saveCCTransaction(Object.assign(ccModel)).subscribe((res: any) => { });
      }
    }, err => {
      this.paymentTable.find(o => o.payId == payId).payFailed = true;
      this.loaderIcon = Promise.resolve(false);
      this.toastr.error('Payment Failed', 'Failure');
      this.payStatus = 'Failed';
      this.isAnyPaymentProcessed();
      this.paymentSuccessFul = false;
      this.paymentProcessing = false;
      this.gotoPaymentSuccess(this.popUpPayment, 0);
      const ccModel = {
        Amount: this.amountToPay,
        Autopay: false,
        paymentModeId: this.paymentTable.find(o => o.payId == payId).payModeId,
        AutoCcProcessingDay: 0,
        CreditCardNumber: 'XXXX',
        CreditCardType: ECreditCards.Visa,
        NameonCard: '',
        CreditCardExpiryMonth: 275,
        CreditCardExpiryYear: 2099,
        CreditCardBillingAddress: '',
        CreditCardBillingZip: '',
        SwipeTransaction: false,
        SecurityCodeSent: false,
        AuthorizationCode: '0',
        ResponseCode: '0',
        Reason: 'Declined!',
        Key: '',
        PaymentAccountid: null,
        CcInfoPurged: false,
        DebitCardPayment: false,
        OfflinePayment: 0,
        PaymentTransactionTypeId: paymentTrnsId,
        OrderId: orderId,
        FacilityId: this.processPayment.facId,
        TransactionDateTime: new Date(),
        TransactionTypeId: EPaymentTransactionType.Processed,
        TerminalDeviceId: null,
        LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
        TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null
      };
      this.paymentService.saveCCTransaction(Object.assign(ccModel)).subscribe((res: any) => { });
    });
  }


  getCresResponse(GatewayRes, count, orderId, payId, paymentTrnsId) {
    let res;
    let maxTime = (this.paymentMaxWaitTime * 60) / this.paymentGetCCTStatusInterval;
    this.paymentService.getCresdata(this.sessiondata).subscribe((Response: any) => {
      if (Response) {
        this.tdChallengeModalRef.hide();
        res = JSON.parse(Response);
        this.loaderIcon = Promise.resolve(true);
        if (this.subTdhost) {
          this.subTdhost.unsubscribe();
          this.subTdhost = null;
        }
        this.challengeFlowRes(res, orderId, payId, paymentTrnsId);
      } else if (Response == null) {
        if (count > maxTime) {
          if (this.subTdhost) {
            this.subTdhost.unsubscribe();
            this.subTdhost = null;
          }
          this.loaderIcon = Promise.resolve(false);
          this.paymentStarted = false;
          this.toastr.error('Payment Failed', 'Failure');
          this.paymentTable.find(o => o.payId == payId).payFailed = true;
        }
      }
    }, err => {
      if (count > maxTime) {
        if (this.subTdhost) {
          this.subTdhost.unsubscribe();
          this.subTdhost = null;
        }
        this.paymentTable.find(o => o.payId == payId).payFailed = true;
        this.loaderIcon = Promise.resolve(false);
        this.paymentStarted = false;
        this.toastr.error('Payment Failed', 'Failure');
      }
    });
  }

  onTransactionCancel() {
    this.tdChallengeModalRef.hide();
    this.loaderIcon = Promise.resolve(false);
    if (this.subTdhost) {
      this.subTdhost.unsubscribe();
      this.subTdhost = null;
    }
    this.toastr.error('Payment Failed', 'Failure');
    this.payStatus = 'Failed';
    this.paymentSuccessFul = false;
    this.paymentFailReason = "Declined!";
    this.paymentProcessing = false;
    this.isAnyPaymentProcessed();
    this.gotoPaymentSuccess(this.popUpPayment, 0);
    let paymentTrnsId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);

    let CCTModel;
    const tempCCModel = {
      Amount: this.TdAmount,
      Autopay: false,
      PaymentModeId: EPaymentModes.CreditCard,
      AutoCcProcessingDay: 0,
      CreditCardNumber: '0',
      CreditCardType: ECreditCards.Visa,
      NameonCard: " ",
      CreditCardExpiryMonth: 275,
      CreditCardExpiryYear: 2099,
      CreditCardBillingAddress: '',
      CreditCardBillingZip: '',
      SwipeTransaction: false,
      SecurityCodeSent: false,
      AuthorizationCode: "0",
      ResponseCode: " ",
      Reason: "Declined!",
      Key: '',
      PaymentAccountid: '',
      CcInfoPurged: false,
      DebitCardPayment: false,
      OfflinePayment: 0,
      PaymentTransactionTypeId: paymentTrnsId,
      TransactionDateTime: new Date(),
      TransactionTypeId: EPaymentTransactionType.Declined,
      OrderId: this.paymentTable.find(o => o.payId == this.currentPayId).orderId,
      CCBatchNumber: null,
      EmvReceiptText: null,
      FacilityId: this.processPayment.facId,
      TerminalDeviceId: null
    };

    CCTModel = Object.assign(tempCCModel);
    this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => { });
  }

  setUserPermissions() {
    const userPermissionsOfflinePayment = this.generalService.getUserPermissionsForModule(EUserFunctions['Rentals : Offline CC Transactions']);
    this.editRightOfflinePayment = userPermissionsOfflinePayment.EditRight;
    this.viewRightOfflinePayment = userPermissionsOfflinePayment.ViewRight;
  }

  isString(val: any): boolean {
    return (val && (typeof val === 'string' || val instanceof String));
  }

  mapCountryIsoCode(): void {
    if (this.countryList && this.countryList.length) {
      this.commonMethod.mapCountryIsoCode(this.countryList);
    }
  }

  setOpenEdgeMandatory(response) {
    this.openEdgeBillingFields = '';
    this.payFieldsStateRequired = response.Form.ListOfProperties.some(field => field.Name == 'tdState' && field.Required);
    this.payFieldsMandatoryFieldsLoaded = true;
    response.Form.ListOfProperties.forEach(field => {
      var mandatoryField = '';
      if (field.Name == 'tdFName') {
        if (field.Required) {
          mandatoryField = `<BILLINGFIRSTNAME> <REQUIRED>TRUE</REQUIRED> </BILLINGFIRSTNAME>`;
        } else {
          mandatoryField = `<BILLINGFIRSTNAME> <REQUIRED>FALSE</REQUIRED> </BILLINGFIRSTNAME>`;
        }
      } else if (field.Name == 'tdLName') {
        if (field.Required) {
          mandatoryField = `<BILLINGLASTNAME> <REQUIRED>TRUE</REQUIRED> </BILLINGLASTNAME>`;
        } else {
          mandatoryField = `<BILLINGLASTNAME> <REQUIRED>FALSE</REQUIRED> </BILLINGLASTNAME>`;
        }
      } else if (field.Name == 'tdAddress') {
        if (field.Required) {
          mandatoryField = `<BILLINGADDRESSONE> <REQUIRED>TRUE</REQUIRED> </BILLINGADDRESSONE>`;
        } else {
          mandatoryField = `<BILLINGADDRESSONE> <REQUIRED>FALSE</REQUIRED> </BILLINGADDRESSONE>`;
        }
      } else if (field.Name == 'tdZip') {
        if (field.Required) {
          mandatoryField = `<BILLINGPOSTALCODE> <REQUIRED>TRUE</REQUIRED> </BILLINGPOSTALCODE>`;
        } else {
          mandatoryField = `<BILLINGPOSTALCODE> <REQUIRED>FALSE</REQUIRED> </BILLINGPOSTALCODE>`;
        }
      } else if (field.Name == 'tdState') {
        if (field.Required) {
          mandatoryField = `<BILLINGSTATEORPROVINCE> <REQUIRED>TRUE</REQUIRED> </BILLINGSTATEORPROVINCE>`;
        } else {
          mandatoryField = `<BILLINGSTATEORPROVINCE> <REQUIRED>FALSE</REQUIRED> </BILLINGSTATEORPROVINCE>`;
        }
      } else if (field.Name == 'tdCity') {
        if (field.Required) {
          mandatoryField = `<BILLINGCITY> <REQUIRED>TRUE</REQUIRED> </BILLINGCITY>`;
        } else {
          mandatoryField = `<BILLINGCITY> <REQUIRED>FALSE</REQUIRED> </BILLINGCITY>`;
        }
      } else if (field.Name == 'tdCountry') {
        if (field.Required) {
          mandatoryField = `<BILLINGCOUNTRYCODE> <REQUIRED>TRUE</REQUIRED> </BILLINGCOUNTRYCODE>`;
        } else {
          mandatoryField = `<BILLINGCOUNTRYCODE> <REQUIRED>FALSE</REQUIRED> </BILLINGCOUNTRYCODE>`;
        }
      } else if (field.Name == 'CustomerTitle') {
        if (field.Required) {
          mandatoryField = `<BILLINGCUSTOMERTITLE> <REQUIRED>TRUE</REQUIRED> </BILLINGCUSTOMERTITLE>`;
        } else {
          mandatoryField = `<BILLINGCUSTOMERTITLE> <REQUIRED>FALSE</REQUIRED> </BILLINGCUSTOMERTITLE>`;
        }
      } else if (field.Name == 'MiddleName') {
        if (field.Required) {
          mandatoryField = `<BILLINGMIDDLENAME> <REQUIRED>TRUE</REQUIRED> </BILLINGMIDDLENAME>`;
        } else {
          mandatoryField = `<BILLINGMIDDLENAME> <REQUIRED>FALSE</REQUIRED> </BILLINGMIDDLENAME>`;
        }
      } else if (field.Name == 'CompanyName') {
        if (field.Required) {
          mandatoryField = `<BILLINGCOMPANY> <REQUIRED>TRUE</REQUIRED> </BILLINGCOMPANY>`;
        } else {
          mandatoryField = `<BILLINGCOMPANY> <REQUIRED>FALSE</REQUIRED> </BILLINGCOMPANY>`;
        }
      } else if (field.Name == 'AddressTwo') {
        if (field.Required) {
          mandatoryField = `<BILLINGADDRESSTWO> <REQUIRED>TRUE</REQUIRED> </BILLINGADDRESSTWO>`;
        } else {
          mandatoryField = `<BILLINGADDRESSTWO> <REQUIRED>FALSE</REQUIRED> </BILLINGADDRESSTWO>`;
        }
      }
      if (this.openEdgeBillingFields && mandatoryField) {
        this.openEdgeBillingFields = this.openEdgeBillingFields + mandatoryField;
      } else if (mandatoryField) {
        this.openEdgeBillingFields = mandatoryField;
      }
    });
  }

  disablePayNowButton(drow) {
    // A mismatch void that is pending or unconfirmed may leave the first sale live: no new payment until it is resolved
    // (onPayClick enforces the same guard).
    if (this.isTdMismatchRetryBlocked || this.isOpenEdgeReconciliationBlocked(drow)) {
      return true;
    }
    if (!this.payModes || this.payModes.length == 1) {
      return true;
    } else if (drow.enterValDisable) {
      return true;
    } else if (drow.payModeId == 0) {
      return true;
    } else {
      return false;
    }
  }

  showPaymentProgress() {
    if (this.paymentInProgress) {
      return true;
    } else {
      return false;
    }
  }

  isAnyPaymentProcessed() {
    let status = this.paymentTable.some(function (ele) { return ele.payComplete });
    if (!status) {
      this.paymentInProgress = false;
    }
  }

  onClickAutoPopulateBillingInfo(gateway) {
    if (gateway == EPaymentGateway.TdBank) {
      if (this.isAutoPopulateBillingInfo && this.customerInfo) {
        this.tdAddress = this.customerInfo.AddressOne ? this.customerInfo.AddressOne : this.tenantModel && this.tenantModel.Address ? this.tenantModel.Address : "";
        this.tdZip = this.customerInfo.PostalCode ? this.customerInfo.PostalCode : this.tenantModel && this.tenantModel.Zip ? this.tenantModel.Zip : "";
        this.tdFName = this.customerInfo.FirstName;
        this.tdLName = this.customerInfo.LastName;
        this.tdEmail = this.customerInfo.Email;
        this.tdCity = this.customerInfo.City ? this.customerInfo.City : this.tenantModel && this.tenantModel.City ? this.tenantModel.City : "";
        this.tdState = this.customerInfo.StateId ? this.customerInfo.StateId : this.tenantModel && this.tenantModel.State.Id ? this.tenantModel.State.Id : 0;
        this.tdCountry = this.customerInfo.CountryId;
        this.tdCellphone = this.customerInfo.CellPhoneNumber;
       // this.onCountryChange(this.tdCountry, 2);
      } else {
        this.tdAddress = '';
        this.tdZip = '';
        this.tdFName = '';
        this.tdLName = '';
        this.tdEmail = '';
        this.tdCity = '';
        this.tdState = 0;
        this.tdCountry = environment.defaultCountryId;
        this.tdCellphone = '';
        this.onCountryChange(this.tdCountry, 1)
      }
    } else {
      this.callCNP(this.tempCNPAmount, 'CREDITSALE', this.tempCNPPayId)
    }
  }

  setCNPCustomerInfo(amount, transType, payId) {
    this.customerInfo.AddressOne = this.customerInfo.AddressOne && this.customerInfo.AddressOne.length > 50 ?
      this.customerInfo.AddressOne.substring(0, 50) : (this.tenantModel && this.tenantModel.Address ? this.tenantModel.Address : this.customerInfo.AddressOne);
    this.customerInfo.City = this.customerInfo.City ? this.customerInfo.City : this.tenantModel && this.tenantModel.City ? this.tenantModel.City : "";
    this.customerInfo.PostalCode = this.customerInfo.PostalCode ? this.customerInfo.PostalCode : this.tenantModel && this.tenantModel.Zip ? this.tenantModel.Zip : "";
    const customerInfo = this.paymentService.mapBillingInfo(this.customerInfo);
    const orderId = this.paymentTable.find(o => o.payId == payId).uniqueTransId;
    this.requestParam = "<REQUEST>" +
      "<XWEBID>" + this.credentials.XWEBID + "</XWEBID>" +
      "<XWEBTERMINALID>" + this.credentials.XWEBTERMINALID + "</XWEBTERMINALID>" +
      "<XWEBAUTHKEY>" + this.credentials.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
      "<TRANSACTIONTYPE>" + transType + "</TRANSACTIONTYPE>" +
      "<AMOUNT>" + amount + "</AMOUNT>" +
      "<BILLINGFIRSTNAME>" + customerInfo.firstName + "</BILLINGFIRSTNAME>" +
      "<BILLINGMIDDLENAME>" + customerInfo.middleName + "</BILLINGMIDDLENAME>" +
      "<BILLINGLASTNAME>" + customerInfo.lastName + "</BILLINGLASTNAME>" +
      "<BILLINGADDRESS1>" + customerInfo.address + "</BILLINGADDRESS1>" +
      "<BILLINGCOMPANY>" + customerInfo.companyName + "</BILLINGCOMPANY>" +
      "<BILLINGCITY>" + customerInfo.city + "</BILLINGCITY>" +
      "<BILLINGCOUNTRY>" + customerInfo.countryCode + "</BILLINGCOUNTRY>" +
      "<BILLINGSTATE>" + customerInfo.stateCode + "</BILLINGSTATE>" +
      "<BILLINGPOSTALCODE>" + customerInfo.postalCode + "</BILLINGPOSTALCODE>" +
      "<CLERK></CLERK>" +
      "<ORDERID>" + orderId + "</ORDERID>" +
      "<ECI>" + EEdgeExpressECIType.Moto + "</ECI>" +
      "<HOSTPAYSETTING>" +
      "<CARDBRAND>" + this.facilityCreditCards + "</CARDBRAND>" +
      "<DISABLEFRAMING>FALSE</DISABLEFRAMING>" +
      "<CUSTOMIZATION>" +
      "<PAGE> " +
      this.openEdgeBillingFields +
      "</PAGE>" +
      "<BRANDING>" +
      "<BODY>" +
      "<FONT-FAMILY> LATO,SANS-SERIF;</FONT-FAMILY>" +
      "<FONT-SIZE>14px</FONT-SIZE>" +
      "</BODY>" +
      "<BTN>" +
      "<BACKGROUND-COLOR>#3757C5;</BACKGROUND-COLOR>" +
      "<FONT-SIZE>14PX;</FONT-SIZE>" +
      "</BTN>" +
      "<SPECIALCSS>" +
      "<SECTION-HEADER-FONT-SIZE>18px</SECTION-HEADER-FONT-SIZE>" +
      "<COLOR>#3757C5;</COLOR>" +
      "</SPECIALCSS>" +
      "</BRANDING>" +
      "</CUSTOMIZATION>" +
      "<POSDEVICE>" +
      "<TYPE>KEYED</TYPE>" +
      "</POSDEVICE>" +
      "</HOSTPAYSETTING>" +
      "</REQUEST>";
  }

  getTenantDetailsById(tenantId) {
    this.prospectSerice.getContactInfo(tenantId).subscribe((response: any) => {
      if (response) {
        this.Tenantinfo = response;
        this.customerInfoPresent = true;
        this.customerInfo = {
          FirstName: response.FirstName,
          MiddleName: response.MiddleName,
          LastName: response.LastName,
          CompanyName: response.CompanyName,
          AddressOne: response.Address,
          City: response.City,
          CountryCode: response.CountryCode.substring(0, 2),
          StateCode: response.State && response.State.Code ? response.State.Code : '',
          StateId: response.State && response.State.Id ? response.State.Id : '',
          PostalCode: response.Zip,
          CountryId: response.CountryId,
          CellPhoneNumber: response.BusinessAccount && response.CompanyPhone ? response.CompanyPhone : response.CellPhoneNumber,
          Email: response.BusinessAccount && response.CompanyEmail ? response.CompanyEmail : response.Email,
          FullName: response.BusinessAccount && response.CompanyName ? response.CompanyName : `${response.FirstName}${response.MiddleName ? ' ' + response.MiddleName : ''} ${response.LastName}`.trim()
        }
      }
    })
  }

  getStoresbyId() {
    this.facilityservice.getFacilityInfoForOp(this.facilityId).subscribe((response: IFacilityInfo) => {
      if (response) {
        this.countryId = response.CountryId;
      }
    });
  }

  saveCCTransactionFailureCase(jsonResp, paymentFailReason, transactionType, paymentTrnsId, orderId, payId?: number) {
    // HostedCNPResponse polls recursively - by the time a poll resolves, currentPayId may have
    // moved to a different row in a multi-payment session, so the caller's own payId takes priority.
    const effectivePayId = payId ?? this.currentPayId;
    const failedPayment = this.paymentTable.find(o => o.payId == effectivePayId);
    this.isTDEmv.isTransactionWaitTime = false;
    if (failedPayment) {
      failedPayment.isOpenEdgePaymentCompleted = true;
    }
    this.paymentSuccessFul = false;
    this.paymentProcessing = false;
    this.retryTransactionStatusLoader = false;
    this.payStatus = 'Failed';
    this.isAnyPaymentProcessed();
    this.paymentFailReason = paymentFailReason ? paymentFailReason : jsonResp?.RESULT?.STATE;
    this.requestGatewaydetails(jsonResp && jsonResp.PaymentModeId ? jsonResp.PaymentModeId : undefined, effectivePayId);
    const CCModel = {
      Amount: failedPayment?.payAmount ?? this.amountToPay,
      Autopay: false,
      paymentModeId: jsonResp?.PaymentModeId || failedPayment?.payModeId || EPaymentModes.CreditCard,
      AutoCcProcessingDay: 0,
      CreditCardNumber: jsonResp && jsonResp.RESULT && jsonResp.RESULT.MASKEDCARDNUMBER ? jsonResp.RESULT.MASKEDCARDNUMBER : '0',
      CreditCardType: jsonResp && jsonResp.RESULT && jsonResp.RESULT.CARDBRAND ? this.paymentService.openEdgeCardType(jsonResp.RESULT.CARDBRAND) : ECreditCards.Visa,
      NameonCard: '',
      CreditCardExpiryMonth: jsonResp && jsonResp.RESULT && jsonResp.RESULT.EXPMONTH ? this.getExpiryMonthValue(parseInt(jsonResp.RESULT.EXPMONTH, 10)) : 275,
      CreditCardExpiryYear: jsonResp && jsonResp.RESULT && jsonResp.RESULT.EXPYEAR ? parseInt(jsonResp.RESULT.EXPYEAR, 10) : 2099,
      CreditCardBillingAddress: jsonResp && jsonResp.RESULT && jsonResp.RESULT.ADDRESS1 ? jsonResp.RESULT.ADDRESS1 : " ",
      CreditCardBillingZip: jsonResp && jsonResp.RESULT && jsonResp.RESULT.BILLINGPOSTALCODE ? jsonResp.RESULT.BILLINGPOSTALCODE : " ",
      SwipeTransaction: false,
      SecurityCodeSent: false,
      AuthorizationCode: jsonResp && jsonResp.RESULT && jsonResp.RESULT.TRANSACTIONID ? jsonResp.RESULT.TRANSACTIONID : '0',
      ResponseCode: jsonResp && jsonResp.RESULT && jsonResp.RESULT.RESPONSECODE ? jsonResp.RESULT.RESPONSECODE : '0',
      Reason: (jsonResp && jsonResp.RESULT && jsonResp.RESULT && jsonResp.RESULT.STATE == 'IN_PROGRESS') ? jsonResp.RESULT.STATE : (jsonResp && jsonResp.RESULT && jsonResp.RESULT.RESPONSEDESCRIPTION) ? jsonResp.RESULT.RESPONSEDESCRIPTION : this.paymentFailReason,
      Key: '',
      PaymentAccountid: '',
      CcInfoPurged: false,
      // Card evidence in the decline first (a debit card under CREDITSALE still reports CARDTYPE "Credit"),
      // then the gateway's card type, then the tender the attempt was made under.
      DebitCardPayment: this.getOpenEdgePresentedCardIsDebit(jsonResp?.RESULT)
        ?? (jsonResp?.RESULT?.CARDTYPE ? jsonResp.RESULT.CARDTYPE != 'Credit' : failedPayment?.payModeId == EPaymentModes.DebitCard),
      OfflinePayment: 0,
      PaymentTransactionTypeId: paymentTrnsId,
      OrderId: orderId,
      FacilityId: this.processPayment.facId,
      TransactionDateTime: new Date(),
      TransactionTypeId: EPaymentTransactionType.Declined,
      TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
      UniqueTransId: failedPayment?.uniqueTransId,
      TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
      LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
      GatewayDetails: this.requestgatewaydetails
    };
    this.paymentService.saveCCTransaction(Object.assign(CCModel)).subscribe((res: any) => { });
    if (transactionType == 'Void') {
      // HostedPage rows are never pushed into multiPaymentVoidEmv (only CreditCard/DEBITSALE rows are) - guard so a HostedPage void failure doesn't throw here and mask itself.
      const voidEntry = this.multiPaymentVoidEmv.find(t => t.orderId === failedPayment?.orderId);
      if (voidEntry) {
        voidEntry.isEmvVoidInitiated = true;
        this.finishOpenEdgeMismatchVoid(voidEntry, false); // mismatch reversal: show "could not be confirmed"
      }
      if (this.multiPaymentVoidEmv.some(function (ele) { return (ele.isEmvVoidInitiated == false); })) {
        this.callOpenEdgeVoid(paymentTrnsId);
      } else {
        if (!this.voidOnCancelInitiated && !this._isMismatchVoid) {
          this.isCancel.emit(true);
        }
        this.loaderIcon = Promise.resolve(false);
      }
      this.toastr.error(`Failed to Reverse the Payment! - $${this.amountToPay}`, 'Failure', this.toasterConfig);
    } else {
      this.loaderIcon = Promise.resolve(false);
      if (this.showOpenEdgeDeclineMismatch(effectivePayId, jsonResp?.RESULT ?? jsonResp?.RESPONSE)) {
        return;
      }
      this.toastr.error('Payment Failed', 'Failure');
      this.gotoPaymentSuccess(this.popUpPayment, 0);
    }

  }

   onAutopayCancel(value) {
    if(!this.hasAutopay){
      this.onClickCancelButton();
    }
  }


  onClickCancelButton() {
    this.auto = false;
    if (this.paymentTable.some(o => o.payComplete)) {
      this.cancelPaymentModalRef = this.modalService.show(this.cancelPaymentModal, { class: 'modal-medium modal-dialog-centered', backdrop: 'static', keyboard: false });
    } else {
      this.onPaymentCancel();
    }
  }

  onCancelPaymentYes() {
    this.voidAllProcessedGatewayTransactions();
  }

  onCancelPaymentNo() {
    this.cancelPaymentModalRef.hide();
  }

  voidAllProcessedGatewayTransactions() {
    this.cancelPaymentModalRef.hide();
    this.voidOnCancelInitiated = true;
    this.loaderIcon = Promise.resolve(true);
    let paymentTrnsId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
    //Checking Duplicate records which holds same gateway details
    this.paymentTable = this.paymentTable.filter((item, i, arr) => arr.findIndex((t) => t.orderId === item.orderId) === i);

    this.multiPaymentVoidEmv = [];
    if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress) {
      this.paymentTable.forEach((ele => {
        if ([EPaymentModes.CreditCard, EPaymentModes.DebitCard].includes(ele.payModeId) && ele['processedCC'] && this.isOpenEdgeDebitSale(ele)) {
          ele['isEmvVoidInitiated'] = false;
          this.multiPaymentVoidEmv.push(ele);
        } else {
          ele['isEmvVoidInitiated'] = true;
        }
      }));
      if (this.multiPaymentVoidEmv.length > 0) {
        this.callOpenEdgeVoid(paymentTrnsId);
      }
    } else if (this.paymentGateway == EPaymentGateway.TdBank) {
      this.paymentTable.forEach((ele => {
        if (ele.payModeId == EPaymentModes.CreditCard && ele['processedCC']) {
          ele['isEmvVoidInitiated'] = false;
          this.multiPaymentVoidEmv.push(ele);
        } else {
          ele['isEmvVoidInitiated'] = true;
        }
      }));
      if (this.multiPaymentVoidEmv.length > 0) {
        this.callTdVoid(paymentTrnsId);
      }
    }
    this.paymentTable.map(ele => {
      if (this.paymentGateway == EPaymentGateway.Stripe && ele.payComplete) {
        let paymentData = [EPaymentModes.CreditCard, EPaymentModes.HostedPage, EPaymentModes.CardOnfile].includes(ele.payModeId) == true ? ele['processedStripeCC'] : ele['processedACH'];
        this.cancelPaymentIntent(paymentData, ele.payAmount, paymentTrnsId, ele.payModeId);
      } else {
        if (ele.payModeId == EPaymentModes.CreditCard && ele.isEmvVoidInitiated) {
          if (this.paymentGateway == EPaymentGateway.TdBank && ele.payComplete) {
            this.showLoaderMesage = true;
            this.loaderIcon = Promise.resolve(true);
            let amount = this.paymentTable.find(o => o.payId == ele.payId)['processedCC'].Amount;
            let cardNumber = this.paymentTable.find(o => o.payId == ele.payId)['processedCC'].CreditCardNumber;
            let auth = this.paymentTable.find(o => o.payId == ele.payId)['processedCC'].AuthorizationCode;
            let voidOrderId = this.paymentTable.find(o => o.payId == ele.payId)['processedCC'].OrderId;
            let CCTModel = this.generateIntialCCT(amount, EPaymentTransactionType.Reversal_Refund, paymentTrnsId, ele.payModeId, 'VOID', cardNumber, auth, voidOrderId, false, ele.payId);
            let obj = this.paymentTable.find(o => o.payId == ele.payId).processedCC;
            if (obj) {
              this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
                if (res.Success) {
                  let cctId = res.Id;
                  this.initiatedVoidCC = true;
                  if (!this.subVoidTd) {
                    let intervalTime = this.paymentGetCCTStatusInterval * 1000;
                    const source = interval(intervalTime);
                    this.subVoidTd = source.subscribe(val => this.getCCTVoidStatus(cctId, ele.payId, val, amount, null, paymentTrnsId));
                  }
                }
              });
            }
          } else {
            if (ele.payComplete) {
              let amount = this.paymentTable.find(o => o.payId == ele.payId)['processedCC'].APPROVEDAMOUNT;
              let CCTModel = this.generateIntialCCT(amount, EPaymentTransactionType.Reversal_Refund, paymentTrnsId, ele.payModeId, null, null, null, null, false, ele.payId);
              this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
                if (res.Success) {
                  this.voidCCRCM(ele.payId, res.Id, paymentTrnsId);
                }
              });
            }
          }
        } else if (ele.payModeId == EPaymentModes.HostedPage && ele.isEmvVoidInitiated) { //Void CC CNP
          if (this.paymentGateway == EPaymentGateway.TdBank) {
            if (this.tdResponseObj && ele.payComplete) {
              let amount = this.paymentTable.find(o => o.payId == ele.payId)['processedTDCC'].trnAmount;
              let transactionId = this.paymentTable.find(o => o.payId == ele.payId)['processedTDCC'].trnId;
              let CCTModel = this.generateIntialCCT(amount, EPaymentTransactionType.Reversal_Refund, paymentTrnsId, ele.payModeId, null, null, null, null, false, ele.payId);
              this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
                this.voidTdPayment(res.Id, ele.payModeId, amount, transactionId, paymentTrnsId);
              });
            }
          } else {
            if (ele.payComplete) {
              let amount = this.paymentTable.find(o => o.payId == ele.payId)['processedCNPCC'].APPROVEDAMOUNT;
              let CCTModel = this.generateIntialCCT(amount, EPaymentTransactionType.Reversal_Refund, paymentTrnsId, ele.payModeId, null, null, null, null, false, ele.payId);
              this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
                this.voidCCCNP(ele.payId, res.Id, ele.payModeId, paymentTrnsId);
              });
            }
          }
        } else if (ele.payModeId == EPaymentModes.ManualAuthorization && ele.isEmvVoidInitiated) { //Void Manual Authorzation
          this.isCancel.emit(true);
          let amount = this.paymentTable.find(o => o.payId == ele.payId).payAmount;
          let ccNo = this.paymentTable.find(o => o.payId == ele.payId).ManualCardNumber;
          let ccExpiry = this.paymentTable.find(o => o.payId == ele.payId).ManualCardExp;
          let ccName = this.paymentTable.find(o => o.payId == ele.payId).ManualCardName;
          let creditCardType = this.paymentTable.find(o => o.payId == ele.payId).CreditCardType;
          let authrizationCode = this.paymentTable.find(o => o.payId == ele.payId).ManualCardAuthorization;
          let CCTModel = this.manulAuthorizationCCT(amount, ccNo, ccName, creditCardType, authrizationCode, ccExpiry, paymentTrnsId, ele.payModeId);
          if (ele.payComplete) {
            this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
              this.showLoaderMesage = false;
              this.loaderIcon = Promise.resolve(false);
            });
          }
        } else if (ele.payModeId == EPaymentModes.CardOnfile && ele.isEmvVoidInitiated) { //Void Card On File
          let amount = ele.payAmount;
          if (ele.payComplete) {
            let transactionId = this.paymentTable.find(o => o.payId == ele.payId)['processedCC'].AuthorizationCode;
            let CCTModel = this.generateIntialCCT(amount, EPaymentTransactionType.Reversal_Refund, paymentTrnsId, ele.payModeId, null, null, null, null, false, ele.payId);
            this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
              if (this.paymentGateway == EPaymentGateway.TdBank) {
                this.voidTdPayment(res.Id, ele.payModeId, amount, transactionId, paymentTrnsId);
              } else {
                this.voidCCCNP(ele.payId, res.Id, ele.payModeId, paymentTrnsId);
              }
            });
          }
        } else {
          if (this.multiPaymentVoidEmv.length == 0) {
            this.loaderIcon = Promise.resolve(false);
            this.isCancel.emit(true); // For other payment modes(Cash)
            this.showLoaderMesage = false;
          }
        }
        this.toastr.success('Refund is Initiated', 'Success', this.toasterConfig);
      }
    });

    this.onPaymentCancel();
    this.voidOnCancelInitiated = false;
  }

  disableCancelButton() {
    if (this.paymentTable.some(ele => ele.payFailed)) {
      return false;
    } else if (this.paymentStarted) {
      return true;
    } else {
      return false;
    }
  }

  disableNextButton() {
    if (!this.processPayment.requireFullPayment && this.paymentTable.some(ele => ele.payFailed) && this.paymentTable.some(ele => ele.payComplete)) {
      if (this.processPayment.Type == EPaymentOrigin.Merchandise) {
        let sum = this.paymentTable.reduce((sum, a) => a.payComplete ? sum + (this.isString(a.payAmount) ? parseFloat(a.payAmount) : a.payAmount) : sum + 0, 0);
        if (sum >= this.processPayment.AmountTobePaid) {
          this.partialPaySuccess = true;
          return false;
        } else {
          this.partialPaySuccess = false;
          return true;
        }
      } else if (!this.processPayment.requireFullPayment && this.paymentTable.some(ele => ele.payFailed || ele.payComplete)) {
        this.partialPaySuccess = false;
        return false;
      } else {
        this.partialPaySuccess = true;
        return false;
      }
    } else if (this.processPayment.requireFullPayment && this.paymentTable.some(ele => ele.payFailed) && this.paymentTable.some(ele => ele.payComplete) &&
      this.checkIfFullAmountPaid()) {
      this.partialPaySuccess = true;
      return false;
    } else if (!this.showPrintEmailRcpt) {
      this.partialPaySuccess = false;
      return true;
    } else {
      this.partialPaySuccess = false;
      return false;
    }
  }
  checkIfFullAmountPaid() {
    if (this.isCurrentPeriodAmountAdded()) {
      let sum = this.paymentTable.reduce((sum, a) => a.payComplete ? sum + (this.isString(a.payAmount) ? parseFloat(a.payAmount) : a.payAmount) : sum + 0, 0);
      if ([EPaymentOrigin.Rental, EPaymentOrigin.Transfer, EPaymentOrigin.MakePayment].includes(this.processPayment.Type)) {
        if (sum >= this.processPayment.currentPeriodTotalAmount.toFixed(2)) {
          return true;
        } else {
          return false;
        }
      } else {
        if (sum >= this.processPayment.AmountTobePaid.toFixed(2)) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  }

  getDayendSettings(facId) {
    this.prospectSerice.GetFacilityDayEndSettings(facId).subscribe((response) => {
      this.dayendSettingDetails = response;
    });
  }


  isCurrentPeriodAmountAdded() {
    let currentPeriodAmountAdded = false;
    if (parseFloat(this.remainingAmount) > 0) {
      let addedAmount = this.paymentTable.reduce((sum, a) => sum + (this.isString(a.payAmount) ? parseFloat(a.payAmount) : a.payAmount), 0);
      if (addedAmount >= this.processPayment.currentPeriodTotalAmount.toFixed(2)) {
        currentPeriodAmountAdded = true;
      }
    } else {
      currentPeriodAmountAdded = true;
    }
    return currentPeriodAmountAdded;
  }

  openEdgeTransactionStatus(OrderId, payId, transactionType, paymentTrnsId) { //calling from Original Request
    this.paymentService.GetCreditCardTransactionById(OrderId).subscribe((cctResponse: any) => {
      let res: any;
      try {
        res = JSON.parse(cctResponse);
      } catch {
        this.loaderIcon = Promise.resolve(false);
        if (transactionType == 'Void') {
          this.failPendingOpenEdgeMismatchVoid(payId);
        }
        return;
      }
      if (res.Reason == "Attempting to Process") {
        this.initiatingOpenEdgeQueryPaymentRequest(OrderId, transactionType, paymentTrnsId, payId, true)
      } else {
        this.paymentFailReason = "Please Contact Administrator to check in Gateway Portal if Payment is Approved. If Yes, key in the Payment as Manual Authorization";
        this.saveCCTransactionFailureCase(this.tempRcmRes.rcmResponse, this.paymentFailReason, transactionType, paymentTrnsId, OrderId, payId);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
      if (transactionType == 'Void') {
        this.failPendingOpenEdgeMismatchVoid(payId);
      }
    });
  }

  /**
   * The gateway status query for a timed-out mismatch reversal (callOpenEdgeVoid) failed before reaching a terminal
   * result: the void can't be confirmed, so end the pending alert as unconfirmed instead of leaving it blocked.
   * No-op for any other void (finishOpenEdgeMismatchVoid only acts on a pending mismatch row).
   */
  private failPendingOpenEdgeMismatchVoid(payId: any): void {
    const orderId = this.paymentTable.find(o => o.payId == payId)?.orderId;
    const voidEntry = this.multiPaymentVoidEmv.find(t => t.orderId === orderId);
    if (voidEntry) {
      this.finishOpenEdgeMismatchVoid(voidEntry, false);
    }
  }

  getOpenEdgeTransactionStatus(orderId, payId, count, transactionType, paymentTrnsId) {
    count = count + 1; //count start from 0
    let maxTime = (this.paymentMaxWaitTime * 60) / this.paymentGetCCTStatusInterval;
    if (count > maxTime) {
      this.cancelRcmRequest(this.tempRcmRes.rcmSessionId, false);
      this.retryTransactionStatusLoader = false;
      this.paymentFailReason = "Payment Status not received. Please Contact Administrator to check in Gateway Portal if Payment is Approved. If Yes, key in the Payment as Manual Authorization";
      if (this.openEdgeSub) {
        this.openEdgeSub.unsubscribe();
        this.openEdgeSub = null;
      }
      this.paymentTable.find(o => o.payId === payId).payFailed = true;
      this.saveCCTransactionFailureCase(this.tempRcmRes.rcmResponse, this.paymentFailReason, transactionType, paymentTrnsId, orderId, payId);
    } else {
      this.initiatingOpenEdgeQueryPaymentRequest(orderId, transactionType, paymentTrnsId, payId, false)
    }
  }

  initiatingOpenEdgeQueryPaymentRequest(orderId, transactionType, paymentTrnsId, payId, callRetryLogic) {
    if (this.credentials) {
      this.paymentService.getCNPResponse(this.credentials, orderId).subscribe((res: any) => {
        const jsonResp = JSON.parse(res);
        this.showLoaderMesage = false;
        this.tempRcmRes.rcmResponse = jsonResp;
        let amount;
        if (this.cctStatusOrderId == 0) {//To avoid Duplicate Save APi call
          if (jsonResp.RESULT && jsonResp.RESULT.RESPONSECODE == EOpenEdgeResponseCode.Approval && jsonResp.RESULT.STATE != 'IN_PROGRESS') {
            this.cctStatusOrderId = jsonResp.RESULT.ORDERID;
            if (this.openEdgeSub) {
              this.openEdgeSub.unsubscribe();
              this.openEdgeSub = null;
            }
            this.retryTransactionStatusLoader = false;
            if (transactionType == 'Void') {
              const CCModel = {
                Amount: jsonResp.RESULT.APPROVEDAMOUNT,
                Autopay: false,
                paymentModeId: EPaymentModes.CreditCard,
                AutoCcProcessingDay: 0,
                CreditCardNumber: jsonResp.RESULT.MASKEDCARDNUMBER == undefined ? 0 : jsonResp.RESULT.MASKEDCARDNUMBER,
                CreditCardType: jsonResp.RESULT && jsonResp.RESULT.CARDBRAND ? this.paymentService.openEdgeCardType(jsonResp.RESULT.CARDBRAND) : ECreditCards.Visa,
                NameonCard: this.autoPayInfo && this.autoPayInfo.NameonCard ? this.autoPayInfo.NameonCard : '',
                CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(jsonResp.RESULT.EXPMONTH, 10)),
                CreditCardExpiryYear: parseInt(jsonResp.RESULT.EXPYEAR, 10),
                CreditCardBillingAddress: this.autoPayInfo && this.autoPayInfo.CreditCardBillingAddress ? this.autoPayInfo.CreditCardBillingAddress : '',
                CreditCardBillingZip: this.autoPayInfo && this.autoPayInfo.CreditCardBillingZip ? this.autoPayInfo.CreditCardBillingZip : '',
                SwipeTransaction: false,
                SecurityCodeSent: false,
                AuthorizationCode: jsonResp.RESULT.TRANSACTIONID,
                ResponseCode: jsonResp.RESULT.RESPONSECODE,
                Reason: jsonResp.RESULT.RESPONSEDESCRIPTION,
                Key: '',
                PaymentAccountid: '',
                CcInfoPurged: false,
                DebitCardPayment: jsonResp.RESULT.CARDTYPE == 'Credit' ? false : true,
                OfflinePayment: 0,
                PaymentTransactionTypeId: paymentTrnsId,
                OrderId: orderId,
                FacilityId: this.processPayment.facId,
                TransactionDateTime: new Date(),
                TransactionTypeId: EPaymentTransactionType.Reversal_Refund, //Reversal
                TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
                TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
                CCBatchNumber: jsonResp.RESULT.BATCHNO ? jsonResp.RESULT.BATCHNO : null
              };
              this.paymentService.saveCCTransaction(Object.assign(CCModel)).subscribe((res: any) => { });
              this.retryTransactionStatusLoader = false;
              const voidEntry = this.multiPaymentVoidEmv.find(t => t.orderId === (this.paymentTable.find(o => o.payId == payId)?.orderId));
              if (voidEntry) {
                voidEntry.isEmvVoidInitiated = true;
                this.finishOpenEdgeMismatchVoid(voidEntry, true); // mismatch reversal confirmed by the status query
              }
              if (this.multiPaymentVoidEmv.some(function (ele) { return (ele.isEmvVoidInitiated == false); })) {
                this.callOpenEdgeVoid(paymentTrnsId);
              } else {
                if (!this.voidOnCancelInitiated && !this._isMismatchVoid) {
                  this.isCancel.emit(true);
                }
                this.loaderIcon = Promise.resolve(false);
              }
            } else {
              this.payStatus = 'Success';
              this.paymentSuccessFul = true;
              this.paymentTable.find(o => o.payId == payId).payFailed = false;
              this.paymentTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted = true;
              amount = parseFloat(jsonResp.RESULT.APPROVEDAMOUNT).toFixed(2);
              jsonResp.RESULT['OrderId'] = jsonResp.RESULT && jsonResp.RESULT.ORDERID ? jsonResp.RESULT.ORDERID : orderId;
              jsonResp.RESULT['CARDHOLDERNAME'] = jsonResp.RESULT.CARDBRAND;
              jsonResp.RESULT['ACCOUNT'] = jsonResp.RESULT.MASKEDCARDNUMBER;
              jsonResp.RESULT['HOSTRESPONSECODE'] = jsonResp.RESULT.RESPONSECODE;
              jsonResp.RESULT['HOSTRESPONSEDESCRIPTION'] = jsonResp.RESULT.ORIGINALRESPONSEDESCRIPTION;
              // QUERYPAYMENT may omit TRANSACTIONTYPE; record the type that was sent (drives the saved debit flag and cancel-time void).
              jsonResp.RESULT.TRANSACTIONTYPE = jsonResp.RESULT.TRANSACTIONTYPE || this.paymentTable.find(o => o.payId == payId).openEdgeSaleType;
              this.paymentTable.find(o => o.payId == payId)['processedCC'] = jsonResp.RESULT;
              this.loaderIcon = Promise.resolve(false);
              if (!this.rejectOpenEdgeMismatchedApproval(payId, jsonResp.RESULT, paymentTrnsId)) {
                this.gotoPaymentSuccess(this.popUpPayment, amount);
              }
            }
            this.getRCMStatus(orderId, true);
          } else if (jsonResp.RESULT && jsonResp.RESULT.STATE != 'IN_PROGRESS' && (jsonResp.RESULT.RESPONSECODE != EOpenEdgeResponseCode.TransactionDoesNotExist && jsonResp.RESULT.RESPONSEDESCRIPTION != 'Invalid Reference Error: Transaction does not exist')) {
            this.retryTransactionStatusLoader = false;
            let reason = ((jsonResp.RESULT.RESPONSECODE != EOpenEdgeResponseCode.TransactionDoesNotExist && jsonResp.RESULT.RESPONSEDESCRIPTION != 'Invalid Reference Error: Transaction does not exist') || jsonResp.RESULT.ORDERID == orderId) ? jsonResp.RESULT.RESPONSEDESCRIPTION : "Transaction Cancelled";
            if (this.openEdgeSub) {
              this.openEdgeSub.unsubscribe();
              this.openEdgeSub = null;
            }
            this.paymentFailReason = reason;
            this.saveCCTransactionFailureCase(jsonResp, reason, transactionType, paymentTrnsId, orderId, payId);
            this.getRCMStatus(orderId, false);
            this.loaderIcon = Promise.resolve(false);
          } else if (callRetryLogic) {
            this.paymentService.GetCreditCardTransactionById(orderId).subscribe((cctResponse: any) => {
              let res = JSON.parse(cctResponse);
              if (!this.openEdgeSub && res.Reason == "Attempting to Process") {
                this.cctStatusOrderId = 0;
                this.retryTransactionStatusLoader = true;
                let intervalTime = this.paymentGetCCTStatusInterval * 1000;
                const source = interval(intervalTime);
                this.openEdgeSub = source.subscribe(val => this.getOpenEdgeTransactionStatus(orderId, payId, val, transactionType, paymentTrnsId));
              } else {
                this.paymentTable.find(o => o.payId == payId).payFailed = true;
                this.paymentFailReason = "Please Contact Administrator to check in Gateway Portal if Payment is Approved. If Yes, key in the Payment as Manual Authorization";
                this.saveCCTransactionFailureCase(jsonResp, this.paymentFailReason, transactionType, paymentTrnsId, orderId, payId);
              }
            }, () => {
              this.retryTransactionStatusLoader = false;
              this.loaderIcon = Promise.resolve(false);
              if (transactionType == 'Void') {
                this.failPendingOpenEdgeMismatchVoid(payId);
              }
            });
          } else {
            this.paymentService.getRCMServiceStatus(null, orderId, false).subscribe((sessionRes: any) => {
              if (sessionRes) {
                this.tempRcmRes.rcmSessionId = sessionRes.SessionId;
                if (sessionRes.SessionState == EOpenEdgeSessionStates.Completed && jsonResp.RESULT && jsonResp.RESULT.RESPONSECODE == EOpenEdgeResponseCode.TransactionDoesNotExist && jsonResp.RESULT.RESPONSEDESCRIPTION == 'Invalid Reference Error: Transaction does not exist') {
                  this.retryTransactionStatusLoader = false;
                  if (this.openEdgeSub) {
                    this.openEdgeSub.unsubscribe();
                    this.openEdgeSub = null;
                  }
                  this.paymentFailReason = "Declined!";
                  jsonResp.RESULT.RESPONSEDESCRIPTION = jsonResp.RESULT.RESPONSEDESCRIPTION + " : RCM Session Completed!";
                  this.paymentTable.find(o => o.payId == payId).payFailed = true;
                  this.saveCCTransactionFailureCase(jsonResp, this.paymentFailReason, transactionType, paymentTrnsId, orderId, payId);
                }
              }
            });
          }
        }
      }, err => {
        this.paymentTable.find(o => o.payId === payId).payFailed = true;
        this.paymentTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted = true;
        this.prePayStatus = 'Payment';
        this.payStatus = 'Failed!';
        this.paymentFailReason = "Payment Status not received. Please Contact Administrator to check in Gateway Portal if Payment is Approved. If Yes, key in the Payment as Manual Authorization";
        this.loaderIcon = Promise.resolve(false);
        if (this.openEdgeSub) {
          this.openEdgeSub.unsubscribe();
          this.openEdgeSub = null;
        }
        this.saveCCTransactionFailureCase({ PaymentModeId: this.paymentTable.find(o => o.payId === payId)?.payModeId }, this.paymentFailReason, transactionType, paymentTrnsId, orderId, payId);
      });
    } else {
      this.toastr.warning('Please ask Administrator to configure RCM URL', 'URL required', this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
    }
  }

  getRCMStatus(orderId, transactinSuccess) {
    this.paymentService.getRCMServiceStatus(null, orderId, false).subscribe((sessionRes: any) => {
      if (sessionRes) {
        if (sessionRes.SessionState == EOpenEdgeSessionStates.PromptingForCardRemoval) {
          this.toastr.warning('Please Remove Your Card From EMV Device', 'Alert', this.toasterConfig);
        }
        this.cancelRcmRequest(sessionRes.SessionId, transactinSuccess);
      }
    });
  }

  cancelRcmRequest(sessionId, isTransactionSuccess) {
    this.paymentService.getRCMServiceStatus(sessionId, 0, true).subscribe((respose: any) => {
      if (!respose.IsSuccessful && !isTransactionSuccess) {
        this.toastr.warning('Please click on Cancel Button in the EMV Device, if it is not in Home Screen. Ignore if already in Home Screen', 'Alert', this.toasterConfig);
      }
    });
  }

  cnpTransactionStatus(uniqueTransOrderId, count, orderId, transactionType, paymentTrnsId) {
    count = count + 1;
    let maxTime = (this.paymentMaxWaitTime * 60) / this.paymentGetCCTStatusInterval;
    this.paymentService.getCNPResponse(this.credentials, uniqueTransOrderId).subscribe((res: any) => {
      if (res) {
        const jsonResp = JSON.parse(res);
        jsonResp['PaymentModeId'] = EPaymentModes.HostedPage;
        this.tempCNPRes = jsonResp;
        this.prePayStatus = 'Payment';
        let amount;
        if (jsonResp.RESULT && jsonResp.RESULT.RESPONSECODE != EOpenEdgeResponseCode.TransactionDoesNotExist && jsonResp.RESULT.RESPONSEDESCRIPTION != 'Invalid Reference Error: Transaction does not exist' && jsonResp.RESULT.STATE != 'IN_PROGRESS') {
          this.loaderIcon = Promise.resolve(false);
          if (this.subOpenEdgeHostedpage) {
            this.subOpenEdgeHostedpage.unsubscribe();
            this.subOpenEdgeHostedpage = null;
          }
          if (this.cctStatusOrderId != jsonResp.RESULT.ORDERID) {
            if (jsonResp.RESULT && jsonResp.RESULT.RESPONSECODE == EOpenEdgeResponseCode.Approval && jsonResp.RESULT.ORDERID == uniqueTransOrderId) {
              this.cctStatusOrderId = jsonResp.RESULT.ORDERID;
              this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = false;
              this.retryTransactionStatusLoader = false;
              if (transactionType == 'Void') {
                if (!this.voidOnCancelInitiated) {
                  this.isCancel.emit(true);
                }
                const CCTModel = {
                  Amount: jsonResp.RESULT.APPROVEDAMOUNT,
                  Autopay: false,
                  paymentModeId: EPaymentModes.HostedPage,
                  AutoCcProcessingDay: 0,
                  CreditCardNumber: jsonResp.RESULT.MASKEDCARDNUMBER == undefined ? 0 : jsonResp.RESULT.MASKEDCARDNUMBER,
                  CreditCardType: jsonResp.RESULT && jsonResp.RESULT.CARDBRAND ? this.paymentService.openEdgeCardType(jsonResp.RESULT.CARDBRAND) : ECreditCards.Visa,
                  NameonCard: this.autoPayInfo && this.autoPayInfo.NameonCard ? this.autoPayInfo.NameonCard : '',
                  CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(jsonResp.RESULT.EXPMONTH, 10)),
                  CreditCardExpiryYear: parseInt(jsonResp.RESULT.EXPYEAR, 10),
                  CreditCardBillingAddress: this.autoPayInfo && this.autoPayInfo.CreditCardBillingAddress ? this.autoPayInfo.CreditCardBillingAddress : '',
                  CreditCardBillingZip: this.autoPayInfo && this.autoPayInfo.CreditCardBillingZip ? this.autoPayInfo.CreditCardBillingZip : '',
                  SwipeTransaction: false,
                  SecurityCodeSent: false,
                  AuthorizationCode: jsonResp.RESULT.TRANSACTIONID,
                  ResponseCode: jsonResp.RESULT.RESPONSECODE,
                  Reason: jsonResp.RESULT.RESPONSEDESCRIPTION,
                  Key: '',
                  PaymentAccountid: '',
                  CcInfoPurged: false,
                  DebitCardPayment: jsonResp.RESULT.CARDTYPE == 'Credit' ? false : true,
                  OfflinePayment: 0,
                  PaymentTransactionTypeId: paymentTrnsId,
                  OrderId: orderId,
                  FacilityId: this.processPayment.facId,
                  TransactionDateTime: new Date(),
                  TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
                  TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
                  LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
                  TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
                  CCBatchNumber: jsonResp.RESULT.BATCHNO ? jsonResp.RESULT.BATCHNO : null
                };
                this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
                this.loaderIcon = Promise.resolve(false);
              } else {
                this.showIFrame = false;
                this.showPage = !this.showIFrame;
                this.paymentSuccessFul = true;
                this.payStatus = 'Success';
                this.disableNextButton();
                this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = false;
                amount = parseFloat(jsonResp.RESULT.APPROVEDAMOUNT).toFixed(2);
                this.paymentTable.find(o => o.payId == this.currentPayId)['processedCNPCC'] = jsonResp.RESULT;
                this.gotoPaymentSuccess(this.popUpPayment, amount);
              }
            } else {
              this.showIFrame = false;
              this.showPage = !this.showIFrame;
              this.payStatus = 'Failed';
              this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
              this.isAnyPaymentProcessed();
              this.paymentFailReason = count >= maxTime ? "Payment Status not received. Please Contact Administrator to check in Gateway Portal if Payment is Approved. If Yes, key in the Payment as Manual Authorization" : jsonResp.RESULT.RESPONSEDESCRIPTION;
              amount = 0;
              this.saveCCTransactionFailureCase(jsonResp, jsonResp.RESULT.RESPONSEDESCRIPTION, transactionType, paymentTrnsId, orderId);
              this.loaderIcon = Promise.resolve(false);
              if (jsonResp.RESULT.RESPONSECODE && jsonResp.RESULT.RESPONSECODE == EOpenEdgeResponseCode.ImproperFieldData) {
                if (jsonResp.RESULT.RESPONSEDESCRIPTION) {
                  jsonResp.RESULT.RESPONSEDESCRIPTION = jsonResp.RESULT.RESPONSEDESCRIPTION + '. ' + 'Customer Name should be less than 50 characters!'
                  this.toastr.warning(jsonResp.RESULT.RESPONSEDESCRIPTION, 'Warning', this.toasterConfig);
                }
              }
            }
          }
        } else if (count >= maxTime && this.cctStatusOrderId != uniqueTransOrderId) {
          this.cctStatusOrderId = uniqueTransOrderId;
          if (this.subOpenEdgeHostedpage) {
            this.subOpenEdgeHostedpage.unsubscribe();
            this.subOpenEdgeHostedpage = null;
          }
          this.paymentStarted = false;
          this.toastr.error('Payment Failed', 'Failure');
          this.isAnyPaymentProcessed();
          this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
          this.payStatus = 'Failed';
          this.showIFrame = false;
          this.showPage = !this.showIFrame;
          this.paymentFailReason = 'Payment Status not received. Please Contact Administrator to check in Gateway Portal if Payment is Approved. If Yes, key in the Payment as Manual Authorization';
          this.saveCCTransactionFailureCase(jsonResp, this.paymentFailReason, transactionType, paymentTrnsId, orderId);
          this.loaderIcon = Promise.resolve(false);
        }
      }
    }, err => {
      if (count >= maxTime && this.cctStatusOrderId != uniqueTransOrderId) {
        if (this.subOpenEdgeHostedpage) {
          this.subOpenEdgeHostedpage.unsubscribe();
          this.subOpenEdgeHostedpage = null;
        }
        this.paymentStarted = false;
        this.toastr.error('Payment Failed', 'Failure');
        this.isAnyPaymentProcessed();
        this.paymentFailReason = 'Payment Status not received. Please Contact Administrator to check in Gateway Portal if Payment is Approved. If Yes, key in the Payment as Manual Authorization';
      }
      this.showIFrame = false;
      this.showPage = !this.showIFrame;
      this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
      this.tempCNPRes['PaymentModeId'] = EPaymentModes.HostedPage;
      this.saveCCTransactionFailureCase(this.tempCNPRes, this.paymentFailReason ? this.paymentFailReason : 'Declined!', transactionType, paymentTrnsId, orderId);
      this.loaderIcon = Promise.resolve(false);
    });
  }

  getFacilityInfoACH() {
    this.loaderIcon = Promise.resolve(true);
    this.facilityservice.getFacilityInfoACHForOp(this.processPayment.facId).subscribe((response: IFacilityInfoACH) => {
      if (response != null && response.GatewayDetails) {
        this.achSettingPaymentGateway = JSON.parse(response.GatewayDetails);
      }
      this.achgateway = response?.PaymentGateway ?? null;
      this.loaderIcon = Promise.resolve(false);
    });
  }

  callSimulatorePage(amount, orderId, paymentTrnsId) {
    this.achOrderNumber = orderId;
    if (this.achSettingPaymentGateway != null) {
      this.loaderIcon = Promise.resolve(true);
      this.requestParam =
        "<REQUEST>" +
        "<XWEBID>" + this.achSettingPaymentGateway.XWEBID + "</XWEBID>" +
        "<XWEBTERMINALID>" + this.achSettingPaymentGateway.XWEBTERMINALID + "</XWEBTERMINALID>" +
        "<XWEBAUTHKEY>" + this.achSettingPaymentGateway.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
        "<TRANSACTIONTYPE>CHECKSALE</TRANSACTIONTYPE>" +
        "<AMOUNT>" + amount + "</AMOUNT>" +
        "<ENTRYCLASS>PPD</ENTRYCLASS>" +
        "<ORDERID>" + orderId + "</ORDERID>" +
        "<HOSTPAYSETTING>" +
        "<DISABLEFRAMING>FALSE</DISABLEFRAMING>" +
        " <POSDEVICE>" +
        "<TYPE>KEYED</TYPE>" +
        "</POSDEVICE>" +
        "<CUSTOMIZATION>" +
        "<PAGE>" +
        "<BANKACCOUNTTYPE><EDIT>TRUE</EDIT><REQUIRED>TRUE</REQUIRED><VISIBLE>TRUE</VISIBLE></BANKACCOUNTTYPE>" +
        "<INVOICENUMBER><EDIT>FALSE</EDIT><REQUIRED>FALSE</REQUIRED><VISIBLE>FALSE</VISIBLE></INVOICENUMBER>" +
        "<PURCHASEORDERNUMBER><EDIT>FALSE</EDIT><REQUIRED>FALSE</REQUIRED><VISIBLE>FALSE</VISIBLE></PURCHASEORDERNUMBER>" +
        "<ORDERID><LABEL>ORDER ID</LABEL><VISIBLE>TRUE</VISIBLE></ORDERID>" +
        "<BRANDING>" +
        "<BODY>" +
        " <BACKGROUNDCOLOR>#FFFF00;</BACKGROUNDCOLOR>" +
        "<COLOR>#0F0F0F;</COLOR>" +
        "<FONTFAMILY>TIMES NEW ROMAN, HELVETICA-NEUE,HELVETICA,ARIAL,SANS-SERIF;</FONTFAMILY>" +
        "<FONTSIZE>18PX;</FONTSIZE>" +
        "<INPUTFIELDHEIGHT />" +
        "</BODY>" +
        "</BRANDING>" +
        "</PAGE>" +
        "</CUSTOMIZATION>" +
        "</HOSTPAYSETTING>" +
        "</REQUEST>";
      this.paymentService.getCNPService(this.achSettingPaymentGateway.CheckNotPresentURL, this.requestParam).subscribe((res: any) => {
        this.loaderIcon = Promise.resolve(false);
        const resultResponse = JSON.parse(res);
        this.achUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(resultResponse.RESULT.PAYPAGEURL);
        this.showAchIFrame = true;
        this.showPage = false
      }, err => {
        this.paymentStarted = false;
        this.loaderIcon = Promise.resolve(false);
        this.payStatus = 'Failed';
        this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
        this.saveAchTransactions(null, paymentTrnsId, EPaymentTransactionType.Declined, err.error && err.error.error ? err.error.error : null, this.currentPayId);
        this.toastr.warning('Please ask Administrator to configure ACH URL', 'URL required', this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
      }
      );
    } else {
      this.loaderIcon = Promise.resolve(false);
      this.payStatus = 'Failed';
      this.paymentSuccessFul = false;
      this.saveAchTransactions(null, paymentTrnsId, EPaymentTransactionType.Declined, 'Declined! - Wrong ACH configuration', this.currentPayId);
      this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
      this.toastr.warning('Please ask Administrator to configure ACH URL', 'URL required', this.toasterConfig);
      this.gotoPaymentSuccess(this.popUpPayment, 0);
    }
  }

  getACHHiddenInput() {
    this.hstPayBtnMsg = 'Cancel';
    let iframeSrc = this.iframeAch.nativeElement.src.split('/');
    let tempId = iframeSrc.pop();
    if (this.sessionId === tempId) {
      this.hstPayBtnMsg = 'OK';
      this.sessionId = tempId;
      let amount;
      let paymentTrnsId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
      this.paymentService.GetACHResponse(this.achOrderNumber, this.achSettingPaymentGateway).subscribe((res: any) => {
        const jsonResp = JSON.parse(res);
        if (jsonResp) {
          console.log('jsonResp', jsonResp);
          this.showAchIFrame = false;
          this.showPage = !this.showAchIFrame;
          this.prePayStatus = 'Payment';
          if (jsonResp.RESULT.RESPONSECODE == EACHCheckResultCode.Check_Submitted && jsonResp.RESULT.RESPONSEDESCRIPTION == "Check Submitted") {
            this.payStatus = 'Success';
            this.paymentSuccessFul = true;
            this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = false;
            amount = parseFloat(jsonResp.RESULT.APPROVEDAMOUNT).toFixed(2);
            this.paymentTable.find(o => o.payId == this.currentPayId)['processedACH'] = jsonResp.RESULT;
          } else {
            this.payStatus = 'Failed';
            this.paymentSuccessFul = false;
            amount = 0;
            this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
            this.paymentFailReason = jsonResp.RESULT.RESPONSEDESCRIPTION ? jsonResp.RESULT.RESPONSEDESCRIPTION : "Declined!";
            this.saveAchTransactions(jsonResp.RESULT, paymentTrnsId, EPaymentTransactionType.Declined, null, this.currentPayId);
            this.toastr.error('Payment Failed', 'Failure');
          }
          this.gotoPaymentSuccess(this.popUpPayment, amount);
        }
      }, err => {
        this.showAchIFrame = false;
        this.showPage = !this.showAchIFrame;
        this.loaderIcon = Promise.resolve(false);
        this.payStatus = 'Failed';
        this.paymentSuccessFul = false;
        this.gotoPaymentSuccess(this.popUpPayment, 0);
        this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
        this.saveAchTransactions(null, paymentTrnsId, EPaymentTransactionType.Declined, null, this.currentPayId);
        this.paymentFailReason = "Declined!";
        this.toastr.error('Payment Failed', 'Failure');
      });
    } else {
      this.sessionId = tempId;
    }
  }

  saveInACH(amount, payId, transactionType) {
    let payModeId = this.paymentTable.find(o => o.payId === payId).payModeId;
    this.requestGatewaydetails(payModeId, payId);
    let paymentTrnsId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
    let achModel = this.generateIntialACH(amount, transactionType, paymentTrnsId, payModeId);
    this.paymentService.saveACHTransaction(achModel).subscribe((res) => {
      if (res.Success) {
        this.paymentTable.find(o => o.payId == payId).orderId = res.Id;
        this.paymentTable.find(o => o.payId == payId).uniqueTransId = res.UniqueTransId;
        if (payModeId == EPaymentModes.ACH || payModeId == EPaymentModes.DirectDebitEFT) {
          if (this.paymentGateway == EPaymentGateway.Stripe && this.achgateway == EACHPaymentGateway.Stripe) {
            this.selectedPaymentMode = payModeId;
            this.achOrderId = res.Id;
            if ([EPaymentOrigin.MakePayment, EPaymentOrigin.ReInstate, EPaymentOrigin.Rental, EPaymentOrigin.Transfer].includes(this.processPayment.Type) && this.isAutopayEnabled()) {
              this.loaderIcon = Promise.resolve(false);
              if (payModeId == EPaymentModes.ACH) {
                this.autopayHeader = "Enable Autopay or ACH on File?";
                this.autopayMessage = "Do you want to enable Autopay or ACH on File for the details used to Pay Now?";
                this.autopayFooter = "Enable ACH on File";
              }
              else {
                this.autopayHeader = "Enable Autopay or EFT on File?";
                this.autopayMessage = "Do you want to enable Autopay or EFT on File for the details used to Pay Now?";
                this.autopayFooter = "Enable EFT on File";
              }
              this.enableAutopayOrCardOnFile = this.modalService.show(this.SelectAutopayorCardOnFile, { class: 'modal-medium modal-dialog-centered', backdrop: 'static', keyboard: false });
            } else {
              this.createPaymentIntent(amount, payModeId, payId);
            }

          } else {// open edge gateway
            this.callSimulatorePage(amount, res.UniqueTransId, paymentTrnsId);
          }
        } else if (payModeId == EPaymentModes.ACHOnFile || payModeId == EPaymentModes.DirectDebitEFTOnFile) {
          if (this.paymentGateway == EPaymentGateway.Stripe) {
            this.OnFileStripe(amount, res, payId, paymentTrnsId, payModeId);
          } else {
            this.callAChOnFile(amount, paymentTrnsId, res.UniqueTransId);
          }
        }
      } else {
        this.loaderIcon = Promise.resolve(false);
        this.paymentStarted = false;
        this.toastr.error("We couldn't create ACH Transaction, Please try again!", 'Failure', this.toasterConfig);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
      this.paymentStarted = false;
      this.toastr.error(' Something went wrong!', 'Failure', this.toasterConfig);
    });
  }

  generateIntialACH(amount, transactionType, paymentTrnsId, payModeId) {
    const ACHModel = {
      Amount: amount,
      Autopay: false,
      paymentModeId: payModeId,
      AutoACHProcessingDay: 0,
      AchAccountNumber: 0,
      AchRoutingNumber: 0,
      AccountClass: 277,
      AchAccountType: EACHAccountType.Checking,
      SwipeTransaction: false,
      AutoAchPayment: false,
      AuthorizationCode: 0,
      ResponseCode: '0',
      Reason: 'Attempting to Process',
      CcInfoPurged: false,
      OfflinePayment: false,
      ACHInfoPurged: false,
      PaymentTransactionTypeId: paymentTrnsId,
      OrderId: null,
      FacilityId: this.processPayment.facId,
      TransactionDateTime: new Date(),
      TransactionTypeId: transactionType,
      LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
      TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
      GatewayDetails: this.requestgatewaydetails
    };
    return Object.assign(ACHModel);
  }

  callAChOnFile(amount, paymentTrnsId, achOrderId) {
    if (this.achSettingPaymentGateway) {
      this.achOrderNumber = achOrderId;
      let achPaymentAliasKey = "";
      let accounType = "";

      if ([EPaymentOrigin.Rental, EPaymentOrigin.Transfer, EPaymentOrigin.MakePayment, EPaymentOrigin.ReInstate].includes(this.processPayment.Type) && this.facOpsDataService && this.facOpsDataService.saveautopay) {
        achPaymentAliasKey = this.facOpsDataService.saveautopay.ACHPaymentAccountId;
        accounType = this.facOpsDataService.saveautopay.ACHAccountType == EACHAccountType.Savings ? 'SAVINGS' : 'CHECKING';
      } else {
        achPaymentAliasKey = this.autoPayInfo && this.autoPayInfo.ACHPaymentAccountId ? this.autoPayInfo.ACHPaymentAccountId : "";
        accounType = this.autoPayInfo && this.autoPayInfo.ACHAccountType == EACHAccountType.Savings ? 'SAVINGS' : 'CHECKING';
      }
      var aliaseRequest = "<REQUEST>" +
        "<XWEBID>" + this.achSettingPaymentGateway.XWEBID + "</XWEBID>" +
        "<XWEBTERMINALID>" + this.achSettingPaymentGateway.XWEBTERMINALID + "</XWEBTERMINALID>" +
        "<XWEBAUTHKEY>" + this.achSettingPaymentGateway.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
        "<TRANSACTIONTYPE>CHECKSALE</TRANSACTIONTYPE>" +
        "<AMOUNT>" + amount + "</AMOUNT>" +
        "<ENTRYCLASS>PPD</ENTRYCLASS>" +
        "<BANKACCOUNTTYPE>" + accounType + "</BANKACCOUNTTYPE>" +
        "<ORDERID>" + this.achOrderNumber + "</ORDERID>" +
        "<ALIAS>" + achPaymentAliasKey + "</ALIAS>" +
        "</REQUEST>";
      this.paymentService.getCNPService(this.achSettingPaymentGateway.QueryPaymentStatusURL, aliaseRequest).subscribe((res: any) => {
        if (res) {
          const jsonResp = JSON.parse(res);
          this.prePayStatus = 'Payment';
          this.disableNextButton();
          if (jsonResp.RESULT.RESPONSECODE == EACHCheckResultCode.Check_Submitted && jsonResp.RESULT.RESPONSEDESCRIPTION == "Check Submitted") {
            this.payStatus = 'Success';
            this.loaderIcon = Promise.resolve(false);
            this.paymentSuccessFul = true;
            this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = false;
            amount = parseFloat(jsonResp.RESULT.APPROVEDAMOUNT).toFixed(2);
            this.paymentTable.find(o => o.payId == this.currentPayId)['processedACH'] = jsonResp.RESULT;
            this.paymentTable.find(o => o.payId == this.currentPayId)['processedACH'].PaymentAccountId = achPaymentAliasKey;
            this.paymentTable.find(o => o.payId == this.currentPayId)['processedACH'].ACCOUNTYPE = (accounType == 'SAVINGS' ? EACHAccountType.Savings : EACHAccountType.Checking);
          } else {
            amount = 0;
            this.payStatus = 'Failed';
            this.paymentSuccessFul = false;
            this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
            this.paymentFailReason = jsonResp.RESULT.RESPONSEDESCRIPTION ? jsonResp.RESULT.RESPONSEDESCRIPTION : "Declined!";
            this.saveAchTransactions(jsonResp.RESULT, paymentTrnsId, EPaymentTransactionType.Declined, null, this.currentPayId);
            this.toastr.error('Payment Failed', 'Failure');
            this.loaderIcon = Promise.resolve(false);
          }
          this.gotoPaymentSuccess(this.popUpPayment, amount);
        }
      }, err => {
        this.loaderIcon = Promise.resolve(false);
        this.payStatus = 'Failed';
        this.paymentSuccessFul = false;
        this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
        this.saveAchTransactions(null, paymentTrnsId, EPaymentTransactionType.Declined, err.error && err.error.error ? err.error.error : null, this.currentPayId);
        this.paymentFailReason = "Declined!";
        this.toastr.error('Payment Failed', 'Failure');
        this.gotoPaymentSuccess(this.popUpPayment, 0);
      });
    } else {
      this.loaderIcon = Promise.resolve(false);
      this.payStatus = 'Failed';
      this.paymentSuccessFul = false;
      this.saveAchTransactions(null, paymentTrnsId, EPaymentTransactionType.Declined, 'Declined! - Wrong ACH configuration', this.currentPayId);
      this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
      this.toastr.warning('Please ask Administrator to configure ACH URL', 'URL required', this.toasterConfig);
      this.gotoPaymentSuccess(this.popUpPayment, 0);
    }
  }

  saveAchTransactions(achResponse, paymentTrnsId, transactionType, reason, payId) {
    this.loaderIcon = Promise.resolve(false);
    const achModel = {
      Amount: achResponse && achResponse.APPROVEDAMOUNT ? parseFloat(achResponse.APPROVEDAMOUNT).toFixed(2) : this.amountToPay,
      Autopay: false,
      paymentModeId: this.paymentTable.find(o => o.payId == payId).payModeId,
      AutoACHProcessingDay: 0,
      AchAccountNumber: achResponse && achResponse.ACCOUNT ? achResponse.ACCOUNT : "0",
      AchRoutingNumber: achResponse && achResponse.ROUTINGNUMBER ? achResponse.ROUTINGNUMBER : "0",
      AccountClass: 277,
      AchAccountType: this.paymentTable.find(o => o.payId == payId).payModeId == EPaymentModes.ACHOnFile && this.autoPayInfo && this.autoPayInfo.ACHAccountType ? this.autoPayInfo.ACHAccountType : EACHAccountType.Checking,
      SwipeTransaction: false,
      AutoAchPayment: false,
      AuthorizationCode: 0,
      ResponseCode: achResponse && achResponse.RESPONSECODE ? achResponse.RESPONSECODE : "0",
      Reason: reason ? reason : (achResponse && achResponse.RESPONSEDESCRIPTION ? achResponse.RESPONSEDESCRIPTION : "Declined!"),
      CcInfoPurged: false,
      OfflinePayment: false,
      ACHInfoPurged: false,
      PaymentTransactionTypeId: paymentTrnsId,
      OrderId: achResponse && achResponse.AchIntOrderId ? achResponse.AchIntOrderId : this.paymentTable.find(o => o.payId == payId).orderId,
      FacilityId: this.processPayment.facId,
      TransactionDateTime: new Date(),
      TransactionTypeId: transactionType,
      LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
      TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
      ReceiptText: achResponse && achResponse.RECEIPTTEXT ? achResponse.RECEIPTTEXT : null
    };
    this.paymentService.saveACHTransaction(Object.assign(achModel)).subscribe((res) => { });
  }

  onACHManualCancel() {
    this.achManualCardAuthorization = '';
    this.nameonAccount = '';
    this.accountType = 279;
    this.checkNumber = '';
    this.accountNumber = '';
    this.routingNumber = '';
    this.achManualModalRef.hide();
    this.checkPaymentProcess();
  }

  onEFTManualCancel() {
    this.eftManualCardAuthorization = '';
    this.bankName = '';
    this.accountType = 279;
    this.accountNumber = '';
    this.routingNumber = '';
    this.eftManualModalRef.hide();
    this.checkPaymentProcess();
  }

  restrictAddressinput(event) {
    if (event.charCode == 60 || event.charCode == 62 || event.charCode == 47) {
      event.preventDefault();
    }
  }

  tdEmvFailedResponse(amount, res, payId, cctId, paymentTrnsId, transactionType) {
    this.paymentTable.find(o => o.payId == payId).payFailed = true;
    this.prePayStatus = '';

    switch (res.ResponseCode) {
      case '050':
      case '086':
        this.payStatus = 'Declined!';
        break;
      case '107':
        this.payStatus = '$ LIMIT EXCEEDED';
        break;
      case '903':
        this.payStatus = 'CARD CANCELLED';
        break;
      case '10':
        this.payStatus = 'Declined by host or by card';
        break;
      case '11':
        this.payStatus = 'Communication Error';
        break;
      case '12':
        this.payStatus = 'USER ABORTED';
        break;
      case '13':
        this.payStatus = 'TIME OUT';
        break;
      case '14':
        this.payStatus = 'Transaction/Function Not Completed';
        break;
      case '16':
        this.payStatus = 'Declined by Merchant';
        break;
      case '405':
        this.payStatus = 'Card Verification Decline';
        break;
      case '18':
        this.payStatus = 'Transaction Already Voided';
        break;
      case '95':
        this.toastr.warning('Device is not ready to Accept any Payment. Please ensure Device is Idle and ready to Accept New Payment Request.', 'Alert', this.toasterConfig);
        this.payStatus = 'Failed';
        break;
      default:
        if (res.Reason === "EMV Device Not Connected!") {
          this.payStatus = 'Failed';
          this.paymentFailReason = 'EMV Device Not Connected';
        } else {
          if (res.Reason === 'Device is Busy, Please try after sometime.') {
            this.toastr.warning('Device is not ready to Accept Payment, Please try after sometime.', 'Alert', this.toasterConfig);
          }
          this.payStatus = 'Declined!';
          this.paymentFailReason = 'Declined!';
        }
        break;
    }
    this.paymentSuccessFul = false;
    this.paymentProcessing = false;

    this.isAnyPaymentProcessed();

    if (res.ResponseCode != '000') {
      const CCModel = {
        Amount: amount,
        Autopay: false,
        PaymentModeId: EPaymentModes.CreditCard,
        AutoCcProcessingDay: 0,
        CreditCardNumber: !res && res.CreditCardNumber == undefined ? 0 : res.CreditCardNumber,
        CreditCardType: res && res.CreditCardType ? res.CreditCardType : ECreditCards.Visa,
        NameonCard: res.NameonCard ? res.NameonCard : " ",
        CreditCardExpiryMonth: res && res.CreditCardExpiryMonth == 264 && res.CreditCardExpiryYear != 0 ? this.getExpiryMonthValue(parseInt(res.CreditCardExpiryMonth, 10)) : 275,
        CreditCardExpiryYear: (res == null || !parseInt(res.CreditCardExpiryYear, 10)) ? 2099 : parseInt(res.CreditCardExpiryYear, 10),
        CreditCardBillingAddress: '',
        CreditCardBillingZip: '',
        SwipeTransaction: false,
        SecurityCodeSent: false,
        AuthorizationCode: res && res.AuthorizationCode ? res.AuthorizationCode : " ",
        ResponseCode: res && res.ResponseCode ? res.ResponseCode : "",
        Reason: res && res.Reason ? res.Reason : "DECLINED!",
        Key: '',
        PaymentAccountid: '',
        CcInfoPurged: false,
        DebitCardPayment: res && res.DebitCardPayment ? true : false,
        OfflinePayment: 0,
        PaymentTransactionTypeId: paymentTrnsId,
        TransactionDateTime: new Date(),
        TransactionTypeId: EPaymentTransactionType.Declined,
        OrderId: cctId,
        CCBatchNumber: res && res.CCBatchNumber ? res.CCBatchNumber : null,
        EmvReceiptText: res && res.EmvReceiptText ? res.EmvReceiptText : null,
        FacilityId: this.processPayment.facId,
        TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
        TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
        LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null
      };
      this.paymentService.saveCCTransaction(Object.assign(CCModel)).subscribe((res: any) => { });
    }
    if (transactionType == "SALE") {
      this.gotoPaymentSuccess(this.popUpPayment, 0);
    }
    this.loaderIcon = Promise.resolve(false);
  }

  callOpenEdgeTerminal(amount, payId, orderId, paymentTrnsId, uniqueTransId) {
    if (!this.credentials.RCMURL) {
      this.toastr.warning('Please ask Administrator to configure RCM URL', 'URL required', this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
    } else {
      this.paymentMaxWaitTime = this.paymentMaxWaitTime != undefined ? this.paymentMaxWaitTime : 2;
      const terminalPayment = this.paymentTable.find(o => o.payId == payId);
      terminalPayment.isOpenEdgePaymentCompleted = false;
      terminalPayment.rcmResponsePending = true;
      terminalPayment.rcmApproved = false;
      terminalPayment.rcmApprovedResponse = null;
      terminalPayment.rcmGraceStartedAt = null;
      terminalPayment.rcmOutcomeUnknown = false;
      this.paymentInProgress = true;
      const emvTransactionType = this.getOpenEdgeEmvTransactionType(payId);
      terminalPayment.openEdgeSaleType = emvTransactionType;
      this.RCMStatusResponse.SessionId = '';
      this.RCMStatusResponse.SessionState = -1;
      this.showLoaderMesage = false;
      this.isOpenEdgeEMVCompleted = false;
      if (this.subOpenEdgeEMV != null) {
        this.subOpenEdgeEMV.unsubscribe();
        this.subOpenEdgeEMV = null;
      }
      this.isTDEmv.isTransactionWaitTime = true;
      let disablePinpad = this.credentials?.DISABLEPINPAD ?? false;
      this.loaderIcon = Promise.resolve(true);
      const requestParam =
        "<REQUEST>" +
        "<XWEBID>" + this.credentials.XWEBID + "</XWEBID>" +
        "<XWEBTERMINALID>" + this.credentials.XWEBTERMINALID + "</XWEBTERMINALID>" +
        "<XWEBAUTHKEY>" + this.credentials.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
        "<DISABLEDEVICEMANUALENTRY>" + disablePinpad + "</DISABLEDEVICEMANUALENTRY>" +
        "<TRANSACTIONTYPE>" + emvTransactionType + "</TRANSACTIONTYPE>" +
        "<AMOUNT>" + amount + "</AMOUNT>" +
        "<ORDERID>" + uniqueTransId + "</ORDERID>" +
        "<OTK>" + uniqueTransId + "</OTK>" +
        "<CLERK></CLERK>" +
        "<RECEIPTCOPYLABEL>MERCHANT_COPY</RECEIPTCOPYLABEL>" +
        "<TITLE>SSM 6.0</TITLE>" +
        "<CREATEALIAS>FALSE</CREATEALIAS>" +
        "</REQUEST>";
        this.appInsightsService.logPaymentEvent(true, `Initializing the Credit Card  RCM Request.`, { Gateway: this.paymentGateway, FacilityId : this.processPayment.facId, OrderId : uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
        // Kept open for the whole transaction (as callRCM does): the RCM's answer carries the device's reason and card
        // details, which the QUERYPAYMENT poll below can't see for a device-side decline or cancel.
        this.openEdgeRcmRequest?.unsubscribe();
        this.openEdgeRcmRequest = this.paymentService.getRCMService(this.credentials.RCMURL, requestParam).subscribe(
          (res: any) => this.handleOpenEdgeRcmResponse(res, payId, orderId, paymentTrnsId, uniqueTransId),
          // Transport error: no RCM details will come, but the sale may still have succeeded — only a terminal
          // QUERYPAYMENT result or the max-wait reconciliation decides (see isOpenEdgeSaleOutcomePending).
          () => {
            terminalPayment.rcmResponsePending = false;
            terminalPayment.rcmOutcomeUnknown = true;
          });

      this.paymentFailReason = '';
      setTimeout(() => {
        this.CNPResponse(orderId, payId, paymentTrnsId, uniqueTransId);
      }, 5000);

      setTimeout(() => {
        if (!this.paymentTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted && this.paymentTable.find(o => o.payId == payId).orderId == orderId) {
          this.openEdgeRcmRequest?.unsubscribe();
          this.isTDEmv.isTransactionWaitTime = false;
          this.paymentTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted = true;
          this.appInsightsService.logPaymentEvent(true, `Transaction time reached max Wait Time, OrderId : ${uniqueTransId},`, { Gateway: this.paymentGateway , FacilityId :  this.processPayment.facId, OrderId : this.getPaymentOrderId(), UserId : this.userSessionService.userSessionData.UserId});
          this.paymentService.GetCreditCardTransactionById(orderId).subscribe((cctResponse: any) => {
            let res: any;
            try {
              res = JSON.parse(cctResponse);
            } catch {
              this.loaderIcon = Promise.resolve(false);
              this.failOpenEdgeAtMaxWait({ PaymentModeId: this.paymentTable.find(o => o.payId == payId)?.payModeId }, 'No Response', payId, orderId, paymentTrnsId);
              this.cancelRCMPaymetRequest(uniqueTransId);
              return;
            }
            if (res.Reason == "Attempting to Process") {
              this.paymentService.getCNPResponse(this.credentials, uniqueTransId).subscribe((res: any) => {
                let jsonResp: any = null;
                try {
                  jsonResp = typeof res === 'string' ? JSON.parse(res) : res;
                } catch { }
                this.loaderIcon = Promise.resolve(false);
                this.appInsightsService.logPaymentEvent(true, `Received the response when the transaction reached the maximum wait time, OrderId : ${uniqueTransId},`, { Gateway: this.paymentGateway,FacilityId : this.processPayment.facId, OrderId : this.getPaymentOrderId(), UserId : this.userSessionService.userSessionData.UserId});
                if (this.isOpenEdgeQueryTerminal(jsonResp)) {
                  // A terminal gateway result settles it (approval → success / mismatch check, real decline → failure).
                  this.gotoCNPResponse(jsonResp, orderId, payId, paymentTrnsId);
                } else {
                  this.failOpenEdgeAtMaxWait(jsonResp ?? {}, jsonResp?.RESULT?.RESPONSEDESCRIPTION ?? 'No Response', payId, orderId, paymentTrnsId);
                }
              }, err => {
                let obj = {
                  RESULT: {
                    RESPONSECODE: err?.status ?? 0,
                    RESPONSEDESCRIPTION: err?.statusText ?? ''
                  }
                }
                this.failOpenEdgeAtMaxWait(obj, 'No Response', payId, orderId, paymentTrnsId);
                this.loaderIcon = Promise.resolve(false);
              });
            } else {
              this.paymentFailReason = "Please Contact Administrator to check in Gateway Portal if Payment is Approved. If Yes, key in the Payment as Manual Authorization";
              this.appInsightsService.logPaymentEvent(true, `${this.paymentFailReason}, OrderId : ${uniqueTransId},`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : this.getPaymentOrderId(), UserId : this.userSessionService.userSessionData.UserId});
              this.loaderIcon = Promise.resolve(false);
            }
            this.cancelRCMPaymetRequest(uniqueTransId);
          }, err => {
            this.loaderIcon = Promise.resolve(false);
            this.failOpenEdgeAtMaxWait({ PaymentModeId: this.paymentTable.find(o => o.payId == payId)?.payModeId }, 'No Response', payId, orderId, paymentTrnsId);
            this.cancelRCMPaymetRequest(uniqueTransId);
          });
        }
      }, 10000 * 6 * this.paymentMaxWaitTime);
    }
  }

  /**
   * Max-wait outcome when no terminal QUERYPAYMENT result settled the sale. If the RCM approved, its answer was lost,
   * or it never answered, the card may already be charged: record it for manual reconciliation and block further card
   * attempts in this payment session (Manual Authorization stays available, as the message instructs) — a card retry
   * could double-charge. Otherwise the RCM had nothing to report beyond the poll, so it's an ordinary failure.
   */
  private failOpenEdgeAtMaxWait(jsonResp: any, reason: string, payId: any, orderId: any, paymentTrnsId: any): void {
    const payment = this.paymentTable.find(o => o.payId == payId);
    if (payment) {
      payment.payFailed = true;
    }
    if (payment && (payment.rcmApproved || payment.rcmOutcomeUnknown || payment.rcmResponsePending)) {
      this.openEdgeReconciliationRequired = true;
      reason = PaymentComponent.openEdgeReconciliationMessage;
      this.appInsightsService.logPaymentEvent(true, `OpenEdge sale outcome unknown at max wait - manual reconciliation required (rcmApproved: ${!!payment.rcmApproved}, rcmOutcomeUnknown: ${!!payment.rcmOutcomeUnknown}, rcmResponsePending: ${!!payment.rcmResponsePending})`, { Gateway: this.paymentGateway, FacilityId: this.processPayment.facId, OrderId: payment.uniqueTransId, UserId: this.userSessionService.userSessionData.UserId });
    }
    this.saveCCTransactionFailureCase(jsonResp, reason, 'SALE', paymentTrnsId, orderId, payId);
  }

  /** While an OpenEdge sale needs manual reconciliation, only Manual Authorization may be taken in this payment session. */
  isOpenEdgeReconciliationBlocked(drow: any): boolean {
    return this.openEdgeReconciliationRequired && drow?.payModeId != EPaymentModes.ManualAuthorization;
  }

  CNPResponse(orderId, payId, paymentTrnsId, uniqueTransId) 
  {
    const payment = this.paymentTable.find(o => o.payId === payId);
    if (!payment) {
      this.appInsightsService.logPaymentEvent(true,'CNPResponse aborted: payment not found',{ Gateway: this.paymentGateway, FacilityId : this.processPayment.facId, OrderId : uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
      return;
    }
    if (payment.isOpenEdgePaymentCompleted) {
      return;
    }
    const startTime = Date.now();
    this.appInsightsService.logPaymentEvent(true,'CNPResponse polling started',{ Gateway: this.paymentGateway, FacilityId : this.processPayment.facId, OrderId : uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
    this.paymentService.getCNPResponse(this.credentials, uniqueTransId).subscribe((res: any) => {
          // The RCM callback (or the max-wait timeout) may have completed this payment while the query was in flight.
          if (payment.isOpenEdgePaymentCompleted) {
            return;
          }
          let jsonResp: any;
          try {
            jsonResp = typeof res === 'string' ? JSON.parse(res) : res;
          } catch (e) {
            this.appInsightsService.logPaymentEvent(true,'CNPResponse invalid JSON',{ Gateway: this.paymentGateway, FacilityId : this.processPayment.facId, OrderId : uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
            this.retryCNP(orderId, payId, paymentTrnsId, uniqueTransId, startTime);
            return;
          }
          this.appInsightsService.logPaymentEvent(true, `GetCNPResponseURL Response`, {ResponseCode: jsonResp?.RESULT?.RESPONSECODE ?? null, State: jsonResp?.RESULT?.STATE ?? '', Message: jsonResp?.RESULT?.RESPONSEDESCRIPTION ?? '',OrderId: uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
          if (this.isOpenEdgeQueryTerminal(jsonResp)) {
            // The gateway result lacks the device's reason and chip receipt (needed for a decline's message and to spot a
            // debit card approved as CREDITSALE) — let the RCM's own response land first, within the grace period.
            if (this.waitForOpenEdgeRcmResponse(payment) || this.isAwaitingOpenEdgeCardEvidence(payment, jsonResp)) {
              this.retryCNP(orderId, payId, paymentTrnsId, uniqueTransId, startTime);
              return;
            }
            payment.isOpenEdgePaymentCompleted = true;
            this.isOpenEdgeEMVCompleted = true;
            this.loaderIcon = Promise.resolve(false);

            this.appInsightsService.logPaymentEvent(true,'CNPResponse completed successfully',{ Gateway: this.paymentGateway, FacilityId : this.processPayment.facId, OrderId : uniqueTransId, UserId : this.userSessionService.userSessionData.UserId });

            this.gotoCNPResponse(jsonResp, orderId, payId, paymentTrnsId);
            return;
          }
          if (jsonResp?.RESULT?.RESPONSECODE == EOpenEdgeResponseCode.TransactionDoesNotExist) {
            this.checkOpenEdgeDeviceDecline(orderId, payId, paymentTrnsId, uniqueTransId, startTime);
            return;
          }
          this.retryCNP(orderId, payId, paymentTrnsId, uniqueTransId, startTime);
        },
        err => {
          if (payment.isOpenEdgePaymentCompleted) {
            return;
          }
          this.appInsightsService.logPaymentEvent(true,'GetCNPResponseURL Error',{Status: err?.status ?? null,StatusText: err?.statusText ?? '',OrderId: uniqueTransId,UserId : this.userSessionService.userSessionData.UserId});
          // While the RCM hasn't reported a failure (still pending, approved, or its answer was lost) the card may already
          // be charged: failing now would allow a duplicate payment, so keep polling until the outcome is known or the
          // max-wait reconciliation runs.
          if (err?.status === HttpStatusCode.BadGateway || payment.rcmResponsePending || this.isOpenEdgeSaleOutcomePending(payment)) {
            this.retryCNP(orderId, payId, paymentTrnsId, uniqueTransId, startTime);
            return;
          }

          this.cancelRCMPaymetRequest(uniqueTransId);

          payment.isOpenEdgePaymentCompleted = true;
          payment.payFailed = true;
          this.isOpenEdgeEMVCompleted = true;
          this.loaderIcon = Promise.resolve(false);

          const obj = {
            RESULT: {
              RESPONSECODE: err?.status ?? 0,
              RESPONSEDESCRIPTION: err?.statusText ?? ''
            }
          };
          this.saveCCTransactionFailureCase(obj,'Gateway Rejected - No response received!','SALE',paymentTrnsId,orderId,payId);
        }
      );
  }

  /**
   * The RCM's own answer for a new-architecture terminal sale (callOpenEdgeTerminal). Every terminal error result
   * (cancel, fail, decline, device/chip errors) is completed here with the device's reason and card details.
   * An approval is only recorded on the row: the QUERYPAYMENT poll (gotoCNPResponse) completes it once the gateway
   * transaction is visible, and meanwhile it must never be classified as a device decline.
   */
  private handleOpenEdgeRcmResponse(res: any, payId: any, orderId: any, paymentTrnsId: any, uniqueTransId: any): void {
    const payment = this.paymentTable.find(o => o.payId == payId);
    if (!payment) {
      return;
    }
    payment.rcmResponsePending = false;
    let rcmResponse: any;
    try {
      rcmResponse = JSON.parse(res?.RcmResponse)?.RESPONSE;
    } catch {
      // Unreadable: the sale may still have gone through — same as a transport error, only a terminal QUERYPAYMENT
      // result or the max-wait reconciliation decides.
      payment.rcmOutcomeUnknown = true;
      return;
    }
    if (this.paymentComponentDestroyed || payment.isOpenEdgePaymentCompleted) {
      return;
    }
    if (!rcmResponse) {
      // Parsed, but no RESPONSE: says nothing about whether a charge happened — keep it in reconciliation.
      payment.rcmOutcomeUnknown = true;
      return;
    }
    // RESULT arrives as a string ("0", "3", "12"...).
    const result = Number(rcmResponse.RESULT);
    if (result === EEdgeExpressResultCode.Success) {
      payment.rcmApproved = true;
      payment.rcmApprovedResponse = rcmResponse; // chip receipt: card-type evidence for gotoCNPResponse's mismatch check
      return;
    }
    // Every other defined EdgeExpress result is a terminal error.
    const failureResults = Object.values(EEdgeExpressResultCode)
      .filter((code): code is number => typeof code === 'number' && code !== EEdgeExpressResultCode.Success);
    if (!failureResults.includes(result)) {
      // Unrecognised RESULT: outcome unknown, same as above.
      payment.rcmOutcomeUnknown = true;
      return;
    }
    this.appInsightsService.logPaymentEvent(true, `RCM Error. Message : ${rcmResponse.RESULTMSG ?? 'No Response'}`, { Gateway: this.paymentGateway, FacilityId : this.processPayment.facId, OrderId : uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
    payment.isOpenEdgePaymentCompleted = true;
    payment.payFailed = true;
    this.isOpenEdgeEMVCompleted = true;
    // saveCCTransactionFailureCase reads the QUERYPAYMENT shape (RESULT.*), so map the RCM field names across.
    const normalizedResult = {
      ...rcmResponse,
      MASKEDCARDNUMBER: rcmResponse.ACCOUNT,
      RESPONSECODE: rcmResponse.HOSTRESPONSECODE ?? rcmResponse.RESULT,
      RESPONSEDESCRIPTION: rcmResponse.HOSTRESPONSEDESCRIPTION ?? rcmResponse.RESULTMSG
    };
    this.saveCCTransactionFailureCase({ PaymentModeId: payment.payModeId, RESULT: normalizedResult }, rcmResponse.RESULTMSG ?? 'No Response', 'SALE', paymentTrnsId, orderId, payId);
  }

  /** Same approval rule gotoCNPResponse applies to a QUERYPAYMENT result. */
  /**
   * A QUERYPAYMENT result that settles the sale (approved or declined). Requires an actual RESULT with a response code:
   * an in-progress state, "transaction does not exist", or a payload without RESULT ({} / malformed) is not terminal,
   * so it must never be completed as a decline.
   */
  private isOpenEdgeQueryTerminal(jsonResp: any): boolean {
    const result = jsonResp?.RESULT;
    const responseCode = result?.RESPONSECODE;
    return !!result && responseCode !== undefined && responseCode !== null && responseCode !== ''
      && result.STATE !== 'IN_PROGRESS'
      && responseCode != EOpenEdgeResponseCode.TransactionDoesNotExist;
  }

  private isOpenEdgeQueryApproved(jsonResp: any): boolean {
    return (jsonResp?.RESULT?.RESPONSECODE == EOpenEdgeResponseCode.Approval && jsonResp?.RESULT?.STATE != 'IN_PROGRESS')
      || (jsonResp?.RESULT?.RESPONSECODE == "-1" && jsonResp?.RESULT?.STATE == "CAPTURED" && !!jsonResp?.RESULT?.APPROVALCODE);
  }

  /**
   * True while a non-approved outcome should hold off because the RCM's own response (with the device's reason and
   * card details) is still expected. Bounded by openEdgeRcmResponseGraceMs from the first time it is asked.
   */
  private waitForOpenEdgeRcmResponse(payment: any): boolean {
    if (!payment?.rcmResponsePending) {
      return false;
    }
    payment.rcmGraceStartedAt = payment.rcmGraceStartedAt ?? Date.now();
    return Date.now() - payment.rcmGraceStartedAt < PaymentComponent.openEdgeRcmResponseGraceMs;
  }

  /**
   * A Credit Card (CREDITSALE) approval can't be finalised until the RCM's own response arrives: only its chip receipt
   * (AID NAME) shows whether a debit card was tapped, which must be reversed as a mismatch. Unbounded by the grace
   * period — only the RCM answer (or its loss: transport error / unreadable) or the max-wait reconciliation ends it.
   * A DEBITSALE approval needs no evidence (only a debit card can be approved for it).
   */
  private isAwaitingOpenEdgeCardEvidence(payment: any, jsonResp: any): boolean {
    return !!payment?.rcmResponsePending
      && payment.payModeId == EPaymentModes.CreditCard
      && payment.openEdgeSaleType === 'CREDITSALE'
      && this.isOpenEdgeQueryApproved(jsonResp);
  }

  /**
   * True while "no gateway transaction" must not be read as a device decline: the RCM hasn't answered yet, reported
   * success (the record is still propagating), or its answer was lost (transport error / unreadable) — in each case
   * the sale may have gone through. Polling continues until QUERYPAYMENT returns a terminal result or the max-wait
   * reconciliation runs (failOpenEdgeAtMaxWait); declining earlier would allow a retry and risk a duplicate charge.
   * A real device decline still shows at once: it arrives through the RCM's own answer (handleOpenEdgeRcmResponse).
   */
  private isOpenEdgeSaleOutcomePending(payment: any): boolean {
    return !!payment?.rcmResponsePending || !!payment?.rcmApproved || !!payment?.rcmOutcomeUnknown;
  }

  /**
   * A card the device declines itself (e.g. a credit card presented for DEBITSALE) never reaches the gateway, so
   * QUERYPAYMENT keeps answering "transaction does not exist" until the max wait time. Once the RCM session has
   * completed (and the RCM's own response hasn't arrived within the grace period), re-query once to rule out a
   * just-approved payment, then fail the payment immediately. Never while the sale's outcome is pending
   * (isOpenEdgeSaleOutcomePending) — rechecked after every async step, since the RCM answer can land in between.
   */
  private checkOpenEdgeDeviceDecline(orderId, payId, paymentTrnsId, uniqueTransId, startTime: number): void {
    const terminalPayment = this.paymentTable.find(o => o.payId === payId);
    if (this.isOpenEdgeSaleOutcomePending(terminalPayment)) {
      this.retryCNP(orderId, payId, paymentTrnsId, uniqueTransId, startTime);
      return;
    }
    this.paymentService.getRCMServiceStatus(null, uniqueTransId, false).subscribe((sessionRes: any) => {
      if (sessionRes?.SessionState != EOpenEdgeSessionStates.Completed
        || this.waitForOpenEdgeRcmResponse(terminalPayment)
        || this.isOpenEdgeSaleOutcomePending(terminalPayment)) {
        this.retryCNP(orderId, payId, paymentTrnsId, uniqueTransId, startTime);
        return;
      }
      this.paymentService.getCNPResponse(this.credentials, uniqueTransId).subscribe((res: any) => {
        let jsonResp: any;
        try {
          jsonResp = typeof res === 'string' ? JSON.parse(res) : res;
        } catch {
          this.retryCNP(orderId, payId, paymentTrnsId, uniqueTransId, startTime);
          return;
        }
        const payment = this.paymentTable.find(o => o.payId === payId);
        if (!payment || payment.isOpenEdgePaymentCompleted) {
          return;
        }
        const notFound = jsonResp?.RESULT?.RESPONSECODE == EOpenEdgeResponseCode.TransactionDoesNotExist;
        // Anything other than a terminal result or a confirmed "not found" (in progress, {} / no RESULT) is indeterminate.
        if ((!notFound && !this.isOpenEdgeQueryTerminal(jsonResp)) || (notFound && this.isOpenEdgeSaleOutcomePending(payment))) {
          this.retryCNP(orderId, payId, paymentTrnsId, uniqueTransId, startTime);
          return;
        }
        payment.isOpenEdgePaymentCompleted = true;
        this.isOpenEdgeEMVCompleted = true;
        this.loaderIcon = Promise.resolve(false);
        if (!notFound) {
          this.gotoCNPResponse(jsonResp, orderId, payId, paymentTrnsId);
          return;
        }
        this.appInsightsService.logPaymentEvent(true, 'RCM session completed without a gateway transaction - treating as device decline', { Gateway: this.paymentGateway, FacilityId: this.processPayment.facId, OrderId: uniqueTransId, UserId: this.userSessionService.userSessionData.UserId });
        payment.payFailed = true;
        jsonResp.RESULT.RESPONSEDESCRIPTION = `${jsonResp.RESULT.RESPONSEDESCRIPTION || 'Transaction does not exist'} : RCM Session Completed!`;
        this.saveCCTransactionFailureCase(jsonResp, 'Declined!', 'SALE', paymentTrnsId, orderId, payId);
      }, () => this.retryCNP(orderId, payId, paymentTrnsId, uniqueTransId, startTime));
    }, () => this.retryCNP(orderId, payId, paymentTrnsId, uniqueTransId, startTime));
  }

private retryCNP(orderId,payId,paymentTrnsId,uniqueTransId,startTime
) {
  const elapsedTime = Date.now() - startTime;
  const waitTime = Math.max(1000 - elapsedTime, 0);

  setTimeout(() => {
    this.CNPResponse(orderId, payId, paymentTrnsId, uniqueTransId);
  }, waitTime);
}

  gotoCNPResponse(jsonResp, orderId, payId, paymentTrnsId) {
    this.appInsightsService.logPaymentEvent(true, `Gateway Response code : ${jsonResp?.RESULT?.RESPONSECODE ?? null}, Response State : ${jsonResp?.RESULT?.STATE}  OrderId : ${orderId},`, { Gateway: this.paymentGateway , FacilityId :  this.processPayment.facId, OrderId : orderId, UserId : this.userSessionService.userSessionData.UserId});
    if (this.isOpenEdgeQueryApproved(jsonResp)) {
      this.paymentTable.find(o => o.payId == payId).payFailed = false; //Reponse Code -1 && State - Captured -> A payment has been approved by the processor and flagged for settlement
      this.disableNextButton();
      this.isTDEmv.isTransactionWaitTime = false;
      this.payStatus = 'Success';
      this.paymentSuccessFul = true;
      jsonResp.RESULT['OrderId'] = orderId;
      if (jsonResp?.RESULT?.CARDHOLDERNAME == undefined) {
        jsonResp.RESULT['CARDHOLDERNAME'] = jsonResp.RESULT.CARDBRAND != 'Unknown' ? jsonResp.RESULT.CARDBRAND : '';
      }
      jsonResp.RESULT['ACCOUNT'] = jsonResp?.RESULT?.MASKEDCARDNUMBER ?? '';
      jsonResp.RESULT['HOSTRESPONSECODE'] = jsonResp?.RESULT?.RESPONSECODE ?? '';
      jsonResp.RESULT['HOSTRESPONSEDESCRIPTION'] = jsonResp?.RESULT?.ORIGINALRESPONSEDESCRIPTION ?? jsonResp.RESULT?.STATE ?? '';
      const terminalPayment = this.paymentTable.find(o => o.payId == payId);
      // QUERYPAYMENT may omit TRANSACTIONTYPE; record the type that was sent (drives the saved debit flag and cancel-time void).
      jsonResp.RESULT.TRANSACTIONTYPE = jsonResp.RESULT.TRANSACTIONTYPE || terminalPayment.openEdgeSaleType;
      terminalPayment['processedCC'] = jsonResp.RESULT;
      this.loaderIcon = Promise.resolve(false);
      // The RCM's own approval carries the chip receipt (AID NAME) that identifies a debit card approved as CREDITSALE.
      if (this.rejectOpenEdgeMismatchedApproval(payId, jsonResp.RESULT, paymentTrnsId, terminalPayment.rcmApprovedResponse)) {
        return;
      }
      this.appInsightsService.logPaymentEvent(true, `Goto Payment Success : ${parseFloat(jsonResp?.RESULT?.APPROVEDAMOUNT ?? 0).toFixed(2)}`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : orderId, UserId : this.userSessionService.userSessionData.UserId});
      this.gotoPaymentSuccess(this.popUpPayment, parseFloat(jsonResp.RESULT.APPROVEDAMOUNT).toFixed(2));
    } else {
      this.appInsightsService.logPaymentEvent(true, `Gateway Error Response Message : ${jsonResp?.RESULT?.RESPONSEDESCRIPTION ?? ''}, OrderId : ${orderId},`, { Gateway: this.paymentGateway, FacilityId : this.processPayment.facId, OrderId : orderId, UserId : this.userSessionService.userSessionData.UserId});
      this.paymentTable.find(o => o.payId == payId).payFailed = true;
      if (jsonResp?.RESULT?.RESPONSEDESCRIPTION) {
        jsonResp.RESULT.RESPONSEDESCRIPTION = this.paymentFailReason == 'RCM Not Running! – Transaction Not found' ? 'Device Not Connected! – Transaction Not found' : jsonResp.RESULT.RESPONSEDESCRIPTION;
      }
      this.saveCCTransactionFailureCase(jsonResp, jsonResp?.RESULT?.RESPONSEDESCRIPTION ?? "Transaction Cancelled", 'SALE', paymentTrnsId, orderId, payId);
    }
  }

  ccAutoPayDetails() {
    let autoPayObj = {
      PaymentAliasKey: this.autoPayInfo && this.autoPayInfo.PaymentAccountId ? this.autoPayInfo.PaymentAccountId : "",
      LeaseNo: this.autoPayInfo && this.autoPayInfo.LeaseNo ? this.autoPayInfo.LeaseNo : 0,
      FacilityId: this.autoPayInfo && this.autoPayInfo.FacilityId ? this.autoPayInfo.FacilityId : this.processPayment.facId,
      CardType: this.autoPayInfo && this.autoPayInfo.CreditCardType ? this.autoPayInfo.CreditCardType : ECreditCards.Visa,
      NameOnCard: this.autoPayInfo && this.autoPayInfo.NameonCard ? this.autoPayInfo.NameonCard : "",
      ExpiryMonth: this.autoPayInfo && this.autoPayInfo.CreditCardExpiryMonth ? this.autoPayInfo.CreditCardExpiryMonth : 275,
      ExpiryYear: this.autoPayInfo && this.autoPayInfo.CreditCardExpiryYear ? this.autoPayInfo.CreditCardExpiryYear : 2099,
      BillingAdd: this.autoPayInfo && this.autoPayInfo.CreditCardBillingAddress ? this.autoPayInfo.CreditCardBillingAddress : "",
      ZillingZip: this.autoPayInfo && this.autoPayInfo.CreditCardBillingZip ? this.autoPayInfo.CreditCardBillingZip : "",
      CcNumber: this.autoPayInfo && this.autoPayInfo.CreditCardNumber ? this.autoPayInfo.CreditCardNumber : 0,
      SerialId: this.autoPayInfo && this.autoPayInfo.SeriesId ? this.autoPayInfo.SeriesId : 0,
      GatewayDetails: this.autoPayInfo?.GatewayDetails ?? "",
      PaymentMethod: this.autoPayInfo?.ACHPaymentAccountId ?? "",
      AccountNumber: this.autoPayInfo?.ACHAccountNo ?? "",
      RoutingNumber: this.autoPayInfo?.ACHRoutingNo ?? "",
      PaymentAccountId: this.autoPayInfo?.ACHPaymentAccountId ?? "",
      MandateId: this.autoPayInfo?.MandateId ?? ""
    }

    if ([EPaymentOrigin.Rental, EPaymentOrigin.Transfer, EPaymentOrigin.MakePayment, EPaymentOrigin.ReInstate].includes(this.processPayment.Type) && (this.facOpsDataService?.saveautopay?.PaymentAccountId || this.facOpsDataService?.saveautopay?.ACHPaymentAccountId)) {
      autoPayObj.PaymentAliasKey = this.facOpsDataService.saveautopay.PaymentAccountId;
      autoPayObj.LeaseNo = 0;
      autoPayObj.FacilityId = this.facOpsDataService.saveautopay.FacilityId ? this.facOpsDataService.saveautopay.FacilityId : this.processPayment.facId;
      autoPayObj.CardType = this.facOpsDataService.saveautopay.CreditCardType ? this.facOpsDataService.saveautopay.CreditCardType : ECreditCards.Visa;
      autoPayObj.NameOnCard = this.facOpsDataService.saveautopay.NameonCard ? this.facOpsDataService.saveautopay.NameonCard : "";
      autoPayObj.ExpiryMonth = this.facOpsDataService.saveautopay.CreditCardExpiryMonth ? this.facOpsDataService.saveautopay.CreditCardExpiryMonth : 275;
      autoPayObj.ExpiryYear = this.facOpsDataService.saveautopay.CreditCardExpiryYear ? this.facOpsDataService.saveautopay.CreditCardExpiryYear : 2099;
      autoPayObj.BillingAdd = this.facOpsDataService.saveautopay.CreditCardBillingAddress ? this.facOpsDataService.saveautopay.CreditCardBillingAddress : "";
      autoPayObj.ZillingZip = this.facOpsDataService.saveautopay.CreditCardBillingZip ? this.facOpsDataService.saveautopay.CreditCardBillingZip : "";
      autoPayObj.CcNumber = this.facOpsDataService.saveautopay.CreditCardNumber ? this.facOpsDataService.saveautopay.CreditCardNumber : 0;
      autoPayObj.SerialId = this.facOpsDataService.saveautopay.SeriesId ? this.facOpsDataService.saveautopay.SeriesId : 0;
      autoPayObj.GatewayDetails = this.facOpsDataService.saveautopay.GatewayDetails ? this.facOpsDataService.saveautopay.GatewayDetails : "",
        autoPayObj.PaymentMethod = this.facOpsDataService.saveautopay?.ACHPaymentAccountId ?? "";
      autoPayObj.AccountNumber = this.facOpsDataService.saveautopay?.ACHAccountNo ?? "";
      autoPayObj.RoutingNumber = this.facOpsDataService.saveautopay?.ACHRoutingNo ?? "";
      autoPayObj.PaymentAccountId = this.facOpsDataService.saveautopay?.ACHPaymentAccountId ?? "";
      autoPayObj.MandateId = this.facOpsDataService.saveautopay?.MandateId ?? "";
    }
    return autoPayObj;
  }

  getFirstEmailId(tdEmail) {
    let emailIdList = '';
    if (tdEmail && tdEmail.length) {
      emailIdList = tdEmail.split(/[,;]/);
    }
    return emailIdList && emailIdList.length ? emailIdList[0] : emailIdList;
  }

  autopayDataOnSave(event) {
    this.autoPayInfo = event;
    this.LinkedleaseNo = event.LinkedleaseNo;
  }

  postAutoPay(event) {
    if (this.returnPostPayment) {
      this.autopayCompleted.emit([null, null]);
      return;
    }
  }

  cancelRCMPaymetRequest(orderId) {
    this.paymentService.getRCMServiceStatus(null, orderId, false).subscribe((sessionRes: any) => {
      if (sessionRes && sessionRes.SessionState != EOpenEdgeSessionStates.Completed) {
        this.paymentService.getRCMServiceStatus(sessionRes.SessionId, 0, true).subscribe((respose: any) => { }, err => { });
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
  }

  callStripeHostedPage() {
    this.loaderIcon = Promise.resolve(false);    
    this.stripeModalRef = this.modalService.show(this.showStripePage, { class: 'modal-medium modal-dialog-centered', backdrop: 'static', keyboard: false });
  }

  closeStripeModal(reason?) {
    this.paymentTable.find(o => o.payId === this.currentPayId).EnableAutopayOrCardOnFile = 'cancel';
    this.paymentStarted = false;
    this.stripeModalRef.hide();
    let paymentransactionTypeId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
    const intentId = this.paymentTable.find(o => o.payId === this.currentPayId).stripePaymentIntentId;
    if (this.paymentTable.find(o => o.payId === this.currentPayId).payModeId == EPaymentModes.HostedPage) {
      const stripFailedResponse = {
        Reason: reason ??'Transaction Cancelled By User',
        Key: intentId
      };
      const obj = {
        amountToPay: this.paymentTable.find(o => o.payId === this.currentPayId).payAmount,
        paymentMode: EPaymentModes.HostedPage,
        paymentTrnsId: paymentransactionTypeId,
        orderId: this.paymentTable.find(o => o.payId === this.currentPayId).orderId,
        requestgatewaydetails: this.requestgatewaydetails
      }
      const CCModel = this.paymentService.saveCCTFailModelStripe(stripFailedResponse, this.processPayment, obj);
      if (intentId.Key) {
        this.paymentService.CancelPaymentIntent(intentId, this.processPayment.facId).subscribe((cancelRes: any) => { });
      }
      this.paymentService.saveCCTransaction(Object.assign(CCModel)).subscribe((res: any) => { });
    }
    const paymentEntry = this.paymentTable.find(o => o.payId === this.currentPayId);
    if (paymentEntry && (paymentEntry.payModeId === EPaymentModes.ACH || paymentEntry.payModeId === EPaymentModes.DirectDebitEFT)) {
      const achModel = this.generateIntialACH(paymentEntry.payAmount, EPaymentTransactionType.Declined, paymentransactionTypeId, paymentEntry.payModeId);
      achModel.Reason = reason ?? 'Transaction Cancelled By User';
      achModel.OrderId = paymentEntry.orderId;
      achModel.PaymentIntentId = intentId;
      this.paymentService.saveACHTransaction(achModel).subscribe((res) => { });
      // Payment with autopay only has a setup intent at this point (stripePaymentIntentId is still 0), so there is no payment intent to cancel.
      if (intentId) {
        this.paymentService.CancelPaymentIntent(intentId, this.processPayment.facId).subscribe((cancelRes: any) => { });
      }

      const setupRow = this.autopaySetupAchRows[this.currentPayId];
      if (setupRow) {
        const setupAchModel = this.generateIntialACH(0, EPaymentTransactionType.Declined, paymentransactionTypeId, paymentEntry.payModeId);
        setupAchModel.Reason = reason ?? 'Autopay Cancelled By User!';
        setupAchModel.OrderId = setupRow.Id;
        setupAchModel.PaymentIntentId = this.stripeSetupIntent;
        this.paymentService.saveACHTransaction(setupAchModel).subscribe((res) => { });
        delete this.autopaySetupAchRows[this.currentPayId];
      }
    }
    this.loaderIcon = Promise.resolve(false);
    this.checkPaymentProcess();
  }

  getLovTransactionType() {
    let transType = 0;
    if (this.processPayment.Type == EPaymentOrigin.Reservation) {
      transType = ELOV_TransactionTypes.Reservation;
    } else if (this.processPayment.Type == EPaymentOrigin.Merchandise) {
      transType = ELOV_TransactionTypes.Merchandise;
    } else {
      transType = ELOV_TransactionTypes.Rental;
    }
    return transType;
  }

  createPaymentIntent(amount: number | string, payMode: EPaymentModes, payId: string): void {
  this.loaderIcon = Promise.resolve(true);

  try {
    const paymentRow = this.paymentTable.find(o => o.payId === payId);
    if (!paymentRow || !amount) {
      throw new Error('Invalid payment data');
    }

    const paymentTrnsId =this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);

    const customerObj = (this.IsQuickProspect && this.tenantModel)
      ? {
          Name: this.tenantModel.BusinessAccount? this.tenantModel.CompanyName
            : `${this.tenantModel.FirstName}${this.tenantModel.MiddleName ? ' ' + this.tenantModel.MiddleName : ''} ${this.tenantModel.LastName}`.trim(),
          Email: this.tenantModel.Email,
          Phone: this.tenantModel.CellPhoneNumber
        }
      : {
          Name: this.customerInfo.FullName,
          Email: this.customerInfo.Email,
          Phone: this.customerInfo.CellPhoneNumber
        };

    const inputObj = {
      OrderId: paymentRow?.uniqueTransId,
      UserId: this.userSessionService.userSessionData?.UserId,
      TenantId: this.processPayment?.TenantId,
      TransactionType: this.getLovTransactionType(),
      Amount: Number(amount) * 100,
      FacilityId: this.facilityId,
      SelectedPaymentModeType:payMode === EPaymentModes.DirectDebitEFT ? 'EFT': payMode === EPaymentModes.ACH ? 'ACH': 'HostedPage',
      LeaseNo: this.processPayment?.LeaseNo,
      SetUpFutureUsage:paymentRow?.EnableAutopayOrCardOnFile === 'cancel' ? null : 'off_session',
      Name: customerObj.Name,
      Email: customerObj.Email,
      Phone: customerObj.Phone,
      IsQuickProspectPayment: this.IsQuickProspect,
      Customer:this.processPayment?.CustomerId ||this.facOpsDataService?.saveautopay?.CustomerId ||'',
      PaymentTransactionType: this.getTransactionType()
    };
     this.appInsightsService.logPaymentEvent(true, `Call  CreatePaymentIntent . Order Id: ${paymentRow.uniqueTransId}`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : paymentRow.uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
    this.paymentService.getPaymentIntent_Stripe(inputObj).subscribe({
      next: (response: any) => {
        if (!response) {
          this.saveStripeCCTransactionFail( response,paymentTrnsId,paymentRow.orderId,payMode);
          return;
        }
        this.appInsightsService.logPaymentEvent(true, `Received CreatePaymentIntent response. Order Id: ${paymentRow.uniqueTransId} response : ${JSON.stringify(response)} `, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : paymentRow.uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
        paymentRow.stripePaymentIntentId = response.PaymentIntentId;
        this.stripeClientSecret = response.ClientSecret;
        this.callStripeHostedPage();
      },
      error: (err) => {
        const errorResponse = this.handelStripeError(err);
        this.saveStripeCCTransactionFail(errorResponse, paymentTrnsId, paymentRow.orderId,payMode);
      },
      complete: () => {
        this.loaderIcon = Promise.resolve(false);
      }
    });

  } catch (error) {
    console.error('createPaymentIntent error:', error);
    this.loaderIcon = Promise.resolve(false);
  }
}
  getConfirmationTokenData(confirmationTokenInfo) {
    this.paymentInProgress = true;
    this.ConfirmPaymentIntent(confirmationTokenInfo, null);
  }

  GetChargesDetailsByIntentId() {
    let paymentIntentId = this.paymentTable.find(o => o.payId === this.currentPayId).stripePaymentIntentId;
    let orderId = this.paymentTable.find(o => o.payId == this.currentPayId).orderId;
    let paymentMode = this.paymentTable.find(o => o.payId == this.currentPayId).payModeId;
      if (paymentMode !== EPaymentModes.CreditCard && this.stripeModalRef) {
        this.stripeModalRef.hide();
      }
    let paymentTrnsId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
    const obj = {
      PaymentIntentId: paymentIntentId,
      FacilityId: this.processPayment.facId,
      PayId: this.currentPayId,
      OrderId: orderId,
      PaymentTrnsId: paymentTrnsId,
      PaymentModeId: paymentMode
    }
    this.callGetStripeCharge(obj);
  }

ConfirmPaymentIntent(confirmationTokenInfo: any, paymentMethodId: string): void {
  this.loaderIcon = Promise.resolve(true);

  try {
    const selectedPayment = this.paymentTable.find(o => o.payId === this.currentPayId);
    if (!selectedPayment) {
      throw new Error('Payment record not found');
    }
    const paymentTrnsId =this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
    /* AUTOPAY FLOW  */
    if (this.isPaymentWithAutoPay && [ EPaymentModes.ACH, EPaymentModes.DirectDebitEFT].includes(this.paymentTable.find(o => o.payId === this.currentPayId).payModeId)) {
      this.isPaymentWithAutoPay = false;
      if (
        selectedPayment.payModeId !== EPaymentModes.CreditCard &&this.stripeModalRef) {
        this.stripeModalRef.hide();
      } 
      if (this.paymentTable.find(o => o.payId === this.currentPayId).payModeId == EPaymentModes.ACH) {
        this.paymentService.GetCardDetailsByPaymentMethodId(this.facilityId, confirmationTokenInfo.payment_method).subscribe((response: any) => {
          if (response) {
            const ACHModel = {
              LeaseNo: this.processPayment?.LeaseNo,
              FacilityId:this.facilityId,
              Amount: 0,
              OrderId: this.autopaySetupAchRows[this.currentPayId]?.Id ?? null,
              Autopay: false,
              paymentModeId: selectedPayment.payModeId,
              AutoCcProcessingDay: 0,
              Reason: response.Status ?? '',
              AchAccountNumber: response.AccountNumber ?? '',
              AchRoutingNumber: response.RoutingNumber ?? '',
              PaymentAccountId: response.PaymentMethodId ?? '',
              PaymentIntentId: this.stripeSetupIntent,
              AchAuthorizationCode: "",
              PaymentTransactionTypeId: EPaymentTransactionTypes.ProcessCreditCard,
              TransactionTypeId: EPaymentTransactionType.Processed,
              ActIntAchaccountType: EACHAccountType.Checking,
              AchAccountClass: 276,
              ResponseCode: "00",
              TenantId: this.processPayment?.TenantId ?? null,
              GatewayDetails: this.requestgatewaydetails
            };
            this.paymentService.saveACHTransaction(Object.assign(ACHModel)).subscribe((res: any) => { });
          }
        });
      }
      const inputObj = {
        OrderId: selectedPayment.uniqueTransId,
        UserId: this.userSessionService.userSessionData?.UserId,
        TenantId: this.processPayment?.TenantId,
        TransactionType: this.getLovTransactionType(),
        Amount: Number(this.amountToPay) * 100,
        FacilityId: this.facilityId,
        LeaseNo: this.processPayment?.LeaseNo,
        PaymentMethod: confirmationTokenInfo?.payment_method,
        Customer:this.processPayment?.CustomerId ||this.facOpsDataService?.saveautopay?.CustomerId ||'',
        PaymentTransactionType: this.getTransactionType(),
      };
       this.appInsightsService.logPaymentEvent(true, `Call  processPaymentWithAutopay  . Order Id: ${selectedPayment.uniqueTransId}`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId :selectedPayment.uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
      this.paymentService.processPaymentWithAutopay(inputObj).subscribe({next: (response: any) => {
         this.appInsightsService.logPaymentEvent(true, `Received processPaymentWithAutopay response. Order Id: ${selectedPayment.uniqueTransId} `, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : selectedPayment.uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
          selectedPayment.stripePaymentIntentId = response?.PaymentIntentId;
          this.GetStripeResponse(response,this.currentPayId,selectedPayment.orderId,paymentTrnsId,selectedPayment.payModeId);
        },
        error: (errorResponse) => {
          let apiResponse = errorResponse?.error || {};
          apiResponse.Reason = apiResponse?.Reason ||apiResponse?.error ||apiResponse?.Message || errorResponse?.error || 'Payment Failed!';
          apiResponse.Success = false;
          this.paymentTable.find(o => o.payId === this.currentPayId).EnableAutopayOrCardOnFile = 'cancel';
          this.GetStripeResponse(apiResponse, this.currentPayId, selectedPayment.orderId, paymentTrnsId, selectedPayment.payModeId);
        },
        complete: () => {
          this.loaderIcon = Promise.resolve(false);
        }
      });

      return;
    }

    /* NORMAL CONFIRM FLOW  */
    const paymentIntentId = selectedPayment.stripePaymentIntentId;
    if (!paymentIntentId) {
      throw new Error('Missing PaymentIntentId');
    }
    const confirmationId = confirmationTokenInfo?.id || null;
    this.appInsightsService.logPaymentEvent(true, `Call  ConfirmPaymentIntent . Order Id: ${selectedPayment.uniqueTransId}`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : selectedPayment.uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
    this.paymentService.ConfirmPaymentIntent(this.facilityId,paymentIntentId,paymentMethodId,confirmationId).subscribe({
      next: (response: any) => {
        this.appInsightsService.logPaymentEvent(true, `Received ConfirmPaymentIntent response. Order Id: ${selectedPayment.uniqueTransId} response : ${JSON.stringify(response)} `, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : selectedPayment.uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
        if (!response) return;
        if (response.Status === 'requires_action' && response.ClientSecret && selectedPayment.payModeId === EPaymentModes.HostedPage) {
          this.prePayStatus = 'Payment';
          this.generalService.stripeMethod(this.stripePublishableKey,response.ClientSecret);
        } else if (selectedPayment.payModeId !== EPaymentModes.CreditCard) {
          this.prePayStatus = 'Payment';
          this.GetChargesDetailsByIntentId();
        }
      },
      error: (err) => {
        if (err?.error?.error) {
          const errorReason= err.error?.error;
          this.closeStripeModal(errorReason);
          this.toastr.error(err.error.error, 'Failure', this.toasterConfig);
        } else {
          const errorReason=err?.error?.detail
          this.closeStripeModal(errorReason);
          this.toastr.error(err?.error?.detail, 'Failure', this.toasterConfig);
        }
      },
      complete: () => {
        this.loaderIcon = Promise.resolve(false);
      }
    });
  } catch (error) {
    const errorReason=error?.error?.detail
    this.closeStripeModal(errorReason);
    console.error(error?.error?.detail, error);
    this.loaderIcon = Promise.resolve(false);
  }
}

  GetStripeResponse(stripeRes, payId, orderId, paymentTrnsId, paymentMode) {
    this.isOpenEdgeEMVCompleted = true;
    this.stripeLoader.isStripeterminal = false;
    this.loaderIcon = Promise.resolve(false);
    this.paymentTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted = true;
    if (stripeRes?.Success) {
      this.cleanupSignalR();
      this.paymentSuccessFul = true;
      this.payStatus = 'Success';
      this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = false;
      this.disableNextButton();
      if ([EPaymentModes.CreditCard, EPaymentModes.HostedPage, EPaymentModes.CardOnfile, EPaymentModes.DebitCard].includes(paymentMode)) {
        if (paymentMode == EPaymentModes.CreditCard && stripeRes.IsInteracPayment) {
          let requestgatewaydetailsObj = JSON.parse(this.requestgatewaydetails);
          requestgatewaydetailsObj['IsInteracPayment'] = stripeRes.IsInteracPayment;
          this.requestgatewaydetails = JSON.stringify(requestgatewaydetailsObj);
        }
        const stripeCCModel = {
          Amount: parseFloat(stripeRes.Amount) / 100,
          Autopay: false,
          PaymentModeId: paymentMode,
          AutoCcProcessingDay: 0,
          CreditCardNumber: `XXXXXXXXXXX${stripeRes.CreditCardNumber}`,
          CreditCardType: this.paymentService.openEdgeCardType(stripeRes.CardBrand),
          NameonCard: stripeRes.CreditHolderName,
          CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(stripeRes.ExpiryMonth, 10)),
          CreditCardExpiryYear: parseInt(stripeRes.ExpiryYear, 10),
          CreditCardBillingAddress: stripeRes?.BillingDetails?.Address ? ((stripeRes.BillingDetails.Address.Line1 ?? '') + ',' + (stripeRes.BillingDetails.Address.Line2 ?? '')).trim().slice(0, 50) : '',
          CreditCardBillingZip: stripeRes?.BillingDetails?.Address?.PostalCode ?? "",
          SwipeTransaction: false,
          SecurityCodeSent: false,
          AuthorizationCode: stripeRes.ChargeId,
          Key: stripeRes.PaymentIntentId,
          ResponseCode: stripeRes.ResponseCode,
          Reason: stripeRes?.Reason ?? '',
          PaymentAccountid: paymentMode == EPaymentModes.CardOnfile && stripeRes.PaymentMethodId ? stripeRes.PaymentMethodId : "",
          CcInfoPurged: false,
          DebitCardPayment: stripeRes.CardType == 'debit',
          OfflinePayment: 0,
          PaymentTransactionTypeId: paymentTrnsId,
          TransactionDateTime: new Date(),
          TransactionTypeId: EPaymentTransactionType.Processed,
          OrderId: orderId,
          EmvReceiptText: stripeRes.ReceiptUrl,
          TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
          TenantId: this.processPayment.TenantId ? this.processPayment.TenantId : null,
          FacilityId: this.processPayment.facId,
          GatewayDetails: this.requestgatewaydetails,
          PaymentMethodId: stripeRes.PaymentMethodId,
          CustomerId: stripeRes?.CustomerId ?? '',
          GatewayId : this.paymentGateway
        };
        this.paymentTable.find(o => o.payId == this.currentPayId)['processedStripeCC'] = stripeCCModel;
        // Story 2.5 (FR-8): reject payment if Stripe Terminal card type mismatches selected mode.
        // Only applies to terminal card modes (CreditCard, DebitCard) — HostedPage/CardOnfile don't swipe.
        if ([EPaymentModes.CreditCard, EPaymentModes.DebitCard].includes(paymentMode)) {
          const isStripeDebitFromGateway = stripeRes.CardType == 'debit';
          if (this.checkCardModeMismatch(payId, isStripeDebitFromGateway)) {
            // Cancel the PaymentIntent on Stripe before showing the alert.
            this._isMismatchVoid = true;
            this.cancelPaymentIntent(stripeCCModel, stripeCCModel.Amount, paymentTrnsId, paymentMode, orderId);
            return;
          }
        }
        if ([EPaymentOrigin.Rental, EPaymentOrigin.Transfer, EPaymentOrigin.ReInstate, EPaymentOrigin.MakePayment].includes(this.processPayment.Type) && this.paymentTable.find(ele => ele.payId == payId && ele.EnableAutopayOrCardOnFile != 'cancel')) {
          this.setUpStripeAutopayModel(stripeCCModel, paymentMode, payId);
        }
      } else if ([EPaymentModes.DirectDebitEFTOnFile, EPaymentModes.ACHOnFile].includes(paymentMode)) {
        const stripeACHModel = {
          APPROVEDAMOUNT: (stripeRes.Amount) / 100,
          CHECKNUMBER: '',
          TRANSACTIONID: stripeRes.ChargeId,
          RESPONSECODE: stripeRes.ResponseCode,
          RESPONSEDESCRIPTION: stripeRes?.Reason ?? "",
          ACCOUNT: this.accountNumber,
          ROUTINGNUMBER: this.routingNumber,
          RECEIPTTEXT: '',
          ACCOUNTYPE: '',
          PaymentIntentId: stripeRes.PaymentIntentId,
          PaymentAccountId: this.paymentAccountId,
          PaymentMethod: this.PaymentMethod,
          PaymentAccountid: paymentMode == EPaymentModes.CardOnfile && stripeRes.PaymentMethodId ? stripeRes.PaymentMethodId : "",
          IsStripeEFT: (paymentMode == EPaymentModes.ACHOnFile) ? false : true,
          CustomerId: stripeRes?.CustomerId ?? ''
        }
        this.paymentTable.find(o => o.payId == this.currentPayId)['processedACH'] = stripeACHModel;
      } else if ([EPaymentModes.ACH, EPaymentModes.DirectDebitEFT].includes(paymentMode)) {
        const stripeModel = {
          APPROVEDAMOUNT: parseFloat(stripeRes.Amount) / 100,
          CHECKNUMBER: stripeRes?.InstitutionNumber ?? '',
          TRANSACTIONID: stripeRes.ChargeId,
          RESPONSECODE: stripeRes.ResponseCode,
          RESPONSEDESCRIPTION: stripeRes?.Reason ?? "",
          ACCOUNT: stripeRes.AccountNumber,
          ROUTINGNUMBER: paymentMode == EPaymentModes.DirectDebitEFT ? stripeRes.TransitNumber : stripeRes.RoutingNumber,
          PaymentIntentId: stripeRes.PaymentIntentId,
          PaymentAccountId: stripeRes.PaymentMethodId,
          IsStripeEFT: paymentMode == EPaymentModes.DirectDebitEFT ? true : false,
          CustomerId: stripeRes?.CustomerId ?? ''
        }
        this.paymentTable.find(o => o.payId == this.currentPayId)['processedACH'] = stripeModel;
        if ([EPaymentOrigin.Rental, EPaymentOrigin.Transfer, EPaymentOrigin.ReInstate, EPaymentOrigin.MakePayment].includes(this.processPayment.Type) && this.paymentTable.find(ele => ele.payId == payId && ele.EnableAutopayOrCardOnFile != 'cancel')) {
          this.setUpStripeAutopayModel(stripeModel, paymentMode, payId);
        }
      }
      this.gotoPaymentSuccess(this.popUpPayment, (parseFloat(stripeRes.Amount) / 100).toFixed(2));
    } else {
      this.saveStripeCCTransactionFail(stripeRes, paymentTrnsId, orderId, paymentMode);
    }
  }

  saveStripeCCTransactionFail(stripFailedResponse, paymentTrnsId, orderId, paymentMode) {
    this.isTDEmv.isTransactionWaitTime = false;
    this.paymentTable.find(o => o.payId == this.currentPayId).isOpenEdgePaymentCompleted = true;
    this.paymentTable.find(o => o.payId === this.currentPayId).EnableAutopayOrCardOnFile == 'cancel';
    this.paymentSuccessFul = false;
    this.paymentProcessing = false;
    this.retryTransactionStatusLoader = false;
    this.prePayStatus = 'Payment';
    this.payStatus = 'Failed';
    this.paymentStarted = false;
    this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
    this.isAnyPaymentProcessed();
    this.toastr.error(`Payment Failed! - $${this.amountToPay}`, 'Failure', this.toasterConfig);
    if (this.credentials?.DeviceSettings?.length > 1) {
      this.paymentTable.find(o => o.payId === this.currentPayId).TerminalDeviceId = '';
      this.selectStripeReaderId = '';
    }
    let obj = {
      amountToPay: this.amountToPay,
      paymentMode: paymentMode,
      paymentTrnsId: paymentTrnsId,
      orderId: orderId,
      requestgatewaydetails: this.requestgatewaydetails
    }
    this.paymentFailReason = stripFailedResponse && stripFailedResponse.Reason ? stripFailedResponse.Reason : "Payment Failed!";
    const CCModel = this.paymentService.saveCCTFailModelStripe(stripFailedResponse, this.processPayment, obj);
    if (stripFailedResponse.PaymentIntentId) {
      this.appInsightsService.logPaymentEvent(true, `Call  CancelPaymentIntent. Order Id: ${ this.paymentTable.find(o => o.payId == this.currentPayId).uniqueTransId}`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId :  this.paymentTable.find(o => o.payId == this.currentPayId).uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
      this.paymentService.CancelPaymentIntent(stripFailedResponse.PaymentIntentId, this.processPayment.facId).subscribe((cancelRes: any) => {
        if(cancelRes)
        {
              this.appInsightsService.logPaymentEvent(true, `Received CancelPaymentIntent response. Order Id: ${this.paymentTable.find(o => o.payId == this.currentPayId).uniqueTransId} `, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : this.paymentTable.find(o => o.payId == this.currentPayId).uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
        }
       });
    }
    this.paymentService.saveCCTransaction(Object.assign(CCModel)).subscribe((res: any) => { });
    this.gotoPaymentSuccess(this.popUpPayment, 0);
    this.loaderIcon = Promise.resolve(false);
  }

  capturePaymentIntent(facilityId, paymentIntentId, orderId) {
    this.paymentService.CapturePaymentIntent(facilityId, paymentIntentId).subscribe((response: any) => {
      if (response.Status == "succeeded") {
        this.paymentService.updateCreditCardPaymentReason(orderId, response.Status).subscribe((response: any) => { })
      }
    }, err => {
    });
  }

  onRemotePayCancel() {
    this.remotePayModalRef.hide();
    this.remotePayIsSMS = false;
    this.remotePayPhoneNumber = '';
    this.remotePayIsEmail = false;
    this.remotePayEmailId = '';
    this.checkPaymentProcess();
  }

  disableRemotePayOK(smsVal, emailVal) {
    if (!this.remotePayIsSMS && !this.remotePayIsEmail) {
      return true;
    } else {
      if (this.remotePayIsSMS && (!smsVal.value || smsVal.value.length < 10)) {
        return true;
      }
      if (this.remotePayIsEmail && (!emailVal.value || !emailVal.valid)) {
        return true;
      }
    }
    return false;
  }

 onRemotePayOK(): void {
  this.loaderIcon = Promise.resolve(true);
  try {
    if (!this.processPayment?.UnitDetails?.length) {
      throw new Error('No unit details found');
    }
    let amountRemaining = Number(this.amountToPay);

    const unitsList = this.processPayment.UnitDetails.map(item => {
      let appliedAmount = 0;

      if (this.processPayment.UnitDetails.length === 1) {
        appliedAmount = amountRemaining;
      } else if (amountRemaining >= item.Amount) {
        appliedAmount = item.Amount;
        amountRemaining -= item.Amount;
      } else {
        appliedAmount = amountRemaining;
        amountRemaining = 0;
      }

      appliedAmount = appliedAmount? Number(this.decimalPipe.transform(appliedAmount, '1.2-2')?.replace(/,/g, '')): appliedAmount;
      return {
        Id: item.UnitId,
        LeaseNo:[EPaymentOrigin.Reservation, EPaymentOrigin.Rental].includes(this.processPayment.Type) ||(this.processPayment.Type === EPaymentOrigin.Transfer && !item.TransferOutUnit)? 0 : item.LeaseNo,
        ReservationNo:this.processPayment.Type === EPaymentOrigin.Reservation? item.ReservationNo: 0,
        UnitNo: item.UnitNo,
        Amount: appliedAmount,
        PaymentDistribution: item.PaymentDistribution
      };
    });

    let tenantData = null;
    if (this.tenantModel) {
      tenantData = this.createTenantInfoModel();
      tenantData.SendSmsAlerts = this.remotePayIsSMS;
      tenantData.SMSEnabled = this.tenantModel.SendSMSAlerts ? 'YES' : 'NO';
    }

    const inputObj = {
      FacilityId: this.processPayment.facId,
      TenantId: this.processPayment.TenantId,
      TotalAmount: this.amountToPay,
      EmailAddress: this.remotePayIsEmail ? this.remotePayEmailId : '',
      PhoneNumber: this.remotePayIsSMS ? this.remotePayPhoneNumber : '',
      TransactionTypeId: this.paymentService.GetTransactionTypeId(this.processPayment.Type),
      PaymentTransactionTypeId: this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type),
      UnitsBeingPaidFor: unitsList,
      TenantInfo: tenantData,
      LeaseInfo: this.leaseModel
    };
    this.generalService.emailSmsModelForRemotePay = [];
    this.appInsightsService.logPaymentEvent(true, `Call  GenerateRemotePayLink. Order Id: ${this.paymentTable.find(o => o.payId == this.currentPayId).uniqueTransId}`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : this.paymentTable.find(o => o.payId == this.currentPayId).uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
    this.paymentService.GenerateRemotePayLink(inputObj).subscribe({
      next: (response: any) => {
        if (response?.Success && (response.EmailSent || response.SmsSent || ((this.processPayment.Type == EPaymentOrigin.Rental || this.processPayment.Type == EPaymentOrigin.Transfer) && response.EmailSmsModelForRemotePay != null))) {
          this.paymentSuccessFul = true;
          if (response?.EmailSmsModelForRemotePay) {
            this.generalService.emailSmsModelForRemotePay.push(
              response.EmailSmsModelForRemotePay
            );
          }
          this.RemotePayTransactionId = response.RemotePayTransactionId;
          this.toastr.success('Remote Pay Link Generated successfully', 'Success',this.toasterConfig);
           this.appInsightsService.logPaymentEvent(true, `gotoPaymentSuccess . Order Id: ${this.paymentTable.find(o => o.payId == this.currentPayId).uniqueTransId}`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : this.paymentTable.find(o => o.payId == this.currentPayId).uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
          this.gotoPaymentSuccess(this.popUpPayment, this.amountToPay);
        } else {
          this.paymentSuccessFul = false;
          this.payStatus = 'Failed!';
          this.toastr.error('Failed to Generate Remote Pay Link', 'Failure', this.toasterConfig);
        }
      },
      error: () => {
        this.paymentSuccessFul = false;
        this.payStatus = 'Failed!';
        this.toastr.error('Failed to Generate Remote Pay Link','Failure',this.toasterConfig);
      },
      complete: () => {
        this.remotePayModalRef?.hide();
        this.loaderIcon = Promise.resolve(false);
      }
    });

  } catch (error) {
    console.error('onRemotePayOK error:', error);
    this.remotePayModalRef?.hide();
    this.loaderIcon = Promise.resolve(false);
  }
}

  callGetStripeCharge(payDetails: any): void {
    this.loaderIcon = Promise.resolve(true);
    try {
      const stripePaymentTable = this.paymentTable.find(o => o.payId === payDetails.PayId);
      if (!stripePaymentTable) {
        throw new Error('Payment row not found');
      }
      const readerId = stripePaymentTable.payModeId === EPaymentModes.CreditCard ? stripePaymentTable.TerminalDeviceId : '';
      this.appInsightsService.logPaymentEvent(true, `Call  GetChargesDetailsByIntentId  . Order Id: ${stripePaymentTable.uniqueTransId}`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId :stripePaymentTable.uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
      this.paymentService.GetChargesDetailsByIntentId(payDetails.PaymentIntentId, payDetails.FacilityId, readerId).subscribe({
        next: (res: any) => {
          this.appInsightsService.logPaymentEvent(true, `received  GetChargesDetailsByIntentId response . Order Id: ${stripePaymentTable.uniqueTransId}`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId :stripePaymentTable.uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
          if (!res) return;
          this.mandateId = res.MandateId;
          if (!res.CreditHolderName && payDetails?.NameOnCard) {
            res.CreditHolderName = payDetails.NameOnCard;
          }
          if (payDetails.PaymentModeId !== EPaymentModes.CreditCard && this.stripeModalRef) {
            this.stripeModalRef.hide();
          }
          if (res.Success && stripePaymentTable.EnableAutopayOrCardOnFile !== 'cancel') {
            if (this.autopayLinledUnitList.length > 0) {
              this.stripeResponse = res;
              this.loaderIcon = Promise.resolve(false);
              this.linkedAutopayModalRef = this.modalService.show(this.linkedAutopay, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
              return;
            }
          }
          if (payDetails.PaymentModeId === EPaymentModes.CreditCard && res.ResponseCode === '-1' && res.Reason === 'Transaction Time Out!') {
            this.toastr.warning('Please ask Administrator to Reset the Terminal Device', 'Alert', this.toasterConfig);
          }
          this.GetStripeResponse(res, payDetails.PayId, payDetails.OrderId, payDetails.PaymentTrnsId, payDetails.PaymentModeId);
        },
        error: () => {
          if (payDetails.PaymentModeId !== EPaymentModes.CreditCard && this.stripeModalRef) {
            this.stripeModalRef.hide();
          }
        },
        complete: () => {
          this.loaderIcon = Promise.resolve(false);
        }
      });
    } catch (error) {
      console.error('callGetStripeCharge error:', error);
      this.loaderIcon = Promise.resolve(false);
    }
  }

  OnFileStripe(amount, cct, payId, paymentTrnsId, payModeId) {
    this.loaderIcon = Promise.resolve(true);
    let ccDetails = this.ccAutoPayDetails();
    this.PaymentMethod = ccDetails.PaymentMethod;
    this.accountNumber = ccDetails.AccountNumber;
    this.routingNumber = ccDetails.RoutingNumber;
    this.paymentAccountId = ccDetails.PaymentMethod;
    this.mandateId = ccDetails.MandateId;
    let inputObj = {
      OrderId: cct.UniqueTransId,
      UserId: this.userSessionService.userSessionData.UserId,
      TenantId: this.processPayment.TenantId,
      TransactionType: this.getLovTransactionType(),
      Amount: parseFloat(amount) * 100,
      FacilityId: this.facilityId,
      SelectedPaymentModeType: payModeId == EPaymentModes.ACHOnFile ? 'ACH' : 'EFT',
      LeaseNo: this.processPayment.LeaseNo,
      PaymentMethod: this.PaymentMethod,
      Mandate: this.mandateId,
      Confirm: true,
      Success: true,
      Customer: this.processPayment?.CustomerId ? this.processPayment.CustomerId
        : this.facOpsDataService?.saveautopay?.CustomerId || '',
      PaymentTransactionType: this.getTransactionType()
    }
    this.paymentService.getPaymentIntent_Stripe(inputObj).subscribe((response: any) => {
      if (inputObj.SelectedPaymentModeType == 'ACH') {
        this.GetStripeResponse(response, payId, cct.Id, paymentTrnsId, EPaymentModes.ACHOnFile);
      } else {
        this.GetStripeResponse(response, payId, cct.Id, paymentTrnsId, EPaymentModes.DirectDebitEFTOnFile);
      }
    }, err => {
      this.GetStripeResponse(err.error, payId, cct.Id, paymentTrnsId, EPaymentModes.ACHOnFile);
    });
  }

  cardOnFileStripe(amount: any, cct: any, payId: any, paymentTrnsId: any): void {

    this.loaderIcon = Promise.resolve(true);
    try {
      if (!cct || !amount) {
        throw new Error('Invalid card-on-file input');
      }

      const paymentRow = this.paymentTable.find(o => o.payId === payId);
      if (!paymentRow) {
        throw new Error('Payment row not found');
      }

      const tdAutoPayDetails = this.ccAutoPayDetails();
      if (!tdAutoPayDetails?.PaymentAliasKey) {
        throw new Error('Missing autopay payment method');
      }

      const inputObj = {
        OrderId: cct.UniqueTransId,
        UserId: this.userSessionService.userSessionData?.UserId,
        TenantId: this.processPayment?.TenantId,
        TransactionType: this.getLovTransactionType(),
        Amount: Number(amount) * 100,
        FacilityId: this.facilityId,
        SelectedPaymentModeType: 'CardOnFile',
        LeaseNo: this.processPayment?.LeaseNo,
        PaymentMethod: tdAutoPayDetails.PaymentAliasKey,
        Customer:
          this.processPayment?.CustomerId ||
          this.facOpsDataService?.saveautopay?.CustomerId ||
          '',
        PaymentTransactionType: this.getTransactionType()
      };
      this.appInsightsService.logPaymentEvent(true, `Call getPaymentIntent_Stripe`, { Gateway: 204 , FacilityId : this.userSessionService.userSessionData.LastAccessedStoreId, UserId : this.userSessionService.userSessionData.UserId});
      this.paymentService.getPaymentIntent_Stripe(inputObj).subscribe({
        next: (response: any) => {
          if (!response) {
            this.GetStripeResponse(this.handelStripeError(null), payId, cct.Id, paymentTrnsId, EPaymentModes.CardOnfile);
            return;
          }
          if (response.Status === 'requires_capture') {
            this.appInsightsService.logPaymentEvent(true, `Received  getPaymentIntent_Stripe response`, { Gateway: 204 , FacilityId : this.userSessionService.userSessionData.LastAccessedStoreId, UserId : this.userSessionService.userSessionData.UserId});
            paymentRow.stripePaymentIntentId = response.PaymentIntentId;

            const obj = {
              PaymentIntentId: response.PaymentIntentId,
              FacilityId: this.facilityId,
              PayId: payId,
              OrderId: cct.Id,
              PaymentTrnsId: paymentTrnsId,
              PaymentModeId: EPaymentModes.CardOnfile,
              NameOnCard: tdAutoPayDetails.NameOnCard
            };

            this.callGetStripeCharge(obj);
          } else {
            response.CreditHolderName = tdAutoPayDetails?.NameOnCard ?? '';
            this.GetStripeResponse(response, payId, cct.Id, paymentTrnsId, EPaymentModes.CardOnfile);
          }
        },
        error: (err) => {
          const errorResponse = this.handelStripeError(err);
          this.GetStripeResponse(errorResponse, payId, cct.Id, paymentTrnsId, EPaymentModes.CardOnfile);
        },
        complete: () => {
          this.loaderIcon = Promise.resolve(false);
        }
      });

    } catch (error) {
      console.error('cardOnFileStripe error:', error);
      this.loaderIcon = Promise.resolve(false);
    }
  }

  handelStripeError(err) {
    const obj = {
      Reason: err?.error?.detail ?? 'Declined!',
      ResponseCode: err?.error?.status ?? '',
      Success: false
    }
    return obj;
  }

  onSelectAutopay(eve: string) {
    this.loaderIcon = Promise.resolve(true);
    this.enableAutopayOrCardOnFile.hide();
    this.paymentTable.find(o => o.payId === this.currentPayId).EnableAutopayOrCardOnFile = eve;
    let selectedPaymentModeId = this.paymentTable.find(o => o.payId === this.currentPayId).payModeId;
    if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress && selectedPaymentModeId == EPaymentModes.HostedPage
      && this.canUseOpenEdgePayFieldsRuntime()) {
      this.openPayFieldsEmbeddedForm(this.tempCNPAmount, this.currentPayId);
      return;
    }
    if (eve == 'cancel') {
      if ([EPaymentModes.HostedPage, EPaymentModes.ACH, EPaymentModes.DirectDebitEFT].includes(selectedPaymentModeId)) {
        this.createPaymentIntent(this.amountToPay, selectedPaymentModeId, this.currentPayId);
      } else {
        this.stripeTerminalPayment();
      }
    } else { //Process Autopay and Payment
      this.isPaymentWithAutoPay = true;
      if ([ EPaymentModes.ACH, EPaymentModes.DirectDebitEFT].includes(selectedPaymentModeId)) {
        this.callPaymentWithAutopay();
      } else if (selectedPaymentModeId == EPaymentModes.CreditCard) {
        this.stripeTerminalPayment();
      }
      else if(selectedPaymentModeId == EPaymentModes.HostedPage) {
        this.createPaymentIntent(this.amountToPay, selectedPaymentModeId, this.currentPayId);
      }
    }
  }

  async stripeTerminalPayment(): Promise<void> {
    const payId = this.currentPayId;
    const paymentTrnsId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
    const paymentRow = this.paymentTable.find(o => o.payId === payId);

    if (!paymentRow || !this.credentials?.DeviceSettings?.length || !paymentRow.TerminalDeviceId) {
      this.toastr.warning('Please ask Administrator to configure Device Setup', 'Device Setup required', this.toasterConfig);
      this.saveStripeCCTransactionFail({ Reason: 'Device Setup required!' }, paymentTrnsId, paymentRow?.orderId, EPaymentModes.CreditCard);
      this.loaderIcon = Promise.resolve(false);
      return;
    }

    this.paymentMaxWaitTime ??= 2;
    paymentRow.isOpenEdgePaymentCompleted = false;
    this.paymentInProgress = true;
    this.isOpenEdgeEMVCompleted = false;
    this.stripeTerminalDeviceId = paymentRow.TerminalDeviceId;
    this.requestGatewaydetails(paymentRow.payModeId, paymentRow.payId);
    const customerObj = this.IsQuickProspect && this.tenantModel
      ? {
        Name: this.tenantModel.BusinessAccount ? this.tenantModel.CompanyName : `${this.tenantModel.FirstName}${this.tenantModel.MiddleName ? ' ' + this.tenantModel.MiddleName : ''} ${this.tenantModel.LastName}`.trim(),
        Email: this.tenantModel.Email,
        Phone: this.tenantModel.CellPhoneNumber
      }
      : {
        Name: this.customerInfo.FullName,
        Email: this.customerInfo.Email,
        Phone: this.customerInfo.CellPhoneNumber
      };
    const requestObj = {
      Amount: Number(this.amountToPay),
      OrderId: paymentRow.uniqueTransId,
      DeviceId: paymentRow.TerminalDeviceId,
      TransactionType: this.getLovTransactionType(),
      TenantId: this.processPayment?.TenantId ?? 0,
      StripePaymentType: 'SALE',
      Name: customerObj.Name,
      Email: customerObj.Email,
      Phone: customerObj.Phone,
      FacilityId: this.processPayment.facId,
      EnableAutopayOrCardOnFile: paymentRow.EnableAutopayOrCardOnFile,
      IsQuickProspectPayment: this.IsQuickProspect,
      PaymentTransactionType: this.getTransactionType(),
      SignalRConnectionId: ''
    };
    try {
      await this.signalRService.startConnection(this.baseUrl);
    } catch (err) {
      console.error('SignalR connection failed before terminal payment:', err);
      this.resetTerminalUI();
      return;
    }
    requestObj.SignalRConnectionId = this.signalRService.getConnectionId();
    this.appInsightsService.logPaymentEvent(true, `Call  processTerminalPayment. Order Id: ${paymentRow.uniqueTransId}`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : paymentRow.uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
    this.paymentService.processTerminalPayment(requestObj).subscribe({
      next: (stripeRes: any) => {
            this.appInsightsService.logPaymentEvent(true, `Received processTerminalPayment response. Order Id: ${paymentRow.uniqueTransId} `, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : paymentRow.uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
        this.showLoaderMesage = false;
        this.stripeLoader.isStripeterminal = true;
        this.isTDEmv.isTransactionWaitTime = true;
        this.loaderIcon = Promise.resolve(true);

        if (!stripeRes?.Success) {
          this.isStripeTerminalPay = stripeRes?.Reason === 'Another Transaction is in Progress';
          this.signalRService.stopConnection();
          this.saveStripeCCTransactionFail(stripeRes, paymentTrnsId, paymentRow.orderId, EPaymentModes.CreditCard);
          this.resetTerminalUI();
          return;
        }
        paymentRow.stripePaymentIntentId = stripeRes.PaymentIntentId;
        this.appInsightsService.logPaymentEvent(true, `Initiating SignalR connection for Stripe Terminal updates. Order Id: ${paymentRow.uniqueTransId}`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : paymentRow.uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
        this.signalRService.addStripeResponseListener('ReceivePaymentUpdate');
        this.stripeResponseSubscription = this.signalRService.stripeResponse$.subscribe({
          next: (response: any) => {
            this.cleanupSignalR();
            this.appInsightsService.logPaymentEvent(true, `Recevied respone from stripe terminal device. Order Id: ${paymentRow.uniqueTransId}`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : paymentRow.uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
            const result = JSON.parse(response);
            this.stripeResponse = result;
            this.isTDEmv.isTransactionWaitTime = false;
            if (result.Success && result.OrderId === paymentRow.uniqueTransId && paymentRow.EnableAutopayOrCardOnFile !== 'cancel' && this.autopayLinledUnitList.length > 0) {
              this.loaderIcon = Promise.resolve(false);
              this.linkedAutopayModalRef = this.modalService.show(this.linkedAutopay, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
              return;
            }

            if (result.Success && result.OrderId !== paymentRow.uniqueTransId) {
              stripeRes.Reason = `Another Transaction in progress - OrderId mismatch`;
              this.saveStripeCCTransactionFail(stripeRes, paymentTrnsId, paymentRow.orderId, EPaymentModes.CreditCard);
              return;
            }
            if (result.OrderId == paymentRow.uniqueTransId && !paymentRow.isOpenEdgePaymentCompleted) {
              this.appInsightsService.logPaymentEvent(true, `Go to GetStripeResponse. Order Id: ${paymentRow.uniqueTransId}`, { Gateway: this.paymentGateway , FacilityId : this.processPayment.facId, OrderId : paymentRow.uniqueTransId, UserId : this.userSessionService.userSessionData.UserId});
              this.GetStripeResponse(result, payId, paymentRow.orderId, paymentTrnsId, EPaymentModes.CreditCard);
            }
          },
          error: () => {
            this.saveStripeCCTransactionFail(stripeRes, paymentTrnsId, paymentRow.orderId, EPaymentModes.CreditCard);
          }
        });
      },
      error: (err) => {
        this.signalRService.stopConnection();
        const errorResponse = this.handelStripeError(err);
        this.saveStripeCCTransactionFail(errorResponse, paymentTrnsId, paymentRow.orderId, EPaymentModes.CreditCard);
        this.resetTerminalUI();
      }
    });

    setTimeout(() => {
      if (!paymentRow.isOpenEdgePaymentCompleted) {
        this.cleanupSignalR();
        paymentRow.isOpenEdgePaymentCompleted = true;
        this.isTDEmv.isTransactionWaitTime = false;
        if (paymentRow.stripePaymentIntentId) {
          this.callGetStripeCharge({
            PaymentIntentId: paymentRow.stripePaymentIntentId,
            FacilityId: this.processPayment.facId,
            PayId: payId,
            OrderId: paymentRow.orderId,
            PaymentTrnsId: paymentTrnsId,
            PaymentModeId: EPaymentModes.CreditCard
          });
        } else {
          this.loaderIcon = Promise.resolve(false);
        }
      }
    }, 60000 * this.paymentMaxWaitTime);
  }

private resetTerminalUI() {
  this.stripeLoader.isStripeterminal = false;
  this.isTDEmv.isTransactionWaitTime = false;
  this.paymentInProgress = false;
  this.loaderIcon = Promise.resolve(false);
}

private cleanupSignalR() {
  this.signalRService.stopConnection();
  this.unSubscribeSignalRSubscribe();
  this.stripeLoader.isStripeterminal = false;
}


  setUpStripeAutopayModel(autopayModel, paymentMode, payId) {
    let achAutopayMode = [EPaymentModes.ACH, EPaymentModes.DirectDebitEFT];
    let ccAutopayMode = [EPaymentModes.CreditCard, EPaymentModes.HostedPage];
    let autoCCObj = {
      LeaseNo: this.processPayment.LeaseNo,
      FacilityId: this.facilityId,
      Autopay: ccAutopayMode.includes(paymentMode) && this.paymentTable.find(o => o.payId === payId).EnableAutopayOrCardOnFile == 'autopay',
      AutoCcProcessingDay: ccAutopayMode.includes(paymentMode) ? this.dayendSettingDetails.DefaultAutoPayDay : 0,
      CreditCardNumber: autopayModel.CreditCardNumber ? autopayModel.CreditCardNumber : null,
      CreditCardType: autopayModel.CreditCardType ? autopayModel.CreditCardType : null,
      NameonCard: autopayModel.NameonCard ? autopayModel.NameonCard : '',
      CreditCardExpiryMonth: autopayModel.CreditCardExpiryMonth ? autopayModel.CreditCardExpiryMonth : 264,
      CreditCardExpiryYear: autopayModel.CreditCardExpiryYear ? autopayModel.CreditCardExpiryYear : null,
      CreditCardBillingAddress: autopayModel.CreditCardBillingAddress ? autopayModel.CreditCardBillingAddress : null,
      CreditCardBillingZip: autopayModel.CreditCardBillingZip ? autopayModel.CreditCardBillingZip : null,
      PaymentAccountId: autopayModel.PaymentMethodId,
      ACHPayment: achAutopayMode.includes(paymentMode) ? this.paymentTable.find(o => o.payId === payId).EnableAutopayOrCardOnFile == 'autopay' : null,
      ACHProcessingDay: achAutopayMode.includes(paymentMode) ? this.dayendSettingDetails.DefaultAutoPayDay : 0,
      DirectDebit: paymentMode == EPaymentModes.DirectDebitEFT ? true : false,
      DirectDebitProcessingDay: paymentMode == EPaymentModes.DirectDebitEFT ? this.dayendSettingDetails.DefaultAutoPayDay : 0,
      ACHAccountNo: autopayModel.ACCOUNT ? autopayModel.ACCOUNT : null,
      ACHRoutingNo: autopayModel.ROUTINGNUMBER ? autopayModel.ROUTINGNUMBER : null,
      ACHAccountClass: autopayModel.ACHaccountclass ? autopayModel.ACHaccountclass : null,
      ACHAccountType: autopayModel.ACHaccounttype ? autopayModel.ACHaccounttype : null,
      AccountHolder: autopayModel.AccountName ? autopayModel.AccountName : null,
      BankCode: autopayModel.bankcode ? autopayModel.bankcode : null,
      TransitNo: autopayModel.transitNo ? autopayModel.transitNo : null,
      BankAccountNo: autopayModel.Accountnumber ? autopayModel.Accountnumber : null,
      EmailPaymentReceipt: null,
      PrintPaymentReceipt: null,
      SeriesId: null,
      ACHPaymentAccountId: achAutopayMode.includes(paymentMode) && autopayModel.PaymentAccountId ? autopayModel.PaymentAccountId : null,
      AutopayLinkedUnitLeaseNoList: this.enableLinkedUnitLeaseNo,
      IsStripe: this.paymentGateway == EPaymentGateway.Stripe,
      MandateId: this.mandateId,
      TransactionTypeId: this.paymentService.GetTransactionTypeId(this.processPayment.Type),
      CustomerId: autopayModel.CustomerId,
      GatewayDetails: this.requestgatewaydetails
    };
    this.transferdataservice.pastdueautopay = autoCCObj;
    this.facOpsDataService.saveautopay = autoCCObj;

    let autopayObj = {
      Enabled: this.paymentTable.find(o => o.payId === payId).EnableAutopayOrCardOnFile == 'autopay',
      AutoCC: ccAutopayMode.includes(paymentMode) && this.paymentTable.find(o => o.payId === payId).EnableAutopayOrCardOnFile == 'autopay',
      AutoACH: achAutopayMode.includes(paymentMode) && this.paymentTable.find(o => o.payId === payId).EnableAutopayOrCardOnFile == 'autopay',
      Processed: true
    }
    this.facOpsDataService.autoPayData = autopayObj;
    return autoCCObj;
  }

  callLinkedUnlitList() {
    this.paymentService.callLinkedAutopayList(this.processPayment.facId, this.processPayment.TenantId, this.processPayment.LeaseNo).subscribe((res: any) => {
      if (res) {
        this.autopayLinledUnitList = res;
      }
    })
  }

  isAutopayEnabled() {
    const saveAutopay = this.facOpsDataService.saveautopay;
    const autoPayInfo = this.autoPayInfo;
    if (this.paymentTable.every(ele => ele.EnableAutopayOrCardOnFile == 'cancel')) {
      if (saveAutopay?.ACHPaymentAccountId || saveAutopay?.PaymentAccountId || autoPayInfo?.ACHPaymentAccountId || autoPayInfo?.PaymentAccountId) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  }

  onClickLinkeAutopay(eve) {
    this.stripeLoader.isStripeterminal = true;
    this.loaderIcon = Promise.resolve(true);
    this.linkedAutopayModalRef.hide();
    if (eve) {
      this.enableLinkedUnitLeaseNo = this.autopayLinledUnitList.map(ele => ele.LeaseNumber);
      this.LinkedleaseNo = this.enableLinkedUnitLeaseNo;
    } else {
      this.enableLinkedUnitLeaseNo = [];
      this.LinkedleaseNo= [];
    }
    let currentPayment = this.paymentTable.find(o => o.payId == this.currentPayId);
    let orderId = currentPayment.orderId;
    let payModeId = currentPayment.payModeId;
    let paymentTrnsId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
    if (!this.isPaymentWithAutoPay) {
      if ([EPaymentModes.ACH, EPaymentModes.DirectDebitEFT, EPaymentModes.HostedPage, EPaymentModes.CreditCard].includes(payModeId)) {
        this.GetStripeResponse(this.stripeResponse, this.currentPayId, orderId, paymentTrnsId, payModeId);
      }
    } else {
      if ([EPaymentModes.ACH, EPaymentModes.DirectDebitEFT].includes(payModeId)) {
        this.callPaymentWithAutopay();
      } else if (payModeId == EPaymentModes.HostedPage) {
        this.GetStripeResponse(this.stripeResponse, this.currentPayId, orderId, paymentTrnsId, payModeId);
      } else {
        const obj = {
          payment_method: this.stripeResponse.PaymentMethodId
        };
        this.ConfirmPaymentIntent(obj, null);
      }
    }
  }

  cancelPaymentIntent(paymentData, amount, paymentTrnsId, paymentMode, mismatchOrderId = null) {
    if ([EPaymentModes.CreditCard, EPaymentModes.DebitCard, EPaymentModes.HostedPage, EPaymentModes.CardOnfile].includes(paymentMode)) {
      const initialCCT = mismatchOrderId
        ? of({ Id: mismatchOrderId })
        : this.paymentService.saveCCTransaction(this.generateIntialCCT(amount, EPaymentTransactionType.Reversal_Refund, paymentTrnsId, paymentMode, null, null, null, null, false));
      initialCCT.subscribe((cctRes: any) => {
        this.paymentService.CancelPaymentIntent(paymentData.Key, this.processPayment.facId).subscribe((cancelRes: any) => {
          const cancelReason = cancelRes.Status == "canceled" ? "Payment Intent Cancelled" : "Failed to Cancel the Intent";
          if (mismatchOrderId) {
            if (cancelRes.Status === "canceled") {
              this.saveCardModeMismatchDecline(mismatchOrderId, amount, paymentMode, paymentTrnsId, paymentData, cancelReason)
                .subscribe({ error: () => { } });
            }
            return;
          }
          let obj = {
            amountToPay: amount,
            paymentMode: paymentMode,
            paymentTrnsId: paymentTrnsId,
            orderId: cctRes.Id,
            requestgatewaydetails: this.requestgatewaydetails
          }
          paymentData.Reason = cancelReason;
          const CCModel = this.paymentService.saveCCTFailModelStripe(paymentData, this.processPayment, obj);
          this.paymentService.saveCCTransaction(Object.assign(CCModel)).subscribe((res: any) => { });
        });
        this.loaderIcon = Promise.resolve(false);
      });
    } else {
      let achModel = this.generateIntialACH(amount, EPaymentTransactionType.Reversal_Refund, paymentTrnsId, paymentMode);
      this.paymentService.saveACHTransaction(achModel).subscribe((res) => {
        this.paymentService.CancelPaymentIntent(paymentData.PaymentIntentId, this.processPayment.facId).subscribe((cancelRes: any) => {
          this.saveAchTransactions(paymentData, paymentTrnsId, EACHCheckResultCode.CheckApproval && paymentData.RESULT.RESPONSEDESCRIPTION == "Check Approval: Transaction voided" ? EPaymentTransactionType.Reversal_Refund : EPaymentTransactionType.Declined, null, paymentData.payId);
        });
        this.loaderIcon = Promise.resolve(false);
      });
    }
    if (!this._isMismatchVoid) { this.isCancel.emit(true); }
    this.showLoaderMesage = false;
    this.loaderIcon = Promise.resolve(false);
    if (!this._isMismatchVoid) { this.toastr.success('Cancel Capture Initiated', 'Success', this.toasterConfig); }
  }

  createTenantInfoModel() {
    let obj = {
      TenantId: this.tenantModel.TenantId,
      BusinessAccount: this.tenantModel.BusinessAccount,
      FullName: this.tenantModel.BusinessAccount ? this.tenantModel.CompanyName :
        `${this.tenantModel.FirstName}${this.tenantModel.MiddleName ? ' ' + this.tenantModel.MiddleName : ''} ${this.tenantModel.LastName}`.trim(),
      FirstName: this.tenantModel.FirstName,
      MiddleName: this.tenantModel.MiddleName,
      LastName: this.tenantModel.LastName,
      Address: this.tenantModel.Address,
      City: this.tenantModel.City,
      StateCode: this.tenantModel.State?.Id,
      CountryCode: this.tenantModel.CountryId,
      Zip: this.tenantModel.Zip,
      Country: this.tenantModel.CountryId,
      CellPhoneNumber: this.tenantModel.CellPhoneNumber,
      HomePhone: this.tenantModel.HomePhone,
      WorkPhone: this.tenantModel.WorkPhone,
      WorkPhoneExtn: this.tenantModel.WorkPhoneExtn,
      Fax: this.tenantModel.Fax,
      Email: this.tenantModel.BusinessAccount ? this.tenantModel.CompanyEmail : this.tenantModel.Email,
      CompanyName: this.tenantModel.CompanyName,
      CompanyAddress: this.tenantModel.CompanyAddress,
      CompanyCity: this.tenantModel.CompanyCity,
      CompanyState: this.tenantModel.CompanyState,
      CompanyZip: this.tenantModel.CompanyZip,
      CompanyCountry: this.tenantModel.CompanyCountryId,
      CompanyPhone: this.tenantModel.CompanyPhone,
      CompanyFax: this.tenantModel.CompanyFax,
      CompanyEmail: this.tenantModel.CompanyEmail,
      IsMilitary: this.tenantModel.Military ? 'YES' : 'NO',
      BirthDate: this.tenantModel.DOB,
      BirthDateDMY: this.tenantModel.DOB,
      DLNumber: this.tenantModel.DLId,
      MaskedDLNumber: this.tenantModel.DLId,
      DLProvince: this.tenantModel.DLStateId,
      DLExpDate: this.tenantModel.DLExpDate,
      DLExpDateDMY: this.tenantModel.DLExpDate,
      HCode: this.tenantModel.HomePhoneCountryId,
      WCode: this.tenantModel.WorkPhoneCountryId,
      Rank: this.tenantModel.MilitaryInfo ? this.tenantModel.MilitaryInfo.Rank : '',
      CommandOfficer: this.tenantModel.MilitaryInfo ?
        this.tenantModel.MilitaryInfo.COFirstname + '' + this.tenantModel.MilitaryInfo.COLastname : '',
      MilitaryBranch: this.tenantModel.MilitaryInfo ? this.tenantModel.MilitaryInfo.MilitaryBranch : '',
      MilitaryBase: this.tenantModel.MilitaryInfo ? this.tenantModel.MilitaryInfo.MilitaryBase : '',
      BusinessOrTenantAddress: this.tenantModel.BusinessAccount ? this.tenantModel.CompanyAddress : this.tenantModel.Address,
      BusinessOrTenantCity: this.tenantModel.BusinessAccount ? this.tenantModel.CompanyCity : this.tenantModel.City,
      BusinessOrTenantStateCode: this.tenantModel.BusinessAccount ? this.tenantModel.CompanyState : this.tenantModel.State?.Id,
      BusinessOrTenantZipCode: this.tenantModel.BusinessAccount ? this.tenantModel.CompanyZip : this.tenantModel.Zip,
      BusinessOrTenantCountryCode: this.tenantModel.BusinessAccount ? this.tenantModel.CompanyCountryId : this.tenantModel.CountryId,
      SendSmsAlerts: this.tenantModel.SendSMSAlerts,
      CellPhoneCountryId: this.tenantModel.CellPhoneCountryId,
      TenantEmail: this.tenantModel.Email,
      Phone: this.tenantModel.BusinessAccount ? this.tenantModel.CompanyPhone : this.tenantModel.CellPhoneNumber,
      PrimaryIDType: this.tenantModel.PrimaryIdType,
      DialInCode: this.tenantModel.CountryId,
      CountryId: this.tenantModel.CountryId,
      CommandOfficerCellPhone: this.tenantModel.MilitaryInfo ? this.tenantModel.MilitaryInfo.COCellPhone : '',
      MilitaryDOD: this.tenantModel.MilitaryInfo ? this.tenantModel.MilitaryInfo.DODNumber : '',
      CommandOfficerEmail: this.tenantModel.MilitaryInfo ? this.tenantModel.MilitaryInfo.COEmail : '',
      MilitaryIdExpDate: this.tenantModel.MilitaryInfo ? this.tenantModel.MilitaryInfo.MilitaryIdExpDate : '',
      SMSEnabled: this.tenantModel.SendSMSAlerts ? 'YES' : 'NO'
    }

    return obj;
  }

  checkPaymentProcess() {
    var anypaid = function (element) {
      return element.payComplete == true;
    };
    this.paymentProcessing = this.paymentTable.some(anypaid);
  }

  handleLoaderStatus(status: boolean) {
    this.isLoaderActive = status;
  }

  emitPaymentTerminalStatus(eve) {
    let paymentTrnsId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
    let stripePaymentTable = this.paymentTable.find(o => o.payId === this.currentPayId);
    if (eve == 'Status') {
      this.paymentService.GetChargesDetailsByIntentId(stripePaymentTable.stripePaymentIntentId, this.processPayment.facId, stripePaymentTable.TerminalDeviceId, true).subscribe(async (res: any) => {
        if (res.Success) {
          if (!stripePaymentTable.isOpenEdgePaymentCompleted && stripePaymentTable.uniqueTransId == res.OrderId) {
            this.paymentTable.find(o => o.payId == this.currentPayId).isOpenEdgePaymentCompleted = true;
            this.GetStripeResponse(res, this.currentPayId, stripePaymentTable.orderId, paymentTrnsId, EPaymentModes.CreditCard);
          }
        } else {
          this.toastr.info("Your transaction is in progress. Please wait...", "Info", this.toasterConfig);
        }
      });
    } else {
      this.stripeLoader.isStripeterminal = false;
      this.signalRService.stopConnection();
      this.stripeResponseSubscription.unsubscribe();
      const obj = {
        Reason: "Transaction Cancelled by User!",
        PaymentIntentId: stripePaymentTable.stripePaymentIntentId
      };
      this.paymentService.CancelTerminalAction(stripePaymentTable.TerminalDeviceId, this.processPayment.facId).subscribe((res: any) => {
        this.saveStripeCCTransactionFail(obj, paymentTrnsId, stripePaymentTable.orderId, EPaymentModes.CreditCard);
        if (!res) {
          this.toastr.warning('Please ask Administrator to Reset the Terminal Device', 'Alert', this.toasterConfig);
        }
      }, err => {
        this.saveStripeCCTransactionFail(obj, paymentTrnsId, stripePaymentTable.orderId, EPaymentModes.CreditCard);
        this.toastr.warning('Please ask Administrator to Reset the Terminal Device', 'Alert', this.toasterConfig);
      });
    }
  }

  getTransactionType() {
    let transType = 0;
    if (this.processPayment.Type == EPaymentOrigin.Reservation) {
      transType = ETransactionTypes.Reservation;
    } else if (this.processPayment.Type == EPaymentOrigin.Merchandise) {
      transType = ETransactionTypes.Merchandise;
    } else if (this.processPayment.Type == EPaymentOrigin.MoveOut) {
      transType = ETransactionTypes.Move_Out;
    } else if (this.processPayment.Type == EPaymentOrigin.MakePayment) {
      transType = ETransactionTypes.Payment;
    } else if (this.processPayment.Type == EPaymentOrigin.Transfer) {
      transType = ETransactionTypes.Transfer;
    } else if (this.processPayment.Type == EPaymentOrigin.ReInstate) {
      transType = ETransactionTypes.Reinstate_Unit;
    } else if (this.processPayment.Type == EPaymentOrigin.AuctionManager) {
      transType = ETransactionTypes.Auction_Manager;
    } else if (this.processPayment.Type == EPaymentOrigin.Refund) {
      transType = ETransactionTypes.Refund;
    } else if (this.processPayment.Type == EPaymentOrigin.SeperateMerchRefund) {
      transType = ETransactionTypes.Merchandise_Return;
    } else {
      transType = ETransactionTypes.Move_In;
    }
    return transType;
  }

  cancelTerminalAction() {
    this.paymentService.CancelTerminalAction(this.stripeTerminalDeviceId, this.processPayment.facId).subscribe((res: any) => {
      if (!res) {
        this.toastr.warning('Please ask Administrator to Reset the Terminal Device', 'Alert', this.toasterConfig);
      } else {
        this.toastr.success('Terminal device Reset successfully', 'Success', this.toasterConfig);
      }
    }, err => {
      this.toastr.warning('Please ask Administrator to Reset the Terminal Device', 'Alert', this.toasterConfig);
    });
    this.afterpaymentSuccess()
  }
  ContinueWithAutoEnrollPP()
  {
    this.generalService.revokeAutoEnrollPP=false;
    this.showpopupforpartialPayment?.hide()
  }
  CancelAutoEnrollPP()
  { var Amount=0
    this.generalService.revokeAutoEnrollPP=true;
    this.displayPaymentPopup=true
    this.showpopupforpartialPayment?.hide()
    this.totalAmount =this.totalAmount- this.generalService.dueinsurance;
    this.paymentTable.forEach((ele) => {
      Amount += ele.payAmount;
    });
    this.remainingAmount =this.totalAmount-Amount;
    if (this.amount == 0 && this.paymentTable.length == 1) { // for Transfer and Movein Zero payment
      if ([EPaymentOrigin.Transfer, EPaymentOrigin.Rental].includes(this.processPayment.Type) && this.processPayment.requireFullPayment) {
        this.payBasedOnMode(this.amount, this.payId, this.template, this.templateCheck);
      } else {
        this.loaderIcon = Promise.resolve(true); // gets stopped after the Transaction is Success/Failed
        this.paymentStarted = true;
        this.showPrintEmailRcpt = true;
        let obj = null;
        this.payStatus = 'Success';
        this.paymentSuccessFul = true;
        this.currentPayId = this.payId;
        this.shareModel.push(obj);
        let ccObj;
        ccObj = null;
        this.shareModel.push(ccObj);
        this.charityFeesContribution.emit(this.charityContribution);
        this.surchargeContribution.emit(this.buildSurchargeContribution());
        this.payCompleted.emit(this.shareModel);
      }
    }else{
      this.payBasedOnMode(this.amount, this.payId, this.template, this.templateCheck);
    }
      
  }
  

  callPaymentWithAutopay() {
    const payId = this.currentPayId;
    const setupRow = this.autopaySetupAchRows[payId];
    if (setupRow) {
      this.createAutopaySetupIntent(setupRow.UniqueTransId);
      return;
    }

    // Autopay setup gets its own ACT row (separate from the payment's row). The setup intent id is stamped on it server-side before the client can confirm, so the setup_intent.succeeded webhook always finds it.
    const paymentTrnsId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
    const payModeId = this.paymentTable.find(o => o.payId === payId).payModeId;
    const achModel = this.generateIntialACH(0, EPaymentTransactionType.Processed, paymentTrnsId, payModeId);
    this.paymentService.saveACHTransaction(achModel).subscribe((res: any) => {
      if (!res?.Success) {
        this.toastr.error('Failed to Create Payment Intent', 'Failure', this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
        return;
      }
      this.autopaySetupAchRows[payId] = { Id: res.Id, UniqueTransId: res.UniqueTransId };
      this.createAutopaySetupIntent(res.UniqueTransId);
    }, err => {
      this.toastr.error('Failed to Create Payment Intent', 'Failure', this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
    });
  }

  createAutopaySetupIntent(uniqueTransId: string) {
    const isQuickProspect = this.quickProspectTenantInfo?.IsQuickProspect;
    const setupIntent = {
      OrderId: uniqueTransId,
      TenantId: this.processPayment.TenantId,
      Name: `${this.customerInfo.FirstName}${this.customerInfo.MiddleName ? ' ' + this.customerInfo.MiddleName : ''} ${this.customerInfo.LastName}`.trim(),
      Email: this.customerInfo.Email,
      Phone: this.customerInfo.CellPhoneNumber,
      FacilityId: this.facilityId,
      LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
      SelectedPaymentModeType: this.selectedPaymentMode === EPaymentModes.ACH ? "ACH" : this.selectedPaymentMode === EPaymentModes.DirectDebitEFT ? "EFT" : "HostedPage",
      TransactionType: this.getLovTransactionType(),
      IsQuickProspectPayment: isQuickProspect,
      Customer: this.processPayment?.CustomerId ? this.processPayment.CustomerId : this.facOpsDataService?.saveautopay?.CustomerId || ''
    };

    this.paymentService.SetupCardIntent(setupIntent).subscribe((response: any) => {
      if (response) {
        this.isPaymentWithAutoPay = true;
        this.stripeClientSecret = response.ClientSecret;
        this.stripeSetupIntent = response.SetupIntentId;
        this.processPayment.CustomerId = this.processPayment?.CustomerId || response?.CustomerId || this.facOpsDataService?.saveautopay?.CustomerId || '';
        this.callStripeHostedPage();
      } else {
        this.toastr.error('Failed to Create Payment Intent', 'Failure', this.toasterConfig);
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.toastr.error('Failed to Create Payment Intent', 'Failure', this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
    });
  }

  async setUpStripeTerminalAutopay() {
    let paymentTrnsId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
    let stripePaymentTable = this.paymentTable.find(o => o.payId == this.currentPayId);
    this.paymentMaxWaitTime = this.paymentMaxWaitTime != undefined ? this.paymentMaxWaitTime : 2;
    this.paymentTable.find(o => o.payId == this.currentPayId).isOpenEdgePaymentCompleted = false;
    this.paymentInProgress = true;
    this.isOpenEdgeEMVCompleted = false;
    this.stripeTerminalDeviceId = stripePaymentTable.TerminalDeviceId
    this.requestGatewaydetails(stripePaymentTable.payModeId, stripePaymentTable.payId);
    const isQuickProspect = this.quickProspectTenantInfo?.IsQuickProspect;
    try {
      await this.signalRService.startConnection(this.baseUrl);
    } catch (err) {
      console.error('SignalR connection failed before terminal autopay:', err);
      this.resetTerminalUI();
      return;
    }
    const obj = {
      OrderId: stripePaymentTable.uniqueTransId,
      DeviceId: this.selectStripeReaderId,
      TenantId: this.processPayment.TenantId ?? 0,
      Name: isQuickProspect ? this.quickProspectTenantInfo.Name : `${this.customerInfo.FirstName}${this.customerInfo.MiddleName ? ' ' + this.customerInfo.MiddleName : ''} ${this.customerInfo.LastName}`.trim(),
      Email: isQuickProspect ? this.quickProspectTenantInfo.Email : this.customerInfo.Email,
      Phone: isQuickProspect ? this.quickProspectTenantInfo.Phone : this.customerInfo.CellPhoneNumber,
      FacilityId: this.facilityId,
      LeaseNo: this.processPayment.LeaseNo ? this.processPayment.LeaseNo : null,
      IsQuickProspectPayment: isQuickProspect,
      Customer: this.processPayment?.CustomerId ? this.processPayment.CustomerId : this.facOpsDataService?.saveautopay?.CustomerId || '',
      SignalRConnectionId: this.signalRService.getConnectionId()
    };
    this.paymentService.SetupTerminalAutopay(obj).subscribe((stripeRes: any) => {
      this.showLoaderMesage = false;
      this.isTDEmv.isTransactionWaitTime = this.stripeLoader.isStripeterminal = true;
      this.paymentTable.find(o => o.payId === this.currentPayId).stripePaymentIntentId = stripeRes.PaymentMethodId;
      this.loaderIcon = Promise.resolve(true);
      if (stripeRes) {
        if (!stripeRes.Success) {
          this.isStripeTerminalPay = stripeRes.Reason == 'Another Transaction is in Progress';
          this.stripeResponse = stripeRes;
          this.signalRService.stopConnection();
          this.saveStripeCCTransactionFail(stripeRes, paymentTrnsId, stripePaymentTable.orderId, EPaymentModes.CreditCard);
          this.stripeLoader.isStripeterminal = false;
          this.loaderIcon = Promise.resolve(false);
        } else {
          this.signalRService.addStripeResponseListener("ReceiveAutopayUpdate");
          this.stripeResponseSubscription = this.signalRService.stripeResponse$.subscribe((response: any) => {
            this.signalRService.stopConnection();
            this.stripeLoader.isStripeterminal = false;
            this.unSubscribeSignalRSubscribe();
            this.isPaymentWithAutoPay = true;
            let resultResponse = JSON.parse(response);
            this.processPayment.CustomerId = this.processPayment?.CustomerId || resultResponse?.CustomerId || this.facOpsDataService?.saveautopay?.CustomerId || '';
            this.stripeResponse = resultResponse;
            this.isTDEmv.isTransactionWaitTime = false;
            if (resultResponse.Success && this.autopayLinledUnitList.length > 0) {
              this.loaderIcon = Promise.resolve(false);
              this.linkedAutopayModalRef = this.modalService.show(this.linkedAutopay, { class: 'modal-dialog-centered ', backdrop: 'static', keyboard: false });
            } else if (!stripePaymentTable.isOpenEdgePaymentCompleted) {
              const obj = {
                payment_method: resultResponse.PaymentMethodId
              };
              this.ConfirmPaymentIntent(obj, null);
            }
          }, err => {
            this.saveStripeCCTransactionFail(stripeRes, paymentTrnsId, stripePaymentTable.orderId, EPaymentModes.CreditCard);
          });
          setTimeout(() => {
            if (!this.paymentTable.find(o => o.payId == this.currentPayId).isOpenEdgePaymentCompleted && this.paymentTable.find(o => o.payId == this.currentPayId).uniqueTransId == stripePaymentTable.uniqueTransId) {
              this.unSubscribeSignalRSubscribe();
              this.paymentTable.find(o => o.payId == this.currentPayId).isOpenEdgePaymentCompleted = true;
              this.isTDEmv.isTransactionWaitTime = false;
              this.paymentService.getCardDetailsBySetupIntentId(this.paymentTable.find(o => o.payId === this.currentPayId).stripePaymentIntentId, this.facilityId).subscribe((resultResponse: any) => {
                if (resultResponse.Success) {
                  const obj = {
                    payment_method: resultResponse.PaymentMethodId
                  };
                  this.ConfirmPaymentIntent(obj, null);
                } else {
                  this.cancelTerminalAction();
                  this.saveStripeCCTransactionFail(resultResponse, paymentTrnsId, stripePaymentTable.orderId, EPaymentModes.CreditCard);
                }
              }, err => {
                this.cancelTerminalAction();
                this.saveStripeCCTransactionFail(null, paymentTrnsId, stripePaymentTable.orderId, EPaymentModes.CreditCard);
              });
            }
          }, 10000 * 6 * this.paymentMaxWaitTime);
        }
      }
    }, (err) => {
      this.signalRService.stopConnection();
      this.stripeLoader.isStripeterminal = false;
      this.loaderIcon = Promise.resolve(false);
      const errorResponse = this.handelStripeError(err);
      this.saveStripeCCTransactionFail(errorResponse, paymentTrnsId, stripePaymentTable.orderId, EPaymentModes.CreditCard);
    });
  }

  unSubscribeSignalRSubscribe() {
    if (this.stripeResponseSubscription != null) {
      this.stripeResponseSubscription.unsubscribe();
      this.stripeResponseSubscription = null;
    }
  }

  getPaymentOrderId(){
    return this.paymentGateway == EPaymentGateway.TdBank ? this.paymentTable.find(o => o.payId == this.currentPayId).orderId : this.paymentTable.find(o => o.payId == this.currentPayId).uniqueTransId;
  }

  ClearFullPrepaymentOnDueDateChangeData(){
    this.facOpsDataService.clearRequireFullPrepaymentOnDueDateChange();
    this.show_OnDueDateChangeConfirmPopup.hide();
    this.onPayClick(this.amount, this.payId, this.template, this.templateCheck);
  }

CalculateRoundedCashAmount(amount: any, Id: number, IschangesAmount?: boolean) {
  const amt = parseFloat((amount || '').toString().replace(/[^0-9.]/g, '')) || 0;

  const CashRounding = {
    167: 0.05,
    168: 0.10,
    169: 0.50,
    170: 1
  } as const;

  const step = CashRounding[this.RoundingValue] ?? 1;

  let roundedAmount = amt;
  // Trim float noise (e.g. 0.3 / 0.1 = 2.9999999999999996) so an amount already on the step is not moved a
  // whole step by floor/ceil, and midpoints round up - the same result as the server's decimal math.
  const steps = Number((amt / step).toFixed(6));

  switch (this.RoundingOption) {
    case ECashRoundingOption.RoundDown:
      roundedAmount = Math.floor(steps) * step;
      break;

    case ECashRoundingOption.RoundUp:
      roundedAmount = Math.ceil(steps) * step;
      break;

    default:
      roundedAmount = Math.round(steps) * step;
      break;
  }

  // Fix floating precision (important for values like 0.05)
  roundedAmount = Number(roundedAmount.toFixed(2));

  if (IschangesAmount) {
    const payment = this.paymentTable.find(o => o.payId === Id);
    if (payment) {
      payment.roundingvalue = Number((roundedAmount - amt).toFixed(2));
    }
  }
    return roundedAmount;
  }

  hasValidAutopay(ap: any): boolean {
  if (!ap) return false;

  const hasCore =
    !!ap.LeaseNo &&
    !!ap.FacilityId;

  const hasCard =
    !!ap.PaymentAccountId ||
    (ap.CreditCardNumber && ap.CreditCardType);

  const hasAch =
    ap.ACHPayment === true &&
    (!!ap.ACHPaymentAccountId || !!ap.ACHAccountNo);

  const hasDirectDebit =
    ap.DirectDebit === true;

  return hasCore && (hasCard || hasAch || hasDirectDebit);
}

  ngAfterViewInit(): void {
    this.hasAutopay = this.hasValidAutopay(this.autoPayInfo);
    if (this.autoPayRequired && (this.processPayment.Type == EPaymentOrigin.Rental || this.processPayment.Type == EPaymentOrigin.Transfer) && !this.hasAutopay) {
      this.clickautopay();
    }
    if (this.returnPostPayment && this.hasAutopay) {
      this.autopayCompleted.emit([null, null]);
      return;
    }
  }
  get stripeModule(): number {
    return this.isPaymentWithAutoPay &&(this.selectedPaymentMode === EPaymentModes.ACH ||this.selectedPaymentMode === EPaymentModes.DirectDebitEFT)? 2: 1;
  }
}
